function trackViewCart(cart) {
  console.log("GA view_cart");
  var _items = [];
  $.each(cart.items, function (_index, product) {
    var item_id = `shopify_US_${product.product_id}_${product.variant_id}`;
    _items.push({
      item_id: item_id,
      item_name: product.title,
      currency: cart.currency,
      index: _index,
      item_brand: window.shop_name,
      item_category: product.product_type,
      item_variant: product.variant_title,
      price: product.price / 100,
      quantity: product.quantity,
    });
  });
  gtag("event", "view_cart", {
    currency: cart.currency,
    value: cart.total_price / 100,
    items: _items,
  });
}

var arrowSize = {
  x0: 10,
  x1: 40,
  y1: 50,
  x2: 80,
  y2: 50,
  x3: 50,
};
var svgArrowSizeLeft =
  '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow"></path></svg>';
var svgArrowSizeRight =
  '<svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 62,90 L 22,50  L 62,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>';

jQuery.fn.extend({
  shadowRoot: function () {
    return $(this.get(0).shadowRoot);
  },
});

/*============================================================================
  Image functions
==============================================================================*/

var usePageDots = false;

function slugify(text) {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "-") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text
}

var imageFunctions = {
  zoom: function (zoomParent, enableTouch, magnify) {
    var activateZoom = $(zoomParent).data("zoom");
    if (activateZoom) {
      $(zoomParent + " img")
        .wrap('<span style="display:inline-block"></span>')
        .css("display", "block")
        .parent()
        .zoom({
          touch: enableTouch,
          magnify: magnify ? magnify : 1,
        });
    }
  },
  linkGalleryAndCarousel: function ($gallery, $carousel) {
    $carousel.find(".gallery-cell:nth-child(1)").addClass("is-nav-selected");

    //EVENT - click on carousel item to slide gallery
    $carousel.on("click", ".gallery-cell", function () {
      var index = $(this).index();
      $carousel.find(".is-nav-selected").removeClass("is-nav-selected");
      $(this).addClass("is-nav-selected");
      $gallery.flickity("select", index);
    });

    //EVENT - update carousel based on gallery index
    $gallery.on("cellSelect", function () {
      var galleryData = $(this).data("flickity");
      if (galleryData) {
        $carousel.find(".is-nav-selected").removeClass("is-nav-selected");
        $carousel
          .find(
            ".gallery-cell:nth-child(" + (galleryData.selectedIndex + 1) + ")"
          )
          .addClass("is-nav-selected");
      }
    });
  },
  fullWidth: function (images, imageContainer) {
    $(images).each(function () {
      var $image = $(this),
        alt = $image.attr("alt"),
        src = $image.attr("src");

      if (alt.indexOf("[") >= 0) {
        //remove from description
        $image.remove();

        //find shortcode values and remove from alt
        var shortcodes = alt.match(/\[(.*?)\]/gi);
        alt = alt.replace(/\[(.*?)\]/gi, "");

        //remove brackets from shortcode to be used as classes
        var captionClass = $.map(shortcodes, function (value, index) {
          value = value.replace(/[\[\]']+/g, "");
          return value;
        });

        //markup for caption

        var caption = [
          '<div class="position-' +
            (captionClass.length ? captionClass : "center") +
            ' caption js-caption">',
          '<div class="caption-content caption-background-false align-' +
            (captionClass.length ? captionClass : "center") +
            '">',
          '<p class="headline">' + alt + "</p>",
          "</div>",
          "</div>",
        ].join("");

        //image attributes added
        $image.attr({
          alt: alt,
          class: "lazyload none",
          src: src,
          dataSizes: "auto",
        });

        var image = $image.prop("outerHTML");
        var banner = '<div class="banner">' + image + caption + "</div>";

        $(imageContainer).append(banner);
      }
    });
  },
  showSecondaryImage: function () {
    $("body").on("mouseenter", ".swap-true", function () {
      $(this).toggleClass("toggle-images");
    });

    $("body").on("mouseleave", ".swap-true", function () {
      $(this).toggleClass("toggle-images");
    });
  },
};

/*============================================================================
  ntntly Viewed
==============================================================================*/

var recentlyViewed = {
  init: function () {
    var productHandle, rvCookie, rvProducts, displayProducts, rvProductArray;

    if ($(".js-product_section[data-rv-handle]").length) {
      productHandle = $(".js-product_section").data("rv-handle").toString();
      rvCookie = Cookies.get("recentlyViewed");
      rvProducts = recentlyViewed.getCookieProducts(rvCookie, productHandle);
    } else if ($(".recently-viewed__section").length) {
      rvCookie = Cookies.get("recentlyViewed");
      rvProducts = recentlyViewed.getCookieProducts(rvCookie, productHandle);
    } else if (
      $(".collection-template-section .js-sidebar-recently-viewed").length
    ) {
      rvCookie = Cookies.get("recentlyViewed");
      rvProducts = recentlyViewed.getCookieProducts(rvCookie, productHandle);
    }

    if (rvProducts) {
      rvProductArray = unescape(rvProducts).split(",");
    }

    if (productHandle) {
      if (!$.inArray(productHandle, rvProductArray) !== -1) {
        displayProducts = [];
        rvProductArray.unshift(productHandle);
        $.each(rvProductArray, function (i, el) {
          if ($.inArray(el, displayProducts) === -1) displayProducts.push(el);
        });
      }

      recentlyViewed.setCookieProducts(displayProducts);
    } else {
      displayProducts = rvProductArray;
    }

    if ($(".recently-viewed__section").length) {
      var parent = ".recently-viewed__section";
      recentlyViewed.getProductInformation(parent, displayProducts);
    } else if ($(".js-recently-viewed .rv-main").length) {
      var parent = ".js-recently-viewed";
      recentlyViewed.getProductInformation(
        parent,
        displayProducts,
        productHandle
      );
    }

    if ($(".sidebar .js-sidebar-recently-viewed").length) {
      var parent = ".sidebar .js-sidebar-recently-viewed";
      if (productHandle) {
        recentlyViewed.getProductInformation(
          parent,
          displayProducts,
          productHandle
        );
      } else {
        recentlyViewed.getProductInformation(parent, displayProducts);
      }
      $(".js-sidebar-recently-viewed.hidden").parents(".sidebar-block").hide();
    }
  },
  getCookieProducts: function (rvCookie, productHandle) {
    if (!rvCookie && productHandle) {
      Cookies.set("recentlyViewed", productHandle, { expires: 90, path: "/" });
      rvCookie = Cookies.get("recentlyViewed");
    } else {
      rvCookie = Cookies.get("recentlyViewed");
    }

    return rvCookie;
  },
  setCookieProducts: function (rvProductArray) {
    Cookies.set("recentlyViewed", escape(rvProductArray.join(",")), {
      expires: 30,
      path: "/",
    });
  },
  getProductInformation: function (parent, displayProducts, productHandle) {
    if (productHandle) {
      displayProducts.splice($.inArray(productHandle, displayProducts), 1);
    }

    var productLimit = $(parent).data("visible-products");

    if (productLimit && displayProducts) {
      displayProducts = displayProducts.slice(0, productLimit);
    }

    $.each(displayProducts, function (index, value) {
      if (value) {
        $(parent).removeClass("hidden");

        $(parent).parents(".sidebar-block").show();

        $.ajax({
          type: "GET",
          url: "/products/" + value + "?view=rv",
          success: function (data) {
            var rvProduct = $(data).find(".js-recently-viewed-product");

            $(parent)
              .find(" .rv-box-" + index)
              .append(rvProduct);

            //Convert pricing
          },
          error: function (x, t, m) {
            console.log(x);
            console.log(t);
            console.log(m);
          },
          dataType: "html",
        });
      }

      if ($(parent).find(".rv-main").hasClass("js-rv-slider")) {
        if (displayProducts.length <= productLimit) {
          $(".js-rv-slider .gallery-cell")
            .eq(displayProducts.length)
            .nextAll()
            .addBack()
            .remove();
        } else {
          $(".js-rv-slider .gallery-cell")
            .eq(productLimit)
            .nextAll()
            .addBack()
            .remove();
        }
        recentlyViewed.createSlider(parent, productLimit);
      } else if ($(parent).find(".rv-main").hasClass("js-rv-grid")) {
        if (displayProducts.length <= productLimit) {
          $(".js-rv-grid .thumbnail")
            .eq(displayProducts.length)
            .nextAll()
            .addBack()
            .remove();
        } else {
          $(".js-rv-grid .thumbnail")
            .eq(productLimit)
            .nextAll()
            .addBack()
            .remove();
        }
      }
    });
  },

  createSlider: function (el, productsAvailable) {
    var products_per_slide = $(".js-rv-slider").data("products-per-slide");
    var products_limit = $(".js-rv-slider").data("products-limit");
    var products_available = productsAvailable;
    var indexProductsAvailable = productsAvailable - 1;
    var rvProductstoShow = $(".js-rv-slider").find(".gallery-cell");
    var cellAlign, draggable, prevNext, wrapAround, initialIndex;

    if (
      (products_per_slide == "2" &&
        products_available > products_per_slide &&
        products_limit > products_per_slide) ||
      (products_per_slide == "4" &&
        products_available > products_per_slide &&
        products_limit > products_per_slide) ||
      (products_per_slide == "6" &&
        products_available > products_per_slide &&
        products_limit > products_per_slide)
    ) {
      cellAlign = "left";
    } else {
      cellAlign = "center";
    }

    if (
      products_available > products_per_slide &&
      products_limit > products_per_slide
    ) {
      draggable = true;
      prevNext = true;
      wrapAround = true;
    } else {
      draggable = false;
      prevNext = false;
      wrapAround = false;
    }

    if (
      (products_per_slide == "2" && products_available > products_per_slide) ||
      (products_per_slide == "4" && products_available > products_per_slide) ||
      (products_per_slide == "6" && products_available > products_per_slide)
    ) {
      initialIndex = 0;
    } else if (products_per_slide == "3" && products_available) {
      initialIndex = 1;
    } else if (products_per_slide == "5" && products_available) {
      initialIndex = 2;
    } else if (products_per_slide == "7" && products_available) {
      initialIndex = 3;
    }

    if ($(window).width() <= 798) {
      cellAlign = "center";
      initialIndex = 1;

      if (rvProductstoShow.length <= 2) {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      } else if (products_available > 3 && products_limit > 3) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      $(".js-rv-slider")
        .parents(".even-num-slides")
        .removeClass("even-num-slides");
    }

    $(".js-rv-slider").flickity({
      lazyLoad: 2,
      imagesLoaded: true,
      draggable: draggable,
      prevNextButtons: prevNext,
      wrapAround: wrapAround,
      cellAlign: cellAlign,
      pageDots: usePageDots,
      contain: true,
      freeScroll: true,
      arrowShape: arrowSize,
      initialIndex: initialIndex,
    });

    $(".js-rv-slider").addClass("slider-initialized");
  },
};

/*============================================================================
  Featured collection section
==============================================================================*/

var featuredCollectionSection = {
  init: function () {
    $(".js-product-slider .products-slider").each(function (index, value) {
      var productSlider = $(this);
      var products_per_slide = $(this).data("products-per-slide");
      var products_limit = $(this).data("products-limit");
      var products_available = $(this).data("products-available");
      var cellAlign, draggable, prevNext, wrapAround, initialIndex;

      if (
        (products_per_slide == "2" &&
          products_available > products_per_slide &&
          products_limit > products_per_slide) ||
        (products_per_slide == "4" &&
          products_available > products_per_slide &&
          products_limit > products_per_slide) ||
        (products_per_slide == "6" &&
          products_available > products_per_slide &&
          products_limit > products_per_slide)
      ) {
        cellAlign = "left";
      } else {
        cellAlign = "left";
      }

      if (
        products_available > products_per_slide &&
        products_limit > products_per_slide
      ) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      if (
        (products_per_slide == "2" &&
          products_available > products_per_slide) ||
        (products_per_slide == "4" &&
          products_available > products_per_slide) ||
        (products_per_slide == "6" && products_available > products_per_slide)
      ) {
        initialIndex = 0;
      } else if (products_per_slide == "3" && products_available) {
        initialIndex = 1;
      } else if (products_per_slide == "5" && products_available) {
        initialIndex = 2;
      } else if (products_per_slide == "7" && products_available) {
        initialIndex = 3;
      }

      if ($(window).width() <= 798) {
        cellAlign = "center";
        draggable = true;
        prevNext = true;
        wrapAround = true;
        initialIndex = 1;

        $(this).parents(".even-num-slides").removeClass("even-num-slides");
      }
      var leftMostTileIndex = 0;

      $(this).flickity({
        lazyLoad: 2,
        imagesLoaded: true,
        draggable: draggable,
        prevNextButtons: prevNext,
        wrapAround: wrapAround,
        cellAlign: cellAlign,
        pageDots: usePageDots,
        contain: true,
        freeScroll: true,
        arrowShape: arrowSize,
        initialIndex: initialIndex,
        on: {
            ready: handleReady,
            change: handleChange, 
            settle: handleSettle
        }
      });
      function handleReady() {
          productSlider.attr('aria-label', 'Track of tiles. Use arrow keys to navigate.');
          hideNonVisibleTiles();
      }
      function handleChange(index) {
        leftMostTileIndex = index;
        // Immediately show slides so transition has visible content
          productSlider.find('.gallery-cell').each(function () {
            this.classList.remove('is-hidden');
            this.removeAttribute('aria-hidden');
            this.removeAttribute('tabindex');
          });
      }

      function handleSettle(index) {
        requestAnimationFrame(() => hideNonVisibleTiles());
      }
      // function hideNonVisibleTiles() {
      //      productSlider.find('.gallery-cell').attr('aria-hidden', true).attr('tabindex', -1).addClass('is-hidden')

      //       // Figure out how many slides are visible (or partially visible)
      //       var containerWidth = productSlider.width();
      //       var tileWidth = productSlider.find('.gallery-cell')[0].offsetWidth;

      //       // // How many tiles can fit into this container (including partially visible ones)?
      //       // // NOTE: this method assumes a constant slide width. Update as needed if you want to support variable slide width.
      //       var numVisibleTiles = Math.ceil(containerWidth / tileWidth) - 1;

      //       // // Make only the desired number of tiles available for screen reader and keyboard users
      //       for (var i = leftMostTileIndex; i < leftMostTileIndex + numVisibleTiles; i++) {
      //           if (i < productSlider.find('.gallery-cell').length) {
      //               // console.log('need to remove',productSlider.find('.gallery-cell')[i])
      //               productSlider.find('.gallery-cell')[i].classList.remove('is-hidden')
      //               productSlider.find('.gallery-cell')[i].removeAttribute('aria-hidden');
      //               productSlider.find('.gallery-cell')[i].removeAttribute('tabindex');
      //           }
      //       }
      //   }
      function hideNonVisibleTiles() {
        var container = productSlider.find('.flickity-viewport')[0];
        var containerRect = container.getBoundingClientRect();

        productSlider.find('.gallery-cell').each(function () {
          var cell = this;
          var cellRect = cell.getBoundingClientRect();

          // Check if this cell is at least partially visible in the viewport
          var isVisible =
            cellRect.right > containerRect.left &&
            cellRect.left < containerRect.right;

          if (isVisible) {
            // Visible: keep accessible
            cell.classList.remove('is-hidden');
            cell.removeAttribute('aria-hidden');
            cell.removeAttribute('tabindex');
          } else {
            // Hidden: hide from accessibility tree
            cell.classList.add('is-hidden');
            cell.setAttribute('aria-hidden', 'true');
            cell.setAttribute('tabindex', '-1');
          }
        });
      }


      $(this).addClass("slider-initialized");
    });
  },
  unload: function ($target) {
    var $slider = $target.find(".js-product-slider");
    if ($slider.hasClass("flickity-enabled")) {
      $slider.flickity("destroy");
    }
  },
};

var featuredPromotions = {
  init: function () {
    if ($(window).width() > 798 || $(window).width() == 0) {
      $(".feature-overlay").hover(
        function () {
          $(this)
            .find(".feature-details")
            .slideDown("100", function () {
              $(this).addClass("reveal-details");
            });
        },
        function () {
          $(this).find(".feature-details").removeClass("reveal-details");
          $(this).find(".feature-details").slideUp("100");
        }
      );

      $(".js-featured-promotions").each(function (index, value) {
        var $promos = $(this);
        var animationStyle = $(this).data("promo-animation");

        $promos.waypoint(
          function () {
            $(this.element)
              .find(".feature-section")
              .addClass("animated " + animationStyle);
          },
          { offset: "80%" }
        );
      });
    }
  },
};

/*============================================================================
  Slideshow section
==============================================================================*/

var slideshow = {
  init: function () {
    $(".js-homepage-slideshow").each(function (index, value) {
      var $homepageSlider = $(this);
      var settings = {
        slideshowSpeed: $homepageSlider.data("slideshow-speed") * 1000,
        slideshowTextAnimation: $homepageSlider.data(
          "slideshow-text-animation"
        ),
      };

      //initiate the slideshow
      if (!$homepageSlider.hasClass("flickity-enabled")) {
        var arrowShow =
          $homepageSlider.find(".gallery-cell").length === 1 ? false : true;
        $homepageSlider.flickity({
          wrapAround: true,
          cellAlign: "left",
          lazyLoad: true,
          imagesLoaded: true,
          prevNextButtons: arrowShow,
          draggable: arrowShow,
          pageDots: true,
          autoPlay: settings.slideshowSpeed,
          arrowShape: arrowSize,
          freeScroll: false,
          on: {
              ready: handleReady,
              change: handleChange,
              settle: handleSettle
          }
        });
        function handleReady(){
          $homepageSlider.attr('aria-label', 'Track of slides. Use arrow keys to navigate.');
        }
        function handleChange(){
          $homepageSlider.find('.gallery-cell').removeClass('is-hidden')
        }
        function handleSettle(){
          hideNonVisibleSlides();
        }
        function hideNonVisibleSlides() {
            var hiddenSlides = $homepageSlider.find('.gallery-cell:not(.is-selected)').addClass('is-hidden')
        }

        if (settings.slideshowTextAnimation != "") {
          var flkty = $homepageSlider.data("flickity");
          setTimeout(function () {
            $homepageSlider
              .find(".gallery-cell:nth-child(1) .caption-content")
              .addClass("animated " + settings.slideshowTextAnimation);
          }, 400);

          $homepageSlider.on("cellSelect", function () {
            if ($homepageSlider.is(":visible")) {
              var currentSlide = flkty.selectedIndex + 1;
              setTimeout(function () {
                $homepageSlider
                  .find(".caption-content")
                  .removeClass("animated " + settings.slideshowTextAnimation);
                $homepageSlider
                  .find(
                    ".gallery-cell:nth-child(" +
                      currentSlide +
                      ") .caption-content"
                  )
                  .addClass("animated " + settings.slideshowTextAnimation);
              }, 400);
            }
          });
        }
      }

      if ($homepageSlider.find(".gallery-cell").length > 1) {
        $homepageSlider.addClass("multi-image");
      } else {
        $homepageSlider.addClass("single-image");
      }

      $homepageSlider.find(".gallery-cell").each(function () {
        var buttonWidth = 0;
        $(this)
          .find(".action_button")
          .each(function () {
            $button = $(this);
            if ($(this).width() > buttonWidth) {
              buttonWidth = $(this).width();
            }
          });
        $(this).find(".action_button").width(buttonWidth);
      });
    });
  },
  unload: function ($target) {
    var $slider = $target.find(".js-homepage-slideshow");
    $slider.flickity("destroy");
  },
};

/*============================================================================
    Testimonial
  ==============================================================================*/

var testimonial = {
  init: function () {
    $(".js-testimonial").each(function (index, value) {
      var $testimonialSlider = $(this);
      var settings = {
        slideshowSpeed: $testimonialSlider.data("slideshow-speed") * 1000,
        slideshowTextAnimation: $testimonialSlider.data(
          "slideshow-text-animation"
        ),
      };

      if ($(".testimonial-image").length > 0) {
        $(".testimonial-block").each(function () {
          if ($(this).find(".testimonial-image").length == 0) {
            var theBlock = $(this).closest(".testimonial-block");
            $(theBlock).addClass("set-testimonial-height");
          }
        });
      }

      //initiate the slideshow
      if (!$testimonialSlider.hasClass("flickity-enabled")) {
        var arrowShow =
          $testimonialSlider.find(".gallery-cell").length === 1 ? false : true;
        $testimonialSlider.flickity({
          wrapAround: true,
          cellAlign: "left",
          imagesLoaded: true,
          prevNextButtons: arrowShow,
          draggable: arrowShow,
          pageDots: usePageDots,
          autoPlay: settings.slideshowSpeed,
          arrowShape: arrowSize,
        });

        if (settings.slideshowTextAnimation != "") {
          var flkty = $testimonialSlider.data("flickity");
          setTimeout(function () {
            $testimonialSlider
              .find(".gallery-cell:nth-child(1) .caption-content")
              .addClass("animated " + settings.slideshowTextAnimation);
          }, 400);

          $testimonialSlider.on("cellSelect", function () {
            if ($testimonialSlider.is(":visible")) {
              var currentSlide = flkty.selectedIndex + 1;
              setTimeout(function () {
                $testimonialSlider
                  .find(".caption-content")
                  .removeClass("animated " + settings.slideshowTextAnimation);
                $testimonialSlider
                  .find(
                    ".gallery-cell:nth-child(" +
                      currentSlide +
                      ") .caption-content"
                  )
                  .addClass("animated " + settings.slideshowTextAnimation);
              }, 400);
            }
          });
        }
      }

      if ($testimonialSlider.find(".gallery-cell").length > 1) {
        $testimonialSlider.addClass("multi-image");
      } else {
        $testimonialSlider.addClass("single-image");
      }

      $testimonialSlider.find(".gallery-cell").each(function () {
        var buttonWidth = 0;
        $(this)
          .find(".action_button")
          .each(function () {
            $button = $(this);
            if ($(this).width() > buttonWidth) {
              buttonWidth = $(this).width();
            }
          });
        $(this).find(".action_button").width(buttonWidth);
      });
    });
  },

  unload: function ($target) {
    var $slider = $target.find(".js-testimonial");

    $slider.flickity("destroy");
  },
};

/*============================================================================
    Gallery section
  ==============================================================================*/

var gallery = {
  init: function () {
    $(".gallery-horizontal")
      .find(".gallery-image-wrapper")
      .each(function () {
        var wrapper = $(this);
        var images = $(this).find("img");
        var imgWidth, imgHeight;

        $("<img />")
          .attr("src", $(images).attr("src"))
          .on("load", function () {
            imgWidth = this.width;
            imgHeight = this.height;

            $(wrapper).css("flex-basis", (imgWidth * 200) / imgHeight);
            $(wrapper).css("flex-grow", (imgWidth * 200) / imgHeight);
            $(wrapper)
              .find("i")
              .css("padding-bottom", (imgHeight / imgWidth) * 100 + "%");
          });
      });

    //initialize lightbox
    lightboxGallery.init();
  },
};

/*============================================================================
  Video section
==============================================================================*/

//check to see if HTML5 video is supported
var supports_video = function () {
  return !!document.createElement("video").canPlayType;
};

var videoSection = {
  init: function () {
    var $videoElement, settings;

    //Check for videos that are set to autoplay
    $(".homepage-video").each(function (index, value) {
      if ($(".homepage-video").length && supports_video()) {
        $videoElement = $(this);

        settings = videoSection.getVideoSettings($videoElement);

        if (
          (is_touch_device() &&
            $(window).width() <= 798 &&
            settings.posterImage === false) ||
          ($(window).width() <= 798 && settings.posterImage === false)
        ) {
          //add video element on small screens if there is no poster image
          videoSection.appendFrame($videoElement, settings);
        } else if (settings.autoPlayVideo && $(window).width() > 798) {
          //add video element when autoplay is true and it's on a larger screen
          videoSection.appendFrame($videoElement, settings);
        } else if (
          settings.autoPlayVideo === false &&
          settings.posterImage === false
        ) {
          //add video element when autoplay is false but there is no poster image
          videoSection.appendFrame($videoElement, settings);
        } else {
          //Show poster image on smaller sceens and when it exists
          $videoElement.find(".homepage-video__placeholder").show();
          $videoElement.find(".placeholder-svg--video").show();
        }
      }
    });

    //Attach event listener for videos
    $("body").on("click", ".video__play-button", function (e) {
      $videoElement = $(this).parents(".video-section").find(".homepage-video");
      $(this).fadeOut();
      settings = videoSection.getVideoSettings($videoElement);
      if (
        $videoElement.find(".mediaWrapper").length < 1 &&
        $videoElement.find("video").length < 1
      ) {
        videoSection.appendFrame($videoElement, settings);
      }
    });

    $("body").on("click", "[data-play-video]", function (e) {
      $videoElement = $(this).parents(".video-section").find(".homepage-video");
      $(this).fadeOut();
      settings = videoSection.getVideoSettings($videoElement);
      if (
        $videoElement.find(".mediaWrapper").length < 1 &&
        $videoElement.find("video").length < 1
      ) {
        videoSection.appendFrame($videoElement, settings);
      }
    });
  },
  getVideoSettings: function ($videoElement) {
    var settings = {
      container: $videoElement.find(".homepage-video"),
      header: $videoElement.find(".homepage-video--media"),
      posterImage: $videoElement.data("poster-image"),
      videoText: $videoElement.find(".homepage-video--media .caption"),
      videoTrigger: $videoElement.find("[data-play-video]"),
      autoPlayVideo: $videoElement.data("autoplay"),
      displayTextOverVideo: $videoElement.data("display-text-over-video"),
      autoloop: $videoElement.data("autoloop"),
      id: $videoElement.attr("data-video-src"),
      aspectRatio: $videoElement.attr("data-aspect-ratio").split(":"),
      provider: $videoElement.attr("data-provider").toLowerCase(),
      videoMP4: $videoElement.attr("data-video-mp4"),
      videoOGV: $videoElement.attr("data-video-ogv"),
    };
    return settings;
  },
  createFrame: function (settings) {
    var autoloop,
      controls,
      html,
      autoplay,
      poster = "";

    if (settings.provider === "youtube") {
      if (settings.autoloop) {
        autoloop = "1&iv_load_policy=3&playlist=" + settings.id;
      } else {
        autoloop = 0;
      }

      if (settings.posterImage === false && settings.autoPlayVideo === false) {
        autoplay = 0;
      } else {
        autoplay = 1;
      }

      controls = 1;

      html =
        '<iframe src="//www.youtube.com/embed/' +
        settings.id +
        "?&autoplay=" +
        autoplay +
        "&loop=" +
        autoloop +
        '&rel=0&hd=1&showinfo=0&color=white&controls=0" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
    } else if (settings.provider === "vimeo") {
      if (settings.posterImage === false && settings.autoPlayVideo === false) {
        autoplay = 0;
      } else {
        autoplay = 1;
      }

      if (settings.autoloop) {
        autoloop = 1;
      } else {
        autoloop = 0;
      }
      html =
        '<iframe src="//player.vimeo.com/video/' +
        settings.id +
        "?loop=" +
        autoloop +
        "&amp;title=0&amp;byline=0&amp;portrait=0&amp;color=3d96d2&autoplay=" +
        autoplay +
        '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
    } else if (settings.provider === "html5") {
      if (settings.posterImage !== false) {
        poster = ' poster="https://' + settings.posterImage;
      }

      if (
        settings.posterImage === false &&
        settings.autoPlayVideo === false &&
        is_touch_device() === 0
      ) {
        autoplay = " ";
      } else if (settings.autoPlayVideo && settings.posterImage !== false) {
        poster = ' poster="https://' + settings.posterImage;
        autoplay = " autoplay ";
      } else {
        autoplay = " autoplay ";
      }

      if (settings.autoloop) {
        autoloop = ' loop="loop" ';
      }

      controls = "";

      html =
        "<video " +
        controls +
        autoplay +
        autoloop +
        poster +
        ' id="video" onclick="this.paused?this.play():this.pause();" ><source src="' +
        settings.videoMP4 +
        '" type="video/mp4"><source src="' +
        settings.videoOGV +
        '" type="video/ogg" ></video>';
    }
    return html;
  },
  appendFrame: function ($videoElement, settings) {
    var mediaWrapper;

    if (settings.displayTextOverVideo === false) {
      settings.videoText.fadeOut();
    }

    $videoElement.find(".video__play-button").fadeOut();

    $videoElement.append(videoSection.createFrame(settings));

    if (settings.provider != "html5") {
      var paddingBottomValue =
        (settings.aspectRatio[1] / settings.aspectRatio[0]) * 100 + "%";

      $videoElement.find("iframe").mediaWrapper({
        intrinsic: false,
        baseWidth: settings.aspectRatio[0],
        baseHeight: settings.aspectRatio[1],
      });

      $videoElement.css({
        height: 0,
        paddingBottom: paddingBottomValue,
      });
    } else {
      $videoElement.find(".homepage-video__image").hide();
    }
  },
  unload: function ($target) {
    $target.find("[data-play-video]").off("click");
  },
};

var cart = {
  init: function () {
    if ($("#cart_form .tos_agree").length) {
      //Terms of service on cart page
      $("body").on("click", "#cart_form input[type='submit']", function () {
        if ($(this).parents("form").find(".tos_agree").is(":checked")) {
          $(this).submit();
        } else {
          var warning =
            '<p class="warning animated bounceIn">' +
            "You must agree with the terms and conditions to checkout." +
            "</p>";
          if ($("p.warning").length == 0) {
            $(this).before(warning);
          }
          return false;
        }
      });
    }
  },
};

/*============================================================================
  Product page
==============================================================================*/

$("body").on("click touchstart", "#notify_me", function (e) {
  //   console.log(
  //     $(".bis-button.BIS_trigger").data("variant-id"),
  //     $(".bis-button.BIS_trigger")
  //   );
  var variant_id = $("#notify_me").attr("data-variant-id");
  try {
    if (BISPopover) {
      if (typeof BISPopover.show === "function") {
        BISPopover.show({ variantId: variant_id });
      }
    }
  } catch (ex) {}
});

selectCallback = function (variant, selector) {
  window.variant_metafield.map(function (match) {
    if (match.id == variant.id) {
      // console.log(match.description)
      $(".meta-description").empty();
      $(".meta-description").append(match.description);
    }
  });
  var $product = $(".product-" + selector.product.id);
  //   console.log("product", $product);
  var $notify_form = $(".notify-form-" + selector.product.id);
  var $productForm = $("form.product_form", $product);
  var variantInventory = $productForm.data("variant-inventory");

  //   console.log($product)
  var prodJson = $.parseJSON($productForm.attr("data-product"));

  //Image Variant feature
  if (variant && variant.featured_image && $product.is(":visible")) {
    var $sliders = $(".product_gallery", $product);
    $sliders.each(function () {
      var $slider = $(this);
      var $sliderInstance = Flickity.data(this);
      if ($slider.is(":visible") && $sliderInstance != undefined) {
        var index = $(
          '[data-image-id="' + variant.featured_image.id + '"]'
        ).data("index");
        $sliderInstance.select(index, false, true);
      }
    });
  }

  //   console.log($product,variant.featured_image.src);
  //   console.log()
  if ($(".collection-template-section").length > 0) {
    if (variant) {
      $(
        ".image__container:not(.secondary_image_container) img",
        $product.parents(".thumbnail")
      )
        .attr("src", variant.featured_image.src)
        .attr("srcset", variant.featured_image.src);
      // console.log(variant.featured_image.src)
      var product_url = $(
        ".product-info__caption",
        $product.parents(".thumbnail")
      ).attr("data-url");

      var $price_ele = $(
        "span.price span.current_money",
        $product.parents(".thumbnail")
      );
      // console.log($price_ele.parent())
      if(variant.compare_at_price){
        if(variant.compare_at_price>variant.price){
          $price_ele.parent().addClass('sale');
        }
        else{
          $price_ele.parent().removeClass('sale');
        }
      }
      else{
        $price_ele.parent().removeClass('sale');
      }
      product_url = product_url + `?variant=${variant.id}`;
      // console.log(product_url)
      $.each(
        $(".js-product-link", $product.parents(".thumbnail")),
        function (index, ele) {
          $(ele).attr("href", product_url);
        }
      );
      // $('.product-info__caption',$product.parents('.thumbnail')).attr('href',product_url)
      if (variant.price > 0) {
        $price_ele
          .empty()
          .html(
            '<span class="visually-hidden">final product price: '+variant.price/100+' dollars </span> <span class="money" aria-hidden="true">' +
              Shopify.formatMoney(variant.price, window.shop_money_format) +
              "</span>"
          );
        
        var $was_price = $(
          "span.price span.was-money",
          $product.parents(".thumbnail")
        );
        if(variant.compare_at_price > variant.price){
          // console.log('was current ',variant.compare_at_price);
          $was_price.show();
          $was_price
          .empty()
          .html(
            '<span class="visually-hidden">original product price; '+variant.compare_at_price/100+' dollars </span> <span class="money" aria-hidden="true">' +
              Shopify.formatMoney(
                variant.compare_at_price,
                window.shop_money_format
              ) +
              "</span>"
          );  
        }
        else{
          $was_price.hide();
          // console.log('was is 0',$was_price)
        }
        
      } else {
        $price_ele.empty().html("Free");
      }
    }
  }
  if ($("body").hasClass("product")) {
    var color_tag = $.grep(window.variant_metadata, function (n, i) {
      return n.color == variant.title;
    });
  } else {
    var color_tag = [];
  }
  $('.price-varies-ele',$product).addClass('hidden');
  // console.log('variant',variant)

  if (variant) {
    $('.plp-price-varies-ele',$product.parents(".thumbnail")).addClass('hidden');
    //     console.log(prodJson)
    var prod_url = "/products/" + prodJson.handle + "?variant=" + variant.id;
    $(".plp-pre-order-link", $product).attr("href", prod_url).hide();
    if (variantInventory) {
      // console.log('variantInventory',variantInventory)
      variantInventory.forEach(function (v) {
        if (v.id === variant.id) {
          variant.inventory_quantity = v.inventory_quantity;
          variant.inventory_management = v.inventory_management;
          variant.inventory_policy = v.inventory_policy;
        }
      });
    }

    // console.log(variant)
    if (variant.inventory_quantity > 0) {
      $(".custom-field__expected-ship-date .custom-field--value").empty();
      $(".custom-field__expected-ship-date").addClass("hidden");
    } else {
      if (color_tag.length > 0) {
        $(".custom-field__expected-ship-date .custom-field--value")
          .empty()
          .text(color_tag[0].expected_ship_date);
        $(".custom-field__expected-ship-date").removeClass("hidden");
      } else {
        $(".custom-field__expected-ship-date .custom-field--value").empty();
        $(".custom-field__expected-ship-date").addClass("hidden");
      }
    }

    $(".sku span", $product).text(variant.sku);

    var thumb_badge_class = $(".js-product-page-gallery").data(
      "thumbnail-badge"
    );
    var soon_thumb_badge_class = $(".js-product-page-gallery").data(
      "soon-thumbnail-badge"
    );
    //     console.log(org_class)
    if (variant.sku == "coming-soon") {
      $(".thumbnail_banner", $product).attr(
        "class",
        "thumbnail_banner " + soon_thumb_badge_class
      );
    } else {
      $(".thumbnail_banner", $product).attr(
        "class",
        "thumbnail_banner " + thumb_badge_class
      );
    }

    $(".notify_form_message", $product).attr(
      "value",
      $(".notify_form_message", $product).data("body") + " - " + variant.title
    );

    // console.log('variant' , variant)
    var image_alt = variant.option1;
    //     if(image_alt.indexOf("/")>=0){
    //       image_alt = variant.title.split("/")[1].trim();
    //     }
    //     console.log(image_alt,image_alt.length)

    var has_variant_url = Shopify.urlParam("variant") ? true : false;
    if (has_variant_url == false) {
      var variants = $.parseJSON($productForm.attr("data-product")).variants;
      image_alt = variant.option1;
      //       console.log(variants)
    } else {
      image_alt = variant.option1;
    }
    var varJson = $.parseJSON($productForm.attr("data-product")).variants;
    var sortedPriceVars = [];
    var priceVaries = $productForm.attr('data-price-varies');
    sortedPriceVars.push(variant);
    if(varJson){
      sortedPriceVars = varJson.sort((a, b) => {
          if (a.price < b.price) {
            return -1;
          }
        });
    }
    image_alt = variant.title;
    // console.log(variant, image_alt);
    if ($(".product_gallery_nav").hasClass("iphone-img-slider")) {
      //iPhone PDP gallery slider
      // var iPhone_slider = $(".iphone-img-slider");
      // // console.log("non-magsafe");
      // iPhone_slider
      //   .slick("slickUnfilter")
      //   .slick(
      //     "slickFilter",
      //     `.iphone-image-slide[data-${slugify(
      //       image_alt
      //     )}*="${image_alt}"], .iphone-image-slide[data-device="generic"], .iphone-image-slide[data-media-type="video"], .iphone-image-slide[data-media-type="external_video"]`
      //   )
      //   .slick("slickGoTo", 0);

      // //normal gallery slider
      // $(".iphone_product_gallery")
      //   .slick("slickUnfilter")
      //   .slick(
      //     "slickFilter",
      //     `.gallery-cell[data-${slugify(
      //       image_alt
      //     )}="${image_alt}"], .gallery-cell[data-device="generic"], .gallery-cell[data-media-type="video"],.gallery-cell[data-media-type="external_video"]`
      //   )
      //   .slick("slickGoTo", 0);
      
      // function slugify(str) {
      //     return String(str).toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '');
      //   }
        function slugify(text) {
          return text
            .toString()
            .toLowerCase()
            .replace(/\s+/g, "-") // Replace spaces with -
            .replace(/[^\w\-]+/g, "-") // Remove all non-word chars
            .replace(/\-\-+/g, "-") // Replace multiple - with single -
            .replace(/^-+/, "") // Trim - from start of text
            .replace(/-+$/, ""); // Trim - from end of text
        }
        
  function filterGalleryByAltDynamic(image_alt, type = 'main') {
      if (!image_alt) return;

      const slug = slugify(image_alt);
      let $slider, slideSelector, filterSelectors;

      if (type === 'thumb' || type === 'iphone') {
        $slider = $(".iphone-img-slider");
        slideSelector = '.iphone-image-slide';
        filterSelectors = [
          `${slideSelector}[data-${slug}*="${image_alt}"]`,
          `${slideSelector}[data-device="generic"]`,
          `${slideSelector}[data-media-type="video"]`,
          `${slideSelector}[data-media-type="external_video"]`
        ];
      } else {
        $slider = $(".iphone_product_gallery");
        slideSelector = '.gallery-cell';
        filterSelectors = [
          `${slideSelector}[data-${slug}="${image_alt}"]`,
          `${slideSelector}[data-device="generic"]`,
          `${slideSelector}[data-media-type="video"]`,
          `${slideSelector}[data-media-type="external_video"]`
        ];
      }

      if (!$slider.hasClass('slick-initialized')) return;

      const slickObj = $slider.slick('getSlick');

      // ✅ Step 1: Force rebuild the full slide set before filtering
      const originalSlides = slickObj.$sliderCloneCache || slickObj.$slides.clone(true, true);
      slickObj.$sliderCloneCache = originalSlides; // persist for future calls

      // Detach everything and reappend original slides
      slickObj.unload();
      slickObj.$slideTrack.children().remove();
      slickObj.$sliderCloneCache.clone(true, true).appendTo(slickObj.$slideTrack);
      slickObj.reinit();

      // ✅ Step 2: Apply the filter safely
      $slider.slick('slickFilter', function () {
        const $slide = $(this);
        const $cell = $slide.find(slideSelector);
        let matched = false;

        // Dynamic match
        $.each($cell.data(), function (key, val) {
          if (slugify(String(val)) === slugify(image_alt)) {
            matched = true;
            return false;
          }
        });

        // Fallback selector logic
        if (!matched && $cell.is(filterSelectors.join(','))) matched = true;

        return matched;
      });

      // ✅ Step 3: ADA-friendly UI reset
      $slider.slick('setPosition');
      $slider.slick('slickGoTo', 0);

      // Debug info
      // console.log('%cFilter Applied:', 'color:#09f', {
      //   image_alt,
      //   slug,
      //   totalSlides: $slider.find('.slick-slide').length
      // });
  }


      


       filterGalleryByAltDynamic(image_alt,"main");
      // //  if(window.innerWidth >= 768){
        filterGalleryByAltDynamic(image_alt,'thumb');
      //  }
    }

    //     console.log("BIS_trigger on PLP",$(".BIS_trigger", $product))
    $(".plp-product-section a.BIS_trigger", $product).hide();
    $(".addtocart-btn-col", $product).show();
    $(".BIS_trigger", $product).attr("data-variant-id", variant.id);
    $("#BIS_trigger", $product).attr("data-variant-id", variant.id);
    $(".notify-me").attr("data-variant-id", variant.id);
    $(".plp-soldout-ele", $product).remove();

    if (variant.price < variant.compare_at_price) {
      $('.price-varies-ele',$product).addClass('hidden');
      $('.plp-price-varies-ele',$product.parents(".thumbnail")).addClass('hidden');
      // console.log(
      //   "variant is on sale",
      //   variant.price,
      //   variant.compare_at_price
      // );

      var originalprice = Shopify.formatMoney(
        variant.compare_at_price,
        $productForm.data("money-format")
      );

      $(".was_price", $product).html(
        '<span class="visually-hidden">original product price; '+variant.compare_at_price/100+' dollars </span><span class="money" aria-hidden="true">' + originalprice +"</span>"
      );
      $(".savings .price-percent-off", $product).html(
        "(" +
          parseInt(
            ((variant.compare_at_price - variant.price) * 100) /
              variant.compare_at_price
          ) +
          "% off)"
      );
    } else {
      // console.log("1145");
      $(".was_price", $product).html("");
      $(".savings", $product).html("");
    }

    if (variant.price > 0) {
      if(Shopify.urlParam("variant")!= null){
        $('.price-varies-ele',$product).addClass('hidden');
        // $('.plp-price-varies-ele',$product.parents(".thumbnail")).addClass('hidden');
          $(".current_price", $product).html(
            '<span class="visually-hidden">final product price; '+variant.price/100+' dollars </span><span class="money">' +
              Shopify.formatMoney(
                variant.price,
                $productForm.data("money-format")
              ) +
              "</span>"
          );
      }
      else{
        setTimeout(()=>{
            if(Shopify.urlParam("variant") == null && (priceVaries==true || priceVaries=='true')){
            $('.price-varies-ele',$product).removeClass('hidden');
              // $('.plp-price-varies-ele',$product.parents(".thumbnail")).removeClass('hidden');
            $(".current_price", $product).html(
              '<span class="money">' +
                Shopify.formatMoney(
                  sortedPriceVars[0].price,
                  $productForm.data("money-format")
                ) +
                "</span>"
            );
          }
          else{
            $('.price-varies-ele',$product).addClass('hidden');
            // $('.plp-price-varies-ele',$product.parents(".thumbnail")).addClass('hidden');
            $(".current_price", $product).html(
              '<span class="visually-hidden">Final product price:'+variant.price/100+' dollars</span><span class="money" aria-hidden="true">' +
                Shopify.formatMoney(
                  variant.price,
                  $productForm.data("money-format")
                ) +
                "</span>"
            );
          }
        },50);
      }
      
    } else {
      $('.price-varies-ele',$product).addClass('hidden');
      // $('.plp-price-varies-ele',$product.parents(".thumbnail")).addClass('hidden');
      $(".current_price", $product).html("Free");
    }
    if (variant && variant.available == true) {
      $("#BIS_trigger").hide();

      if (variant.inventory_management && variant.inventory_quantity > 0) {
      } else {
        $(".items_left", $product).text("");
        $(".quantity", $product).removeAttr("max");
      }

      $(".sold_out", $product).text("");

      //     console.log($('.add_to_cart', $product).data('label'))

      if (variant.sku == "coming-soon") {
        $(".sold_out", $product).text("Coming Soon");
        $(".add_to_cart", $product)
          .show()
          .addClass("disabled")
          .attr("disabled", "disabled")
          .find("span")
          .text("Coming Soon");
        $("#BIS_trigger").attr("data-variant-id", variant.id).hide();
      } else if (
        (prodJson.tags.indexOf("pre-order") >= 0 ||
          prodJson.tags.indexOf("spo-enabled") >= 0) &&
        variant.inventory_policy == "continue"
      ) {
        $(".plp-pre-order-link", $product)
          .attr("href", prod_url)
          .css({ display: "block" });
        //         console.log(variant)
        $(".add_to_cart", $product)
          .hide()
          .removeClass("disabled")
          .removeAttr("disabled")
          .find("span")
          .text("PRE-ORDER");
        $("#BIS_trigger").attr("data-variant-id", variant.id).show();
      } else {
        $("#BIS_trigger").attr("data-variant-id", variant.id).hide();
        $(".add_to_cart", $product)
          .show()
          .removeClass("disabled")
          .removeAttr("disabled")
          .find("span")
          .text($(".add_to_cart", $product).data("label"));
      }

      //     $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span').text($('.add_to_cart', $product).data('label'));
      $notify_form.hide();
      $(".soldout-badge").hide();
    } else {
      $("#BIS_trigger").hide();
      //       $("#BIS_trigger").show();
      //     console.log($('#BIS_trigger'),variant.id)
      var message = variant ? "Coming Soon" : "Unavailable";
      //     console.log(message)
      //     $(".was_price", $product).text("");
      $(".savings", $product).text("");
      //     $("span.money", $product).text("");
      //     $(".current_price", $product).text("");
      $(".items_left", $product).text("");
      $(".quantity", $product).removeAttr("max");
      if (variant.sku == "coming-soon") {
        $(".sold_out", $product).text("Coming Soon");
        $(".add_to_cart", $product)
          .show()
          .addClass("disabled")
          .attr("disabled", "disabled")
          .find("span")
          .text("Coming Soon");
      } else {
        if (
          $("body").hasClass("collection-alt-iphone") == true ||
          $("body").hasClass("collection") == true
        ) {
          $notify_form.fadeIn();
          $(".addtocart-btn-col", $product).hide();
          $(".plp-product-section a.BIS_trigger", $product).css({
            display: "block",
          });
          //           $('.select',$product).before($('<span class="plp-soldout-ele"></span>').text('SOLD OUT'));
        } else {
          $(".sold_out", $product).text(message);
          $(".add_to_cart", $product)
            .show()
            .addClass("disabled")
            .attr("disabled", "disabled")
            .find("span")
            .text(message);
        }
      }
      if (variant) {
        $notify_form.fadeIn();
        $(".soldout-badge").hide();
      }
    }
  }
};

var productPage = {
  init: function () {
    var draggable = true;
    var prevNextButtons = true;

    setTimeout(function () {
      imageFunctions.linkGalleryAndCarousel(
        $(".js-product-page-gallery .product_gallery"),
        $(".js-product-page-gallery .product_gallery_nav")
      );
    }, 1000);
    imageFunctions.zoom(".product_gallery", false);

    //       setTimeout(function(){
    //         imageFunctions.linkGalleryAndCarousel($('.js-product-page-gallery .product_gallery'), $('.js-product-page-gallery .product_gallery_nav_mobile'));
    //       }, 1000);

    if ($(".js-full-width-product-images").length) {
      imageFunctions.fullWidth(
        ".product-template .product .description img",
        ".js-full-width-product-images"
      );
    }

    if ($(".product_gallery").hasClass("single-image")) {
      draggable = false;
      prevNextButtons = false;
    }

    //detect autoplay settings
    var autoplay = $(".product_gallery").data("autoplay");

    var autoplay2 = $(".product_gallery_mobile").data("autoplay");
    //initialize lightbox
    //     lightboxGallery.init();

    $(".product_gallery").flickity({
      wrapAround: "true",
      cellAlign: "left",
      draggable: draggable,
      contain: true,
      imagesLoaded: true,
      lazyLoad: 2,
      pageDots: usePageDots,
      prevNextButtons: prevNextButtons,
      autoPlay: autoplay ? 6000 : false,
      selectedAttraction: 0.01,
      friction: 0.15,
      arrowShape: arrowSize,
      dots: true,
    });

    $(".iphone_product_gallery").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: false,
      prevArrow:
        '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
      nextArrow:
        '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
      fade: true,
      asNavFor: ".iphone-img-slider",
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            centerMode: true,
            centerPadding: "50px",
            slidesToShow: 1,
            dots: true,
          },
        },
      ],
    });

    if ($(".product_gallery_nav").hasClass("iphone-img-slider")) {
      var iPhone_slider = $(".iphone-img-slider").slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 2,
        useTransform: false,
        asNavFor: ".iphone_product_gallery",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 2,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 2,
              infinite: true,
              dots: true,
            },
          },
        ],
      });

 
      $("body").on("click", ".iphone-image-slide", function () {
        //           var index = $(this).find('img').data('index');
        var index = $(this).parents('.slick-slide').index();
                  // console.log('index',$(this).parents('.slick-slide').index(),'parent',$(this).parents('.slick-slide'))
        $(".iphone_product_gallery").slick("slickGoTo", index);
      });
    }

    /* Poroduct Gallery for mobile*/
    //        $('.product_gallery_mobile').flickity({
    //         "wrapAround": "true",
    //         "cellAlign": "left",
    //         "draggable": draggable,
    //         "contain": true,
    //         "imagesLoaded": true,
    //         "lazyLoad": 2,
    //         "pageDots": usePageDots,
    //         "prevNextButtons": prevNextButtons,
    //         "autoPlay": autoplay2 ? 6000 : false,
    //         "selectedAttraction": 0.01,
    //         "friction": 0.15,
    //         "arrowShape": arrowSize
    //       });

    $(".js-product_section .product_form_options").each(function () {
      new Shopify.OptionSelectors($(this).data("select-id"), {
        product: $(this).data("product"),
        onVariantSelected: selectCallback,
        enableHistoryState: $(this).data("enable-state"),
      });
    });

    var $notify_form = $(".notify_form .contact-form");
    $notify_form.each(function () {
      var $nf = $(this);
      $nf.on("submit", function (e) {
        if ($('input[name="challenge"]', $nf).val() !== "true") {
          $.ajax({
            type: $nf.attr("method"),
            url: $nf.attr("action"),
            data: $nf.serialize(),
            success: function (data) {
              $nf.fadeOut("slow", function () {
                $nf
                  .prev(".message")
                  .html(
                    "Thanks! We will notify you when this product becomes available!"
                  );
              });
            },
            error: function (data) {
              $('input[name="challenge"]', $nf).val("true");
              $nf.submit();
            },
          });
          e.preventDefault();
        }
      });
    });
  },
  relatedProducts: function () {
    $(".js-related-products-slider .products-slider").each(function (
      index,
      value
    ) {
      var products_per_slide = $(this).data("products-per-slide");
      var products_limit = $(this).data("products-limit");
      var products_available = $(this).data("products-available");
      var cellAlign, draggable, prevNext, wrapAround, initialIndex;

      if (
        (products_per_slide == "2" &&
          products_available > products_per_slide &&
          products_limit > products_per_slide) ||
        (products_per_slide == "4" &&
          products_available > products_per_slide &&
          products_limit > products_per_slide) ||
        (products_per_slide == "6" &&
          products_available > products_per_slide &&
          products_limit > products_per_slide)
      ) {
        cellAlign = "left";
      } else {
        cellAlign = "center";
      }

      if (
        products_available > products_per_slide &&
        products_limit > products_per_slide
      ) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      if (
        (products_per_slide == "2" &&
          products_available > products_per_slide) ||
        (products_per_slide == "4" &&
          products_available > products_per_slide) ||
        (products_per_slide == "6" && products_available > products_per_slide)
      ) {
        initialIndex = 0;
      } else if (products_per_slide == "3" && products_available) {
        initialIndex = 1;
      } else if (products_per_slide == "5" && products_available) {
        initialIndex = 2;
      } else if (products_per_slide == "7" && products_available) {
        initialIndex = 3;
      }

      if ($(window).width() <= 798) {
        cellAlign = "center";
        draggable = true;
        prevNext = true;
        wrapAround = true;
        initialIndex = 1;

        $(this).parents(".even-num-slides").removeClass("even-num-slides");
      }

      $(this).flickity({
        lazyLoad: 2,
        imagesLoaded: true,
        draggable: true,
        cellAlign: cellAlign,
        prevNextButtons: true,
        wrapAround: wrapAround,
        pageDots: usePageDots,
        contain: true,
        freeScroll: true,
        arrowShape: arrowSize,
        initialIndex: initialIndex,
      });
    });
  },

  initializeQuantityBox: function () {
    $("body").on("click", ".js-change-quantity", function () {
      var $this = $(this),
        $input = $(this).siblings("input"),
        val = parseInt($input.val()),
        valMax = 100000000000000000000000000000,
        valMin = $input.attr("min") || 0;

      if ($input.attr("max") != null) {
        valMax = $input.attr("max");
      }

      if (isNaN(val) || val < valMin) {
        $input.val(valMin);
        return false;
      } else if (val > valMax) {
        $input.val(valMax);
        return false;
      }

      if ($this.data("func") == "remove") {
        alert($this.data("func"));
        $this.closest(".cart_item").addClass("animated fadeOutUp");
      }
      if ($this.data("func") == "plus") {
        if (val < valMax) $input.val(val + 1);
      } else {
        if (val > valMin) $input.val(val - 1);
        if ($this.parents(".cart_item").length) {
          if (val - 1 == 0) {
            $this.closest(".cart_item").addClass("animated fadeOutUp");
          }
        }
      }
      $input.trigger("change");
    });
  },
  unload: function ($target) {
    var $slider = $target.find(".products-slider");
    $slider.flickity("destroy");
  },
};

/*============================================================================
  Newsletter Popup
==============================================================================*/

var newsletter_popup = {
  init: function () {
    var popup = Cookies.get("popup");
    var cookie_enabled = true;

    if (cookie_enabled && popup == "open") {
      return false;
    } else {
      newsletter_popup.open();
    }
    if (cookie_enabled) {
      Cookies.set("popup", "open", { expires: 14 });
    }
  },
  open: function () {
    if (false || $(window).width() > 798) {
      setTimeout(function () {
        $("[data-remodal-id=newsletter]").remodal().open();
      }, 0 * 1000);
    }
  },
};

/*============================================================================
  Header section
==============================================================================*/

var header = {
  init: function () {
    if ($(".promo_banner").length) {
      var promo_banner = Cookies.get("promo_banner");

      if (promo_banner != "dismiss") {
        $("body").addClass("promo_banner-show");
        $(".promo_banner").on("click", ".promo_banner-close", function () {
          $("body").removeClass("promo_banner-show");
          Cookies.set("promo_banner", "dismiss", { expires: 30 });
        });
      }
    }

    //offscreen check for menu
    $(".vertical-menu_submenu, .vertical-menu_sub-submenu").each(function () {
      if ($(this).is(":off-right")) {
        $(this).addClass("vertical-menu--align-right");
      }
    });

    //Only apply on larger screen sizes
    if ($(window).width() > 798) {
      if ($(".header").hasClass("header-fixed--true")) {
        if (!$(".main_nav_wrapper").hasClass("sticky_nav")) {
          var sticky_nav = new Headhesive(".main_nav_wrapper", {
            offset: 700,
            throttle: 300,
            classes: {
              clone: "sticky_nav",
              stick: "sticky_nav--stick",
              unstick: "sticky_nav--unstick",
            },
            onInit: function () {
              $(".sticky_nav .secondary_logo").hide();
              $(".sticky_nav .primary_logo").show();
              $(".sticky_nav .icon-search").show();
              $(".sticky_nav .search_container").hide();
              $(".sticky_nav .nav:last").prepend(
                $(".header .cart_container").clone()
              );

              var sticky_nav_height = $(".sticky_nav").height() + 5;

              $(".sticky_nav .mini_cart").css(
                "height",
                $(".sticky_nav").height() + 5
              );
              $(".sticky_nav .cart_content").css(
                "top",
                $(".sticky_nav").height()
              );
            },
            onUnstick: function () {
              $(".cart_container").removeClass("active_link");
            },
          });
        }
      } else {
        $(".header-fixed--true").removeClass("header-fixed--true");
        if ($(".main_nav_wrapper").length > 1) {
          $(".main_nav_wrapper").first().remove();
        }
      }

      if ($("img.primary_logo:visible")) {
        $(".logo img", $(".feature_image .header")).attr(
          "src",
          $(".logo img").data("src-home")
        );
      } else {
        $(".logo img").attr("src", $(".logo img").data("src"));
      }
    } else {
      if ($("#header").hasClass("mobile_nav-fixed--true")) {
        $("body").addClass("mobile_nav-fixed--true");
      } else {
        $("body").addClass("mobile_nav-fixed--false");
      }
    }

    //     $('#header .cart_container').append($('.cart_content').clone());

    if ($(window).width() <= 798) {
      $(".dropdown_link").attr("data-no-instant", true);

      $("body").on("click", ".dropdown_link", function (e) {
        $(".nav a").removeClass("active_link");
        if ($("#header").is(":visible")) {
          var $dropdown = $(this)
            .parents("#header")
            .find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]');
          if (!$(this).hasClass("mini_cart")) {
            $(".cart_container").removeClass("active_link");
          }
        } else {
          if ($(this).hasClass("icon-search")) {
            window.location = $(this).attr("href");
            return false;
          }
          var $dropdown = $(this)
            .parents(".main_nav")
            .find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]');
        }
        //         if ($dropdown.is(':visible') || $dropdown.attr('class') === undefined) {

        //           $('div.dropdown.dropdown-slide').removeClass('translate-zero');
        //           $dropdown.hide();
        //           $('body').removeClass('is-active');
        //         } else {
        // //
        //           if(!$(this).hasClass('cart_container')) {
        //             $('.is-absolute').parent().removeClass('feature_image');
        //           }
        //           $('div.dropdown.dropdown-slide').addClass('translate-zero');
        //           $dropdown.show();

        //           $('body').addClass('is-active');
        //           $('.mobile_nav').find('div').removeClass('open');
        //         }

        if ($dropdown.is(":visible")) {
          e.stopPropagation();
          return false;
        }
      });

      $("a.mobile_nav.dropdown_link").click(function () {        
        if($('.dropdown_container.mobile-search').hasClass('active')){
          $('.dropdown_container.mobile-search').removeClass('active');
          $('.mobile-search .search-terms').val('');
        }
        $("div.mobile-menu").css("display", "block");
        $("div.dropdown.dropdown-slide").toggleClass("translate-zero");
        $("body").toggleClass("blocked-scroll");
        $(
          ".dropdown_container.mobile-menu .dropdown_container.mega-menu.custom-submenu"
        ).removeClass("custom-translate-zero");
      });
      $("body").on("click", ".mobile_nav", function () {
        $(this).find("div").toggleClass("open");
      });

      var closeDropdown = function () {
        $("body").removeClass("is-active");
        $(".dropdown_link").removeClass("active_link");
        $(".dropdown_container").hide();
        $(".mobile_nav").find("div").removeClass("open");
        $("body").removeClass("blocked-scroll");
      };

      var closeMiniCart = function () {
        $("body").removeClass("is-active");
        $(".dropdown_link").toggleClass("active_link");
        $(".cart_container").removeClass("active_link");
        $("body").removeClass("blocked-scroll");
      };

      var openMiniCart = function ($cart_container) {
        $(".mobile_nav div").removeClass("open");
        $(".dropdown_link").removeClass("active_link");
        $cart_container.addClass("active_link");
        //           $('body').removeClass('blocked-scroll');
      };

      //Click anywhere outside of dropdown to close
      //       $('html').on('click', function(event) {
      //         if (!$(event.target).closest('.cart_container').length && $('.cart_content').is(':visible')) {
      //           closeMiniCart();
      //         }

      //         if (!$(event.target).closest('.dropdown_container').length && $('.dropdown').is(':visible')) {
      //           closeDropdown();
      //         }
      //       });

      //Toggle mini-cart with menu icon
      //       $(".mini_cart").on("click", function(e) {
      //         var $cart_container = $(this).parent();
      //         if($cart_container.hasClass('active_link')) {
      //           closeMiniCart();
      //         } else {
      //           openMiniCart($cart_container);
      //         }

      //         if (is_touch_device() || $(window).width() <= 798) {
      //           e.preventDefault();
      //         }
      //       });

      $(".cart_content__continue-shopping").on("click", function (e) {
        closeMiniCart();
        $("body").removeClass("blocked-scroll");
      });
    } else {
      $(".nav a, .logo a")
        .not(".cart_content a")
        .on("mouseenter", function () {
          if (!$(this).hasClass("active_link")) {
            $(".dropdown_container").hide();
            $(".active_link").removeClass("active_link");
            $(".is-absolute").parent().addClass("feature_image");
          }
        });

      $(".main_nav, .top_bar, .cart_container").on("mouseleave", function () {
        $(".dropdown_container").hide();
        $(".active_link").removeClass("active_link");
        $(".is-absolute").parent().addClass("feature_image");
      });

      $(".dropdown_link, .dropdown_link--vertical").attr("data-click-count", 0);

      $(".dropdown_link").on("mouseover touchstart", function (e) {
        var $dropdown = $(this)
          .parents(".main_nav")
          .find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]');
        //               console.log($dropdown)
        var clickCount = $(this).attr("data-click-count");

        $(".active_link").removeClass("active_link");

        if (!$(this).hasClass("active_link")) {
          $dropdown.show();

          if ($(this).hasClass("mini_cart")) {
            $(this).parent(".cart_container").addClass("active_link");
          } else {
            $(this).addClass("active_link");
            $(".is-absolute").parent().removeClass("feature_image");
          }
        }

        //Enable touch on parent link if on touch device and desktop menu is visible
        if (is_touch_device()) {
          $(".dropdown_link").not(this).attr("data-click-count", 0);
          $(".dropdown_link").attr("data-no-instant", true);

          //capture touch event
          if (e.type == "touchstart") {
            clickCount++;
            $(this).attr("data-click-count", clickCount);

            if (clickCount < 2) {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
          }
        }
      });

      //Vertical menu enabled
      if ($(".dropdown_link--vertical").length) {
        $(".dropdown_link--vertical").on("mouseover", function (e) {
          var $dropdown = $(this)
            .parents(".main_nav")
            .find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]');
          var clickCount = $(this).attr("data-click-count");

          $(".active_link").removeClass("active_link");
          if (!$(this).hasClass("active_link")) {
            $(this).children("a").addClass("active_link");
            $(".is-absolute").parent().removeClass("feature_image");
          }
        });

        //Enable touch on parent link if on touch device and desktop menu is visible
        if (is_touch_device()) {
          $(".dropdown_link--vertical").on("touchstart", function (e) {
            var $dropdownMegaMenu = $(this)
              .parents(".main_nav")
              .find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]');
            var $dropdownVertical = $(this).next(".vertical-menu_submenu");
            var clickCount = $(this).attr("data-click-count");

            $(".dropdown_link--vertical").not(this).attr("data-click-count", 0);
            $(".dropdown_link--vertical").attr("data-no-instant", true);
            $(".dropdown_container").hide();

            $dropdownMegaMenu.show();
            $(".vertical-menu_submenu").removeClass("is-visible");
            $dropdownVertical.addClass("is-visible");

            //capture touch event
            if (e.type == "touchstart") {
              clickCount++;
              $(this).attr("data-click-count", clickCount);

              if (clickCount < 2) {
                e.preventDefault();
                e.stopPropagation();
                return false;
              }
            }
          });
        }
      }
    }
  },
  removeDataAttributes: function (target) {
    if ($(target).length) {
      var i,
        $target = $(target),
        attrName,
        dataAttrsToDelete = [],
        dataAttrs = $target.get(0).attributes,
        dataAttrsLen = dataAttrs.length;

      for (i = 0; i < dataAttrsLen; i++) {
        if ("data-" === dataAttrs[i].name.substring(0, 5)) {
          dataAttrsToDelete.push(dataAttrs[i].name);
        }
      }
      $.each(dataAttrsToDelete, function (index, attrName) {
        $target.removeAttr(attrName);
      });
    }
  },
  loadMegaMenu: function () {
    //Remove old mega-menus so that theme-editor works properly
    $(".sticky_nav .mega-menu").remove();
    $(".header .mega-menu").remove();

    //Clone the mega menu from section into sticky_nav
    $(".mega-menu-container .mega-menu")
      .clone()
      .appendTo(".sticky_nav .main_nav");
    //Remove theme-editor data-attributes
    header.removeDataAttributes(
      ".sticky_nav .mega-menu.dropdown_container .dropdown_column"
    );

    //Loop through mega-menus to add arrow to parent
    $(".mega-menu-container .mega-menu").each(function (index) {
      var megaMenuValue = $(this).data("dropdown");
      $('[data-dropdown-rel="' + megaMenuValue + '"]')
        .find("span")
        .remove();

      $('[data-dropdown-rel="' + megaMenuValue + '"]')
        .not(".icon-search")
        .append(' <span class="icon-down-arrow"></span>')
        .addClass("mega-menu-parent")
        .addClass("dropdown_link")
        .removeClass("top_link");

      $('[data-dropdown="' + megaMenuValue + '"]').each(function (index) {
        if (!$(this).hasClass("mega-menu")) {
          $(this).remove();
        }
      });

      $(this).clone().appendTo(".header .main_nav");
    });

    //Remove default mega menus if vertical menus are selected
    if ($(".dropdown_link--vertical").length) {
      $(
        ".dropdown_link--vertical.mega-menu-parent + .vertical-menu_submenu"
      ).remove();
      $(".dropdown_link--vertical:not(.mega-menu-parent)").each(function (
        index
      ) {
        var megaMenuValue = $(this).data("dropdown-rel");
        $('[data-dropdown="' + megaMenuValue + '"]').remove();
      });
    }

    $(".mega-menu-parent").on("mouseenter", function () {
      if (!$(this).hasClass("active_link")) {
        $(".dropdown_container").hide();
        $(this)
          .parents(".main_nav")
          .find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')
          .toggle();

        $(this).addClass("active_link");
        $(".is-absolute").parent().removeClass("feature_image");
      }
    });

    //Remove theme-editor data-attributes
    header.removeDataAttributes(
      ".header .mega-menu.dropdown_container .dropdown_column"
    );

    if (is_touch_device() || $(window).width() <= 798) {
      $(".dropdown_link").attr("data-no-instant", true);
    }

    // Custom Submegamenu
    //           $(".dropdown_container.mega-menu .dropdown_column").hover(function(){
    //             var submenu = $(this).find('.mega-menu__image-caption-link a[submegamenu]').attr("submegamenu");
    //             $('.main_nav .dropdown_container.mega-menu[data-dropdown="'+submenu+'"]').show();
    //           });
    //             $('.main_nav .dropdown_container.mega-menu[data-dropdown="'+submenu+'"]').show();
    //           $(".dropdown_container.mega-menu .dropdown_column").on('mouseleave',function(){
    //             var submenu = $(this).find('.mega-menu__image-caption-link a[submegamenu]').attr("submegamenu");
    //             $('.main_nav .dropdown_container.mega-menu[data-dropdown="'+submenu+'"]').hide();
    //           })

    header.loadMobileMegaMenu();
  },
  loadMobileMegaMenu: function () {
    //Loop through mega menus and add to mobile menu
    $(".mega-menu-container .mobile-mega-menu").each(function (index) {
      $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]')
        .find("span")
        .remove();
      $(
        '[data-mobile-dropdown-rel="' +
          $(this).data("mobile-dropdown") +
          '"] > a'
      )
        .append(' <span class="right icon-right-arrow"></span>')
        .attr("data-no-instant", "true");
      $(
        '[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]'
      ).addClass("mobile-mega-menu-parent sublink");
      $(
        '[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]'
      ).append(this);
      $(
        '[data-mobile-dropdown-rel="' +
          $(this).data("mobile-dropdown") +
          '"] > ul'
      ).each(function (index) {
        if (!$(this).hasClass("mobile-mega-menu")) {
          $(this).remove();
        }
      });
    });

    if (
      $(".main_nav_wrapper .dropdown_container.mega-menu").hasClass(
        "custom-submenu"
      )
    ) {
      var custom_submenu = $(
        ".main_nav_wrapper .dropdown_container.mega-menu.custom-submenu"
      ).clone();
      $(".dropdown_container.mobile-menu")
        .find(".dropdown.dropdown-slide")
        .after(custom_submenu);
      custom_submenu.addClass("dropdown-slide");
      var close_submenu = $("<div>")
        .attr({ class: "close-submenu" })
        .html('<span class="left icon-left-arrow"></span> Back');
      custom_submenu.find(".dropdown_content").before(close_submenu);
      $("body").on("click", ".close-submenu", function () {
        custom_submenu.removeClass("custom-translate-zero");
      });
      $(".mobile-mega-menu_block.custom-submenu a[submegamenu]").on(
        "click",
        function (e) {
          custom_submenu.addClass("custom-translate-zero");
          //               custom_submenu.show();
          return false;
        }
      );
    }
  },
  unloadMegaMenu: function () {
    $(".header .mega-menu").remove();
    $(".mega-menu-container .mega-menu").each(function (index) {
      var menuParent = $(this).data("dropdown");
      //       $('.mega-menu-parent[data-dropdown-rel="' + $(this).data("dropdown") + '"]').find('.icon-down-arrow').remove();
    });
  },
  unload: function () {
    $("body").off("click", ".mobile_nav");
    $("body").off("click", ".dropdown_link");
    $("html").off("click");
    $(".mini_cart").off("click");
    $(".cart_content__continue-shopping").off("click");
  },
};

/*============================================================================
  Load More Products
==============================================================================*/
function plpAtcButton(eles, label) {
  eles.each(function () {
    var selectId     = $(this).data("select-id");
    var $form        = $("#" + selectId).closest("form");
    var preorderMap  = $form.data("variantPreorder") || {};

    new Shopify.OptionSelectors(selectId, {
      product:            $(this).data("product"),
      enableHistoryState: $(this).data("enable-state"),
      onVariantSelected: function (variant, selector) {
        if(variant){
          // console.log('variant',variant)
          var $btnAdd      = $form.find(".add_to_cart");
          var $btnNotify   = $form.find(".BIS_trigger");
          var $btnPreorder = $form.find(".plp-pre-order-link");
          var isPreOrder   = Boolean(preorderMap[variant.id]);

          if (isPreOrder) {
            $btnAdd.hide();
            $btnNotify.hide();
            $btnPreorder.show();
          } else if (variant && variant.available) {
            $btnPreorder.hide();
            $btnNotify.css("display", "none");
            $btnAdd
              .show()
              .prop("disabled", false)
              .find("span.text").text("Add to Bag");
          } else {
            $btnAdd.hide();
            $btnPreorder.hide();
            $btnNotify.css("display", "block");
          }
        }
      }
    });
  });

  eles.each(function (indx, ele) {
    var current_collection = $(ele)
      .parents(".plp-product-section")
      .attr("data-collection")
      ? $(ele).parents(".plp-product-section").attr("data-collection")
      : false;
    if (current_collection) {
      current_collection = current_collection
        .replaceAll('-cases', '')
        .replaceAll('square®-', '');
    }

    var parent = $(ele);
    var label  = "Select a Model";

    if (current_collection != false) {
      if ($(".single-option-selector", parent).length > 0) {
        $(".single-option-selector:eq(0) option", parent).removeAttr("selected");

        var selected_index = $(
          ".single-option-selector:eq(0)" +
            ' option[data-key="' +
            current_collection +
            '"]',
          parent
        ).index();

        if (
          $(
            ".single-option-selector:eq(0)" +
              ' option[data-key="' +
              current_collection +
              '"]',
            parent
          ).length
        ) {
          $(".single-option-selector:eq(0) option", parent)
            .eq(selected_index)
            .prop("selected", true);
        } else {
          $(
            ".single-option-selector:eq(0) option[value*='Galaxy']:eq(0)",
            parent
          ).before(
            '<option value="" disabled selected="selected">' +
              label +
              "</option>"
          );
        }

        $(".add_to_cart", parent)
          .attr("disabled", "disabled")
          .find("span.text")
          .text("Add to Bag");
      }
    } else {
      if ($(".single-option-selector", parent).length > 0) {
        var t = $(".add_to_cart", parent).find("span.text").text();

        if (t.indexOf("Coming Soo") > -1) {
          $(".add_to_cart", parent)
            .attr("disabled", "disabled")
            .find("span.text")
            .text("Coming Soon");
        } else {
          if (
            $(
              ".single-option-selector:eq(0) option[value*='iPhone']:eq(0)",
              parent
            ).length
          ) {
            $(
              ".single-option-selector:eq(0) option[value*='iPhone']:eq(0)",
              parent
            ).before(
              '<option value="" disabled selected="selected">' +
                label +
                "</option>"
            );
          } else if (
            $(".single-option-selector:eq(0) option[value*='Pixel']:eq(0)", parent)
              .length
          ) {
            $(
              ".single-option-selector:eq(0) option[value*='Pixel']:eq(0)",
              parent
            ).before(
              '<option value="" disabled selected="selected">' +
                label +
                "</option>"
            );
          } else if (
            $(".single-option-selector:eq(0) option[value*='AirPods']:eq(0)", parent)
              .length
          ) {
            $(
              ".single-option-selector:eq(0) option[value*='AirPods']:eq(0)",
              parent
            ).before(
              '<option value="" disabled selected="selected">Select a Model </option>'
            );
          } else {
            $(
              ".single-option-selector:eq(0) option[value*='Galaxy']:eq(0)",
              parent
            ).before(
              '<option value="" disabled selected="selected">' +
                label +
                "</option>"
            );
          }

          $(".add_to_cart", parent)
            .attr("disabled", "disabled")
            .find("span.text")
            .text("Add to Bag");
        }
      }
    }
  });

  eles.each(function () {
    var selectId = $(this).data("select-id");
    var $form    = $("#" + selectId).closest("form");
    var $allNotifies = $form.find(".BIS_trigger");
    if ($allNotifies.length > 1) {
      $allNotifies.slice(1).remove();
    }
  });
}

var enableLoadMoreProducts = function () {
  $("body").on("click", ".js-load-more a", function (e) {
    enableInfiniteScroll();
    e.stopPropagation();
    return false;
  });
};

var enableInfiniteScroll = function () {
  var oldData = $(".plp-product-section .product_form_options");
  var infiniteScroll = new Waypoint.Infinite({
    element: $(".collection-matrix")[0],
    items: ".collection-matrix",
    more: ".load-more__btn",
    loadingClass: "loading-in-progress",
    onBeforePageLoad: function () {
      $(".js-load-more").hide();
    },
    onAfterPageLoad: function (data) {
      // var label =
      //   $(".selector-wrapper").length > 1
      //     ? "Select a Model"
      //     : "Select a Device";
      // var label = "Select a Model";
      // var new_eles = $(data).find(".product_form_options");
      plpAtcButton(new_eles, label);
    },
  });
};

/*============================================================================
  Filter Products with AJAX
==============================================================================*/

Shopify.queryParams = {};
if (location.search.length) {
  for (
    var aKeyValue, i = 0, aCouples = location.search.substr(1).split("&");
    i < aCouples.length;
    i++
  ) {
    aKeyValue = aCouples[i].split("=");
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] =
        decodeURIComponent(aKeyValue[1]);
    }
  }
}

var quickFilter = {
  init: function () {
    var selectedOptions = [],
      query = "",
      currentTags = "",
      siteUrl = "https://" + $("hostname"),
      url1 = $("1") ? "/" + $("1") + "/" : "",
      url2 = $("2") ? $("2") + "/" : "",
      url3 = $("3"),
      path = url1 + url2;

    //Handle dropdowns if they exist
    if ($("#sort-by").length) {
      query = $("#sort-by").val();
    } else {
      query = url("?sort_by");
    }

    if ($("#tag_filter").length) {
      if (
        $("#tag_filter").data("default-collection") != $("#tag_filter").val()
      ) {
        urlTag = $("#tag_filter")
          .val()
          .substr($("#tag_filter").val().lastIndexOf("/") + 1);

        if (urlTag != "all") {
          if ($.inArray(urlTag, selectedOptions) > -1) {
            //Do nothing
          } else {
            selectedOptions.unshift(urlTag);
          }
        }
      }
    }

    //Add all checkbox values to array
    $("[data-option-filter] input:checked").each(function () {
      selectedOptions.push($(this).val());
    });
    selectedOptions = $.makeArray(selectedOptions);

    //Loop through tags to create string to update page url
    $.each(selectedOptions, function (i, value) {
      if (i != selectedOptions.length - 1) {
        currentTags += selectedOptions[i] + "+";
      } else {
        currentTags += selectedOptions[i];
      }
    });

    Shopify.queryParams.sort_by = query;
    query = "?" + $.param(Shopify.queryParams);

    quickFilter.processUrl(path, currentTags, query);
  },
  updateView: function (filterURL) {
    $.ajax({
      type: "GET",
      url: filterURL,
      beforeSend: function () {
        $(".collection-matrix").addClass(
          "fadeOut animated loading-in-progress filter-loading"
        );
        Waypoint.destroyAll();
      },
      success: function (data) {
        $(".collection-matrix").removeClass("loading-in-progress");
        $(".collection-matrix").removeClass("filter-loading");
        var filteredBreadcrumb = $(data).find(".breadcrumb_text").html();
        $(".breadcrumb_text").html(filteredBreadcrumb);

        var filteredPagination = $(data).find(".paginate").html();
        $(".paginate").html(filteredPagination);

        var filteredSidebar = $(data).find(".sidebar").html();
        $(".sidebar").html(filteredSidebar);

        var filteredPageLinks = $(data).find(".paginate").html();
        $(".paginate").empty();
        $(".paginate").html(filteredPageLinks);

        var filteredData = $(data).find(".collection-matrix");
        $(".collection-matrix").remove();
        filteredData.insertBefore($(".load-more__icon"));

        window.history &&
          window.history.pushState &&
          window.history.pushState("", "", filterURL);

        if ($(".sidebar__collection-filter").length) {
          collectionSidebarFilter.init();
        }
      },
      error: function (x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + "//" + location.host + filterURL);
      },
      dataType: "html",
    });
  },
  processUrl: function (path, tags, query) {
    var query = query.replace(/\page=(\w+)&/, ""),
      urlString = "";

    urlString = path + tags + query;

    quickFilter.updateView(urlString);
  },
};

$("#sort-by").val($("#sort-by").data("default-sort"));

$("body").on("change", "#tag_filter, #sort-by", function () {
  quickFilter.init();
});

$("body").on("change", "#blog_filter", function () {
  var url = $(this).val();
  window.location = url;
});

$("input, select, textarea").on("focus blur", function (event) {
  $("meta[name=viewport]").attr(
    "content",
    "width=device-width,initial-scale=1,maximum-scale=" +
      (event.type == "blur" ? 10 : 1)
  );
});

/*============================================================================
  Sidebar filter on collection pages
==============================================================================*/

var collectionSidebarFilter = {
  init: function () {
    $(".filter-active-tag input:checked")
      .parents(".filter-active-tag")
      .siblings(".filter-all-tags")
      .hide();
    $(".toggle-all--true .toggle_list .filter-active-tag input:checked")
      .parents("ul.toggle_list")
      .prev()
      .click();

    //Hide filters if types or vendors is in URL (can't be combined)
    //     if ($.url(2) === "types" || $.url(2) === "vendors") {
    //       $(".sidebar__collection-filter").remove();
    //     }

    $(".sidebar-block:empty").prev().css("border-bottom", "none");
  },
  clearAllFilters: function () {
    $("[data-option-filter] input").attr("checked", false);
    $("[data-option-filter] input").trigger("change");
  },
  clearSelectedFilter: function (optionFilter) {
    optionFilter.find("[data-option-filter] input").attr("checked", false);
    optionFilter.find("[data-option-filter] input").trigger("change");
  },
};

//Check the checkbox values
$("body").on("change", "[data-option-filter] input", function () {
  quickFilter.init();
});

$("body").on("click", "[data-reset-filters]", function () {
  collectionSidebarFilter.clearAllFilters();
});

$("body").on("click", "[data-clear-filter]", function () {
  var selectedOption = $(this).parents(".filter-active-tag");
  collectionSidebarFilter.clearSelectedFilter(selectedOption);
});

/*============================================================================
  FAQ
==============================================================================*/
var faqAccordion = {
  init: function () {
    var flg = 0;
    var $faqHeading = $(".faqAccordion > dt > button");
    $(".faqAccordion > dd").attr("aria-hidden", true);
    $faqHeading.attr("aria-expanded", false);
    $faqHeading.on("click activate", function () {
      if (flg) return false;
      flg = 1;
      var state = $(this).attr("aria-expanded") === "false" ? true : false;
      $(this).attr("aria-expanded", state);

      $(this)
        .parent()
        .next()
        .slideToggle(function () {
          flg = 0;
        });
      $(this).parent().next().attr("aria-hidden", !state);
      return false;
    });
    $faqHeading.on("keydown", function (event) {
      var keyCode = event.keyCode || e.which;
      if (keyCode === 13) {
        $(this).trigger("activate");
      }
    });
  },
};
var VideofaqAccordion = {
  init: function () {
    $(".video-accordian .my-div").hide();
    var flg = 0;
    var $faqHeading = $(".video-accordian .video-accordion-title");
    $(
      ".video-accordian .video-accordion-title > dd.video-accordion-content"
    ).attr("aria-hidden", true);
    $faqHeading.attr("aria-expanded", false);
    $faqHeading.on("click", function () {
      var $heading = $(this);
      //       if( flg ) return false;
      var state = $(this).attr("aria-expanded") === "false" ? true : false;

      $(this).attr("aria-expanded", state);
      $heading.toggleClass("active");
      //       $heading.nextUntil( "h2.video-accordion-title" )
      $heading.nextUntil("h2.video-accordion-title").slideToggle(function () {
        flg = 0;
      });
      $heading
        .nextUntil("h2.video-accordion-title")
        .attr("aria-hidden", !state);

      //             console.log($heading)
      var $faqHeading = $heading.next();
      var $btn = $faqHeading.find('button[type="button"]');
      $btn.attr("aria-expanded", true);
      var $heading = $faqHeading.find("dd#" + $btn.attr("id"));
      $heading.removeAttr("style");
      $heading.attr("aria-hidden", false);
      //             console.log($faqHeading)
      return false;
    });
    $faqHeading.on("keydown", function (event) {
      var keyCode = event.keyCode || e.which;
      if (keyCode === 13) {
        $(this).trigger("activate");
      }
    });

    //           var current_Tab = $('[data-counter="1"]');
    //           var SingleTab = $(current_Tab);
    //           SingleTab.nextUntil( "h2.video-accordion-title" ).fadeIn();
    // 		console.log(SingleTab)
    //           var $faqHeading = SingleTab;
    //           var $btn = $faqHeading.find('button[type="button"]');
    //           $btn.attr('aria-expanded',true);
    //           var $heading = $faqHeading.find('dd#panel-01');
    //           $heading.attr('aria-hidden',false);
  },
};

/*============================================================================
  Utilities
==============================================================================*/

//used for settings.slideshow_arrow_size === 'regular'
var arrowSize = {
  x0: 10,
  x1: 60,
  y1: 50,
  x2: 70,
  y2: 40,
  x3: 30,
};

//compatibility with gallery using remodal
var lightboxGallery = {
  init: function () {
    //compatibility with gallery using remodal
    if ($(".lightbox img").length) {
      var currentSlide;
      var $lightboxImages = $("a.lightbox");
      var groups = [];

      //get all lightbox images and divide into groups based on rel attribute
      $lightboxImages.each(function (index) {
        groups.push($(this).attr("rel"));
        groups = groups.filter(function (item, i, ar) {
          return ar.indexOf(item) === i;
        });
      });

      //loop through gallery groups and create modals
      $.each(groups, function (index, value) {
        //Loop through images and add link to remodal
        $(".lightbox[rel=" + value + "]").attr(
          "data-remodal-target",
          "lightbox-id-" + index
        );

        var lightboxModal = [
          '<div class="remodal remodal-lightbox js-remodal-lightbox js-lightbox-' +
            index +
            '" data-rel="' +
            value +
            '" data-remodal-id="lightbox-id-' +
            index +
            '" data-remodal-options="hashTracking: false">',
          '<a data-remodal-action="close" class="remodal-close"></a>',
          '<div class="lightbox-gallery"></div>',
          "</div>",
        ].join("");

        //Add modal lightbox to page to be populated by lightboxImageGallery
        $("body").append(lightboxModal);

        $(".lightbox[rel=" + value + "]").each(function (index) {
          $(this).attr("data-image-id", index);
          $(this).attr("data-no-instant", "");
        });
      });
    }
  },
};

var utils = {
  createAccordion: function (container, tab, content) {
    var $container = $(container);
    var $tab = $(container).find(tab);
    var $content = $(container).find(content);
    var specificTab = container + " " + tab;

    //Check to see if need to rearrange product tabs to create accordion (backwards compatible)
    if (container.indexOf(".accordion-tabs") >= 0) {
      var rearrangedTabs = $.map($tab, function (v, i) {
        return [v, $content[i]];
      });
      $container.empty();

      $.each(rearrangedTabs, function (index, value) {
        $container.append(this);
      });

      $content.removeClass("active");
      $container.find(".active").next().slideToggle();

      tab = container + "> a";
    }

    $(container)
      .children("a")
      .each(function (i, tab) {
        var tab = $(this);
        var tabValue = tab.attr("href"); //get tab id
        tab.attr("data-tab-value", tabValue); //set tab id in data attribute
        tab.removeAttr("href"); //remove href (to prevent url hash update)
      });

    $(container)
      .find(tab + ".active")
      .next()
      .slideToggle();
    $("body").on("click", specificTab, function (e) {
      e.preventDefault();
      $(this).toggleClass("active");
      $(this).next().slideToggle();
    });
  },
  mobileAccordion: function (container, tab, content) {
    $container = $(container);
    $tab = $(container).find(tab);
    $content = $(container).find(content);

    $(tab + ".active")
      .next()
      .slideToggle();

    $("body").on("click", tab, function (e) {
      e.preventDefault();
      $(this).toggleClass("active");
      $(this).next().slideToggle();
    });
  },
  mobileParentActiveAccordion: function (container, tab, content) {
    $container = $(container);
    $tab = $(container).find(tab);
    $content = $(container).find(content);

    $(tab + ".active")
      .parent()
      .next()
      .slideToggle();

    $("body").on("click", tab, function (e) {
      e.preventDefault();
      $(this).toggleClass("active");
      $(this).parent().next().slideToggle();
    });
  },
  initializeTabs: function () {
    $("ul.tabs > li > a").attr("data-no-instant", true);
    $("body").on("click", "ul.tabs > li > a", function (e) {
      e.preventDefault();
      var contentLocation = $(this).attr("href");
      if (contentLocation.charAt(0) == "#") {
        $("ul.tabs > li > a.active").removeClass("active");
        $(this).addClass("active");
        $(this)
          .parents("ul.tabs")
          .next()
          .find(contentLocation)
          .show()
          .css({ display: "block" })
          .addClass("active")
          .siblings()
          .hide()
          .removeClass("active");
      }
    });
  },
  pageBannerCheck: function () {
    //check for header banner
    if (
      !$(".page_banner").length > 0 ||
      $(".header").hasClass("header-background--solid")
    ) {
      $(".feature_image").removeClass("feature_image");
      $(".header.is-absolute").removeClass("is-absolute");
      //hide secondary logo
      $(".secondary_logo--true").find(".secondary_logo").hide();
      $(".secondary_logo--true").find(".primary_logo").show();
    } else {
      $(".header").parent().addClass("feature_image");
      $(".header").addClass("is-absolute");
      //check for secondary logo
      if ($("header.feature_image").hasClass("secondary_logo--true")) {
        $(".secondary_logo--true").find(".secondary_logo").show();
        $(".secondary_logo--true").find(".primary_logo").hide();
      }
    }

    //check for section that uses header banner on home page
    if ($(".index-sections").children().first().hasClass("under-menu")) {
      if (!$(".header").hasClass("header-background--solid")) {
        $(".index .header").parent().addClass("feature_image");
        $(".index .header").addClass("is-absolute");
      }
      //check for secondary logo
      if ($("header.feature_image").hasClass("secondary_logo--true")) {
        $(".secondary_logo--true").find(".secondary_logo").show();
        $(".secondary_logo--true").find(".primary_logo").hide();
      }
    } else {
      $(".index .feature_image").removeClass("feature_image");
      $(".index .header.is-absolute").removeClass("is-absolute");
      //hide secondary logo
      if (!$("header.feature_image").hasClass("secondary_logo--true")) {
        $(".secondary_logo--true").find(".secondary_logo").hide();
        $(".secondary_logo--true").find(".primary_logo").show();
      }
    }

    //check for section that uses header banner on the page details template
    if ($(".detail-sections").children().first().hasClass("under-menu")) {
      if (!$(".header").hasClass("header-background--solid")) {
        $('[class^="page-details"] .header').parent().addClass("feature_image");
        $('[class^="page-details"] .header').addClass("is-absolute");
      }

      //check for secondary logo
      if ($("header.feature_image").hasClass("secondary_logo--true")) {
        $(".secondary_logo--true").find(".secondary_logo").show();
        $(".secondary_logo--true").find(".primary_logo").hide();
      }
    } else {
      $('[class^="page-details"] .feature_image').removeClass("feature_image");
      $('[class^="page-details"] .header.is-absolute').removeClass(
        "is-absolute"
      );

      //hide secondary logo
      if (!$("header.feature_image").hasClass("secondary_logo--true")) {
        $(".secondary_logo--true").find(".secondary_logo").hide();
        $(".secondary_logo--true").find(".primary_logo").show();
      }
    }
  },
  resizeActionButtons: function () {
    $(".js-caption:visible").each(function () {
      var buttonWidth = 0;
      $(this)
        .find(".action_button")
        .each(function () {
          $button = $(this);
          if ($(this).width() > buttonWidth) {
            buttonWidth = $(this).width();
          }
        });
      $(this).find(".action_button").width(buttonWidth);
    });
  },
};

var sliderBlock = {
  select: function (blockId, $parentSection) {
    var $blocks = $parentSection.find(".gallery-cell");
    var blockIdsArray = $blocks.map(function () {
      return String($(this).data("block-id"));
    });
    var $slider = $parentSection.find(".js-homepage-slideshow");
    var settings = {
      slideshowTextAnimation: $slider.data("slideshow-text-animation"),
    };
    var flkty = $slider.data("flickity");

    $slider.flickity("pausePlayer");

    for (var i = 0; i < blockIdsArray.length; i++) {
      if (blockIdsArray[i] === blockId) {
        var currentSlide = i;
        if (currentSlide !== flkty.selectedIndex) {
          $slider.flickity("select", parseInt(currentSlide), false, true);
        }
      }
    }
  },
  deselect: function ($parentSection) {
    var $slider = $parentSection.find(".flexslider").data("flexslider");
    if ($slider) {
      $slider.flickity("unpausePlayer");
    }
  },
};

// if($('.lozad').length>0){
//   const observer = lozad('.lozad', {
//     load: function(el) {
//       console.log('loading element',el);
//       if($(el).hasClass('video-ele')){
//         el.play();
//       }
//     }
//   })
//   observer.observe();
// }
// document.addEventListener("DOMContentLoaded", function() {
//   var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

//   if ("IntersectionObserver" in window) {
//     var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
//       entries.forEach(function(video) {
//         if (video.isIntersecting) {
//           for (var source in video.target.children) {
//             var videoSource = video.target.children[source];
//             if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
//               videoSource.src = videoSource.dataset.src;
//             }
//           }

//           video.target.load();
//           video.target.classList.remove("lazy");
//           lazyVideoObserver.unobserve(video.target);
//           console.log('video lazy loaded success');
//         }
//       });
//     });

//     lazyVideos.forEach(function(lazyVideo) {
//       lazyVideoObserver.observe(lazyVideo);
//     });
//   }
// });
//document ready
$(function () {
  /**************************Open_upsell_modal functionalities***************************/

  Cookies.set("secondPopupOpen", false, { expires: 90, path: "/" });
  var secondPopupOpen = Cookies.get("secondPopupOpen");
  $(".upsell-product-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 500,
    fade: true,
    infinite: true,
    speed: 300,
    adaptiveHeight: true,
  });
  //         console.log(secondPopupOpen)
  var upsellPhoneMirrors = $("[data-remodal-id=upsellPhoneMirrors]").remodal({
    hashTracking: false,
    closeOnOutsideClick: true,
  });
  var upsellPhoneCases = $("[data-remodal-id=upsellPhoneCases]").remodal({
    hashTracking: false,
    closeOnOutsideClick: true,
  });
  var upsellPhonePockets = $("[data-remodal-id=upsellPhonePockets]").remodal({
    hashTracking: false,
    closeOnOutsideClick: true,
  });
  var upsellPhoneRings = $("[data-remodal-id=upsellPhoneRings]").remodal({
    hashTracking: false,
    closeOnOutsideClick: true,
  });
  var upsellPhoneCharms = $("[data-remodal-id=upsellPhoneCharms]").remodal({
    hashTracking: false,
    closeOnOutsideClick: true,
  });
  var upsellSwipeWipes = $("[data-remodal-id=upsellSwipeWipes]").remodal({
    hashTracking: false,
    closeOnOutsideClick: true,
  });
  var upsellStickerTags = $("[data-remodal-id=upsellStickerTags]").remodal({
    hashTracking: false,
    closeOnOutsideClick: true,
  });
  function Open_upsell_modal(type) {
    var type = type || "shop-phone-mirrors";
    if (type == "shop-phone-mirrors") {
      upsellPhoneRings.open();
    } else if (type == "shop-phone-cases" || type == "phone-case") {
      upsellPhoneRings.open();
    } else if (type == "shop-phone-pockets") {
      upsellPhoneMirrors.open();
    } else if (type == "shop-phone-rings") {
      upsellPhonePockets.open();
    } else if (type == "shop-phone-charms") {
      upsellPhoneRings.open();
    } else if (type == "shop-swipe-wipes") {
      upsellPhoneCharms.open();
    } else if (type == "shop-sticker-tags") {
      upsellPhoneCharms.open();
    }
  }

  /**************************Open_upsell_modal functionalities Ends***************************/
  var oldFlickityCreate = window.Flickity.prototype._create;

  window.Flickity.prototype._create = function () {
    var that = this;
    if (this.element.addEventListener) {
      this.element.addEventListener(
        "load",
        function () {
          that.onresize();
        },
        true
      );
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  FastClick.attach(document.body);

  header.init();
  //Set current slide
  $("body").on("click", ".lightbox", function () {
    currentSlide = $(this).parents(".slick-slide").index();
    //     console.log($(this).parents('.slick-slide').index())
  });

  //detect when a remodal lightbox is opened
  $("body").on("opening", ".js-remodal-lightbox", function () {
    var $currentLightbox = $(this);
    var $currentLightboxGallery = $currentLightbox.find(".lightbox-gallery");
    var $currentLightboxImages = $currentLightbox.find(".lightbox-image");
    var activate_zoom = $("body").find(".product_gallery").data("zoom");
    var arrowShow = $currentLightboxImages.length === 1 ? false : true;
    var group = $(this).data("rel");
    var draggable = true;

    $currentLightbox.attr("data-zoom", activate_zoom);

    if (activate_zoom && $(window).width() <= 798) {
      draggable = false;
    } else {
      draggable = $currentLightboxImages.length === 1 ? false : true;
    }

    $groupImages = $(".lightbox[rel=" + group + "]");

    //       $currentLightboxGallery.flickity(
    //         "remove",
    //         $currentLightboxGallery.find(".gallery-cell")
    //       );

    //     $currentLightboxGallery.find(".gallery-cell").remove();
    var $cellElems;

    $groupImages.each(function (index) {
      var imagePath = $(this).attr("href");
      console.log(imagePath);
      $cellElems = $(
        '<div class="gallery-cell"><img src="' +
          imagePath +
          '" class="lightbox-image"></div>'
      );

      console.log(
        $groupImages.length,
        $currentLightboxGallery.find(".gallery-cell").length
      );

      if (
        $groupImages.length >
        $currentLightboxGallery.find(".gallery-cell").length
      ) {
        $currentLightboxGallery.append($cellElems);
      }
      //       if ($currentLightboxGallery.hasClass("slick-initialized")) {
      //         $currentLightboxGallery.find('.slick-track').append($cellElems);
      //       }

      $currentLightbox.find(".lightbox-image").css("opacity", "1");
      //         console.log($currentLightbox.find(".lightbox-image"),$currentLightbox.find(".lightbox-image").clientHeight)
    });

    //Add gallery when lightbox opens
    console.log(currentSlide);
    var settings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      draggable: true,
      easing: "linear",
      edgeFriction: 0.2,
      cssEase: "ease",
      prevArrow:
        '<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Previous" role="button"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
      nextArrow:
        '<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><svg viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
      fade: true,
    };
    try {
      if (!$currentLightboxGallery.hasClass("slick-initialized")) {
        var $lightboxGallery = $currentLightboxGallery.slick(settings);
        $currentLightboxGallery.trigger("resize");
        console.log($currentLightboxGallery);
      }
      //       else{
      // //         $('.lightbox-gallery').slick('unslick');
      // //         $('.lightbox-gallery').slick(settings)
      //       }
    } catch (ex) {
      console.log(ex);
    }
    $currentLightboxGallery.slick("resize");
    $currentLightboxGallery.slick("slickGoTo", currentSlide);
    //     $currentLightboxGallery.flickity("select", window.currentSlide, false, true).focus();

    //add zoom to product images
    if (activate_zoom && $(window).width() <= 798) {
      imageFunctions.zoom(".js-remodal-lightbox", true, 1.8);
    }
  });
  slideshow.init();
  header.loadMegaMenu();
  utils.pageBannerCheck();

  testimonial.init();
  if (!$("body").hasClass("product")) {
    gallery.init();
  }

  videoSection.init();
  featuredPromotions.init();
  featuredCollectionSection.init();
  collectionSidebarFilter.init();
  cart.init();

  productPage.initializeQuantityBox();
  productPage.init();
  productPage.relatedProducts();

  recentlyViewed.init();

  $("body").on("closed", ".js-remodal-lightbox", function () {
    var $currentLightbox = $(this);
    //     $currentLightbox.find(".lightbox-image").css("opacity", "0");
  });

  if (window.location.pathname.indexOf("/comments") != -1) {
    $("html,body").animate(
      { scrollTop: $("#new-comment").offset().top - 140 },
      "slow"
    );
  }

  $("body").on("mouseenter", ".icon-search", function () {
    $(".search-terms").focus();
  });

  $("body").on("click", ".search-submit", function () {
    $(this).parent().submit();
  });

  if ($(window).width() > 798) {
    $(".animate_right").waypoint(
      function () {
        $(this.element).addClass("animated fadeInRight");
      },
      { offset: "70%" }
    );
    $(".animate_left").waypoint(
      function () {
        $(this.element).addClass("animated fadeInLeft");
      },
      { offset: "70%" }
    );
    $(".animate_up").waypoint(
      function () {
        $(this.element).addClass("animated fadeInUp");
      },
      { offset: "70%" }
    );
    $(".animate_down").waypoint(
      function () {
        $(this.element).addClass("animated fadeInDown");
      },
      { offset: "70%" }
    );
  }

  //backwards compatibility with flexslider
  $(".slider, .flexslider").find("li").unwrap();
  $(".slider, .flexslider").flickity({
    pageDots: usePageDots,
    imagesLoaded: true,
    lazyLoad: 2,
  });

  utils.createAccordion(".toggle-all--true", "h4.toggle", "ul.toggle_list");
  utils.createAccordion(".footer_menu", "h3", "ul");
  utils.createAccordion(".footer_content", "h6", "div.toggle_content");
  utils.createAccordion(
    ".product_section .accordion-tabs",
    ".tabs li > a",
    ".tabs-content li"
  );

  utils.mobileParentActiveAccordion(
    "#mobile_menu",
    "li.sublink > a.parent-link--true span",
    "li.sublink ul"
  );
  utils.mobileAccordion(
    "#mobile_menu",
    "li.sublink > a.parent-link--false",
    "li.sublink ul"
  );

  utils.initializeTabs();
  utils.resizeActionButtons();
  faqAccordion.init();

  $(window).on("resize", function () {
    utils.resizeActionButtons();
  });

  //Sidebar toggle check
  if ($(window).width() <= 798) {
    utils.createAccordion(".toggle-all--false", "h4.toggle", "ul.toggle_list");
  }

  $("body").on("click", ".menu-toggle", function (e) {
    var $content = $(this).next("ul");
    $content.slideToggle();
    $(this).toggleClass("active");
    $(this).attr(
      "aria-expanded",
      $(this).attr("aria-expanded") == "true" ? "false" : "true"
    );
  });

  if ($(".shopify-section.page-details-section").length) {
    // Don't apply mediaWrapper
  } else if ($("body").hasClass("index")) {
    $(
      ".featured-products-section iframe[src*=youtube], .featured-products-section iframe[src*=vimeo]"
    ).mediaWrapper({
      intrinsic: true,
    });
  } else {
    $("iframe[src*=youtube], iframe[src*=vimeo]").mediaWrapper({
      intrinsic: true,
    });
  }

  if ($(window).width() >= 959) {
    var modal_width = "870px";
    if ($(window).width() >= 1200 || $("html").hasClass("ie")) {
      modal_width = "1110px";
    }
  }

  //Terms of service settings for minicart

  //         $('body').on('click', ".cart_content .action_button", function(e) {
  //           // Redirect to cart page
  //           e.preventDefault();
  //           document.location.href = "/cart";
  //         });
  $("body").on("click", ".cart_content .checkout-btn", function (e) {
    // Redirect to cart page
    e.preventDefault();
    document.location.href = "/checkout";
  });

  imageFunctions.showSecondaryImage();

  var $contact_form = $(".newsletter .contact-form");
  $contact_form.each(function () {
    var $cf = $(this);
    $cf.on("submit", function (e) {
      if ($('input[name="challenge"]', $cf).val() !== "true") {
        $.ajax({
          type: $cf.attr("method"),
          url: $cf.attr("action"),
          data: $cf.serialize(),
          success: function (data) {
            $cf.fadeOut("slow", function () {
              $cf
                .prev(".message")
                .html("Thank you for joining our mailing list!");
            });
          },
          error: function (data) {
            $('input[name="challenge"]', $cf).val("true");
            $cf.submit();
          },
        });
        e.preventDefault();
      }
    });
  });

  $(".maps").click(function () {
    $(".maps iframe").css("pointer-events", "auto");
  });

  enableInfiniteScroll();

  /*============================================================================
    Quick Shop
  ==============================================================================*/

  var globalQuickShopProduct;

  $("body").on("change", ".currencies", function (e) {
    $("[data-initial-modal-price]").attr("data-initial-modal-price", "");
  });

  $("body").on("change", ".js-quick-shop select", function (e) {
    var currentVariant = $('.js-quick-shop select[name="id"]').val();
    if (currentVariant && globalQuickShopProduct) {
      quickShop.updateVariant(currentVariant);
    }
  });

  var quickShop = {
    init: function () {
      //Quick-shop variables
      var productData;
      var productForm;
      var notifyForm;

      //EVENT - click on quick-shop
      $("body").on("click", ".js-quick-shop-link", function (e) {
        e.preventDefault();

        //split image info into two arrays
        var arr = $(this).data("images").trim("||").split("||");
        var imageIds = [];
        var imageAlts = [];
        for (var i = 0; i < arr.length; i += 2) {
          imageIds.push(arr[i]);
          arr[i + 1] && imageAlts.push(arr[i + 1]);
        }

        //Set productData based on data attributes
        productData = {
          handle: $(this).data("handle"),
          product_id: $(this).data("id"),
          single_variant: $(this).attr("data-single-variant"),
          product_in_collection_url: $(this).data("url"),
          escaped_title: $(this).data("title"),
          details_text: $(this).data("details-text"),
          full_description: $(this).data("full-description"),
          regular_description: $(this).data("regular-description"),
          image_ids: imageIds.filter(function (v) {
            return v !== "";
          }),
          image_alts: imageAlts,
          collection_handles: $(this)
            .data("collection-handles")
            .trim(",")
            .split(","),
          money_format: $(this).data("money-format"),
        };

        if (!$(".js-gallery-modal").hasClass("flickity-enabled")) {
          $(".js-gallery-modal").flickity({
            wrapAround: "true",
            cellAlign: "left",
            contain: true,
            imagesLoaded: true,
            lazyLoad: 2,
            pageDots: usePageDots,
            prevNextButtons: true,
            autoPlay: autoplay,
            selectedAttraction: 0.01,
            friction: 0.15,
            arrowShape: arrowSize,
          });
        }

        //Find current product and notify forms
        notifyForm = $(this).next(".js-forms").find(".notify_form");
        productForm = $(this).next(".js-forms").find(".product_form");
        //Add Product Ids to parent container so form will work
        $(".quick-shop .container").attr(
          "class",
          "container section product-" + productData.product_id
        );
        $(".quick-shop .container").attr(
          "id",
          "product-" + productData.product_id
        );
        $(".quick-shop .container").attr("data-id", productData.product_id);
        //Function to send attribute data to API
        quickShop.retrieveProductInfo(productData);
      });

      //EVENT - modal is open
      $("body").on("opened", ".js-quick-shop", function () {
        //Copy form data to modal

        $(".remodal.quick-shop .js-product-form").html(productForm);
        $(".remodal.quick-shop .js-notify-form").html(notifyForm);

        //Initiate selectCallback
        if (
          $(productForm).hasClass("product_form_options") &&
          !$(productForm).hasClass("viewed")
        ) {
          new Shopify.OptionSelectors($(productForm).data("select-id"), {
            product: $(productForm).data("product"),
            onVariantSelected: selectCallback,
            enableHistoryState: $(productForm).data("enable-state"),
          });
        } else {
        }

        utils.initializeTabs();
        $('.js-quick-shop select[name="id"]').trigger("change");
      });

      //EVENT - modal is closed
      $("body").on("closed", ".js-quick-shop", function (e) {
        var insertedProductForm = $(".js-quick-shop .product_form");
        var insertedNotifyForm = $(".js-quick-shop .notify_form");
        console.log("JSQUICKSHOP m", productData);
        //Copy form data back to product loop and add .viewed
        if (productData) {
          $(".form-holder-" + productData.product_id).append(
            insertedProductForm
          );
          $(".form-holder-" + productData.product_id).append(
            insertedNotifyForm
          );
          $(
            ".form-holder-" + productData.product_id + " .product_form"
          ).addClass("viewed");
          $(
            ".form-holder-" + productData.product_id + " .notify_form"
          ).addClass("viewed");
          var variantPrice = $(".js-current-price .money").text();
          $(".js-quick-shop-link[data-id=" + productData.product_id + "]").attr(
            "data-initial-modal-price",
            variantPrice
          );
        }
        $(".js-current-price, .js-was-price, .js-savings").empty();
      });
    },
    retrieveProductInfo: function (productData) {
      $.ajax({
        dataType: "json",
        async: false,
        cache: false,
        url: "/products/" + productData.handle + ".js",
        success: function (product) {
          var product = $.extend({}, product, productData); //Create new object combining info
          quickShop.populateGallery(product);

          globalQuickShopProduct = product;

          quickShop.updateVariant(product.variants[0].id.toString());
        },
      });
    },
    updateVariant: function (variant) {
      $(
        ".js-sale-banner, .js-sold-out, .js-current-price, .js-was-price, .js-savings, .js-new-banner, .js-pre-order-banner"
      ).empty();

      if (globalQuickShopProduct != "undefined") {
        var product = globalQuickShopProduct;

        $(".modal_price, .js-notify-form").show();

        //Title and Vendor
        $(".js-product-title").html(
          '<a href="' +
            product.product_in_collection_url +
            '" title="' +
            product.escaped_title +
            '">' +
            product.title +
            "</a>"
        );
        $(".js-product-vendor").html(
          '<a href="/collections/vendors?q=' +
            product.vendor +
            '">' +
            product.vendor +
            "</a>"
        );

        //Product Description
        $(".js-full-description").html(product.full_description);
        $(".js-regular-description").html(product.regular_description);
        var productDetails =
          '<a href="' +
          product.product_in_collection_url +
          '" class="secondary_button" title="' +
          product.escaped_title +
          ' Details">' +
          product.details_text +
          "</a>";
        $(".js-product-details").html(productDetails);

        //Collection banners
        $.each(product.collection_handles, function (value, index) {
          if (this.toString() == "new") {
            $(".js-new-banner").html("New");
          }
          if (this.toString() == "pre-order") {
            $(".js-pre-order-banner").html("Pre-Order");
          }
          if (this.toString() == "coming-soon") {
            product.price = "Coming Soon";
          }
        });

        if (product.single_variant == "true") {
          //No variants
          //Sale Banner

          //Sale
          if (product.compare_at_price > product.price) {
            $(".js-current-price").addClass("sale");
          } else {
            $(".js-current-price").removeClass("sale");
          }

          //Availability
          if (product.available == false) {
            $(".js-sold-out").html("Sold Out");
          }

          //Price
          if (product.available == true) {
            if (product.compare_at_price > product.price) {
              $(".js-was-price").html(
                '<span class="visually-hidden">original product price; '+variant.compare_at_price/100+' dollars </span> <span class="money" aria-hidden="true">' +
                  Shopify.formatMoney(
                    product.compare_at_price,
                    product.money_format
                  ) +
                  "</span>"
              );
              $(".js-savings").html(
                "You Save" +
                  " " +
                  parseInt(
                    ((product.compare_at_price - product.price) * 100) /
                      product.compare_at_price
                  ) +
                  "% (" +
                  '<span class="money">' +
                  Shopify.formatMoney(
                    product.compare_at_price - product.price,
                    product.money_format
                  ) +
                  "</span>)"
              );
            }

            if (product.price == "Coming Soon") {
              $(".js-current-price").html("Coming Soon");
            } else if (product.price) {
              $(".js-current-price").html(
                '<span class="money">' +
                  Shopify.formatMoney(product.price, product.money_format) +
                  "</span>"
              );
            } else {
              $(".js-current-price").html("Free");
            }
          }
        } else {
          //Variant loop
          for (var i = 0; i < product.variants.length; i++) {
            if (variant == product.variants[i].id.toString()) {
              //Sale Banner

              //Sale
              if (
                product.variants[i].compare_at_price > product.variants[i].price
              ) {
                $(".js-current-price").addClass("sale");
              } else {
                $(".js-current-price").removeClass("sale");
              }

              //Availability
              if (product.variants[i].available == false) {
                $(".js-sold-out").html("Sold Out");
              }

              //Price
              if (product.variants[i].available == true) {
                if (
                  product.variants[i].compare_at_price >
                  product.variants[i].price
                ) {
                  $(".js-was-price").html(
                    '<span class="visually-hidden">original product price; '+product.variants[i].compare_at_price/100+' dollars </span> <span class="money" aria-hidden="true">' +
                      Shopify.formatMoney(
                        product.variants[i].compare_at_price,
                        product.money_format
                      ) +
                      "</span>"
                  );
                  $(".js-savings").html(
                    "You Save" +
                      " " +
                      parseInt(
                        ((product.variants[i].compare_at_price -
                          product.variants[i].price) *
                          100) /
                          product.variants[i].compare_at_price
                      ) +
                      "% (" +
                      '<span class="money">' +
                      Shopify.formatMoney(
                        product.variants[i].compare_at_price -
                          product.variants[i].price,
                        product.money_format
                      ) +
                      "</span>)"
                  );
                }

                if (product.variants[i].price == "Coming Soon") {
                  $(".js-current-price").html("Coming Soon");
                } else if (product.variants[i].price) {
                  $(".js-current-price").html(
                    '<span class="visually-hidden">original product price; '+product.variants[i].price/100+' dollars </span><span class="money">' +
                      Shopify.formatMoney(
                        product.variants[i].price,
                        product.money_format
                      ) +
                      "</span>"
                  );
                } else {
                  $(".js-current-price").html("Free");
                }
              }
            }
          }
        }
      }

      $(
        ".js-quick-shop iframe[src*=youtube], .js-quick-shop iframe[src*=vimeo]"
      ).mediaWrapper({
        intrinsic: true,
      });
    },
    populateGallery: function (product) {
      //Find gallery and carousel
      var $gallery = $(".js-gallery-modal");
      var $carousel = $(".js-gallery-carousel");

      //EVENT - modal closed
      $(document).on("closed", ".js-quick-shop", function (e) {
        $gallery.flickity("remove", $(".js-gallery-modal .gallery-cell"));
        $carousel.empty();
      });

      //Add gallery images based on product info from API
      function addMainGalleryImages(multiImage) {
        $.each(product.images, function (i, imgPath) {
          var imgGrande = imgPath
            .replace(/(\.[^.]*)$/, "_grande$1")
            .replace("http:", "");
          var img1024x1024 = imgPath
            .replace(/(\.[^.]*)$/, "_1024x1024$1")
            .replace("http:", "");
          var img2048x2048 = imgPath
            .replace(/(\.[^.]*)$/, "_2048x2048$1")
            .replace("http:", "");
          var alt = product.image_alts[i];
          var cellContent;

          if (alt.indexOf("youtube") >= 0) {
            cellContent =
              '<div class="video-container youtube"><div>' +
              alt +
              "</div></div>";
          } else if (alt.indexOf("vimeo") >= 0) {
            cellContent =
              '<div class="video-container vimeo"><div>' + alt + "</div></div>";
          } else {
            cellContent =
              '<img src="' +
              imgGrande +
              '" data-src="' +
              img1024x1024 +
              '" alt="' +
              alt +
              '" data-image-id="' +
              product.image_ids[i].trim() +
              '" data-index="' +
              i +
              '" srcset="' +
              imgGrande +
              " 600w, " +
              img1024x1024 +
              " 1024w, " +
              img2048x2048 +
              ' 2048w" sizes="(min-width: 800px) 50vw, 100vw"/>';
          }

          var $cellElems = $(
            '<div class="gallery-cell">' + cellContent + "</div>"
          );
          $gallery.flickity("append", $cellElems);
        });

        $gallery
          .removeClass("single-image multi-image")
          .addClass(multiImage ? "multi-image" : "single-image");
      }

      //Add carousel images based on product info from API
      function addCarouselGalleryImages() {
        $.each(product.images, function (i, imgPath) {
          var carouselSizedImg = imgPath
            .replace(/(\.[^.]*)$/, "_grande$1")
            .replace("http:", "");

          var img =
            '<img src="' +
            carouselSizedImg +
            '" alt="' +
            product.image_alts[i] +
            '" />';
          var $carouselCellElems = $(
            '<div class="gallery-cell">' + img + "</div>"
          );
          $carousel.append($carouselCellElems);
        });

        imageFunctions.linkGalleryAndCarousel($gallery, $carousel);
      }

      //Check how many images are returned from API - addMainGalleryImages() takes true or false based on whether gallery slider is multi-image (shows prev/next arrows)
      var multiImage;

      if (product.images.length > 1) {
        multiImage = true;
        addMainGalleryImages(multiImage);
        addCarouselGalleryImages();
      } else {
        multiImage = false;
        addMainGalleryImages(multiImage);
      }

      imageFunctions.zoom(".js-gallery-modal", false);
    },
  };

  quickShop.init();

  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/
  function isDuplicate(data, id) {
    $.map(data, function (elem, index) {
      console.log(elem.id);
      if (elem.id == id) return true;
      else return false;
    });
  }
  function removeElement(data, id) {
    $.each(data, function (i, el) {
      if (this.id == id) {
        data.splice(i, 1);
      }
    });
    return data;
  }
  window.CartHasPhonecases = [];
  function ajaxSubmitCart(cart) {
    $cart = cart;
    $.ajax({
      url: "/cart/update.js",
      dataType: "json",
      cache: false,
      type: "post",
      data: $cart.serialize(),
      success: function (data) {
        refreshCart(data);
      },
    });
  }

  function ajaxUpdateCart(lineID, quantity, parent) {
    var updated_price = 0;
    $.ajax({
      url: "/cart/change.js",
      dataType: "json",
      cache: false,
      type: "post",
      data: { quantity: quantity, line: lineID },
      success: function (data) {
        refreshCart(data);

        var lineIDIndex = lineID - 1;

        //check to see if there are correct amount of products in array
        if (typeof data.items[lineIDIndex] === "undefined") {
          var updated_quantity = 0;
        } else {
          var updated_quantity = data.items[lineIDIndex].quantity;
          updated_price = data.items[lineIDIndex].price * updated_quantity;
          var cart_page = is_home;
          if (cart_page == "cart") {
            parent
              .find("input[data-line-id='" + lineID + "']")
              .parent()
              .prev()
              .find("span.original_price")
              .html(
                Shopify.formatMoney(
                  updated_price,
                  $("#cart_form").data("money-format")
                )
              );
          } else {
            parent
              .find("input[data-line-id='" + lineID + "']")
              .parent()
              .prev()
              .find("span.original_price")
              .html(
                Shopify.formatMoney(
                  updated_price,
                  $(".cart_content form").data("money-format")
                )
              );
          }
        }
        if (quantity > 0 && quantity != updated_quantity) {
          if (updated_quantity == 1) {
            items_left_text = "item left";
          } else {
            items_left_text = "items left";
          }

          $(".warning--quantity").remove();
          var warning =
            '<p class="warning warning--quantity animated bounceIn">' +
            updated_quantity +
            " " +
            items_left_text +
            "</p>";
          parent
            .find("input[data-line-id='" + lineID + "']")
            .parent()
            .after(warning);
          parent
            .find("input[data-line-id='" + lineID + "']")
            .val(updated_quantity);
        } else if (parent.is("#cart_form")) {
          $("#cart_form").submit();
        }
      },
    });
  }

  function get_minicart_notify() {
    //     NudgeFlush();
    window.appn.notification_shown = false;
    for (var i = "", t = 0; t < document.scripts.length; t++)
      document.scripts[t].src.indexOf("notifications-v") > -1 &&
        (i = utilGetParameterByName(
          "shop",
          "?" + document.scripts[t].src.split("?")[1]
        ));
    (i = i.replace(".myshopify.com", "")),
      (window.appn = {
        shop: i,
        api_get:
          "https://notificationssg.herokuapp.com/api/v1/shop-notifications",
        shop_notifications_shown: [],
        notifications: [],
        settings: {},
        cart_total_price: 0,
        notification_shown: !1,
      }),
      "dev" == utilGetParameterByName("env") &&
        (window.appn.api_get =
          "https://localhost:5000/api/v1/shop-notifications"),
      jQuery.ajax({
        cache: !1,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        type: "GET",
        url: "/cart.js",
        success: function (i) {
          (window.appn.cart_total_price = i.total_price / 100),
            startNotifications(),
            jQuery("#shop-notification").show();
        },
      });
  }
  function refreshCart(cart) {
    // $(".cart_count").empty();
    $cartBtn = $(".cart_count");
    var value = $cartBtn.text() || "0";
    var cart_items_html = "";
    var cart_action_html = "";
    var cart_savings_html = "";
    if (is_home == "cart") var $cart = $("#cart_form");
    else var $cart = $(".cart_content form");
    var discounted_price_total = 0;
    var total_savings = 0;
    var original_price = 0;
    var fsb_limit = parseInt(window.fsb_shipping_limit);
    var cart_total = cart.total_price;
    var fsb_val = 0;
    var fsb_msg = "";
    console.log(fsb_limit + ", " + cart_total + (cart_total > fsb_limit));
    if (cart_total > fsb_limit) {
      fsb_msg = "Congrats! You've Earned Free Shipping!";
    } else {
      fsb_val = Shopify.formatMoney(
        fsb_limit - cart_total,
        $cart.data("money-format")
      );
      fsb_msg = "Almost there! Add " + fsb_val + " to unlock Free Shipping!";
    }

    var isPhonecases = false;

    $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));
    if (cart.item_count == 0) {
      $(".js-empty-cart__message").removeClass("hidden");
      $("h6.cart-title").html("Oops! Your cart looks a little empty!");
      window.CartHasPhonecases = [];
      //get_minicart_notify();
      Cookies.set("phonecase_confirm_popup", "false", {
        expires: 90,
        path: "/",
      });
      $(".js-cart_content__form").addClass("hidden");
    } else {
      $("h6.cart-title").html(fsb_msg.replace(/\\/g, ""));
      //get_minicart_notify();
      $(".js-empty-cart__message").addClass("hidden");
      $(".js-cart_content__form").removeClass("hidden");

      $.each(cart.items, function (index, item) {
        var line_id = index + 1;
        cart_items_html +=
          '<li class="cart_item clearfix">' + '<a href="' + item.url + '">';
        if (item.image) {
          cart_items_html +=
            '<div class="cart_image">' +
            '<img src="' +
            item.image
              .replace(/(\.[^.]*)$/, "_compact$1")
              .replace("http:", "") +
            '" alt="' +
            htmlEncode(item.title) +
            '" />' +
            "</div>";
        }
        cart_items_html += '<div class="item_title">' + item.product_title;
        var strItemTitle = String(item.handle);
        //                            console.log(strItemTitle,strItemTitle.indexOf('phone-case'))
        if (strItemTitle.indexOf("phone-case") > 0) {
          isPhonecases = true;
          $("#promo-title").css("display", "block");
          var ele = { id: item.id, handle: strItemTitle };
          removeElement(window.CartHasPhonecases, item.id);
          window.CartHasPhonecases.push(ele);
        }
        if (item.properties) {
          $.each(item.properties, function (title, value) {
            if (value) {
              cart_items_html +=
                '<div class="line-item">' + title + ": " + value + "</div>";
            }
          });
        }
        cart_items_html += "</div></a>";
        cart_items_html += '<strong class="price">';

        $.ajax({
          dataType: "json",
          async: false,
          cache: false,
          url: "/products/" + item.handle + ".js",
          success: function (data) {
            var variant_id = item.variant_id;
            var variant = $.grep(data.variants, function (v) {
              return v.id == variant_id;
            });

            if (variant[0] && variant[0].compare_at_price > item.price) {
              cart_items_html +=
                ' <span class="money was_price was_price_clr">' +
                Shopify.formatMoney(
                  variant[0].compare_at_price * item.quantity,
                  $cart.data("money-format")
                ) +
                "</span> ";
              discounted_price_total += item.price * item.quantity;
              total_savings += variant[0].compare_at_price * item.quantity;
            }
            if (variant[0].compare_at_price > item.price) {
              original_price += item.quantity * variant[0].compare_at_price;
            } else {
              original_price += item.quantity * item.price;
            }
          },
        });

        // cart_items_html +=
        //   '<span class="money original_price">' +
        //   Shopify.formatMoney(
        //     item.price * item.quantity,
        //     $cart.data("money-format")
        //   ) +
        //   "</span>";

        if (item.variant_options.length) {
          $.each(item.options_with_values, function (opt, key) {
            //             console.log(opt,key)
            if (key.value != "Default Title") {
              cart_items_html += '<div class="variant-cart">' + key.name + ": ";
              cart_items_html += key.value;
            }
          });
          cart_items_html += "</div>";
        }
        cart_items_html +=
          '<a class="item-delete js-change-quantity" href="#" data-func="remove" data-qty="0" data-line-id="' +
          line_id +
          '" data-varid="' +
          item.id +
          '" style="display: block;margin-top: 5px;" >Delete</a></strong>';

        //         cart_items_html += '<div class="right product-quantity-box">' +
        //             '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>' +
        //             '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" data-line-id="' + line_id +'" />' +
        //             '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>' +
        //           '</div><br/><a class="item-delete js-change-quantity" href="#" data-func="remove" data-qty="0" data-line-id="' + line_id +'">Delete</a><div style="clear:both;"></div>' +
        //         '</li>';

        cart_items_html +=
          '<div class="quantity-row right" style="left:-16px;"><a href="javascript:void(0);" class="btn-subtract js-change-quantity qty-minus"  data-func="minus">';
        cart_items_html +=
          '<svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><title>- icon</title><g fill="none" fill-rule="evenodd"><circle stroke="#CCD2D7" cx="12.5" cy="12.5" r="12"></circle><path fill="#CCD2D7" d="M7 12h11v1H7z"></path></g></svg>';
        cart_items_html +=
          '</a><input type="number" min="0" class="quantity" name="updates[]" id="updates_' +
          item.id +
          '" value="' +
          item.quantity +
          '" data-line-id="' +
          line_id +
          '" data-varid="' +
          item.id +
          '" />';
        cart_items_html +=
          '<a href="javascript:void(0);" class="btn-add js-change-quantity qty-plus" data-func="plus">';
        cart_items_html +=
          '<svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><title>+ icon</title><g fill="none" fill-rule="evenodd"><circle stroke="#CCD2D7" cx="12.5" cy="12.5" r="12"></circle><path fill="#CCD2D7" d="M7 12h11v1H7z"></path><path fill="#CCD2D7" d="M12 18V7h1v11z"></path></g></svg></a>';
        cart_items_html += '</div><div style="clear:both;"></div></li>';
      });

      cart_action_html +=
        '<span class="right"><span class="money">' +
        Shopify.formatMoney(cart.total_price, $cart.data("money-format")) +
        "</span></span>" +
        "<span>Subtotal:</span>";

      if (total_savings > 0) {
        cart_savings_html =
          '<span class="right"><span class="money was_price_clr">' +
          Shopify.formatMoney(original_price, $cart.data("money-format")) +
          "</span></span>" +
          "<span>Original Price:</span>";
      } else {
        cart_savings_html = "";
      }
    }

    $(".js-cart_items").html(cart_items_html);
    $(".js-cart_subtotal").html(cart_action_html);
    $(".js-cart_savings").html(cart_savings_html);

    console.log(isPhonecases);
    if (isPhonecases == true) {
      $("a.minicart-checkout-btn").removeClass("hidden-force");
      $(".cart_content input.action_button").addClass("hidden-force");
    } else {
      $("a.minicart-checkout-btn").addClass("hidden-force");
      $(".cart_content input.action_button").removeClass("hidden-force");
    }
  }

  $("body").on("change", "#cart_form input.quantity", function () {
    //get_minicart_notify();
    ajaxUpdateCart(
      $(this).data("line-id"),
      $(this).val(),
      $(this).parents("#cart_form")
    );
  });

  $("body").on("change", ".cart_content input.quantity", function () {
    //get_minicart_notify();
    ajaxUpdateCart(
      $(this).data("line-id"),
      $(this).val(),
      $(this).parents(".cart_content")
    );
  });

  if (is_home == "cart") {
    $("body").on("click", "a.remove", function () {
      ajaxUpdateCart(
        $(this).data("line-id"),
        $(this).data("qty"),
        $(this).parents("#cart_form")
      );
      var Tempid = $(this).data("varid");
      //                           removeElement(window.CartHasPhonecases,Tempid)
      //                           console.log(removeElement(window.CartHasPhonecases,Tempid))
      //get_minicart_notify();
    });
  } else {
    $("body").on("click", "a.item-delete", function () {
      ajaxUpdateCart(
        $(this).data("line-id"),
        $(this).data("qty"),
        $(this).parents(".cart_content")
      );
      var Tempid = $(this).data("varid");
      //                           removeElement(window.CartHasPhonecases,Tempid)
      //get_minicart_notify();
    });
  }

  function openMiniCart() {
    if ($("#header").is(":visible")) {
      //                 $('#header .cart_container').addClass('active_link');
      $(".cart_container .cart_content").show();
      $("#mySidebar").css("transform", "translateX(0px)");
      $("#myOverlay").fadeIn();
    } else if ($(".sticky_nav--stick").length) {
      //                 $('.sticky_nav .cart_container').addClass('active_link');
      $(".cart_container .cart_content").show();
      $("#mySidebar").css("transform", "translateX(0px)");
      $("#myOverlay").fadeIn();
    } else {
      //                 $('.top_bar .cart_container').addClass('active_link');
      $(".cart_container .cart_content").show();
      $("#mySidebar").css("transform", "translateX(0px)");
      $("#myOverlay").fadeIn();
    }
  }
  $(document).on(
    "opening",
    ".remodal.upsell-popup, .remodal.upsell-popup2",
    function (e) {
      $(window).trigger("resize");
      $(".upsell-product-slider").slick("reinit");
      $(window).on("orientationchange resize load", function () {
        $(".upsell-product-slider").slick("reinit");
      });
    }
  );

  $(document).on(
    "closing",
    ".remodal.upsell-popup2:not(.secondpopup)",
    function (e) {
      // Reason: 'confirmation', 'cancellation'
      var current_product_type = String(
        $(".action_button.add_to_cart.cart-btn").data("current-product")
      );
      var current_popup = String($(this).data("remodal-id"));
      console.log(current_product_type, current_popup);
      $("div.remodal").removeClass("secondpopup");
      if (
        current_product_type == "phone-case" &&
        current_popup == "upsellPhoneRings"
      ) {
        //         upsellPhonePockets.open();
        openMiniCart();
        $("[data-remodal-id=upsellPhonePockets]").addClass("secondpopup");
      } else if (
        current_product_type == "shop-phone-pockets" &&
        current_popup == "upsellPhoneMirrors"
      ) {
        $("[data-remodal-id=upsellPhoneCases]").addClass("secondpopup");
        upsellPhoneCases.open();
      } else if (current_product_type != "phone-case") {
        $("[data-remodal-id=upsellPhoneCases]").addClass("secondpopup");
        upsellPhoneCases.open();
      }
    }
  );

  $(document).on("closing", ".remodal.secondpopup", function (e) {
    openMiniCart();
  });
  $("a.upsell-popup1-close").on("click", function (e) {
    e.preventDefault();
    var upsell_modal = $("div.remodal.upsell-popup2.remodal-is-opened").remodal(
      {
        hashTracking: false,
        closeOnOutsideClick: true,
      }
    );
    upsell_modal.close();
  });
  $("a.upsell-popup2-close").on("click", function (e) {
    e.preventDefault();
    var upsell_modal2 = $(
      "div.remodal.upsell-popup2.remodal-is-opened"
    ).remodal({
      hashTracking: false,
      closeOnOutsideClick: true,
    });
    upsell_modal2.close();
  });

  $("body").on("submit", ".product_form", function (e) {
    e.preventDefault();
    var $addToCartForm = $(this);
    var $addToCartBtn = $addToCartForm.find(".add_to_cart");
    console.log('$addToCartForm.serialize()',$addToCartForm.serialize())
    // alert('$addToCartForm.serialize()'+$addToCartForm.serialize())
    $addToCartBtn.find('.text').text('Adding...');
    $.ajax({
      url: "/cart/add.js",
      dataType: "json",
      cache: false,
      type: "post",
      data: $addToCartForm.serialize(),
      beforeSend: function () {
        $addToCartBtn.addClass("disabled");
        //         $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
      },
      success: function (itemData) {
        //         $addToCartBtn.find('.checkmark').addClass('checkmark-active');
        $addToCartBtn.removeClass("disabled");
        $addToCartBtn.find(".text").text("ADDED!");
        setTimeout(function () {
          $addToCartBtn.find(".text").text("Add to Bag");
        }, 700);
        window.setTimeout(function () {
          //           $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
          //           $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');

          var current_Ptype = String($addToCartBtn.data("current-product"));

          if (
            window.upsell_pop_enable == true &&
            window.enable_upsell_phonecases == true
          ) {
            if (
              current_Ptype == "shop-phone-cases" ||
              current_Ptype == "phone-case"
            ) {
              console.log(current_Ptype);
              Open_upsell_modal(current_Ptype);
            } else {
              console.log("else");
              openMiniCart();
            }
          } else if (
            window.upsell_pop_enable == true &&
            window.enable_upsell_phonecases == false
          ) {
            if (current_Ptype == "shop-phone-mirrors") {
              Open_upsell_modal(current_Ptype);
            } else if (
              current_Ptype == "shop-phone-cases" ||
              current_Ptype == "phone-case"
            ) {
              console.log(current_Ptype);
              Open_upsell_modal(current_Ptype);
            } else if (current_Ptype == "shop-phone-pockets") {
              Open_upsell_modal(current_Ptype);
            } else if (current_Ptype == "shop-phone-rings") {
              Open_upsell_modal(current_Ptype);
            } else if (current_Ptype == "shop-phone-charms") {
              Open_upsell_modal(current_Ptype);
            } else if (current_Ptype == "shop-swipe-wipes") {
              Open_upsell_modal(current_Ptype);
            } else if (current_Ptype == "shop-sticker-tags") {
              Open_upsell_modal(current_Ptype);
            } else {
              console.log("this is non popup prods");
              openMiniCart();
            }
            openMiniCart();
          } else {
            console.log("upsell settings off");
            openMiniCart();
          }
        }, 500);

        $.ajax({
          url: "/cart.js",
          dataType: "json",
          cache: false,
          success: function (cart) {
            refreshCart(cart);
            if ($("html").hasClass("remodal-is-locked")) {
              $(".remodal-close").click();
            }
          },
        });
      },
      error: function (XMLHttpRequest) {
        var response = eval("(" + XMLHttpRequest.responseText + ")");
        response = response.description;
        $(".warning").remove();

        var warning =
          '<p class="warning animated bounceIn">' +
          response.replace("All 1 ", "All ") +
          "</p>";
        $addToCartForm.after(warning);
        $addToCartBtn.removeAttr("disabled").removeClass("disabled");
        $addToCartBtn
          .find("span")
          .text("Add to Cart")
          .removeClass("zoomOut")
          .addClass("zoomIn");
      },
    });

    return false;
  });

  //Swatches linked with selected options
});

/*============================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
==============================================================================*/

Shopify.updateOptionsInSelector = function (selectorIndex) {
  switch (selectorIndex) {
    case 0:
      var key = "root";
      var selector = jQuery(".single-option-selector:eq(0)");
      break;
    case 1:
      var key = jQuery(".single-option-selector:eq(0)").val();
      var selector = jQuery(".single-option-selector:eq(1)");
      break;
    case 2:
      var key = jQuery(".single-option-selector:eq(0)").val();
      key += " / " + jQuery(".single-option-selector:eq(1)").val();
      var selector = jQuery(".single-option-selector:eq(2)");
  }

  var initialValue = selector.val();
  selector.empty();
  var availableOptions = Shopify.optionsMap[key];
  for (var i = 0; i < availableOptions.length; i++) {
    var option = availableOptions[i];
    var newOption = jQuery("<option></option>").val(option).html(option);
    selector.append(newOption);
  }
  jQuery(
    '.swatch[data-option-index="' + selectorIndex + '"] .swatch-element'
  ).each(function () {
    if (jQuery.inArray($(this).attr("data-value"), availableOptions) !== -1) {
      $(this)
        .removeClass("soldout")
        .show()
        .find(":radio")
        .removeAttr("disabled", "disabled")
        .removeAttr("checked");
    } else {
      $(this)
        .addClass("soldout")
        .hide()
        .find(":radio")
        .removeAttr("checked")
        .attr("disabled", "disabled");
    }
  });
  if (jQuery.inArray(initialValue, availableOptions) !== -1) {
    selector.val(initialValue);
  }
  selector.trigger("change");
};

Shopify.linkOptionSelectors = function (product) {
  // Building our mapping object.
  for (var i = 0; i < product.variants.length; i++) {
    var variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      Shopify.optionsMap["root"] = Shopify.optionsMap["root"] || [];
      Shopify.optionsMap["root"].push(variant.option1);
      Shopify.optionsMap["root"] = Shopify.uniq(Shopify.optionsMap["root"]);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option2);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        var key = variant.option1 + " / " + variant.option2;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option3);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
    }
  }
};

//Used for cart functionality
function htmlEncode(value) {
  if (value) {
    return $("<div/>").text(value).html();
  } else {
    return "";
  }
}

//Check if device is touch-enabled
function is_touch_device() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}

/* option_selection.js */
function floatToString(t, e) {
  var o = t.toFixed(e).toString();
  return o.match(/^\.\d+/) ? "0" + o : o;
}
if ("undefined" == typeof Shopify) var Shopify = {};
(Shopify.each = function (t, e) {
  for (var o = 0; o < t.length; o++) e(t[o], o);
}),
  (Shopify.map = function (t, e) {
    for (var o = [], i = 0; i < t.length; i++) o.push(e(t[i], i));
    return o;
  }),
  (Shopify.arrayIncludes = function (t, e) {
    for (var o = 0; o < t.length; o++) if (t[o] == e) return !0;
    return !1;
  }),
  (Shopify.uniq = function (t) {
    for (var e = [], o = 0; o < t.length; o++)
      Shopify.arrayIncludes(e, t[o]) || e.push(t[o]);
    return e;
  }),
  (Shopify.isDefined = function (t) {
    return "undefined" == typeof t ? !1 : !0;
  }),
  (Shopify.getClass = function (t) {
    return Object.prototype.toString.call(t).slice(8, -1);
  }),
  (Shopify.extend = function (t, e) {
    function o() {}
    (o.prototype = e.prototype),
      (t.prototype = new o()),
      (t.prototype.constructor = t),
      (t.baseConstructor = e),
      (t.superClass = e.prototype);
  }),
  (Shopify.locationSearch = function () {
    return window.location.search;
  }),
  (Shopify.locationHash = function () {
    return window.location.hash;
  }),
  (Shopify.replaceState = function (t) {
    window.history.replaceState({}, document.title, t);
  }),
  (Shopify.urlParam = function (t) {
    var e = RegExp("[?&]" + t + "=([^&#]*)").exec(Shopify.locationSearch());
    return e && decodeURIComponent(e[1].replace(/\+/g, " "));
  }),
  (Shopify.newState = function (t, e) {
    var o;
    return (
      (o = Shopify.urlParam(t)
        ? Shopify.locationSearch().replace(
            RegExp("(" + t + "=)[^&#]+"),
            "$1" + e
          )
        : "" === Shopify.locationSearch()
        ? "?" + t + "=" + e
        : Shopify.locationSearch() + "&" + t + "=" + e),
      o + Shopify.locationHash()
    );
  }),
  (Shopify.setParam = function (t, e) {
    Shopify.replaceState(Shopify.newState(t, e));
  }),
  (Shopify.Product = function (t) {
    Shopify.isDefined(t) && this.update(t);
  }),
  (Shopify.Product.prototype.update = function (t) {
    for (property in t) this[property] = t[property];
  }),
  (Shopify.Product.prototype.optionNames = function () {
    return "Array" == Shopify.getClass(this.options) ? this.options : [];
  }),
  (Shopify.Product.prototype.optionValues = function (t) {
    if (!Shopify.isDefined(this.variants)) return null;
    var e = Shopify.map(this.variants, function (e) {
      var o = "option" + (t + 1);
      return void 0 == e[o] ? null : e[o];
    });
    return null == e[0] ? null : Shopify.uniq(e);
  }),
  (Shopify.Product.prototype.getVariant = function (t) {
    var e = null;
    return t.length != this.options.length
      ? e
      : (Shopify.each(this.variants, function (o) {
          for (var i = !0, r = 0; r < t.length; r++) {
            var n = "option" + (r + 1);
            o[n] != t[r] && (i = !1);
          }
          return 1 == i ? void (e = o) : void 0;
        }),
        e);
  }),
  (Shopify.Product.prototype.getVariantById = function (t) {
    for (var e = 0; e < this.variants.length; e++) {
      var o = this.variants[e];
      if (t == o.id) return o;
    }
    return null;
  }),
  (Shopify.money_format = "$"),
  (Shopify.formatMoney = function (t, e) {
    function o(t, e) {
      return "undefined" == typeof t ? e : t;
    }
    function i(t, e, i, r) {
      if (
        ((e = o(e, 2)), (i = o(i, ",")), (r = o(r, ".")), isNaN(t) || null == t)
      )
        return 0;
      t = (t / 100).toFixed(e);
      var n = t.split("."),
        a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i),
        s = n[1] ? r + n[1] : "";
      return a + s;
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var r = "",
      n = /\{\{\s*(\w+)\s*\}\}/,
      a = e || this.money_format;
    switch (a.match(n)[1]) {
      case "amount":
        r = i(t, 2);
        break;
      case "amount_no_decimals":
        r = i(t, 0);
        break;
      case "amount_with_comma_separator":
        r = i(t, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        r = i(t, 0, ".", ",");
    }
    return a.replace(n, r);
  }),
  (Shopify.OptionSelectors = function (t, e) {
    return (
      (this.selectorDivClass = "selector-wrapper"),
      (this.selectorClass = "single-option-selector"),
      (this.variantIdFieldIdSuffix = "-variant-id"),
      (this.variantIdField = null),
      (this.historyState = null),
      (this.selectors = []),
      (this.domIdPrefix = t),
      (this.product = new Shopify.Product(e.product)),
      (this.onVariantSelected = Shopify.isDefined(e.onVariantSelected)
        ? e.onVariantSelected
        : function () {}),
      this.replaceSelector(t),
      this.initDropdown(),
      e.enableHistoryState &&
        (this.historyState = new Shopify.OptionSelectors.HistoryState(this)),
      !0
    );
  }),
  (Shopify.OptionSelectors.prototype.initDropdown = function () {
    var t = { initialLoad: !0 },
      e = this.selectVariantFromDropdown(t);
    if (!e) {
      var o = this;
      setTimeout(function () {
        o.selectVariantFromParams(t) ||
          o.fireOnChangeForFirstDropdown.call(o, t);
      });
    }
  }),
  (Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function (
    t
  ) {
    this.selectors[0].element.onchange(t);
  }),
  (Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown =
    function (t) {
      var e = this.selectVariantFromParams(t);
      e || this.selectVariantFromDropdown(t);
    }),
  (Shopify.OptionSelectors.prototype.replaceSelector = function (t) {
    var e = document.getElementById(t),
      o = e.parentNode;
    Shopify.each(this.buildSelectors(), function (t) {
      o.insertBefore(t, e);
    }),
      (e.style.display = "none"),
      (this.variantIdField = e);
  }),
  (Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function (t) {
    var e = document
      .getElementById(this.domIdPrefix)
      .querySelector("[selected]");
    if (
      (e ||
        (e = document
          .getElementById(this.domIdPrefix)
          .querySelector('[selected="selected"]')),
      !e)
    )
      return !1;
    var o = e.value;
    return this.selectVariant(o, t);
  }),
  (Shopify.OptionSelectors.prototype.selectVariantFromParams = function (t) {
    var e = Shopify.urlParam("variant");
    return this.selectVariant(e, t);
  }),
  (Shopify.OptionSelectors.prototype.selectVariant = function (t, e) {
    var o = this.product.getVariantById(t);
    if (null == o) return !1;
    for (var i = 0; i < this.selectors.length; i++) {
      var r = this.selectors[i].element,
        n = r.getAttribute("data-option"),
        a = o[n];
      null != a && this.optionExistInSelect(r, a) && (r.value = a);
    }
    return (
      "undefined" != typeof jQuery
        ? jQuery(this.selectors[0].element).trigger("change", e)
        : this.selectors[0].element.onchange(e),
      !0
    );
  }),
  (Shopify.OptionSelectors.prototype.optionExistInSelect = function (t, e) {
    for (var o = 0; o < t.options.length; o++)
      if (t.options[o].value == e) return !0;
  }),
  (Shopify.OptionSelectors.prototype.insertSelectors = function (t, e) {
    Shopify.isDefined(e) && this.setMessageElement(e),
      (this.domIdPrefix = "product-" + this.product.id + "-variant-selector");
    var o = document.getElementById(t);
    Shopify.each(this.buildSelectors(), function (t) {
      o.appendChild(t);
    });
  }),
  (Shopify.OptionSelectors.prototype.buildSelectors = function () {
    for (var t = 0; t < this.product.optionNames().length; t++) {
      var e = new Shopify.SingleOptionSelector(
        this,
        t,
        this.product.optionNames()[t],
        this.product.optionValues(t)
      );
      (e.element.disabled = !1), this.selectors.push(e);
    }
    var o = this.selectorDivClass,
      i = this.product.optionNames(),
      r = Shopify.map(this.selectors, function (t) {
        var e = document.createElement("div");
        if ((e.setAttribute("class", o), i.length > 0)) {
          var r = document.createElement("label");
          (r.htmlFor = t.element.id),
            (r.innerHTML = t.name + ":"),
            e.appendChild(r);
        }
        // console.log(t.element)
        return e.appendChild(t.element), e;
      });
    return r;
  }),
  (Shopify.OptionSelectors.prototype.selectedValues = function () {
    for (var t = [], e = 0; e < this.selectors.length; e++) {
      var o = this.selectors[e].element.value;
      t.push(o);
    }
    return t;
  }),
  (Shopify.OptionSelectors.prototype.updateSelectors = function (t, e) {
    var o = this.selectedValues(),
      i = this.product.getVariant(o);
    i
      ? ((this.variantIdField.disabled = !1),
        (this.variantIdField.value = i.id))
      : (this.variantIdField.disabled = !0),
      this.onVariantSelected(i, this, e),
      null != this.historyState &&
        this.historyState.onVariantChange(i, this, e);
  }),
  (Shopify.OptionSelectorsFromDOM = function (t, e) {
    var o = e.optionNames || [],
      i = e.priceFieldExists || !0,
      r = e.delimiter || "/",
      n = this.createProductFromSelector(t, o, i, r);
    (e.product = n),
      Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, t, e);
  }),
  Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors),
  (Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector =
    function (t, e, o, i) {
      if (!Shopify.isDefined(o)) var o = !0;
      if (!Shopify.isDefined(i)) var i = "/";
      var r = document.getElementById(t),
        n = r.childNodes,
        a = (r.parentNode, e.length),
        s = [];
      Shopify.each(n, function (t, r) {
        if (1 == t.nodeType && "option" == t.tagName.toLowerCase()) {
          var n = t.innerHTML.split(new RegExp("\\s*\\" + i + "\\s*"));
          0 == e.length && (a = n.length - (o ? 1 : 0));
          var p = n.slice(0, a),
            l = o ? n[a] : "",
            c =
              (t.getAttribute("value"),
              {
                available: t.disabled ? !1 : !0,
                id: parseFloat(t.value),
                price: l,
                option1: p[0],
                option2: p[1],
                option3: p[2],
              });
          s.push(c);
        }
      });
      var p = { variants: s };
      if (0 == e.length) {
        p.options = [];
        for (var l = 0; a > l; l++) p.options[l] = "option " + (l + 1);
      } else p.options = e;
      return p;
    }),
  (Shopify.SingleOptionSelector = function (t, e, o, i) {
    (this.multiSelector = t),
      (this.values = i),
      (this.index = e),
      (this.name = o),
      (this.element = document.createElement("select"));
    for (var r = 0; r < i.length; r++) {
      var n = document.createElement("option");
      (n.value = i[r]),
        (n.innerHTML = i[r]),
        n.setAttribute("data-key", slugify(i[r])),
        this.element.appendChild(n);
    }
    return (
      this.element.setAttribute("class", this.multiSelector.selectorClass),
      this.element.setAttribute('aria-label',"Select a Model"),
      this.element.setAttribute("data-option", "option" + (e + 1)),
      (this.element.id = t.domIdPrefix + "-option-" + e),
      (this.element.onchange = function (o, i) {
        (i = i || {}), t.updateSelectors(e, i);
      }),
      !0
    );
  }),
  (Shopify.Image = {
    preload: function (t, e) {
      for (var o = 0; o < t.length; o++) {
        var i = t[o];
        this.loadImage(this.getSizedImageUrl(i, e));
      }
    },
    loadImage: function (t) {
      new Image().src = t;
    },
    switchImage: function (t, e, o) {
      if (t && e) {
        var i = this.imageSize(e.src),
          r = this.getSizedImageUrl(t.src, i);
        o ? o(r, t, e) : (e.src = r);
      }
    },
    imageSize: function (t) {
      var e = t.match(
        /_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./
      );
      return null != e ? e[1] : null;
    },
    getSizedImageUrl: function (t, e) {
      if (null == e) return t;
      if ("master" == e) return this.removeProtocol(t);
      var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
      if (null != o) {
        var i = t.split(o[0]),
          r = o[0];
        return this.removeProtocol(i[0] + "_" + e + r);
      }
      return null;
    },
    removeProtocol: function (t) {
      return t.replace(/http(s)?:/, "");
    },
  }),
  (Shopify.OptionSelectors.HistoryState = function (t) {
    this.browserSupports() && this.register(t);
  }),
  (Shopify.OptionSelectors.HistoryState.prototype.register = function (t) {
    window.addEventListener("popstate", function (e) {
      t.selectVariantFromParamsOrDropdown({ popStateCall: !0 });
    });
  }),
  (Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (
    t,
    e,
    o
  ) {
    this.browserSupports() &&
      (!t ||
        o.initialLoad ||
        o.popStateCall ||
        Shopify.setParam("variant", t.id));
  }),
  (Shopify.OptionSelectors.HistoryState.prototype.browserSupports =
    function () {
      return window.history && window.history.replaceState;
    });

!(function () {
  "use strict";
  function t(e, o) {
    function i(t, e) {
      return function () {
        return t.apply(e, arguments);
      };
    }
    var r;
    if (
      ((o = o || {}),
      (this.trackingClick = !1),
      (this.trackingClickStart = 0),
      (this.targetElement = null),
      (this.touchStartX = 0),
      (this.touchStartY = 0),
      (this.lastTouchIdentifier = 0),
      (this.touchBoundary = o.touchBoundary || 10),
      (this.layer = e),
      (this.tapDelay = o.tapDelay || 200),
      (this.tapTimeout = o.tapTimeout || 700),
      !t.notNeeded(e))
    ) {
      for (
        var a = [
            "onMouse",
            "onClick",
            "onTouchStart",
            "onTouchMove",
            "onTouchEnd",
            "onTouchCancel",
          ],
          c = this,
          s = 0,
          u = a.length;
        u > s;
        s++
      )
        c[a[s]] = i(c[a[s]], c);
      n &&
        (e.addEventListener("mouseover", this.onMouse, !0),
        e.addEventListener("mousedown", this.onMouse, !0),
        e.addEventListener("mouseup", this.onMouse, !0)),
        e.addEventListener("click", this.onClick, !0),
        e.addEventListener("touchstart", this.onTouchStart, !1),
        e.addEventListener("touchmove", this.onTouchMove, !1),
        e.addEventListener("touchend", this.onTouchEnd, !1),
        e.addEventListener("touchcancel", this.onTouchCancel, !1),
        Event.prototype.stopImmediatePropagation ||
          ((e.removeEventListener = function (t, n, o) {
            var i = Node.prototype.removeEventListener;
            "click" === t
              ? i.call(e, t, n.hijacked || n, o)
              : i.call(e, t, n, o);
          }),
          (e.addEventListener = function (t, n, o) {
            var i = Node.prototype.addEventListener;
            "click" === t
              ? i.call(
                  e,
                  t,
                  n.hijacked ||
                    (n.hijacked = function (t) {
                      t.propagationStopped || n(t);
                    }),
                  o
                )
              : i.call(e, t, n, o);
          })),
        "function" == typeof e.onclick &&
          ((r = e.onclick),
          e.addEventListener(
            "click",
            function (t) {
              r(t);
            },
            !1
          ),
          (e.onclick = null));
    }
  }
  var e = navigator.userAgent.indexOf("Windows Phone") >= 0,
    n = navigator.userAgent.indexOf("Android") > 0 && !e,
    o = /iP(ad|hone|od)/.test(navigator.userAgent) && !e,
    i = o && /OS 4_\d(_\d)?/.test(navigator.userAgent),
    r = o && /OS [6-7]_\d/.test(navigator.userAgent),
    a = navigator.userAgent.indexOf("BB10") > 0;
  (t.prototype.needsClick = function (t) {
    switch (t.nodeName.toLowerCase()) {
      case "button":
      case "select":
      case "textarea":
        if (t.disabled) return !0;
        break;
      case "input":
        if ((o && "file" === t.type) || t.disabled) return !0;
        break;
      case "label":
      case "iframe":
      case "video":
        return !0;
    }
    return /\bneedsclick\b/.test(t.className);
  }),
    (t.prototype.needsFocus = function (t) {
      switch (t.nodeName.toLowerCase()) {
        case "textarea":
          return !0;
        case "select":
          return !n;
        case "input":
          switch (t.type) {
            case "button":
            case "checkbox":
            case "file":
            case "image":
            case "radio":
            case "submit":
              return !1;
          }
          return !t.disabled && !t.readOnly;
        default:
          return /\bneedsfocus\b/.test(t.className);
      }
    }),
    (t.prototype.sendClick = function (t, e) {
      var n, o;
      document.activeElement &&
        document.activeElement !== t &&
        document.activeElement.blur(),
        (o = e.changedTouches[0]),
        (n = document.createEvent("MouseEvents")),
        n.initMouseEvent(
          this.determineEventType(t),
          !0,
          !0,
          window,
          1,
          o.screenX,
          o.screenY,
          o.clientX,
          o.clientY,
          !1,
          !1,
          !1,
          !1,
          0,
          null
        ),
        (n.forwardedTouchEvent = !0),
        t.dispatchEvent(n);
    }),
    (t.prototype.determineEventType = function (t) {
      return n && "select" === t.tagName.toLowerCase() ? "mousedown" : "click";
    }),
    (t.prototype.focus = function (t) {
      var e;
      o &&
      t.setSelectionRange &&
      0 !== t.type.indexOf("date") &&
      "time" !== t.type &&
      "month" !== t.type
        ? ((e = t.value.length), t.setSelectionRange(e, e))
        : t.focus();
    }),
    (t.prototype.updateScrollParent = function (t) {
      var e, n;
      if (((e = t.fastClickScrollParent), !e || !e.contains(t))) {
        n = t;
        do {
          if (n.scrollHeight > n.offsetHeight) {
            (e = n), (t.fastClickScrollParent = n);
            break;
          }
          n = n.parentElement;
        } while (n);
      }
      e && (e.fastClickLastScrollTop = e.scrollTop);
    }),
    (t.prototype.getTargetElementFromEventTarget = function (t) {
      return t.nodeType === Node.TEXT_NODE ? t.parentNode : t;
    }),
    (t.prototype.onTouchStart = function (t) {
      var e, n, r;
      if (t.targetTouches.length > 1) return !0;
      if (
        ((e = this.getTargetElementFromEventTarget(t.target)),
        (n = t.targetTouches[0]),
        o)
      ) {
        if (((r = window.getSelection()), r.rangeCount && !r.isCollapsed))
          return !0;
        if (!i) {
          if (n.identifier && n.identifier === this.lastTouchIdentifier)
            return t.preventDefault(), !1;
          (this.lastTouchIdentifier = n.identifier), this.updateScrollParent(e);
        }
      }
      return (
        (this.trackingClick = !0),
        (this.trackingClickStart = t.timeStamp),
        (this.targetElement = e),
        (this.touchStartX = n.pageX),
        (this.touchStartY = n.pageY),
        t.timeStamp - this.lastClickTime < this.tapDelay && t.preventDefault(),
        !0
      );
    }),
    (t.prototype.touchHasMoved = function (t) {
      var e = t.changedTouches[0],
        n = this.touchBoundary;
      return Math.abs(e.pageX - this.touchStartX) > n ||
        Math.abs(e.pageY - this.touchStartY) > n
        ? !0
        : !1;
    }),
    (t.prototype.onTouchMove = function (t) {
      return this.trackingClick
        ? ((this.targetElement !==
            this.getTargetElementFromEventTarget(t.target) ||
            this.touchHasMoved(t)) &&
            ((this.trackingClick = !1), (this.targetElement = null)),
          !0)
        : !0;
    }),
    (t.prototype.findControl = function (t) {
      return void 0 !== t.control
        ? t.control
        : t.htmlFor
        ? document.getElementById(t.htmlFor)
        : t.querySelector(
            "button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea"
          );
    }),
    (t.prototype.onTouchEnd = function (t) {
      var e,
        a,
        c,
        s,
        u,
        l = this.targetElement;
      if (!this.trackingClick) return !0;
      if (t.timeStamp - this.lastClickTime < this.tapDelay)
        return (this.cancelNextClick = !0), !0;
      if (t.timeStamp - this.trackingClickStart > this.tapTimeout) return !0;
      if (
        ((this.cancelNextClick = !1),
        (this.lastClickTime = t.timeStamp),
        (a = this.trackingClickStart),
        (this.trackingClick = !1),
        (this.trackingClickStart = 0),
        r &&
          ((u = t.changedTouches[0]),
          (l =
            document.elementFromPoint(
              u.pageX - window.pageXOffset,
              u.pageY - window.pageYOffset
            ) || l),
          (l.fastClickScrollParent = this.targetElement.fastClickScrollParent)),
        (c = l.tagName.toLowerCase()),
        "label" === c)
      ) {
        if ((e = this.findControl(l))) {
          if ((this.focus(l), n)) return !1;
          l = e;
        }
      } else if (this.needsFocus(l))
        return t.timeStamp - a > 100 ||
          (o && window.top !== window && "input" === c)
          ? ((this.targetElement = null), !1)
          : (this.focus(l),
            this.sendClick(l, t),
            (o && "select" === c) ||
              ((this.targetElement = null), t.preventDefault()),
            !1);
      return o &&
        !i &&
        ((s = l.fastClickScrollParent),
        s && s.fastClickLastScrollTop !== s.scrollTop)
        ? !0
        : (this.needsClick(l) || (t.preventDefault(), this.sendClick(l, t)),
          !1);
    }),
    (t.prototype.onTouchCancel = function () {
      (this.trackingClick = !1), (this.targetElement = null);
    }),
    (t.prototype.onMouse = function (t) {
      return this.targetElement
        ? t.forwardedTouchEvent
          ? !0
          : t.cancelable &&
            (!this.needsClick(this.targetElement) || this.cancelNextClick)
          ? (t.stopImmediatePropagation
              ? t.stopImmediatePropagation()
              : (t.propagationStopped = !0),
            t.stopPropagation(),
            t.preventDefault(),
            !1)
          : !0
        : !0;
    }),
    (t.prototype.onClick = function (t) {
      var e;
      return this.trackingClick
        ? ((this.targetElement = null), (this.trackingClick = !1), !0)
        : "submit" === t.target.type && 0 === t.detail
        ? !0
        : ((e = this.onMouse(t)), e || (this.targetElement = null), e);
    }),
    (t.prototype.destroy = function () {
      var t = this.layer;
      n &&
        (t.removeEventListener("mouseover", this.onMouse, !0),
        t.removeEventListener("mousedown", this.onMouse, !0),
        t.removeEventListener("mouseup", this.onMouse, !0)),
        t.removeEventListener("click", this.onClick, !0),
        t.removeEventListener("touchstart", this.onTouchStart, !1),
        t.removeEventListener("touchmove", this.onTouchMove, !1),
        t.removeEventListener("touchend", this.onTouchEnd, !1),
        t.removeEventListener("touchcancel", this.onTouchCancel, !1);
    }),
    (t.notNeeded = function (t) {
      var e, o, i, r;
      if ("undefined" == typeof window.ontouchstart) return !0;
      if ((o = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1])) {
        if (!n) return !0;
        if ((e = document.querySelector("meta[name=viewport]"))) {
          if (-1 !== e.content.indexOf("user-scalable=no")) return !0;
          if (
            o > 31 &&
            document.documentElement.scrollWidth <= window.outerWidth
          )
            return !0;
        }
      }
      if (
        a &&
        ((i = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/)),
        i[1] >= 10 &&
          i[2] >= 3 &&
          (e = document.querySelector("meta[name=viewport]")))
      ) {
        if (-1 !== e.content.indexOf("user-scalable=no")) return !0;
        if (document.documentElement.scrollWidth <= window.outerWidth)
          return !0;
      }
      return "none" === t.style.msTouchAction ||
        "manipulation" === t.style.touchAction
        ? !0
        : ((r = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [, 0])[1]),
          r >= 27 &&
          ((e = document.querySelector("meta[name=viewport]")),
          e &&
            (-1 !== e.content.indexOf("user-scalable=no") ||
              document.documentElement.scrollWidth <= window.outerWidth))
            ? !0
            : "none" === t.style.touchAction ||
              "manipulation" === t.style.touchAction
            ? !0
            : !1);
    }),
    (t.attach = function (e, n) {
      return new t(e, n);
    }),
    "function" == typeof define && "object" == typeof define.amd && define.amd
      ? define(function () {
          return t;
        })
      : "undefined" != typeof module && module.exports
      ? ((module.exports = t.attach), (module.exports.FastClick = t))
      : (window.FastClick = t);
})();

/*
 * jQuery offscreen plugin
 *
 * Copyright Cory LaViska for A Beautiful Site, LLC
 *
 * @license: http://opensource.org/licenses/MIT
 *
 */
(function ($) {
  $.extend($.expr[":"], {
    "off-top": function (el) {
      return $(el).offset().top < $(window).scrollTop();
    },
    "off-right": function (el) {
      return (
        $(el).offset().left + $(el).outerWidth() - $(window).scrollLeft() >
        $(window).width()
      );
    },
    "off-bottom": function (el) {
      return (
        $(el).offset().top + $(el).outerHeight() - $(window).scrollTop() >
        $(window).height()
      );
    },
    "off-left": function (el) {
      return $(el).offset().left < $(window).scrollLeft();
    },
    "off-screen": function (el) {
      return $(el).is(":off-top, :off-right, :off-bottom, :off-left");
    },
  });
})(jQuery);

/*!
  Zoom 1.7.15
  license: MIT
  http://www.jacklmoore.com/zoom
*/
(function ($) {
  var defaults = {
    url: false,
    callback: false,
    target: false,
    duration: 120,
    on: "mouseover",
    touch: true,
    onZoomIn: false,
    onZoomOut: false,
    magnify: 1,
  };
  $.zoom = function (target, source, img, magnify) {
    var targetHeight,
      targetWidth,
      sourceHeight,
      sourceWidth,
      xRatio,
      yRatio,
      offset,
      $target = $(target),
      position = $target.css("position"),
      $source = $(source);
    $target.css(
      "position",
      /(absolute|fixed)/.test(position) ? position : "relative"
    );
    $target.css("overflow", "hidden");
    img.style.width = img.style.height = "";
    $(img)
      .addClass("zoomImg")
      .css({
        position: "absolute",
        top: 0,
        left: 0,
        opacity: 0,
        width: img.width * magnify,
        height: img.height * magnify,
        border: "none",
        maxWidth: "none",
        maxHeight: "none",
      })
      .appendTo(target);
    return {
      init: function () {
        targetWidth = $target.outerWidth();
        targetHeight = $target.outerHeight();
        if (source === $target[0]) {
          sourceWidth = targetWidth;
          sourceHeight = targetHeight;
        } else {
          sourceWidth = $source.outerWidth();
          sourceHeight = $source.outerHeight();
        }
        xRatio = (img.width - targetWidth) / sourceWidth;
        yRatio = (img.height - targetHeight) / sourceHeight;
        offset = $source.offset();
      },
      move: function (e) {
        var left = e.pageX - offset.left,
          top = e.pageY - offset.top;
        top = Math.max(Math.min(top, sourceHeight), 0);
        left = Math.max(Math.min(left, sourceWidth), 0);
        img.style.left = left * -xRatio + "px";
        img.style.top = top * -yRatio + "px";
      },
    };
  };
  $.fn.zoom = function (options) {
    return this.each(function () {
      var settings = $.extend({}, defaults, options || {}),
        target = settings.target || this,
        source = this,
        $source = $(source),
        $target = $(target),
        img = document.createElement("img"),
        $img = $(img),
        mousemove = "mousemove.zoom",
        clicked = false,
        touched = false,
        $urlElement;
      if (!settings.url) {
        $urlElement = $source.find("img");
        if ($urlElement[0]) {
          settings.url = $urlElement.data("src") || $urlElement.attr("src");
        }
        if (!settings.url) {
          return;
        }
      }
      (function () {
        var position = $target.css("position");
        var overflow = $target.css("overflow");
        $source.one("zoom.destroy", function () {
          $source.off(".zoom");
          $target.css("position", position);
          $target.css("overflow", overflow);
          $img.remove();
        });
      })();
      img.onload = function () {
        var zoom = $.zoom(target, source, img, settings.magnify);
        function start(e) {
          zoom.init();
          zoom.move(e);
          $img
            .stop()
            .fadeTo(
              $.support.opacity ? settings.duration : 0,
              1,
              $.isFunction(settings.onZoomIn)
                ? settings.onZoomIn.call(img)
                : false
            );
        }
        function stop() {
          $img
            .stop()
            .fadeTo(
              settings.duration,
              0,
              $.isFunction(settings.onZoomOut)
                ? settings.onZoomOut.call(img)
                : false
            );
        }
        if (settings.on === "grab") {
          $source.on("mousedown.zoom", function (e) {
            if (e.which === 1) {
              $(document).one("mouseup.zoom", function () {
                stop();
                $(document).off(mousemove, zoom.move);
              });
              start(e);
              $(document).on(mousemove, zoom.move);
              e.preventDefault();
            }
          });
        } else if (settings.on === "click") {
          $source.on("click.zoom", function (e) {
            if (clicked) {
              return;
            } else {
              clicked = true;
              start(e);
              $(document).on(mousemove, zoom.move);
              $(document).one("click.zoom", function () {
                stop();
                clicked = false;
                $(document).off(mousemove, zoom.move);
              });
              return false;
            }
          });
        } else if (settings.on === "toggle") {
          $source.on("click.zoom", function (e) {
            if (clicked) {
              stop();
            } else {
              start(e);
            }
            clicked = !clicked;
          });
        } else if (settings.on === "mouseover") {
          zoom.init();
          $source
            .on("mouseenter.zoom", start)
            .on("mouseleave.zoom", stop)
            .on(mousemove, zoom.move);
        }
        if (settings.touch) {
          $source
            .on("touchstart.zoom", function (e) {
              e.preventDefault();
              if (touched) {
                touched = false;
                stop();
              } else {
                touched = true;
                start(
                  e.originalEvent.touches[0] ||
                    e.originalEvent.changedTouches[0]
                );
              }
            })
            .on("touchmove.zoom", function (e) {
              e.preventDefault();
              zoom.move(
                e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]
              );
            })
            .on("touchend.zoom", function (e) {
              e.preventDefault();
              if (touched) {
                touched = false;
                stop();
              }
            });
        }
        if ($.isFunction(settings.callback)) {
          settings.callback.call(img);
        }
      };
      img.src = settings.url;
    });
  };
  $.fn.zoom.defaults = defaults;
})(window.jQuery);

/*
 *  Remodal - v1.1.0
 *  Responsive, lightweight, fast, synchronized with CSS animations, fully customizable modal window plugin with declarative configuration and hash tracking.
 *  http://vodkabears.github.io/remodal/
 *
 *  Made by Ilya Makarov
 *  Under MIT License
 */

!(function (a, b) {
  "function" == typeof define && define.amd
    ? define(["jquery"], function (c) {
        return b(a, c);
      })
    : "object" == typeof exports
    ? b(a, require("jquery"))
    : b(a, a.jQuery || a.Zepto);
})(this, function (a, b) {
  "use strict";
  function c(a) {
    if (
      w &&
      "none" === a.css("animation-name") &&
      "none" === a.css("-webkit-animation-name") &&
      "none" === a.css("-moz-animation-name") &&
      "none" === a.css("-o-animation-name") &&
      "none" === a.css("-ms-animation-name")
    )
      return 0;
    var b,
      c,
      d,
      e,
      f =
        a.css("animation-duration") ||
        a.css("-webkit-animation-duration") ||
        a.css("-moz-animation-duration") ||
        a.css("-o-animation-duration") ||
        a.css("-ms-animation-duration") ||
        "0s",
      g =
        a.css("animation-delay") ||
        a.css("-webkit-animation-delay") ||
        a.css("-moz-animation-delay") ||
        a.css("-o-animation-delay") ||
        a.css("-ms-animation-delay") ||
        "0s",
      h =
        a.css("animation-iteration-count") ||
        a.css("-webkit-animation-iteration-count") ||
        a.css("-moz-animation-iteration-count") ||
        a.css("-o-animation-iteration-count") ||
        a.css("-ms-animation-iteration-count") ||
        "1";
    for (
      f = f.split(", "),
        g = g.split(", "),
        h = h.split(", "),
        e = 0,
        c = f.length,
        b = Number.NEGATIVE_INFINITY;
      e < c;
      e++
    )
      (d = parseFloat(f[e]) * parseInt(h[e], 10) + parseFloat(g[e])),
        d > b && (b = d);
    return b;
  }
  function d() {
    if (b(document.body).height() <= b(window).height()) return 0;
    var a,
      c,
      d = document.createElement("div"),
      e = document.createElement("div");
    return (
      (d.style.visibility = "hidden"),
      (d.style.width = "100px"),
      document.body.appendChild(d),
      (a = d.offsetWidth),
      (d.style.overflow = "scroll"),
      (e.style.width = "100%"),
      d.appendChild(e),
      (c = e.offsetWidth),
      d.parentNode.removeChild(d),
      a - c
    );
  }
  function e() {
    if (!x) {
      var a,
        c,
        e = b("html"),
        f = k("is-locked");
      e.hasClass(f) ||
        ((c = b(document.body)),
        (a = parseInt(c.css("padding-right"), 10) + d()),
        c.css("padding-right", a + "px"),
        e.addClass(f));
    }
  }
  function f() {
    if (!x) {
      var a,
        c,
        e = b("html"),
        f = k("is-locked");
      e.hasClass(f) &&
        ((c = b(document.body)),
        (a = parseInt(c.css("padding-right"), 10) - d()),
        c.css("padding-right", a + "px"),
        e.removeClass(f));
    }
  }
  function g(a, b, c, d) {
    var e = k("is", b),
      f = [
        k("is", u.CLOSING),
        k("is", u.OPENING),
        k("is", u.CLOSED),
        k("is", u.OPENED),
      ].join(" ");
    a.$bg.removeClass(f).addClass(e),
      a.$overlay.removeClass(f).addClass(e),
      a.$wrapper.removeClass(f).addClass(e),
      a.$modal.removeClass(f).addClass(e),
      (a.state = b),
      !c && a.$modal.trigger({ type: b, reason: d }, [{ reason: d }]);
  }
  function h(a, d, e) {
    var f = 0,
      g = function (a) {
        a.target === this && f++;
      },
      h = function (a) {
        a.target === this &&
          0 === --f &&
          (b.each(["$bg", "$overlay", "$wrapper", "$modal"], function (a, b) {
            e[b].off(r + " " + s);
          }),
          d());
      };
    b.each(["$bg", "$overlay", "$wrapper", "$modal"], function (a, b) {
      e[b].on(r, g).on(s, h);
    }),
      a(),
      0 === c(e.$bg) &&
        0 === c(e.$overlay) &&
        0 === c(e.$wrapper) &&
        0 === c(e.$modal) &&
        (b.each(["$bg", "$overlay", "$wrapper", "$modal"], function (a, b) {
          e[b].off(r + " " + s);
        }),
        d());
  }
  function i(a) {
    a.state !== u.CLOSED &&
      (b.each(["$bg", "$overlay", "$wrapper", "$modal"], function (b, c) {
        a[c].off(r + " " + s);
      }),
      a.$bg.removeClass(a.settings.modifier),
      a.$overlay.removeClass(a.settings.modifier).hide(),
      a.$wrapper.hide(),
      f(),
      g(a, u.CLOSED, !0));
  }
  function j(a) {
    var b,
      c,
      d,
      e,
      f = {};
    for (
      a = a.replace(/\s*:\s*/g, ":").replace(/\s*,\s*/g, ","),
        b = a.split(","),
        e = 0,
        c = b.length;
      e < c;
      e++
    )
      (b[e] = b[e].split(":")),
        (d = b[e][1]),
        ("string" == typeof d || d instanceof String) &&
          (d = "true" === d || ("false" !== d && d)),
        ("string" == typeof d || d instanceof String) &&
          (d = isNaN(d) ? d : +d),
        (f[b[e][0]] = d);
    return f;
  }
  function k() {
    for (var a = q, b = 0; b < arguments.length; ++b) a += "-" + arguments[b];
    return a;
  }
  function l() {
    var a,
      c,
      d = location.hash.replace("#", "");
    if (d) {
      try {
        c = b('[data-remodal-id="' + d + '"]');
      } catch (e) {}
      c &&
        c.length &&
        ((a = b[p].lookup[c.data(p)]),
        a && a.settings.hashTracking && a.open());
    } else n && n.state === u.OPENED && n.settings.hashTracking && n.close();
  }
  function m(a, c) {
    var d = b(document.body),
      e = d,
      f = this;
    (f.settings = b.extend({}, t, c)),
      (f.index = b[p].lookup.push(f) - 1),
      (f.state = u.CLOSED),
      (f.$overlay = b("." + k("overlay"))),
      null !== f.settings.appendTo &&
        f.settings.appendTo.length &&
        (e = b(f.settings.appendTo)),
      f.$overlay.length ||
        ((f.$overlay = b("<div>")
          .addClass(k("overlay") + " " + k("is", u.CLOSED))
          .hide()),
        e.append(f.$overlay)),
      (f.$bg = b("." + k("bg")).addClass(k("is", u.CLOSED))),
      (f.$modal = a
        .addClass(
          q +
            " " +
            k("is-initialized") +
            " " +
            f.settings.modifier +
            " " +
            k("is", u.CLOSED)
        )
        .attr("tabindex", "-1")),
      (f.$wrapper = b("<div>")
        .addClass(
          k("wrapper") + " " + f.settings.modifier + " " + k("is", u.CLOSED)
        )
        .hide()
        .append(f.$modal)),
      e.append(f.$wrapper),
      f.$wrapper.on(
        "click." + q,
        '[data-remodal-action="close"]',
        function (a) {
          a.preventDefault(), f.close();
        }
      ),
      f.$wrapper.on(
        "click." + q,
        '[data-remodal-action="cancel"]',
        function (a) {
          a.preventDefault(),
            f.$modal.trigger(v.CANCELLATION),
            f.settings.closeOnCancel && f.close(v.CANCELLATION);
        }
      ),
      f.$wrapper.on(
        "click." + q,
        '[data-remodal-action="confirm"]',
        function (a) {
          a.preventDefault(),
            f.$modal.trigger(v.CONFIRMATION),
            f.settings.closeOnConfirm && f.close(v.CONFIRMATION);
        }
      ),
      f.$wrapper.on("click." + q, function (a) {
        var c = b(a.target);
        c.hasClass(k("wrapper")) && f.settings.closeOnOutsideClick && f.close();
      });
  }
  var n,
    o,
    p = "remodal",
    q = (a.REMODAL_GLOBALS && a.REMODAL_GLOBALS.NAMESPACE) || p,
    r = b
      .map(
        [
          "animationstart",
          "webkitAnimationStart",
          "MSAnimationStart",
          "oAnimationStart",
        ],
        function (a) {
          return a + "." + q;
        }
      )
      .join(" "),
    s = b
      .map(
        [
          "animationend",
          "webkitAnimationEnd",
          "MSAnimationEnd",
          "oAnimationEnd",
        ],
        function (a) {
          return a + "." + q;
        }
      )
      .join(" "),
    t = b.extend(
      {
        hashTracking: !0,
        closeOnConfirm: !0,
        closeOnCancel: !0,
        closeOnEscape: !0,
        closeOnOutsideClick: !0,
        modifier: "",
        appendTo: null,
      },
      a.REMODAL_GLOBALS && a.REMODAL_GLOBALS.DEFAULTS
    ),
    u = {
      CLOSING: "closing",
      CLOSED: "closed",
      OPENING: "opening",
      OPENED: "opened",
    },
    v = { CONFIRMATION: "confirmation", CANCELLATION: "cancellation" },
    w = (function () {
      var a = document.createElement("div").style;
      return (
        void 0 !== a.animationName ||
        void 0 !== a.WebkitAnimationName ||
        void 0 !== a.MozAnimationName ||
        void 0 !== a.msAnimationName ||
        void 0 !== a.OAnimationName
      );
    })(),
    x = /iPad|iPhone|iPod/.test(navigator.platform);
  (m.prototype.open = function () {
    var a,
      c = this;
    c.state !== u.OPENING &&
      c.state !== u.CLOSING &&
      ((a = c.$modal.attr("data-remodal-id")),
      a &&
        c.settings.hashTracking &&
        ((o = b(window).scrollTop()), (location.hash = a)),
      n && n !== c && i(n),
      (n = c),
      e(),
      c.$bg.addClass(c.settings.modifier),
      c.$overlay.addClass(c.settings.modifier).show(),
      c.$wrapper.show().scrollTop(0),
      c.$modal.focus(),
      h(
        function () {
          g(c, u.OPENING);
        },
        function () {
          g(c, u.OPENED);
        },
        c
      ));
  }),
    (m.prototype.close = function (a) {
      var c = this;
      c.state !== u.OPENING &&
        c.state !== u.CLOSING &&
        (c.settings.hashTracking &&
          c.$modal.attr("data-remodal-id") === location.hash.substr(1) &&
          ((location.hash = ""), b(window).scrollTop(o)),
        h(
          function () {
            g(c, u.CLOSING, !1, a);
          },
          function () {
            c.$bg.removeClass(c.settings.modifier),
              c.$overlay.removeClass(c.settings.modifier).hide(),
              c.$wrapper.hide(),
              f(),
              g(c, u.CLOSED, !1, a);
          },
          c
        ));
    }),
    (m.prototype.getState = function () {
      return this.state;
    }),
    (m.prototype.destroy = function () {
      var a,
        c = b[p].lookup;
      i(this),
        this.$wrapper.remove(),
        delete c[this.index],
        (a = b.grep(c, function (a) {
          return !!a;
        }).length),
        0 === a &&
          (this.$overlay.remove(),
          this.$bg.removeClass(
            k("is", u.CLOSING) +
              " " +
              k("is", u.OPENING) +
              " " +
              k("is", u.CLOSED) +
              " " +
              k("is", u.OPENED)
          ));
    }),
    (b[p] = { lookup: [] }),
    (b.fn[p] = function (a) {
      var c, d;
      return (
        this.each(function (e, f) {
          (d = b(f)),
            null == d.data(p)
              ? ((c = new m(d, a)),
                d.data(p, c.index),
                c.settings.hashTracking &&
                  d.attr("data-remodal-id") === location.hash.substr(1) &&
                  c.open())
              : (c = b[p].lookup[d.data(p)]);
        }),
        c
      );
    }),
    b(document).ready(function () {
      b("body").on("click", "[data-remodal-target]", function (a) {
        a.preventDefault();
        var c = a.currentTarget,
          d = c.getAttribute("data-remodal-target"),
          e = b('[data-remodal-id="' + d + '"]');
        b[p].lookup[e.data(p)].open();
      }),
        b("body")
          .find("." + q)
          .each(function (a, c) {
            var d = b(c),
              e = d.data("remodal-options");
            e
              ? ("string" == typeof e || e instanceof String) && (e = j(e))
              : (e = {}),
              d[p](e);
          }),
        b("body").on("keydown." + q, function (a) {
          n &&
            n.settings.closeOnEscape &&
            n.state === u.OPENED &&
            27 === a.keyCode &&
            n.close();
        }),
        b(window).on("hashchange." + q, l);
    });
});

/*!
 * JavaScript Cookie v2.1.4
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */

!(function (e) {
  var n = !1;
  if (
    ("function" == typeof define && define.amd && (define(e), (n = !0)),
    "object" == typeof exports && ((module.exports = e()), (n = !0)),
    !n)
  ) {
    var o = window.Cookies,
      t = (window.Cookies = e());
    t.noConflict = function () {
      return (window.Cookies = o), t;
    };
  }
})(function () {
  function e() {
    for (var e = 0, n = {}; e < arguments.length; e++) {
      var o = arguments[e];
      for (var t in o) n[t] = o[t];
    }
    return n;
  }
  function n(o) {
    function t(n, r, i) {
      var c;
      if ("undefined" != typeof document) {
        if (arguments.length > 1) {
          if (
            "number" == typeof (i = e({ path: "/" }, t.defaults, i)).expires
          ) {
            var a = new Date();
            a.setMilliseconds(a.getMilliseconds() + 864e5 * i.expires),
              (i.expires = a);
          }
          i.expires = i.expires ? i.expires.toUTCString() : "";
          try {
            (c = JSON.stringify(r)), /^[\{\[]/.test(c) && (r = c);
          } catch (e) {}
          (r = o.write
            ? o.write(r, n)
            : encodeURIComponent(String(r)).replace(
                /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                decodeURIComponent
              )),
            (n = (n = (n = encodeURIComponent(String(n))).replace(
              /%(23|24|26|2B|5E|60|7C)/g,
              decodeURIComponent
            )).replace(/[\(\)]/g, escape));
          var f = "";
          for (var s in i)
            i[s] && ((f += "; " + s), !0 !== i[s] && (f += "=" + i[s]));
          return (document.cookie = n + "=" + r + f);
        }
        n || (c = {});
        for (
          var p = document.cookie ? document.cookie.split("; ") : [],
            d = /(%[0-9A-Z]{2})+/g,
            u = 0;
          u < p.length;
          u++
        ) {
          var l = p[u].split("="),
            C = l.slice(1).join("=");
          '"' === C.charAt(0) && (C = C.slice(1, -1));
          try {
            var g = l[0].replace(d, decodeURIComponent);
            if (
              ((C = o.read
                ? o.read(C, g)
                : o(C, g) || C.replace(d, decodeURIComponent)),
              this.json)
            )
              try {
                C = JSON.parse(C);
              } catch (e) {}
            if (n === g) {
              c = C;
              break;
            }
            n || (c[g] = C);
          } catch (e) {}
        }
        return c;
      }
    }
    return (
      (t.set = t),
      (t.get = function (e) {
        return t.call(t, e);
      }),
      (t.getJSON = function () {
        return t.apply({ json: !0 }, [].slice.call(arguments));
      }),
      (t.defaults = {}),
      (t.remove = function (n, o) {
        t(n, "", e(o, { expires: -1 }));
      }),
      (t.withConverter = n),
      t
    );
  }
  return n(function () {});
});

/*!
Waypoints - 4.0.0
Copyright © 2011-2015 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!(function () {
  "use strict";
  function t(o) {
    if (!o) throw new Error("No options passed to Waypoint constructor");
    if (!o.element)
      throw new Error("No element option passed to Waypoint constructor");
    if (!o.handler)
      throw new Error("No handler option passed to Waypoint constructor");
    (this.key = "waypoint-" + e),
      (this.options = t.Adapter.extend({}, t.defaults, o)),
      (this.element = this.options.element),
      (this.adapter = new t.Adapter(this.element)),
      (this.callback = o.handler),
      (this.axis = this.options.horizontal ? "horizontal" : "vertical"),
      (this.enabled = this.options.enabled),
      (this.triggerPoint = null),
      (this.group = t.Group.findOrCreate({
        name: this.options.group,
        axis: this.axis,
      })),
      (this.context = t.Context.findOrCreateByElement(this.options.context)),
      t.offsetAliases[this.options.offset] &&
        (this.options.offset = t.offsetAliases[this.options.offset]),
      this.group.add(this),
      this.context.add(this),
      (i[this.key] = this),
      (e += 1);
  }
  var e = 0,
    i = {};
  (t.prototype.queueTrigger = function (t) {
    this.group.queueTrigger(this, t);
  }),
    (t.prototype.trigger = function (t) {
      this.enabled && this.callback && this.callback.apply(this, t);
    }),
    (t.prototype.destroy = function () {
      this.context.remove(this), this.group.remove(this), delete i[this.key];
    }),
    (t.prototype.disable = function () {
      return (this.enabled = !1), this;
    }),
    (t.prototype.enable = function () {
      return this.context.refresh(), (this.enabled = !0), this;
    }),
    (t.prototype.next = function () {
      return this.group.next(this);
    }),
    (t.prototype.previous = function () {
      return this.group.previous(this);
    }),
    (t.invokeAll = function (t) {
      var e = [];
      for (var o in i) e.push(i[o]);
      for (var n = 0, r = e.length; r > n; n++) e[n][t]();
    }),
    (t.destroyAll = function () {
      t.invokeAll("destroy");
    }),
    (t.disableAll = function () {
      t.invokeAll("disable");
    }),
    (t.enableAll = function () {
      t.invokeAll("enable");
    }),
    (t.refreshAll = function () {
      t.Context.refreshAll();
    }),
    (t.viewportHeight = function () {
      return window.innerHeight || document.documentElement.clientHeight;
    }),
    (t.viewportWidth = function () {
      return document.documentElement.clientWidth;
    }),
    (t.adapters = []),
    (t.defaults = {
      context: window,
      continuous: !0,
      enabled: !0,
      group: "default",
      horizontal: !1,
      offset: 0,
    }),
    (t.offsetAliases = {
      "bottom-in-view": function () {
        return this.context.innerHeight() - this.adapter.outerHeight();
      },
      "right-in-view": function () {
        return this.context.innerWidth() - this.adapter.outerWidth();
      },
    }),
    (window.Waypoint = t);
})(),
  (function () {
    "use strict";
    function t(t) {
      window.setTimeout(t, 1e3 / 60);
    }
    function e(t) {
      (this.element = t),
        (this.Adapter = n.Adapter),
        (this.adapter = new this.Adapter(t)),
        (this.key = "waypoint-context-" + i),
        (this.didScroll = !1),
        (this.didResize = !1),
        (this.oldScroll = {
          x: this.adapter.scrollLeft(),
          y: this.adapter.scrollTop(),
        }),
        (this.waypoints = { vertical: {}, horizontal: {} }),
        (t.waypointContextKey = this.key),
        (o[t.waypointContextKey] = this),
        (i += 1),
        this.createThrottledScrollHandler(),
        this.createThrottledResizeHandler();
    }
    var i = 0,
      o = {},
      n = window.Waypoint,
      r = window.onload;
    (e.prototype.add = function (t) {
      var e = t.options.horizontal ? "horizontal" : "vertical";
      (this.waypoints[e][t.key] = t), this.refresh();
    }),
      (e.prototype.checkEmpty = function () {
        var t = this.Adapter.isEmptyObject(this.waypoints.horizontal),
          e = this.Adapter.isEmptyObject(this.waypoints.vertical);
        t && e && (this.adapter.off(".waypoints"), delete o[this.key]);
      }),
      (e.prototype.createThrottledResizeHandler = function () {
        function t() {
          e.handleResize(), (e.didResize = !1);
        }
        var e = this;
        this.adapter.on("resize.waypoints", function () {
          e.didResize || ((e.didResize = !0), n.requestAnimationFrame(t));
        });
      }),
      (e.prototype.createThrottledScrollHandler = function () {
        function t() {
          e.handleScroll(), (e.didScroll = !1);
        }
        var e = this;
        this.adapter.on("scroll.waypoints", function () {
          (!e.didScroll || n.isTouch) &&
            ((e.didScroll = !0), n.requestAnimationFrame(t));
        });
      }),
      (e.prototype.handleResize = function () {
        n.Context.refreshAll();
      }),
      (e.prototype.handleScroll = function () {
        var t = {},
          e = {
            horizontal: {
              newScroll: this.adapter.scrollLeft(),
              oldScroll: this.oldScroll.x,
              forward: "right",
              backward: "left",
            },
            vertical: {
              newScroll: this.adapter.scrollTop(),
              oldScroll: this.oldScroll.y,
              forward: "down",
              backward: "up",
            },
          };
        for (var i in e) {
          var o = e[i],
            n = o.newScroll > o.oldScroll,
            r = n ? o.forward : o.backward;
          for (var s in this.waypoints[i]) {
            var a = this.waypoints[i][s],
              l = o.oldScroll < a.triggerPoint,
              h = o.newScroll >= a.triggerPoint,
              p = l && h,
              u = !l && !h;
            (p || u) && (a.queueTrigger(r), (t[a.group.id] = a.group));
          }
        }
        for (var c in t) t[c].flushTriggers();
        this.oldScroll = { x: e.horizontal.newScroll, y: e.vertical.newScroll };
      }),
      (e.prototype.innerHeight = function () {
        return this.element == this.element.window
          ? n.viewportHeight()
          : this.adapter.innerHeight();
      }),
      (e.prototype.remove = function (t) {
        delete this.waypoints[t.axis][t.key], this.checkEmpty();
      }),
      (e.prototype.innerWidth = function () {
        return this.element == this.element.window
          ? n.viewportWidth()
          : this.adapter.innerWidth();
      }),
      (e.prototype.destroy = function () {
        var t = [];
        for (var e in this.waypoints)
          for (var i in this.waypoints[e]) t.push(this.waypoints[e][i]);
        for (var o = 0, n = t.length; n > o; o++) t[o].destroy();
      }),
      (e.prototype.refresh = function () {
        var t,
          e = this.element == this.element.window,
          i = e ? void 0 : this.adapter.offset(),
          o = {};
        this.handleScroll(),
          (t = {
            horizontal: {
              contextOffset: e ? 0 : i.left,
              contextScroll: e ? 0 : this.oldScroll.x,
              contextDimension: this.innerWidth(),
              oldScroll: this.oldScroll.x,
              forward: "right",
              backward: "left",
              offsetProp: "left",
            },
            vertical: {
              contextOffset: e ? 0 : i.top,
              contextScroll: e ? 0 : this.oldScroll.y,
              contextDimension: this.innerHeight(),
              oldScroll: this.oldScroll.y,
              forward: "down",
              backward: "up",
              offsetProp: "top",
            },
          });
        for (var r in t) {
          var s = t[r];
          for (var a in this.waypoints[r]) {
            var l,
              h,
              p,
              u,
              c,
              d = this.waypoints[r][a],
              f = d.options.offset,
              w = d.triggerPoint,
              y = 0,
              g = null == w;
            d.element !== d.element.window &&
              (y = d.adapter.offset()[s.offsetProp]),
              "function" == typeof f
                ? (f = f.apply(d))
                : "string" == typeof f &&
                  ((f = parseFloat(f)),
                  d.options.offset.indexOf("%") > -1 &&
                    (f = Math.ceil((s.contextDimension * f) / 100))),
              (l = s.contextScroll - s.contextOffset),
              (d.triggerPoint = y + l - f),
              (h = w < s.oldScroll),
              (p = d.triggerPoint >= s.oldScroll),
              (u = h && p),
              (c = !h && !p),
              !g && u
                ? (d.queueTrigger(s.backward), (o[d.group.id] = d.group))
                : !g && c
                ? (d.queueTrigger(s.forward), (o[d.group.id] = d.group))
                : g &&
                  s.oldScroll >= d.triggerPoint &&
                  (d.queueTrigger(s.forward), (o[d.group.id] = d.group));
          }
        }
        return (
          n.requestAnimationFrame(function () {
            for (var t in o) o[t].flushTriggers();
          }),
          this
        );
      }),
      (e.findOrCreateByElement = function (t) {
        return e.findByElement(t) || new e(t);
      }),
      (e.refreshAll = function () {
        for (var t in o) o[t].refresh();
      }),
      (e.findByElement = function (t) {
        return o[t.waypointContextKey];
      }),
      (window.onload = function () {
        r && r(), e.refreshAll();
      }),
      (n.requestAnimationFrame = function (e) {
        var i =
          window.requestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          t;
        i.call(window, e);
      }),
      (n.Context = e);
  })(),
  (function () {
    "use strict";
    function t(t, e) {
      return t.triggerPoint - e.triggerPoint;
    }
    function e(t, e) {
      return e.triggerPoint - t.triggerPoint;
    }
    function i(t) {
      (this.name = t.name),
        (this.axis = t.axis),
        (this.id = this.name + "-" + this.axis),
        (this.waypoints = []),
        this.clearTriggerQueues(),
        (o[this.axis][this.name] = this);
    }
    var o = { vertical: {}, horizontal: {} },
      n = window.Waypoint;
    (i.prototype.add = function (t) {
      this.waypoints.push(t);
    }),
      (i.prototype.clearTriggerQueues = function () {
        this.triggerQueues = { up: [], down: [], left: [], right: [] };
      }),
      (i.prototype.flushTriggers = function () {
        for (var i in this.triggerQueues) {
          var o = this.triggerQueues[i],
            n = "up" === i || "left" === i;
          o.sort(n ? e : t);
          for (var r = 0, s = o.length; s > r; r += 1) {
            var a = o[r];
            (a.options.continuous || r === o.length - 1) && a.trigger([i]);
          }
        }
        this.clearTriggerQueues();
      }),
      (i.prototype.next = function (e) {
        this.waypoints.sort(t);
        var i = n.Adapter.inArray(e, this.waypoints),
          o = i === this.waypoints.length - 1;
        return o ? null : this.waypoints[i + 1];
      }),
      (i.prototype.previous = function (e) {
        this.waypoints.sort(t);
        var i = n.Adapter.inArray(e, this.waypoints);
        return i ? this.waypoints[i - 1] : null;
      }),
      (i.prototype.queueTrigger = function (t, e) {
        this.triggerQueues[e].push(t);
      }),
      (i.prototype.remove = function (t) {
        var e = n.Adapter.inArray(t, this.waypoints);
        e > -1 && this.waypoints.splice(e, 1);
      }),
      (i.prototype.first = function () {
        return this.waypoints[0];
      }),
      (i.prototype.last = function () {
        return this.waypoints[this.waypoints.length - 1];
      }),
      (i.findOrCreate = function (t) {
        return o[t.axis][t.name] || new i(t);
      }),
      (n.Group = i);
  })(),
  (function () {
    "use strict";
    function t(t) {
      this.$element = e(t);
    }
    var e = window.jQuery,
      i = window.Waypoint;
    e.each(
      [
        "innerHeight",
        "innerWidth",
        "off",
        "offset",
        "on",
        "outerHeight",
        "outerWidth",
        "scrollLeft",
        "scrollTop",
      ],
      function (e, i) {
        t.prototype[i] = function () {
          var t = Array.prototype.slice.call(arguments);
          return this.$element[i].apply(this.$element, t);
        };
      }
    ),
      e.each(["extend", "inArray", "isEmptyObject"], function (i, o) {
        t[o] = e[o];
      }),
      i.adapters.push({ name: "jquery", Adapter: t }),
      (i.Adapter = t);
  })(),
  (function () {
    "use strict";
    function t(t) {
      return function () {
        var i = [],
          o = arguments[0];
        return (
          t.isFunction(arguments[0]) &&
            ((o = t.extend({}, arguments[1])), (o.handler = arguments[0])),
          this.each(function () {
            var n = t.extend({}, o, { element: this });
            "string" == typeof n.context &&
              (n.context = t(this).closest(n.context)[0]),
              i.push(new e(n));
          }),
          i
        );
      };
    }
    var e = window.Waypoint;
    window.jQuery && (window.jQuery.fn.waypoint = t(window.jQuery)),
      window.Zepto && (window.Zepto.fn.waypoint = t(window.Zepto));
  })();

/*!
Waypoints Infinite Scroll Shortcut - 4.0.0
Copyright © 2011-2015 Caleb Troughton
Licensed under the MIT license.
https://github.com/imakewebthings/waypoints/blob/master/licenses.txt
*/
!(function () {
  "use strict";
  function t(n) {
    (this.options = i.extend({}, t.defaults, n)),
      (this.container = this.options.element),
      "auto" !== this.options.container &&
        (this.container = this.options.container),
      (this.$container = i(this.container)),
      (this.$more = i(this.options.more)),
      this.$more.length &&
        (this.setupHandler(), (this.waypoint = new o(this.options)));
  }
  var i = window.jQuery,
    o = window.Waypoint;
  (t.prototype.setupHandler = function () {
    this.options.handler = i.proxy(function () {
      this.options.onBeforePageLoad(),
        this.destroy(),
        this.$container.addClass(this.options.loadingClass),
        i.get(
          i(this.options.more).attr("href"),
          i.proxy(function (t) {
            var n = i(i.parseHTML(t)),
              e = n.find(this.options.more),
              s = n.find(this.options.items);
            s.length || (s = n.filter(this.options.items)),
              this.$container.append(s),
              this.$container.removeClass(this.options.loadingClass),
              e.length || (e = n.filter(this.options.more)),
              e.length
                ? (this.$more.replaceWith(e),
                  (this.$more = e),
                  (this.waypoint = new o(this.options)))
                : this.$more.remove(),
              this.options.onAfterPageLoad(s);
          }, this)
        );
    }, this);
  }),
    (t.prototype.destroy = function () {
      this.waypoint && this.waypoint.destroy();
    }),
    (t.defaults = {
      container: "auto",
      items: ".infinite-item",
      more: ".infinite-more-link",
      offset: "bottom-in-view",
      loadingClass: "infinite-loading",
      onBeforePageLoad: i.noop,
      onAfterPageLoad: i.noop,
    }),
    (o.Infinite = t);
})();

// mediaWrapper.js: Simple responsive iframes
// MIT license http://www.opensource.org/licenses/mit-license.php/
// @author Matthew A. K. Smith http://www.akselkreis.com

!(function (t) {
  t.fn.mediaWrapper = function (i) {
    var e = t.extend({ intrinsic: !0, baseWidth: 16, baseHeight: 9 }, i);
    return this.each(function () {
      var i = "";
      (i =
        1 == e.intrinsic &&
        "" !== t(this).attr("width") &&
        "" !== t(this).attr("height")
          ? (t(this).attr("height") / t(this).attr("width")) * 100
          : (e.baseHeight / e.baseWidth) * 100),
        t(this)
          .wrap(
            '<div class="mediaWrapper" style="position: relative; width: 100%; height: 0; padding: ' +
              i +
              '% 0 0 0; " />'
          )
          .css({
            position: "absolute",
            width: "100%",
            height: "100%",
            top: "0",
            left: "0",
          });
    });
  };
})(jQuery);

/*
 * Pointer Events Polyfill: Adds support for the style attribute "pointer-events: none" to browsers without this feature (namely, IE).
 * (c) 2013, Kent Mewhort, licensed under BSD. See LICENSE.txt for details.
 */

function PointerEventsPolyfill(t) {
  if (
    ((this.options = {
      selector: "*",
      mouseEvents: ["click", "dblclick", "mousedown", "mouseup"],
      usePolyfillIf: function () {
        if ("Microsoft Internet Explorer" == navigator.appName) {
          var t = navigator.userAgent;
          if (null != t.match(/MSIE ([0-9]{1,}[\.0-9]{0,})/)) {
            var e = parseFloat(RegExp.$1);
            if (11 > e) return !0;
          }
        }
        return !1;
      },
    }),
    t)
  ) {
    var e = this;
    $.each(t, function (t, n) {
      e.options[t] = n;
    });
  }
  this.options.usePolyfillIf() && this.register_mouse_events();
}
(PointerEventsPolyfill.initialize = function (t) {
  return (
    null == PointerEventsPolyfill.singleton &&
      (PointerEventsPolyfill.singleton = new PointerEventsPolyfill(t)),
    PointerEventsPolyfill.singleton
  );
}),
  (PointerEventsPolyfill.prototype.register_mouse_events = function () {
    $(document).on(
      this.options.mouseEvents.join(" "),
      this.options.selector,
      function (t) {
        if ("none" == $(this).css("pointer-events")) {
          var e = $(this).css("display");
          $(this).css("display", "none");
          var n = document.elementFromPoint(t.clientX, t.clientY);
          return (
            e ? $(this).css("display", e) : $(this).css("display", ""),
            (t.target = n),
            $(n).trigger(t),
            !1
          );
        }
        return !0;
      }
    );
  });

/*!
 * headhesive v1.1.0 - A better sticky header
 * Url: http://markgoodyear.com/labs/headhesive
 * Copyright (c) Mark Goodyear — @markgdyr — http://markgoodyear.com
 * License: MIT
 */
!(function (t, s, e) {
  "use strict";
  function i(t) {
    for (var s = 0; t; ) (s += t.offsetTop), (t = t.offsetParent);
    return s;
  }
  var o = function (t, s) {
      for (var e in s)
        s.hasOwnProperty(e) &&
          (t[e] = "object" == typeof s[e] ? o(t[e], s[e]) : s[e]);
      return t;
    },
    n = function (t, s) {
      var e,
        i,
        o,
        n =
          Date.now ||
          function () {
            return new Date().getTime();
          },
        l = null,
        c = 0,
        h = function () {
          (c = n()), (l = null), (o = t.apply(e, i)), (e = i = null);
        };
      return function () {
        var r = n(),
          f = s - (r - c);
        return (
          (e = this),
          (i = arguments),
          0 >= f
            ? (clearTimeout(l),
              (l = null),
              (c = r),
              (o = t.apply(e, i)),
              (e = i = null))
            : l || (l = setTimeout(h, f)),
          o
        );
      };
    },
    l = function () {
      return t.pageYOffset !== e
        ? t.pageYOffset
        : (s.documentElement || s.body.parentNode || s.body).scrollTop;
    },
    c = function (e, i) {
      "querySelector" in s &&
        "addEventListener" in t &&
        ((this.visible = !1),
        (this.options = {
          offset: 300,
          classes: {
            base: "headhesive",
            stick: "headhesive--stick",
            unstick: "headhesive--unstick",
          },
          throttle: 250,
          onInit: function () {},
          onStick: function () {},
          onUnstick: function () {},
          onDestroy: function () {},
        }),
        (this.elem = "string" == typeof e ? s.querySelector(e) : e),
        (this.options = o(this.options, i)),
        this.init());
    };
  (c.prototype = {
    constructor: c,
    init: function () {
      if (
        ((this.clonedElem = this.elem.cloneNode(!0)),
        (this.clonedElem.className += " " + this.options.classes.clone),
        s.body.insertBefore(this.clonedElem, s.body.firstChild),
        "number" == typeof this.options.offset)
      )
        this.scrollOffset = this.options.offset;
      else {
        if ("string" != typeof this.options.offset)
          throw new Error("Invalid offset: " + this.options.offset);
        this.scrollOffset = i(s.querySelector(this.options.offset));
      }
      (this._throttleUpdate = n(this.update.bind(this), this.options.throttle)),
        t.addEventListener("scroll", this._throttleUpdate, !1),
        this.options.onInit.call(this);
    },
    destroy: function () {
      s.body.removeChild(this.clonedElem),
        t.removeEventListener("scroll", this._throttleUpdate),
        this.options.onDestroy.call(this);
    },
    stick: function () {
      this.visible ||
        ((this.clonedElem.className = this.clonedElem.className.replace(
          new RegExp(
            "(^|\\s)*" + this.options.classes.unstick + "(\\s|$)*",
            "g"
          ),
          ""
        )),
        (this.clonedElem.className += " " + this.options.classes.stick),
        (this.visible = !0),
        this.options.onStick.call(this));
    },
    unstick: function () {
      this.visible &&
        ((this.clonedElem.className = this.clonedElem.className.replace(
          new RegExp("(^|\\s)*" + this.options.classes.stick + "(\\s|$)*", "g"),
          ""
        )),
        (this.clonedElem.className += " " + this.options.classes.unstick),
        (this.visible = !1),
        this.options.onUnstick.call(this));
    },
    update: function () {
      l() > this.scrollOffset ? this.stick() : this.unstick();
    },
  }),
    (t.Headhesive = c);
})(window, document);

/*!
 * Flickity PACKAGED v2.2.1
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2019 Metafizzy
 */

// !(function (e, i) {
//   "function" == typeof define && define.amd
//     ? define("jquery-bridget/jquery-bridget", ["jquery"], function (t) {
//         return i(e, t);
//       })
//     : "object" == typeof module && module.exports
//     ? (module.exports = i(e, require("jquery")))
//     : (e.jQueryBridget = i(e, e.jQuery));
// })(window, function (t, e) {
//   "use strict";
//   var i = Array.prototype.slice,
//     n = t.console,
//     d =
//       void 0 === n
//         ? function () {}
//         : function (t) {
//             n.error(t);
//           };
//   function s(h, s, c) {
//     (c = c || e || t.jQuery) &&
//       (s.prototype.option ||
//         (s.prototype.option = function (t) {
//           c.isPlainObject(t) && (this.options = c.extend(!0, this.options, t));
//         }),
//       (c.fn[h] = function (t) {
//         return "string" == typeof t
//           ? (function (t, o, r) {
//               var a,
//                 l = "$()." + h + '("' + o + '")';
//               return (
//                 t.each(function (t, e) {
//                   var i = c.data(e, h);
//                   if (i) {
//                     var n = i[o];
//                     if (n && "_" != o.charAt(0)) {
//                       var s = n.apply(i, r);
//                       a = void 0 === a ? s : a;
//                     } else d(l + " is not a valid method");
//                   } else d(h + " not initialized. Cannot call methods, i.e. " + l);
//                 }),
//                 void 0 !== a ? a : t
//               );
//             })(this, t, i.call(arguments, 1))
//           : ((function (t, n) {
//               t.each(function (t, e) {
//                 var i = c.data(e, h);
//                 i
//                   ? (i.option(n), i._init())
//                   : ((i = new s(e, n)), c.data(e, h, i));
//               });
//             })(this, t),
//             this);
//       }),
//       o(c));
//   }
//   function o(t) {
//     !t || (t && t.bridget) || (t.bridget = s);
//   }
//   return o(e || t.jQuery), s;
// }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("ev-emitter/ev-emitter", e)
      : "object" == typeof module && module.exports
      ? (module.exports = e())
      : (t.EvEmitter = e());
  })("undefined" != typeof window ? window : this, function () {
    function t() {}
    var e = t.prototype;
    return (
      (e.on = function (t, e) {
        if (t && e) {
          var i = (this._events = this._events || {}),
            n = (i[t] = i[t] || []);
          return -1 == n.indexOf(e) && n.push(e), this;
        }
      }),
      (e.once = function (t, e) {
        if (t && e) {
          this.on(t, e);
          var i = (this._onceEvents = this._onceEvents || {});
          return ((i[t] = i[t] || {})[e] = !0), this;
        }
      }),
      (e.off = function (t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
          var n = i.indexOf(e);
          return -1 != n && i.splice(n, 1), this;
        }
      }),
      (e.emitEvent = function (t, e) {
        var i = this._events && this._events[t];
        if (i && i.length) {
          (i = i.slice(0)), (e = e || []);
          for (
            var n = this._onceEvents && this._onceEvents[t], s = 0;
            s < i.length;
            s++
          ) {
            var o = i[s];
            n && n[o] && (this.off(t, o), delete n[o]), o.apply(this, e);
          }
          return this;
        }
      }),
      (e.allOff = function () {
        delete this._events, delete this._onceEvents;
      }),
      t
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("get-size/get-size", e)
      : "object" == typeof module && module.exports
      ? (module.exports = e())
      : (t.getSize = e());
  })(window, function () {
    "use strict";
    function m(t) {
      var e = parseFloat(t);
      return -1 == t.indexOf("%") && !isNaN(e) && e;
    }
    var i =
        "undefined" == typeof console
          ? function () {}
          : function (t) {
              console.error(t);
            },
      y = [
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "paddingBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "marginBottom",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth",
        "borderBottomWidth",
      ],
      b = y.length;
    function E(t) {
      var e = getComputedStyle(t);
      return (
        e ||
          i(
            "Style returned " +
              e +
              ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"
          ),
        e
      );
    }
    var S,
      C = !1;
    function x(t) {
      if (
        ((function () {
          if (!C) {
            C = !0;
            var t = document.createElement("div");
            (t.style.width = "200px"),
              (t.style.padding = "1px 2px 3px 4px"),
              (t.style.borderStyle = "solid"),
              (t.style.borderWidth = "1px 2px 3px 4px"),
              (t.style.boxSizing = "border-box");
            var e = document.body || document.documentElement;
            e.appendChild(t);
            var i = E(t);
            (S = 200 == Math.round(m(i.width))),
              (x.isBoxSizeOuter = S),
              e.removeChild(t);
          }
        })(),
        "string" == typeof t && (t = document.querySelector(t)),
        t && "object" == typeof t && t.nodeType)
      ) {
        var e = E(t);
        if ("none" == e.display)
          return (function () {
            for (
              var t = {
                  width: 0,
                  height: 0,
                  innerWidth: 0,
                  innerHeight: 0,
                  outerWidth: 0,
                  outerHeight: 0,
                },
                e = 0;
              e < b;
              e++
            ) {
              t[y[e]] = 0;
            }
            return t;
          })();
        var i = {};
        (i.width = t.offsetWidth), (i.height = t.offsetHeight);
        for (
          var n = (i.isBorderBox = "border-box" == e.boxSizing), s = 0;
          s < b;
          s++
        ) {
          var o = y[s],
            r = e[o],
            a = parseFloat(r);
          i[o] = isNaN(a) ? 0 : a;
        }
        var l = i.paddingLeft + i.paddingRight,
          h = i.paddingTop + i.paddingBottom,
          c = i.marginLeft + i.marginRight,
          d = i.marginTop + i.marginBottom,
          u = i.borderLeftWidth + i.borderRightWidth,
          f = i.borderTopWidth + i.borderBottomWidth,
          p = n && S,
          g = m(e.width);
        !1 !== g && (i.width = g + (p ? 0 : l + u));
        var v = m(e.height);
        return (
          !1 !== v && (i.height = v + (p ? 0 : h + f)),
          (i.innerWidth = i.width - (l + u)),
          (i.innerHeight = i.height - (h + f)),
          (i.outerWidth = i.width + c),
          (i.outerHeight = i.height + d),
          i
        );
      }
    }
    return x;
  }),
  (function (t, e) {
    "use strict";
    "function" == typeof define && define.amd
      ? define("desandro-matches-selector/matches-selector", e)
      : "object" == typeof module && module.exports
      ? (module.exports = e())
      : (t.matchesSelector = e());
  })(window, function () {
    "use strict";
    var i = (function () {
      var t = window.Element.prototype;
      if (t.matches) return "matches";
      if (t.matchesSelector) return "matchesSelector";
      for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
        var n = e[i] + "MatchesSelector";
        if (t[n]) return n;
      }
    })();
    return function (t, e) {
      return t[i](e);
    };
  }),
  (function (e, i) {
    "function" == typeof define && define.amd
      ? define(
          "fizzy-ui-utils/utils",
          ["desandro-matches-selector/matches-selector"],
          function (t) {
            return i(e, t);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = i(e, require("desandro-matches-selector")))
      : (e.fizzyUIUtils = i(e, e.matchesSelector));
  })(window, function (h, o) {
    var c = {
        extend: function (t, e) {
          for (var i in e) t[i] = e[i];
          return t;
        },
        modulo: function (t, e) {
          return ((t % e) + e) % e;
        },
      },
      e = Array.prototype.slice;
    (c.makeArray = function (t) {
      return Array.isArray(t)
        ? t
        : null == t
        ? []
        : "object" == typeof t && "number" == typeof t.length
        ? e.call(t)
        : [t];
    }),
      (c.removeFrom = function (t, e) {
        var i = t.indexOf(e);
        -1 != i && t.splice(i, 1);
      }),
      (c.getParent = function (t, e) {
        for (; t.parentNode && t != document.body; )
          if (((t = t.parentNode), o(t, e))) return t;
      }),
      (c.getQueryElement = function (t) {
        return "string" == typeof t ? document.querySelector(t) : t;
      }),
      (c.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t);
      }),
      (c.filterFindElements = function (t, n) {
        t = c.makeArray(t);
        var s = [];
        return (
          t.forEach(function (t) {
            if (t instanceof HTMLElement)
              if (n) {
                o(t, n) && s.push(t);
                for (var e = t.querySelectorAll(n), i = 0; i < e.length; i++)
                  s.push(e[i]);
              } else s.push(t);
          }),
          s
        );
      }),
      (c.debounceMethod = function (t, e, n) {
        n = n || 100;
        var s = t.prototype[e],
          o = e + "Timeout";
        t.prototype[e] = function () {
          var t = this[o];
          clearTimeout(t);
          var e = arguments,
            i = this;
          this[o] = setTimeout(function () {
            s.apply(i, e), delete i[o];
          }, n);
        };
      }),
      (c.docReady = function (t) {
        var e = document.readyState;
        "complete" == e || "interactive" == e
          ? setTimeout(t)
          : document.addEventListener("DOMContentLoaded", t);
      }),
      (c.toDashed = function (t) {
        return t
          .replace(/(.)([A-Z])/g, function (t, e, i) {
            return e + "-" + i;
          })
          .toLowerCase();
      });
    var d = h.console;
    return (
      (c.htmlInit = function (a, l) {
        c.docReady(function () {
          var t = c.toDashed(l),
            s = "data-" + t,
            e = document.querySelectorAll("[" + s + "]"),
            i = document.querySelectorAll(".js-" + t),
            n = c.makeArray(e).concat(c.makeArray(i)),
            o = s + "-options",
            r = h.jQuery;
          n.forEach(function (e) {
            var t,
              i = e.getAttribute(s) || e.getAttribute(o);
            try {
              t = i && JSON.parse(i);
            } catch (t) {
              return void (
                d &&
                d.error("Error parsing " + s + " on " + e.className + ": " + t)
              );
            }
            var n = new a(e, t);
            r && r.data(e, l, n);
          });
        });
      }),
      c
    );
  }),
  (function (e, i) {
    "function" == typeof define && define.amd
      ? define("flickity/js/cell", ["get-size/get-size"], function (t) {
          return i(e, t);
        })
      : "object" == typeof module && module.exports
      ? (module.exports = i(e, require("get-size")))
      : ((e.Flickity = e.Flickity || {}), (e.Flickity.Cell = i(e, e.getSize)));
  })(window, function (t, e) {
    function i(t, e) {
      (this.element = t), (this.parent = e), this.create();
    }
    var n = i.prototype;
    return (
      (n.create = function () {
        (this.element.style.position = "absolute"),
          this.element.setAttribute("aria-hidden", "true"),
          (this.x = 0),
          (this.shift = 0);
      }),
      (n.destroy = function () {
        this.unselect(), (this.element.style.position = "");
        var t = this.parent.originSide;
        this.element.style[t] = "";
      }),
      (n.getSize = function () {
        this.size = e(this.element);
      }),
      (n.setPosition = function (t) {
        (this.x = t), this.updateTarget(), this.renderPosition(t);
      }),
      (n.updateTarget = n.setDefaultTarget =
        function () {
          var t =
            "left" == this.parent.originSide ? "marginLeft" : "marginRight";
          this.target =
            this.x + this.size[t] + this.size.width * this.parent.cellAlign;
        }),
      (n.renderPosition = function (t) {
        var e = this.parent.originSide;
        this.element.style[e] = this.parent.getPositionValue(t);
      }),
      (n.select = function () {
        this.element.classList.add("is-selected"),
          this.element.removeAttribute("aria-hidden");
      }),
      (n.unselect = function () {
        this.element.classList.remove("is-selected"),
          this.element.setAttribute("aria-hidden", "true");
      }),
      (n.wrapShift = function (t) {
        (this.shift = t),
          this.renderPosition(this.x + this.parent.slideableWidth * t);
      }),
      (n.remove = function () {
        this.element.parentNode.removeChild(this.element);
      }),
      i
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define("flickity/js/slide", e)
      : "object" == typeof module && module.exports
      ? (module.exports = e())
      : ((t.Flickity = t.Flickity || {}), (t.Flickity.Slide = e()));
  })(window, function () {
    "use strict";
    function t(t) {
      (this.parent = t),
        (this.isOriginLeft = "left" == t.originSide),
        (this.cells = []),
        (this.outerWidth = 0),
        (this.height = 0);
    }
    var e = t.prototype;
    return (
      (e.addCell = function (t) {
        if (
          (this.cells.push(t),
          (this.outerWidth += t.size.outerWidth),
          (this.height = Math.max(t.size.outerHeight, this.height)),
          1 == this.cells.length)
        ) {
          this.x = t.x;
          var e = this.isOriginLeft ? "marginLeft" : "marginRight";
          this.firstMargin = t.size[e];
        }
      }),
      (e.updateTarget = function () {
        var t = this.isOriginLeft ? "marginRight" : "marginLeft",
          e = this.getLastCell(),
          i = e ? e.size[t] : 0,
          n = this.outerWidth - (this.firstMargin + i);
        this.target = this.x + this.firstMargin + n * this.parent.cellAlign;
      }),
      (e.getLastCell = function () {
        return this.cells[this.cells.length - 1];
      }),
      (e.select = function () {
        this.cells.forEach(function (t) {
          t.select();
        });
      }),
      (e.unselect = function () {
        this.cells.forEach(function (t) {
          t.unselect();
        });
      }),
      (e.getCellElements = function () {
        return this.cells.map(function (t) {
          return t.element;
        });
      }),
      t
    );
  }),
  (function (e, i) {
    "function" == typeof define && define.amd
      ? define("flickity/js/animate", ["fizzy-ui-utils/utils"], function (t) {
          return i(e, t);
        })
      : "object" == typeof module && module.exports
      ? (module.exports = i(e, require("fizzy-ui-utils")))
      : ((e.Flickity = e.Flickity || {}),
        (e.Flickity.animatePrototype = i(e, e.fizzyUIUtils)));
  })(window, function (t, e) {
    var i = {
      startAnimation: function () {
        this.isAnimating ||
          ((this.isAnimating = !0), (this.restingFrames = 0), this.animate());
      },
      animate: function () {
        this.applyDragForce(), this.applySelectedAttraction();
        var t = this.x;
        if (
          (this.integratePhysics(),
          this.positionSlider(),
          this.settle(t),
          this.isAnimating)
        ) {
          var e = this;
          requestAnimationFrame(function () {
            e.animate();
          });
        }
      },
      positionSlider: function () {
        var t = this.x;
        this.options.wrapAround &&
          1 < this.cells.length &&
          ((t = e.modulo(t, this.slideableWidth)),
          (t -= this.slideableWidth),
          this.shiftWrapCells(t)),
          this.setTranslateX(t, this.isAnimating),
          this.dispatchScrollEvent();
      },
      setTranslateX: function (t, e) {
        (t += this.cursorPosition), (t = this.options.rightToLeft ? -t : t);
        var i = this.getPositionValue(t);
        this.slider.style.transform = e
          ? "translate3d(" + i + ",0,0)"
          : "translateX(" + i + ")";
      },
      dispatchScrollEvent: function () {
        var t = this.slides[0];
        if (t) {
          var e = -this.x - t.target,
            i = e / this.slidesWidth;
          this.dispatchEvent("scroll", null, [i, e]);
        }
      },
      positionSliderAtSelected: function () {
        this.cells.length &&
          ((this.x = -this.selectedSlide.target),
          (this.velocity = 0),
          this.positionSlider());
      },
      getPositionValue: function (t) {
        return this.options.percentPosition
          ? 0.01 * Math.round((t / this.size.innerWidth) * 1e4) + "%"
          : Math.round(t) + "px";
      },
      settle: function (t) {
        this.isPointerDown ||
          Math.round(100 * this.x) != Math.round(100 * t) ||
          this.restingFrames++,
          2 < this.restingFrames &&
            ((this.isAnimating = !1),
            delete this.isFreeScrolling,
            this.positionSlider(),
            this.dispatchEvent("settle", null, [this.selectedIndex]));
      },
      shiftWrapCells: function (t) {
        var e = this.cursorPosition + t;
        this._shiftCells(this.beforeShiftCells, e, -1);
        var i =
          this.size.innerWidth -
          (t + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, i, 1);
      },
      _shiftCells: function (t, e, i) {
        for (var n = 0; n < t.length; n++) {
          var s = t[n],
            o = 0 < e ? i : 0;
          s.wrapShift(o), (e -= s.size.outerWidth);
        }
      },
      _unshiftCells: function (t) {
        if (t && t.length) for (var e = 0; e < t.length; e++) t[e].wrapShift(0);
      },
      integratePhysics: function () {
        (this.x += this.velocity), (this.velocity *= this.getFrictionFactor());
      },
      applyForce: function (t) {
        this.velocity += t;
      },
      getFrictionFactor: function () {
        return (
          1 -
          this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
        );
      },
      getRestingPosition: function () {
        return this.x + this.velocity / (1 - this.getFrictionFactor());
      },
      applyDragForce: function () {
        if (this.isDraggable && this.isPointerDown) {
          var t = this.dragX - this.x - this.velocity;
          this.applyForce(t);
        }
      },
      applySelectedAttraction: function () {
        if (
          !(this.isDraggable && this.isPointerDown) &&
          !this.isFreeScrolling &&
          this.slides.length
        ) {
          var t =
            (-1 * this.selectedSlide.target - this.x) *
            this.options.selectedAttraction;
          this.applyForce(t);
        }
      },
    };
    return i;
  }),
  (function (r, a) {
    if ("function" == typeof define && define.amd)
      define("flickity/js/flickity", [
        "ev-emitter/ev-emitter",
        "get-size/get-size",
        "fizzy-ui-utils/utils",
        "./cell",
        "./slide",
        "./animate",
      ], function (t, e, i, n, s, o) {
        return a(r, t, e, i, n, s, o);
      });
    else if ("object" == typeof module && module.exports)
      module.exports = a(
        r,
        require("ev-emitter"),
        require("get-size"),
        require("fizzy-ui-utils"),
        require("./cell"),
        require("./slide"),
        require("./animate")
      );
    else {
      var t = r.Flickity;
      r.Flickity = a(
        r,
        r.EvEmitter,
        r.getSize,
        r.fizzyUIUtils,
        t.Cell,
        t.Slide,
        t.animatePrototype
      );
    }
  })(window, function (n, t, e, a, i, r, s) {
    var l = n.jQuery,
      o = n.getComputedStyle,
      h = n.console;
    function c(t, e) {
      for (t = a.makeArray(t); t.length; ) e.appendChild(t.shift());
    }
    var d = 0,
      u = {};
    function f(t, e) {
      var i = a.getQueryElement(t);
      if (i) {
        if (((this.element = i), this.element.flickityGUID)) {
          var n = u[this.element.flickityGUID];
          return n.option(e), n;
        }
        l && (this.$element = l(this.element)),
          (this.options = a.extend({}, this.constructor.defaults)),
          this.option(e),
          this._create();
      } else h && h.error("Bad element for Flickity: " + (i || t));
    }
    (f.defaults = {
      accessibility: !0,
      cellAlign: "center",
      freeScrollFriction: 0.075,
      friction: 0.28,
      namespaceJQueryEvents: !0,
      percentPosition: !0,
      resize: !0,
      selectedAttraction: 0.025,
      setGallerySize: !0,
    }),
      (f.createMethods = []);
    var p = f.prototype;
    a.extend(p, t.prototype),
      (p._create = function () {
        var t = (this.guid = ++d);
        for (var e in ((this.element.flickityGUID = t),
        ((u[t] = this).selectedIndex = 0),
        (this.restingFrames = 0),
        (this.x = 0),
        (this.velocity = 0),
        (this.originSide = this.options.rightToLeft ? "right" : "left"),
        (this.viewport = document.createElement("div")),
        (this.viewport.className = "flickity-viewport"),
        this._createSlider(),
        (this.options.resize || this.options.watchCSS) &&
          n.addEventListener("resize", this),
        this.options.on)) {
          var i = this.options.on[e];
          this.on(e, i);
        }
        f.createMethods.forEach(function (t) {
          this[t]();
        }, this),
          this.options.watchCSS ? this.watchCSS() : this.activate();
      }),
      (p.option = function (t) {
        a.extend(this.options, t);
      }),
      (p.activate = function () {
        this.isActive ||
          ((this.isActive = !0),
          this.element.classList.add("flickity-enabled"),
          this.options.rightToLeft &&
            this.element.classList.add("flickity-rtl"),
          this.getSize(),
          c(this._filterFindCellElements(this.element.children), this.slider),
          this.viewport.appendChild(this.slider),
          this.element.appendChild(this.viewport),
          this.reloadCells(),
          this.options.accessibility &&
            ((this.element.tabIndex = 0),
            this.element.addEventListener("keydown", this)),
          this.emitEvent("activate"),
          this.selectInitialIndex(),
          (this.isInitActivated = !0),
          this.dispatchEvent("ready"));
      }),
      (p._createSlider = function () {
        var t = document.createElement("div");
        (t.className = "flickity-slider"),
          (t.style[this.originSide] = 0),
          (this.slider = t);
      }),
      (p._filterFindCellElements = function (t) {
        return a.filterFindElements(t, this.options.cellSelector);
      }),
      (p.reloadCells = function () {
        (this.cells = this._makeCells(this.slider.children)),
          this.positionCells(),
          this._getWrapShiftCells(),
          this.setGallerySize();
      }),
      (p._makeCells = function (t) {
        return this._filterFindCellElements(t).map(function (t) {
          return new i(t, this);
        }, this);
      }),
      (p.getLastCell = function () {
        return this.cells[this.cells.length - 1];
      }),
      (p.getLastSlide = function () {
        return this.slides[this.slides.length - 1];
      }),
      (p.positionCells = function () {
        this._sizeCells(this.cells), this._positionCells(0);
      }),
      (p._positionCells = function (t) {
        (t = t || 0), (this.maxCellHeight = (t && this.maxCellHeight) || 0);
        var e = 0;
        if (0 < t) {
          var i = this.cells[t - 1];
          e = i.x + i.size.outerWidth;
        }
        for (var n = this.cells.length, s = t; s < n; s++) {
          var o = this.cells[s];
          o.setPosition(e),
            (e += o.size.outerWidth),
            (this.maxCellHeight = Math.max(
              o.size.outerHeight,
              this.maxCellHeight
            ));
        }
        (this.slideableWidth = e),
          this.updateSlides(),
          this._containSlides(),
          (this.slidesWidth = n
            ? this.getLastSlide().target - this.slides[0].target
            : 0);
      }),
      (p._sizeCells = function (t) {
        t.forEach(function (t) {
          t.getSize();
        });
      }),
      (p.updateSlides = function () {
        if (((this.slides = []), this.cells.length)) {
          var n = new r(this);
          this.slides.push(n);
          var s = "left" == this.originSide ? "marginRight" : "marginLeft",
            o = this._getCanCellFit();
          this.cells.forEach(function (t, e) {
            if (n.cells.length) {
              var i =
                n.outerWidth - n.firstMargin + (t.size.outerWidth - t.size[s]);
              o.call(this, e, i) ||
                (n.updateTarget(), (n = new r(this)), this.slides.push(n)),
                n.addCell(t);
            } else n.addCell(t);
          }, this),
            n.updateTarget(),
            this.updateSelectedSlide();
        }
      }),
      (p._getCanCellFit = function () {
        var t = this.options.groupCells;
        if (!t)
          return function () {
            return !1;
          };
        if ("number" == typeof t) {
          var e = parseInt(t, 10);
          return function (t) {
            return t % e != 0;
          };
        }
        var i = "string" == typeof t && t.match(/^(\d+)%$/),
          n = i ? parseInt(i[1], 10) / 100 : 1;
        return function (t, e) {
          return e <= (this.size.innerWidth + 1) * n;
        };
      }),
      (p._init = p.reposition =
        function () {
          this.positionCells(), this.positionSliderAtSelected();
        }),
      (p.getSize = function () {
        (this.size = e(this.element)),
          this.setCellAlign(),
          (this.cursorPosition = this.size.innerWidth * this.cellAlign);
      });
    var g = {
      center: { left: 0.5, right: 0.5 },
      left: { left: 0, right: 1 },
      right: { right: 0, left: 1 },
    };
    return (
      (p.setCellAlign = function () {
        var t = g[this.options.cellAlign];
        this.cellAlign = t ? t[this.originSide] : this.options.cellAlign;
      }),
      (p.setGallerySize = function () {
        if (this.options.setGallerySize) {
          var t =
            this.options.adaptiveHeight && this.selectedSlide
              ? this.selectedSlide.height
              : this.maxCellHeight;
          this.viewport.style.height = t + "px";
        }
      }),
      (p._getWrapShiftCells = function () {
        if (this.options.wrapAround) {
          this._unshiftCells(this.beforeShiftCells),
            this._unshiftCells(this.afterShiftCells);
          var t = this.cursorPosition,
            e = this.cells.length - 1;
          (this.beforeShiftCells = this._getGapCells(t, e, -1)),
            (t = this.size.innerWidth - this.cursorPosition),
            (this.afterShiftCells = this._getGapCells(t, 0, 1));
        }
      }),
      (p._getGapCells = function (t, e, i) {
        for (var n = []; 0 < t; ) {
          var s = this.cells[e];
          if (!s) break;
          n.push(s), (e += i), (t -= s.size.outerWidth);
        }
        return n;
      }),
      (p._containSlides = function () {
        if (
          this.options.contain &&
          !this.options.wrapAround &&
          this.cells.length
        ) {
          var t = this.options.rightToLeft,
            e = t ? "marginRight" : "marginLeft",
            i = t ? "marginLeft" : "marginRight",
            n = this.slideableWidth - this.getLastCell().size[i],
            s = n < this.size.innerWidth,
            o = this.cursorPosition + this.cells[0].size[e],
            r = n - this.size.innerWidth * (1 - this.cellAlign);
          this.slides.forEach(function (t) {
            s
              ? (t.target = n * this.cellAlign)
              : ((t.target = Math.max(t.target, o)),
                (t.target = Math.min(t.target, r)));
          }, this);
        }
      }),
      (p.dispatchEvent = function (t, e, i) {
        var n = e ? [e].concat(i) : i;
        if ((this.emitEvent(t, n), l && this.$element)) {
          var s = (t += this.options.namespaceJQueryEvents ? ".flickity" : "");
          if (e) {
            var o = l.Event(e);
            (o.type = t), (s = o);
          }
          this.$element.trigger(s, i);
        }
      }),
      (p.select = function (t, e, i) {
        if (
          this.isActive &&
          ((t = parseInt(t, 10)),
          this._wrapSelect(t),
          (this.options.wrapAround || e) &&
            (t = a.modulo(t, this.slides.length)),
          this.slides[t])
        ) {
          var n = this.selectedIndex;
          (this.selectedIndex = t),
            this.updateSelectedSlide(),
            i ? this.positionSliderAtSelected() : this.startAnimation(),
            this.options.adaptiveHeight && this.setGallerySize(),
            this.dispatchEvent("select", null, [t]),
            t != n && this.dispatchEvent("change", null, [t]),
            this.dispatchEvent("cellSelect");
        }
      }),
      (p._wrapSelect = function (t) {
        var e = this.slides.length;
        if (!(this.options.wrapAround && 1 < e)) return t;
        var i = a.modulo(t, e),
          n = Math.abs(i - this.selectedIndex),
          s = Math.abs(i + e - this.selectedIndex),
          o = Math.abs(i - e - this.selectedIndex);
        !this.isDragSelect && s < n
          ? (t += e)
          : !this.isDragSelect && o < n && (t -= e),
          t < 0
            ? (this.x -= this.slideableWidth)
            : e <= t && (this.x += this.slideableWidth);
      }),
      (p.previous = function (t, e) {
        this.select(this.selectedIndex - 1, t, e);
      }),
      (p.next = function (t, e) {
        this.select(this.selectedIndex + 1, t, e);
      }),
      (p.updateSelectedSlide = function () {
        var t = this.slides[this.selectedIndex];
        t &&
          (this.unselectSelectedSlide(),
          (this.selectedSlide = t).select(),
          (this.selectedCells = t.cells),
          (this.selectedElements = t.getCellElements()),
          (this.selectedCell = t.cells[0]),
          (this.selectedElement = this.selectedElements[0]));
      }),
      (p.unselectSelectedSlide = function () {
        this.selectedSlide && this.selectedSlide.unselect();
      }),
      (p.selectInitialIndex = function () {
        var t = this.options.initialIndex;
        if (this.isInitActivated) this.select(this.selectedIndex, !1, !0);
        else {
          if (t && "string" == typeof t)
            if (this.queryCell(t)) return void this.selectCell(t, !1, !0);
          var e = 0;
          t && this.slides[t] && (e = t), this.select(e, !1, !0);
        }
      }),
      (p.selectCell = function (t, e, i) {
        var n = this.queryCell(t);
        if (n) {
          var s = this.getCellSlideIndex(n);
          this.select(s, e, i);
        }
      }),
      (p.getCellSlideIndex = function (t) {
        for (var e = 0; e < this.slides.length; e++) {
          if (-1 != this.slides[e].cells.indexOf(t)) return e;
        }
      }),
      (p.getCell = function (t) {
        for (var e = 0; e < this.cells.length; e++) {
          var i = this.cells[e];
          if (i.element == t) return i;
        }
      }),
      (p.getCells = function (t) {
        t = a.makeArray(t);
        var i = [];
        return (
          t.forEach(function (t) {
            var e = this.getCell(t);
            e && i.push(e);
          }, this),
          i
        );
      }),
      (p.getCellElements = function () {
        return this.cells.map(function (t) {
          return t.element;
        });
      }),
      (p.getParentCell = function (t) {
        var e = this.getCell(t);
        return (
          e || ((t = a.getParent(t, ".flickity-slider > *")), this.getCell(t))
        );
      }),
      (p.getAdjacentCellElements = function (t, e) {
        if (!t) return this.selectedSlide.getCellElements();
        e = void 0 === e ? this.selectedIndex : e;
        var i = this.slides.length;
        if (i <= 1 + 2 * t) return this.getCellElements();
        for (var n = [], s = e - t; s <= e + t; s++) {
          var o = this.options.wrapAround ? a.modulo(s, i) : s,
            r = this.slides[o];
          r && (n = n.concat(r.getCellElements()));
        }
        return n;
      }),
      (p.queryCell = function (t) {
        if ("number" == typeof t) return this.cells[t];
        if ("string" == typeof t) {
          if (t.match(/^[#\.]?[\d\/]/)) return;
          t = this.element.querySelector(t);
        }
        return this.getCell(t);
      }),
      (p.uiChange = function () {
        this.emitEvent("uiChange");
      }),
      (p.childUIPointerDown = function (t) {
        "touchstart" != t.type && t.preventDefault(), this.focus();
      }),
      (p.onresize = function () {
        this.watchCSS(), this.resize();
      }),
      a.debounceMethod(f, "onresize", 150),
      (p.resize = function () {
        if (this.isActive) {
          this.getSize(),
            this.options.wrapAround &&
              (this.x = a.modulo(this.x, this.slideableWidth)),
            this.positionCells(),
            this._getWrapShiftCells(),
            this.setGallerySize(),
            this.emitEvent("resize");
          var t = this.selectedElements && this.selectedElements[0];
          this.selectCell(t, !1, !0);
        }
      }),
      (p.watchCSS = function () {
        this.options.watchCSS &&
          (-1 != o(this.element, ":after").content.indexOf("flickity")
            ? this.activate()
            : this.deactivate());
      }),
      (p.onkeydown = function (t) {
        var e =
          document.activeElement && document.activeElement != this.element;
        if (this.options.accessibility && !e) {
          var i = f.keyboardHandlers[t.keyCode];
          i && i.call(this);
        }
      }),
      (f.keyboardHandlers = {
        37: function () {
          var t = this.options.rightToLeft ? "next" : "previous";
          this.uiChange(), this[t]();
        },
        39: function () {
          var t = this.options.rightToLeft ? "previous" : "next";
          this.uiChange(), this[t]();
        },
      }),
      (p.focus = function () {
        var t = n.pageYOffset;
        this.element.focus({ preventScroll: !0 }),
          n.pageYOffset != t && n.scrollTo(n.pageXOffset, t);
      }),
      (p.deactivate = function () {
        this.isActive &&
          (this.element.classList.remove("flickity-enabled"),
          this.element.classList.remove("flickity-rtl"),
          this.unselectSelectedSlide(),
          this.cells.forEach(function (t) {
            t.destroy();
          }),
          this.element.removeChild(this.viewport),
          c(this.slider.children, this.element),
          this.options.accessibility &&
            (this.element.removeAttribute("tabIndex"),
            this.element.removeEventListener("keydown", this)),
          (this.isActive = !1),
          this.emitEvent("deactivate"));
      }),
      (p.destroy = function () {
        this.deactivate(),
          n.removeEventListener("resize", this),
          this.allOff(),
          this.emitEvent("destroy"),
          l && this.$element && l.removeData(this.element, "flickity"),
          delete this.element.flickityGUID,
          delete u[this.guid];
      }),
      a.extend(p, s),
      (f.data = function (t) {
        var e = (t = a.getQueryElement(t)) && t.flickityGUID;
        return e && u[e];
      }),
      a.htmlInit(f, "flickity"),
      l && l.bridget && l.bridget("flickity", f),
      (f.setJQuery = function (t) {
        l = t;
      }),
      (f.Cell = i),
      (f.Slide = r),
      f
    );
  }),
  (function (e, i) {
    "function" == typeof define && define.amd
      ? define(
          "unipointer/unipointer",
          ["ev-emitter/ev-emitter"],
          function (t) {
            return i(e, t);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = i(e, require("ev-emitter")))
      : (e.Unipointer = i(e, e.EvEmitter));
  })(window, function (s, t) {
    function e() {}
    var i = (e.prototype = Object.create(t.prototype));
    (i.bindStartEvent = function (t) {
      this._bindStartEvent(t, !0);
    }),
      (i.unbindStartEvent = function (t) {
        this._bindStartEvent(t, !1);
      }),
      (i._bindStartEvent = function (t, e) {
        var i = (e = void 0 === e || e)
            ? "addEventListener"
            : "removeEventListener",
          n = "mousedown";
        s.PointerEvent
          ? (n = "pointerdown")
          : "ontouchstart" in s && (n = "touchstart"),
          t[i](n, this);
      }),
      (i.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t);
      }),
      (i.getTouch = function (t) {
        for (var e = 0; e < t.length; e++) {
          var i = t[e];
          if (i.identifier == this.pointerIdentifier) return i;
        }
      }),
      (i.onmousedown = function (t) {
        var e = t.button;
        (e && 0 !== e && 1 !== e) || this._pointerDown(t, t);
      }),
      (i.ontouchstart = function (t) {
        this._pointerDown(t, t.changedTouches[0]);
      }),
      (i.onpointerdown = function (t) {
        this._pointerDown(t, t);
      }),
      (i._pointerDown = function (t, e) {
        t.button ||
          this.isPointerDown ||
          ((this.isPointerDown = !0),
          (this.pointerIdentifier =
            void 0 !== e.pointerId ? e.pointerId : e.identifier),
          this.pointerDown(t, e));
      }),
      (i.pointerDown = function (t, e) {
        this._bindPostStartEvents(t), this.emitEvent("pointerDown", [t, e]);
      });
    var n = {
      mousedown: ["mousemove", "mouseup"],
      touchstart: ["touchmove", "touchend", "touchcancel"],
      pointerdown: ["pointermove", "pointerup", "pointercancel"],
    };
    return (
      (i._bindPostStartEvents = function (t) {
        if (t) {
          var e = n[t.type];
          e.forEach(function (t) {
            s.addEventListener(t, this);
          }, this),
            (this._boundPointerEvents = e);
        }
      }),
      (i._unbindPostStartEvents = function () {
        this._boundPointerEvents &&
          (this._boundPointerEvents.forEach(function (t) {
            s.removeEventListener(t, this);
          }, this),
          delete this._boundPointerEvents);
      }),
      (i.onmousemove = function (t) {
        this._pointerMove(t, t);
      }),
      (i.onpointermove = function (t) {
        t.pointerId == this.pointerIdentifier && this._pointerMove(t, t);
      }),
      (i.ontouchmove = function (t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerMove(t, e);
      }),
      (i._pointerMove = function (t, e) {
        this.pointerMove(t, e);
      }),
      (i.pointerMove = function (t, e) {
        this.emitEvent("pointerMove", [t, e]);
      }),
      (i.onmouseup = function (t) {
        this._pointerUp(t, t);
      }),
      (i.onpointerup = function (t) {
        t.pointerId == this.pointerIdentifier && this._pointerUp(t, t);
      }),
      (i.ontouchend = function (t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerUp(t, e);
      }),
      (i._pointerUp = function (t, e) {
        this._pointerDone(), this.pointerUp(t, e);
      }),
      (i.pointerUp = function (t, e) {
        this.emitEvent("pointerUp", [t, e]);
      }),
      (i._pointerDone = function () {
        this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone();
      }),
      (i._pointerReset = function () {
        (this.isPointerDown = !1), delete this.pointerIdentifier;
      }),
      (i.pointerDone = function () {}),
      (i.onpointercancel = function (t) {
        t.pointerId == this.pointerIdentifier && this._pointerCancel(t, t);
      }),
      (i.ontouchcancel = function (t) {
        var e = this.getTouch(t.changedTouches);
        e && this._pointerCancel(t, e);
      }),
      (i._pointerCancel = function (t, e) {
        this._pointerDone(), this.pointerCancel(t, e);
      }),
      (i.pointerCancel = function (t, e) {
        this.emitEvent("pointerCancel", [t, e]);
      }),
      (e.getPointerPoint = function (t) {
        return { x: t.pageX, y: t.pageY };
      }),
      e
    );
  }),
  (function (e, i) {
    "function" == typeof define && define.amd
      ? define(
          "unidragger/unidragger",
          ["unipointer/unipointer"],
          function (t) {
            return i(e, t);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = i(e, require("unipointer")))
      : (e.Unidragger = i(e, e.Unipointer));
  })(window, function (o, t) {
    function e() {}
    var i = (e.prototype = Object.create(t.prototype));
    (i.bindHandles = function () {
      this._bindHandles(!0);
    }),
      (i.unbindHandles = function () {
        this._bindHandles(!1);
      }),
      (i._bindHandles = function (t) {
        for (
          var e = (t = void 0 === t || t)
              ? "addEventListener"
              : "removeEventListener",
            i = t ? this._touchActionValue : "",
            n = 0;
          n < this.handles.length;
          n++
        ) {
          var s = this.handles[n];
          this._bindStartEvent(s, t),
            s[e]("click", this),
            o.PointerEvent && (s.style.touchAction = i);
        }
      }),
      (i._touchActionValue = "none"),
      (i.pointerDown = function (t, e) {
        this.okayPointerDown(t) &&
          ((this.pointerDownPointer = e),
          t.preventDefault(),
          this.pointerDownBlur(),
          this._bindPostStartEvents(t),
          this.emitEvent("pointerDown", [t, e]));
      });
    var s = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
      r = {
        radio: !0,
        checkbox: !0,
        button: !0,
        submit: !0,
        image: !0,
        file: !0,
      };
    return (
      (i.okayPointerDown = function (t) {
        var e = s[t.target.nodeName],
          i = r[t.target.type],
          n = !e || i;
        return n || this._pointerReset(), n;
      }),
      (i.pointerDownBlur = function () {
        var t = document.activeElement;
        t && t.blur && t != document.body && t.blur();
      }),
      (i.pointerMove = function (t, e) {
        var i = this._dragPointerMove(t, e);
        this.emitEvent("pointerMove", [t, e, i]), this._dragMove(t, e, i);
      }),
      (i._dragPointerMove = function (t, e) {
        var i = {
          x: e.pageX - this.pointerDownPointer.pageX,
          y: e.pageY - this.pointerDownPointer.pageY,
        };
        return (
          !this.isDragging && this.hasDragStarted(i) && this._dragStart(t, e), i
        );
      }),
      (i.hasDragStarted = function (t) {
        return 3 < Math.abs(t.x) || 3 < Math.abs(t.y);
      }),
      (i.pointerUp = function (t, e) {
        this.emitEvent("pointerUp", [t, e]), this._dragPointerUp(t, e);
      }),
      (i._dragPointerUp = function (t, e) {
        this.isDragging ? this._dragEnd(t, e) : this._staticClick(t, e);
      }),
      (i._dragStart = function (t, e) {
        (this.isDragging = !0),
          (this.isPreventingClicks = !0),
          this.dragStart(t, e);
      }),
      (i.dragStart = function (t, e) {
        this.emitEvent("dragStart", [t, e]);
      }),
      (i._dragMove = function (t, e, i) {
        this.isDragging && this.dragMove(t, e, i);
      }),
      (i.dragMove = function (t, e, i) {
        t.preventDefault(), this.emitEvent("dragMove", [t, e, i]);
      }),
      (i._dragEnd = function (t, e) {
        (this.isDragging = !1),
          setTimeout(
            function () {
              delete this.isPreventingClicks;
            }.bind(this)
          ),
          this.dragEnd(t, e);
      }),
      (i.dragEnd = function (t, e) {
        this.emitEvent("dragEnd", [t, e]);
      }),
      (i.onclick = function (t) {
        this.isPreventingClicks && t.preventDefault();
      }),
      (i._staticClick = function (t, e) {
        (this.isIgnoringMouseUp && "mouseup" == t.type) ||
          (this.staticClick(t, e),
          "mouseup" != t.type &&
            ((this.isIgnoringMouseUp = !0),
            setTimeout(
              function () {
                delete this.isIgnoringMouseUp;
              }.bind(this),
              400
            )));
      }),
      (i.staticClick = function (t, e) {
        this.emitEvent("staticClick", [t, e]);
      }),
      (e.getPointerPoint = t.getPointerPoint),
      e
    );
  }),
  (function (n, s) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/drag",
          ["./flickity", "unidragger/unidragger", "fizzy-ui-utils/utils"],
          function (t, e, i) {
            return s(n, t, e, i);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = s(
          n,
          require("./flickity"),
          require("unidragger"),
          require("fizzy-ui-utils")
        ))
      : (n.Flickity = s(n, n.Flickity, n.Unidragger, n.fizzyUIUtils));
  })(window, function (i, t, e, a) {
    a.extend(t.defaults, { draggable: ">1", dragThreshold: 3 }),
      t.createMethods.push("_createDrag");
    var n = t.prototype;
    a.extend(n, e.prototype), (n._touchActionValue = "pan-y");
    var s = "createTouch" in document,
      o = !1;
    (n._createDrag = function () {
      this.on("activate", this.onActivateDrag),
        this.on("uiChange", this._uiChangeDrag),
        this.on("deactivate", this.onDeactivateDrag),
        this.on("cellChange", this.updateDraggable),
        s && !o && (i.addEventListener("touchmove", function () {}), (o = !0));
    }),
      (n.onActivateDrag = function () {
        (this.handles = [this.viewport]),
          this.bindHandles(),
          this.updateDraggable();
      }),
      (n.onDeactivateDrag = function () {
        this.unbindHandles(), this.element.classList.remove("is-draggable");
      }),
      (n.updateDraggable = function () {
        ">1" == this.options.draggable
          ? (this.isDraggable = 1 < this.slides.length)
          : (this.isDraggable = this.options.draggable),
          this.isDraggable
            ? this.element.classList.add("is-draggable")
            : this.element.classList.remove("is-draggable");
      }),
      (n.bindDrag = function () {
        (this.options.draggable = !0), this.updateDraggable();
      }),
      (n.unbindDrag = function () {
        (this.options.draggable = !1), this.updateDraggable();
      }),
      (n._uiChangeDrag = function () {
        delete this.isFreeScrolling;
      }),
      (n.pointerDown = function (t, e) {
        this.isDraggable
          ? this.okayPointerDown(t) &&
            (this._pointerDownPreventDefault(t),
            this.pointerDownFocus(t),
            document.activeElement != this.element && this.pointerDownBlur(),
            (this.dragX = this.x),
            this.viewport.classList.add("is-pointer-down"),
            (this.pointerDownScroll = l()),
            i.addEventListener("scroll", this),
            this._pointerDownDefault(t, e))
          : this._pointerDownDefault(t, e);
      }),
      (n._pointerDownDefault = function (t, e) {
        (this.pointerDownPointer = { pageX: e.pageX, pageY: e.pageY }),
          this._bindPostStartEvents(t),
          this.dispatchEvent("pointerDown", t, [e]);
      });
    var r = { INPUT: !0, TEXTAREA: !0, SELECT: !0 };
    function l() {
      return { x: i.pageXOffset, y: i.pageYOffset };
    }
    return (
      (n.pointerDownFocus = function (t) {
        r[t.target.nodeName] || this.focus();
      }),
      (n._pointerDownPreventDefault = function (t) {
        var e = "touchstart" == t.type,
          i = "touch" == t.pointerType,
          n = r[t.target.nodeName];
        e || i || n || t.preventDefault();
      }),
      (n.hasDragStarted = function (t) {
        return Math.abs(t.x) > this.options.dragThreshold;
      }),
      (n.pointerUp = function (t, e) {
        delete this.isTouchScrolling,
          this.viewport.classList.remove("is-pointer-down"),
          this.dispatchEvent("pointerUp", t, [e]),
          this._dragPointerUp(t, e);
      }),
      (n.pointerDone = function () {
        i.removeEventListener("scroll", this), delete this.pointerDownScroll;
      }),
      (n.dragStart = function (t, e) {
        this.isDraggable &&
          ((this.dragStartPosition = this.x),
          this.startAnimation(),
          i.removeEventListener("scroll", this),
          this.dispatchEvent("dragStart", t, [e]));
      }),
      (n.pointerMove = function (t, e) {
        var i = this._dragPointerMove(t, e);
        this.dispatchEvent("pointerMove", t, [e, i]), this._dragMove(t, e, i);
      }),
      (n.dragMove = function (t, e, i) {
        if (this.isDraggable) {
          t.preventDefault(), (this.previousDragX = this.dragX);
          var n = this.options.rightToLeft ? -1 : 1;
          this.options.wrapAround && (i.x = i.x % this.slideableWidth);
          var s = this.dragStartPosition + i.x * n;
          if (!this.options.wrapAround && this.slides.length) {
            var o = Math.max(-this.slides[0].target, this.dragStartPosition);
            s = o < s ? 0.5 * (s + o) : s;
            var r = Math.min(
              -this.getLastSlide().target,
              this.dragStartPosition
            );
            s = s < r ? 0.5 * (s + r) : s;
          }
          (this.dragX = s),
            (this.dragMoveTime = new Date()),
            this.dispatchEvent("dragMove", t, [e, i]);
        }
      }),
      (n.dragEnd = function (t, e) {
        if (this.isDraggable) {
          this.options.freeScroll && (this.isFreeScrolling = !0);
          var i = this.dragEndRestingSelect();
          if (this.options.freeScroll && !this.options.wrapAround) {
            var n = this.getRestingPosition();
            this.isFreeScrolling =
              -n > this.slides[0].target && -n < this.getLastSlide().target;
          } else
            this.options.freeScroll ||
              i != this.selectedIndex ||
              (i += this.dragEndBoostSelect());
          delete this.previousDragX,
            (this.isDragSelect = this.options.wrapAround),
            this.select(i),
            delete this.isDragSelect,
            this.dispatchEvent("dragEnd", t, [e]);
        }
      }),
      (n.dragEndRestingSelect = function () {
        var t = this.getRestingPosition(),
          e = Math.abs(this.getSlideDistance(-t, this.selectedIndex)),
          i = this._getClosestResting(t, e, 1),
          n = this._getClosestResting(t, e, -1);
        return i.distance < n.distance ? i.index : n.index;
      }),
      (n._getClosestResting = function (t, e, i) {
        for (
          var n = this.selectedIndex,
            s = 1 / 0,
            o =
              this.options.contain && !this.options.wrapAround
                ? function (t, e) {
                    return t <= e;
                  }
                : function (t, e) {
                    return t < e;
                  };
          o(e, s) &&
          ((n += i), (s = e), null !== (e = this.getSlideDistance(-t, n)));

        )
          e = Math.abs(e);
        return { distance: s, index: n - i };
      }),
      (n.getSlideDistance = function (t, e) {
        var i = this.slides.length,
          n = this.options.wrapAround && 1 < i,
          s = n ? a.modulo(e, i) : e,
          o = this.slides[s];
        if (!o) return null;
        var r = n ? this.slideableWidth * Math.floor(e / i) : 0;
        return t - (o.target + r);
      }),
      (n.dragEndBoostSelect = function () {
        if (
          void 0 === this.previousDragX ||
          !this.dragMoveTime ||
          100 < new Date() - this.dragMoveTime
        )
          return 0;
        var t = this.getSlideDistance(-this.dragX, this.selectedIndex),
          e = this.previousDragX - this.dragX;
        return 0 < t && 0 < e ? 1 : t < 0 && e < 0 ? -1 : 0;
      }),
      (n.staticClick = function (t, e) {
        var i = this.getParentCell(t.target),
          n = i && i.element,
          s = i && this.cells.indexOf(i);
        this.dispatchEvent("staticClick", t, [e, n, s]);
      }),
      (n.onscroll = function () {
        var t = l(),
          e = this.pointerDownScroll.x - t.x,
          i = this.pointerDownScroll.y - t.y;
        (3 < Math.abs(e) || 3 < Math.abs(i)) && this._pointerDone();
      }),
      t
    );
  }),
  (function (n, s) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/prev-next-button",
          ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"],
          function (t, e, i) {
            return s(n, t, e, i);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = s(
          n,
          require("./flickity"),
          require("unipointer"),
          require("fizzy-ui-utils")
        ))
      : s(n, n.Flickity, n.Unipointer, n.fizzyUIUtils);
  })(window, function (t, e, i, n) {
    "use strict";
    var s = "http://www.w3.org/2000/svg";
    function o(t, e) {
      (this.direction = t), (this.parent = e), this._create();
    }
    ((o.prototype = Object.create(i.prototype))._create = function () {
      (this.isEnabled = !0), (this.isPrevious = -1 == this.direction);
      var t = this.parent.options.rightToLeft ? 1 : -1;
      this.isLeft = this.direction == t;
      var e = (this.element = document.createElement("button"));
      (e.className = "flickity-button flickity-prev-next-button"),
        (e.className += this.isPrevious ? " previous" : " next"),
        e.setAttribute("type", "button"),
        this.disable(),
        e.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
      var i = this.createSVG();
      e.appendChild(i),
        this.parent.on("select", this.update.bind(this)),
        this.on(
          "pointerDown",
          this.parent.childUIPointerDown.bind(this.parent)
        );
    }),
      (o.prototype.activate = function () {
        this.bindStartEvent(this.element),
          this.element.addEventListener("click", this),
          this.parent.element.appendChild(this.element);
      }),
      (o.prototype.deactivate = function () {
        this.parent.element.removeChild(this.element),
          this.unbindStartEvent(this.element),
          this.element.removeEventListener("click", this);
      }),
      (o.prototype.createSVG = function () {
        var t = document.createElementNS(s, "svg");
        t.setAttribute("class", "flickity-button-icon"),
          t.setAttribute("viewBox", "0 0 100 100");
        var e = document.createElementNS(s, "path"),
          i = (function (t) {
            return "string" != typeof t
              ? "M " +
                  t.x0 +
                  ",50 L " +
                  t.x1 +
                  "," +
                  (t.y1 + 50) +
                  " L " +
                  t.x2 +
                  "," +
                  (t.y2 + 50) +
                  " L " +
                  t.x3 +
                  ",50  L " +
                  t.x2 +
                  "," +
                  (50 - t.y2) +
                  " L " +
                  t.x1 +
                  "," +
                  (50 - t.y1) +
                  " Z"
              : t;
          })(this.parent.options.arrowShape);
        return (
          e.setAttribute("d", i),
          e.setAttribute("class", "arrow"),
          this.isLeft ||
            e.setAttribute("transform", "translate(100, 100) rotate(180) "),
          t.appendChild(e),
          t
        );
      }),
      (o.prototype.handleEvent = n.handleEvent),
      (o.prototype.onclick = function () {
        if (this.isEnabled) {
          this.parent.uiChange();
          var t = this.isPrevious ? "previous" : "next";
          this.parent[t]();
        }
      }),
      (o.prototype.enable = function () {
        this.isEnabled || ((this.element.disabled = !1), (this.isEnabled = !0));
      }),
      (o.prototype.disable = function () {
        this.isEnabled && ((this.element.disabled = !0), (this.isEnabled = !1));
      }),
      (o.prototype.update = function () {
        var t = this.parent.slides;
        if (this.parent.options.wrapAround && 1 < t.length) this.enable();
        else {
          var e = t.length ? t.length - 1 : 0,
            i = this.isPrevious ? 0 : e;
          this[this.parent.selectedIndex == i ? "disable" : "enable"]();
        }
      }),
      (o.prototype.destroy = function () {
        this.deactivate(), this.allOff();
      }),
      n.extend(e.defaults, {
        prevNextButtons: !0,
        arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 },
      }),
      e.createMethods.push("_createPrevNextButtons");
    var r = e.prototype;
    return (
      (r._createPrevNextButtons = function () {
        this.options.prevNextButtons &&
          ((this.prevButton = new o(-1, this)),
          (this.nextButton = new o(1, this)),
          this.on("activate", this.activatePrevNextButtons));
      }),
      (r.activatePrevNextButtons = function () {
        this.prevButton.activate(),
          this.nextButton.activate(),
          this.on("deactivate", this.deactivatePrevNextButtons);
      }),
      (r.deactivatePrevNextButtons = function () {
        this.prevButton.deactivate(),
          this.nextButton.deactivate(),
          this.off("deactivate", this.deactivatePrevNextButtons);
      }),
      (e.PrevNextButton = o),
      e
    );
  }),
  (function (n, s) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/page-dots",
          ["./flickity", "unipointer/unipointer", "fizzy-ui-utils/utils"],
          function (t, e, i) {
            return s(n, t, e, i);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = s(
          n,
          require("./flickity"),
          require("unipointer"),
          require("fizzy-ui-utils")
        ))
      : s(n, n.Flickity, n.Unipointer, n.fizzyUIUtils);
  })(window, function (t, e, i, n) {
    function s(t) {
      (this.parent = t), this._create();
    }
    ((s.prototype = Object.create(i.prototype))._create = function () {
      (this.holder = document.createElement("ol")),
        (this.holder.className = "flickity-page-dots"),
        (this.dots = []),
        (this.handleClick = this.onClick.bind(this)),
        this.on(
          "pointerDown",
          this.parent.childUIPointerDown.bind(this.parent)
        );
    }),
      (s.prototype.activate = function () {
        this.setDots(),
          this.holder.addEventListener("click", this.handleClick),
          this.bindStartEvent(this.holder),
          this.parent.element.appendChild(this.holder);
      }),
      (s.prototype.deactivate = function () {
        this.holder.removeEventListener("click", this.handleClick),
          this.unbindStartEvent(this.holder),
          this.parent.element.removeChild(this.holder);
      }),
      (s.prototype.setDots = function () {
        var t = this.parent.slides.length - this.dots.length;
        0 < t ? this.addDots(t) : t < 0 && this.removeDots(-t);
      }),
      (s.prototype.addDots = function (t) {
        for (
          var e = document.createDocumentFragment(),
            i = [],
            n = this.dots.length,
            s = n + t,
            o = n;
          o < s;
          o++
        ) {
          var r = document.createElement("li");
          (r.className = "dot"),
            r.setAttribute("aria-label", "Page dot " + (o + 1)),
            e.appendChild(r),
            i.push(r);
        }
        this.holder.appendChild(e), (this.dots = this.dots.concat(i));
      }),
      (s.prototype.removeDots = function (t) {
        this.dots.splice(this.dots.length - t, t).forEach(function (t) {
          this.holder.removeChild(t);
        }, this);
      }),
      (s.prototype.updateSelected = function () {
        this.selectedDot &&
          ((this.selectedDot.className = "dot"),
          this.selectedDot.removeAttribute("aria-current")),
          this.dots.length &&
            ((this.selectedDot = this.dots[this.parent.selectedIndex]),
            (this.selectedDot.className = "dot is-selected"),
            this.selectedDot.setAttribute("aria-current", "step"));
      }),
      (s.prototype.onTap = s.prototype.onClick =
        function (t) {
          var e = t.target;
          if ("LI" == e.nodeName) {
            this.parent.uiChange();
            var i = this.dots.indexOf(e);
            this.parent.select(i);
          }
        }),
      (s.prototype.destroy = function () {
        this.deactivate(), this.allOff();
      }),
      (e.PageDots = s),
      n.extend(e.defaults, { pageDots: !0 }),
      e.createMethods.push("_createPageDots");
    var o = e.prototype;
    return (
      (o._createPageDots = function () {
        this.options.pageDots &&
          ((this.pageDots = new s(this)),
          this.on("activate", this.activatePageDots),
          this.on("select", this.updateSelectedPageDots),
          this.on("cellChange", this.updatePageDots),
          this.on("resize", this.updatePageDots),
          this.on("deactivate", this.deactivatePageDots));
      }),
      (o.activatePageDots = function () {
        this.pageDots.activate();
      }),
      (o.updateSelectedPageDots = function () {
        this.pageDots.updateSelected();
      }),
      (o.updatePageDots = function () {
        this.pageDots.setDots();
      }),
      (o.deactivatePageDots = function () {
        this.pageDots.deactivate();
      }),
      (e.PageDots = s),
      e
    );
  }),
  (function (t, n) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/player",
          ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickity"],
          function (t, e, i) {
            return n(t, e, i);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = n(
          require("ev-emitter"),
          require("fizzy-ui-utils"),
          require("./flickity")
        ))
      : n(t.EvEmitter, t.fizzyUIUtils, t.Flickity);
  })(window, function (t, e, i) {
    function n(t) {
      (this.parent = t),
        (this.state = "stopped"),
        (this.onVisibilityChange = this.visibilityChange.bind(this)),
        (this.onVisibilityPlay = this.visibilityPlay.bind(this));
    }
    ((n.prototype = Object.create(t.prototype)).play = function () {
      "playing" != this.state &&
        (document.hidden
          ? document.addEventListener("visibilitychange", this.onVisibilityPlay)
          : ((this.state = "playing"),
            document.addEventListener(
              "visibilitychange",
              this.onVisibilityChange
            ),
            this.tick()));
    }),
      (n.prototype.tick = function () {
        if ("playing" == this.state) {
          var t = this.parent.options.autoPlay;
          t = "number" == typeof t ? t : 3e3;
          var e = this;
          this.clear(),
            (this.timeout = setTimeout(function () {
              e.parent.next(!0), e.tick();
            }, t));
        }
      }),
      (n.prototype.stop = function () {
        (this.state = "stopped"),
          this.clear(),
          document.removeEventListener(
            "visibilitychange",
            this.onVisibilityChange
          );
      }),
      (n.prototype.clear = function () {
        clearTimeout(this.timeout);
      }),
      (n.prototype.pause = function () {
        "playing" == this.state && ((this.state = "paused"), this.clear());
      }),
      (n.prototype.unpause = function () {
        "paused" == this.state && this.play();
      }),
      (n.prototype.visibilityChange = function () {
        this[document.hidden ? "pause" : "unpause"]();
      }),
      (n.prototype.visibilityPlay = function () {
        this.play(),
          document.removeEventListener(
            "visibilitychange",
            this.onVisibilityPlay
          );
      }),
      e.extend(i.defaults, { pauseAutoPlayOnHover: !0 }),
      i.createMethods.push("_createPlayer");
    var s = i.prototype;
    return (
      (s._createPlayer = function () {
        (this.player = new n(this)),
          this.on("activate", this.activatePlayer),
          this.on("uiChange", this.stopPlayer),
          this.on("pointerDown", this.stopPlayer),
          this.on("deactivate", this.deactivatePlayer);
      }),
      (s.activatePlayer = function () {
        this.options.autoPlay &&
          (this.player.play(),
          this.element.addEventListener("mouseenter", this));
      }),
      (s.playPlayer = function () {
        this.player.play();
      }),
      (s.stopPlayer = function () {
        this.player.stop();
      }),
      (s.pausePlayer = function () {
        this.player.pause();
      }),
      (s.unpausePlayer = function () {
        this.player.unpause();
      }),
      (s.deactivatePlayer = function () {
        this.player.stop(),
          this.element.removeEventListener("mouseenter", this);
      }),
      (s.onmouseenter = function () {
        this.options.pauseAutoPlayOnHover &&
          (this.player.pause(),
          this.element.addEventListener("mouseleave", this));
      }),
      (s.onmouseleave = function () {
        this.player.unpause(),
          this.element.removeEventListener("mouseleave", this);
      }),
      (i.Player = n),
      i
    );
  }),
  (function (i, n) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/add-remove-cell",
          ["./flickity", "fizzy-ui-utils/utils"],
          function (t, e) {
            return n(i, t, e);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = n(
          i,
          require("./flickity"),
          require("fizzy-ui-utils")
        ))
      : n(i, i.Flickity, i.fizzyUIUtils);
  })(window, function (t, e, n) {
    var i = e.prototype;
    return (
      (i.insert = function (t, e) {
        var i = this._makeCells(t);
        if (i && i.length) {
          var n = this.cells.length;
          e = void 0 === e ? n : e;
          var s = (function (t) {
              var e = document.createDocumentFragment();
              return (
                t.forEach(function (t) {
                  e.appendChild(t.element);
                }),
                e
              );
            })(i),
            o = e == n;
          if (o) this.slider.appendChild(s);
          else {
            var r = this.cells[e].element;
            this.slider.insertBefore(s, r);
          }
          if (0 === e) this.cells = i.concat(this.cells);
          else if (o) this.cells = this.cells.concat(i);
          else {
            var a = this.cells.splice(e, n - e);
            this.cells = this.cells.concat(i).concat(a);
          }
          this._sizeCells(i), this.cellChange(e, !0);
        }
      }),
      (i.append = function (t) {
        this.insert(t, this.cells.length);
      }),
      (i.prepend = function (t) {
        this.insert(t, 0);
      }),
      (i.remove = function (t) {
        var e = this.getCells(t);
        if (e && e.length) {
          var i = this.cells.length - 1;
          e.forEach(function (t) {
            t.remove();
            var e = this.cells.indexOf(t);
            (i = Math.min(e, i)), n.removeFrom(this.cells, t);
          }, this),
            this.cellChange(i, !0);
        }
      }),
      (i.cellSizeChange = function (t) {
        var e = this.getCell(t);
        if (e) {
          e.getSize();
          var i = this.cells.indexOf(e);
          this.cellChange(i);
        }
      }),
      (i.cellChange = function (t, e) {
        var i = this.selectedElement;
        this._positionCells(t),
          this._getWrapShiftCells(),
          this.setGallerySize();
        var n = this.getCell(i);
        n && (this.selectedIndex = this.getCellSlideIndex(n)),
          (this.selectedIndex = Math.min(
            this.slides.length - 1,
            this.selectedIndex
          )),
          this.emitEvent("cellChange", [t]),
          this.select(this.selectedIndex),
          e && this.positionSliderAtSelected();
      }),
      e
    );
  }),
  (function (i, n) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/lazyload",
          ["./flickity", "fizzy-ui-utils/utils"],
          function (t, e) {
            return n(i, t, e);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = n(
          i,
          require("./flickity"),
          require("fizzy-ui-utils")
        ))
      : n(i, i.Flickity, i.fizzyUIUtils);
  })(window, function (t, e, o) {
    "use strict";
    e.createMethods.push("_createLazyload");
    var i = e.prototype;
    function s(t, e) {
      (this.img = t), (this.flickity = e), this.load();
    }
    return (
      (i._createLazyload = function () {
        this.on("select", this.lazyLoad);
      }),
      (i.lazyLoad = function () {
        var t = this.options.lazyLoad;
        if (t) {
          var e = "number" == typeof t ? t : 0,
            i = this.getAdjacentCellElements(e),
            n = [];
          i.forEach(function (t) {
            var e = (function (t) {
              if ("IMG" == t.nodeName) {
                var e = t.getAttribute("data-flickity-lazyload"),
                  i = t.getAttribute("data-flickity-lazyload-src"),
                  n = t.getAttribute("data-flickity-lazyload-srcset");
                if (e || i || n) return [t];
              }
              var s = t.querySelectorAll(
                "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]"
              );
              return o.makeArray(s);
            })(t);
            n = n.concat(e);
          }),
            n.forEach(function (t) {
              new s(t, this);
            }, this);
        }
      }),
      (s.prototype.handleEvent = o.handleEvent),
      (s.prototype.load = function () {
        this.img.addEventListener("load", this),
          this.img.addEventListener("error", this);
        var t =
            this.img.getAttribute("data-flickity-lazyload") ||
            this.img.getAttribute("data-flickity-lazyload-src"),
          e = this.img.getAttribute("data-flickity-lazyload-srcset");
        (this.img.src = t),
          e && this.img.setAttribute("srcset", e),
          this.img.removeAttribute("data-flickity-lazyload"),
          this.img.removeAttribute("data-flickity-lazyload-src"),
          this.img.removeAttribute("data-flickity-lazyload-srcset");
      }),
      (s.prototype.onload = function (t) {
        this.complete(t, "flickity-lazyloaded");
      }),
      (s.prototype.onerror = function (t) {
        this.complete(t, "flickity-lazyerror");
      }),
      (s.prototype.complete = function (t, e) {
        this.img.removeEventListener("load", this),
          this.img.removeEventListener("error", this);
        var i = this.flickity.getParentCell(this.img),
          n = i && i.element;
        this.flickity.cellSizeChange(n),
          this.img.classList.add(e),
          this.flickity.dispatchEvent("lazyLoad", t, n);
      }),
      (e.LazyLoader = s),
      e
    );
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "flickity/js/index",
          [
            "./flickity",
            "./drag",
            "./prev-next-button",
            "./page-dots",
            "./player",
            "./add-remove-cell",
            "./lazyload",
          ],
          e
        )
      : "object" == typeof module &&
        module.exports &&
        (module.exports = e(
          require("./flickity"),
          require("./drag"),
          require("./prev-next-button"),
          require("./page-dots"),
          require("./player"),
          require("./add-remove-cell"),
          require("./lazyload")
        ));
  })(window, function (t) {
    return t;
  }),
  (function (t, e) {
    "function" == typeof define && define.amd
      ? define(
          "flickity-as-nav-for/as-nav-for",
          ["flickity/js/index", "fizzy-ui-utils/utils"],
          e
        )
      : "object" == typeof module && module.exports
      ? (module.exports = e(require("flickity"), require("fizzy-ui-utils")))
      : (t.Flickity = e(t.Flickity, t.fizzyUIUtils));
  })(window, function (n, s) {
    n.createMethods.push("_createAsNavFor");
    var t = n.prototype;
    return (
      (t._createAsNavFor = function () {
        this.on("activate", this.activateAsNavFor),
          this.on("deactivate", this.deactivateAsNavFor),
          this.on("destroy", this.destroyAsNavFor);
        var t = this.options.asNavFor;
        if (t) {
          var e = this;
          setTimeout(function () {
            e.setNavCompanion(t);
          });
        }
      }),
      (t.setNavCompanion = function (t) {
        t = s.getQueryElement(t);
        var e = n.data(t);
        if (e && e != this) {
          this.navCompanion = e;
          var i = this;
          (this.onNavCompanionSelect = function () {
            i.navCompanionSelect();
          }),
            e.on("select", this.onNavCompanionSelect),
            this.on("staticClick", this.onNavStaticClick),
            this.navCompanionSelect(!0);
        }
      }),
      (t.navCompanionSelect = function (t) {
        var e = this.navCompanion && this.navCompanion.selectedCells;
        if (e) {
          var i = e[0],
            n = this.navCompanion.cells.indexOf(i),
            s = n + e.length - 1,
            o = Math.floor(
              (function (t, e, i) {
                return (e - t) * i + t;
              })(n, s, this.navCompanion.cellAlign)
            );
          if (
            (this.selectCell(o, !1, t),
            this.removeNavSelectedElements(),
            !(o >= this.cells.length))
          ) {
            var r = this.cells.slice(n, 1 + s);
            (this.navSelectedElements = r.map(function (t) {
              return t.element;
            })),
              this.changeNavSelectedClass("add");
          }
        }
      }),
      (t.changeNavSelectedClass = function (e) {
        this.navSelectedElements.forEach(function (t) {
          t.classList[e]("is-nav-selected");
        });
      }),
      (t.activateAsNavFor = function () {
        this.navCompanionSelect(!0);
      }),
      (t.removeNavSelectedElements = function () {
        this.navSelectedElements &&
          (this.changeNavSelectedClass("remove"),
          delete this.navSelectedElements);
      }),
      (t.onNavStaticClick = function (t, e, i, n) {
        "number" == typeof n && this.navCompanion.selectCell(n);
      }),
      (t.deactivateAsNavFor = function () {
        this.removeNavSelectedElements();
      }),
      (t.destroyAsNavFor = function () {
        this.navCompanion &&
          (this.navCompanion.off("select", this.onNavCompanionSelect),
          this.off("staticClick", this.onNavStaticClick),
          delete this.navCompanion);
      }),
      n
    );
  }),
  (function (e, i) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(
          "imagesloaded/imagesloaded",
          ["ev-emitter/ev-emitter"],
          function (t) {
            return i(e, t);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = i(e, require("ev-emitter")))
      : (e.imagesLoaded = i(e, e.EvEmitter));
  })("undefined" != typeof window ? window : this, function (e, t) {
    var s = e.jQuery,
      o = e.console;
    function r(t, e) {
      for (var i in e) t[i] = e[i];
      return t;
    }
    var a = Array.prototype.slice;
    function l(t, e, i) {
      if (!(this instanceof l)) return new l(t, e, i);
      var n = t;
      "string" == typeof t && (n = document.querySelectorAll(t)),
        n
          ? ((this.elements = (function (t) {
              return Array.isArray(t)
                ? t
                : "object" == typeof t && "number" == typeof t.length
                ? a.call(t)
                : [t];
            })(n)),
            (this.options = r({}, this.options)),
            "function" == typeof e ? (i = e) : r(this.options, e),
            i && this.on("always", i),
            this.getImages(),
            s && (this.jqDeferred = new s.Deferred()),
            setTimeout(this.check.bind(this)))
          : o.error("Bad element for imagesLoaded " + (n || t));
    }
    ((l.prototype = Object.create(t.prototype)).options = {}),
      (l.prototype.getImages = function () {
        (this.images = []), this.elements.forEach(this.addElementImages, this);
      }),
      (l.prototype.addElementImages = function (t) {
        "IMG" == t.nodeName && this.addImage(t),
          !0 === this.options.background && this.addElementBackgroundImages(t);
        var e = t.nodeType;
        if (e && h[e]) {
          for (var i = t.querySelectorAll("img"), n = 0; n < i.length; n++) {
            var s = i[n];
            this.addImage(s);
          }
          if ("string" == typeof this.options.background) {
            var o = t.querySelectorAll(this.options.background);
            for (n = 0; n < o.length; n++) {
              var r = o[n];
              this.addElementBackgroundImages(r);
            }
          }
        }
      });
    var h = { 1: !0, 9: !0, 11: !0 };
    function i(t) {
      this.img = t;
    }
    function n(t, e) {
      (this.url = t), (this.element = e), (this.img = new Image());
    }
    return (
      (l.prototype.addElementBackgroundImages = function (t) {
        var e = getComputedStyle(t);
        if (e)
          for (
            var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(e.backgroundImage);
            null !== n;

          ) {
            var s = n && n[2];
            s && this.addBackground(s, t), (n = i.exec(e.backgroundImage));
          }
      }),
      (l.prototype.addImage = function (t) {
        var e = new i(t);
        this.images.push(e);
      }),
      (l.prototype.addBackground = function (t, e) {
        var i = new n(t, e);
        this.images.push(i);
      }),
      (l.prototype.check = function () {
        var n = this;
        function e(t, e, i) {
          setTimeout(function () {
            n.progress(t, e, i);
          });
        }
        (this.progressedCount = 0),
          (this.hasAnyBroken = !1),
          this.images.length
            ? this.images.forEach(function (t) {
                t.once("progress", e), t.check();
              })
            : this.complete();
      }),
      (l.prototype.progress = function (t, e, i) {
        this.progressedCount++,
          (this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded),
          this.emitEvent("progress", [this, t, e]),
          this.jqDeferred &&
            this.jqDeferred.notify &&
            this.jqDeferred.notify(this, t),
          this.progressedCount == this.images.length && this.complete(),
          this.options.debug && o && o.log("progress: " + i, t, e);
      }),
      (l.prototype.complete = function () {
        var t = this.hasAnyBroken ? "fail" : "done";
        if (
          ((this.isComplete = !0),
          this.emitEvent(t, [this]),
          this.emitEvent("always", [this]),
          this.jqDeferred)
        ) {
          var e = this.hasAnyBroken ? "reject" : "resolve";
          this.jqDeferred[e](this);
        }
      }),
      ((i.prototype = Object.create(t.prototype)).check = function () {
        this.getIsImageComplete()
          ? this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
          : ((this.proxyImage = new Image()),
            this.proxyImage.addEventListener("load", this),
            this.proxyImage.addEventListener("error", this),
            this.img.addEventListener("load", this),
            this.img.addEventListener("error", this),
            (this.proxyImage.src = this.img.src));
      }),
      (i.prototype.getIsImageComplete = function () {
        return this.img.complete && this.img.naturalWidth;
      }),
      (i.prototype.confirm = function (t, e) {
        (this.isLoaded = t), this.emitEvent("progress", [this, this.img, e]);
      }),
      (i.prototype.handleEvent = function (t) {
        var e = "on" + t.type;
        this[e] && this[e](t);
      }),
      (i.prototype.onload = function () {
        this.confirm(!0, "onload"), this.unbindEvents();
      }),
      (i.prototype.onerror = function () {
        this.confirm(!1, "onerror"), this.unbindEvents();
      }),
      (i.prototype.unbindEvents = function () {
        this.proxyImage.removeEventListener("load", this),
          this.proxyImage.removeEventListener("error", this),
          this.img.removeEventListener("load", this),
          this.img.removeEventListener("error", this);
      }),
      ((n.prototype = Object.create(i.prototype)).check = function () {
        this.img.addEventListener("load", this),
          this.img.addEventListener("error", this),
          (this.img.src = this.url),
          this.getIsImageComplete() &&
            (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"),
            this.unbindEvents());
      }),
      (n.prototype.unbindEvents = function () {
        this.img.removeEventListener("load", this),
          this.img.removeEventListener("error", this);
      }),
      (n.prototype.confirm = function (t, e) {
        (this.isLoaded = t),
          this.emitEvent("progress", [this, this.element, e]);
      }),
      (l.makeJQueryPlugin = function (t) {
        (t = t || e.jQuery) &&
          ((s = t).fn.imagesLoaded = function (t, e) {
            return new l(this, t, e).jqDeferred.promise(s(this));
          });
      }),
      l.makeJQueryPlugin(),
      l
    );
  }),
  (function (i, n) {
    "function" == typeof define && define.amd
      ? define(
          ["flickity/js/index", "imagesloaded/imagesloaded"],
          function (t, e) {
            return n(i, t, e);
          }
        )
      : "object" == typeof module && module.exports
      ? (module.exports = n(i, require("flickity"), require("imagesloaded")))
      : (i.Flickity = n(i, i.Flickity, i.imagesLoaded));
  })(window, function (t, e, i) {
    "use strict";
    e.createMethods.push("_createImagesLoaded");
    var n = e.prototype;
    return (
      (n._createImagesLoaded = function () {
        this.on("activate", this.imagesLoaded);
      }),
      (n.imagesLoaded = function () {
        if (this.options.imagesLoaded) {
          var n = this;
          i(this.slider).on("progress", function (t, e) {
            var i = n.getParentCell(e.img);
            n.cellSizeChange(i && i.element),
              n.options.freeScroll || n.positionSliderAtSelected();
          });
        }
      }),
      e
    );
  });

/* ===============================================
  #Fancybox
================================================== */

// ==================================================
// fancyBox v3.5.6
//
// Licensed GPLv3 for open source use
// or fancyBox Commercial License for commercial use
//
// http://fancyapps.com/fancybox/
// Copyright 2018 fancyApps
//
// ==================================================
!(function (t, e, n, o) {
  "use strict";
  function i(t, e) {
    var o,
      i,
      a,
      s = [],
      r = 0;
    (t && t.isDefaultPrevented()) ||
      (t.preventDefault(),
      (e = e || {}),
      t && t.data && (e = h(t.data.options, e)),
      (o = e.$target || n(t.currentTarget).trigger("blur")),
      ((a = n.fancybox.getInstance()) && a.$trigger && a.$trigger.is(o)) ||
        (e.selector
          ? (s = n(e.selector))
          : ((i = o.attr("data-fancybox") || ""),
            i
              ? ((s = t.data ? t.data.items : []),
                (s = s.length
                  ? s.filter('[data-fancybox="' + i + '"]')
                  : n('[data-fancybox="' + i + '"]')))
              : (s = [o])),
        (r = n(s).index(o)),
        r < 0 && (r = 0),
        (a = n.fancybox.open(s, e, r)),
        (a.$trigger = o)));
  }
  if (((t.console = t.console || { info: function (t) {} }), n)) {
    if (n.fn.fancybox) return void console.info("fancyBox already initialized");
    var a = {
        closeExisting: !1,
        loop: !1,
        gutter: 50,
        keyboard: !0,
        preventCaptionOverlap: !0,
        arrows: !0,
        infobar: !0,
        smallBtn: "auto",
        toolbar: "auto",
        buttons: ["zoom", "slideShow", "thumbs", "close"],
        idleTime: 3,
        protect: !1,
        modal: !1,
        image: { preload: !1 },
        ajax: { settings: { data: { fancybox: !0 } } },
        iframe: {
          tpl: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src=""></iframe>',
          preload: !0,
          css: {},
          attr: { scrolling: "auto" },
        },
        video: {
          tpl: '<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}"><source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!</video>',
          format: "",
          autoStart: !0,
        },
        defaultType: "image",
        animationEffect: "zoom",
        animationDuration: 366,
        zoomOpacity: "auto",
        transitionEffect: "fade",
        transitionDuration: 366,
        slideClass: "",
        baseClass: "",
        baseTpl:
          '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fancybox-navigation">{{arrows}}</div><div class="fancybox-stage"></div><div class="fancybox-caption"><div class="fancybox-caption__body"></div></div></div></div>',
        spinnerTpl: '<div class="fancybox-loading"></div>',
        errorTpl: '<div class="fancybox-error"><p>{{ERROR}}</p></div>',
        btnTpl: {
          download:
            '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg></a>',
          zoom: '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg></button>',
          close:
            '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg></button>',
          arrowLeft:
            '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div></button>',
          arrowRight:
            '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div></button>',
          smallBtn:
            '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg></button>',
        },
        parentEl: "body",
        hideScrollbar: !0,
        autoFocus: !0,
        backFocus: !0,
        trapFocus: !0,
        fullScreen: { autoStart: !1 },
        touch: { vertical: !0, momentum: !0 },
        hash: null,
        media: {},
        slideShow: { autoStart: !1, speed: 3e3 },
        thumbs: {
          autoStart: !1,
          hideOnClose: !0,
          parentEl: ".fancybox-container",
          axis: "y",
        },
        wheel: "auto",
        onInit: n.noop,
        beforeLoad: n.noop,
        afterLoad: n.noop,
        beforeShow: n.noop,
        afterShow: n.noop,
        beforeClose: n.noop,
        afterClose: n.noop,
        onActivate: n.noop,
        onDeactivate: n.noop,
        clickContent: function (t, e) {
          return "image" === t.type && "zoom";
        },
        clickSlide: "close",
        clickOutside: "close",
        dblclickContent: !1,
        dblclickSlide: !1,
        dblclickOutside: !1,
        mobile: {
          preventCaptionOverlap: !1,
          idleTime: !1,
          clickContent: function (t, e) {
            return "image" === t.type && "toggleControls";
          },
          clickSlide: function (t, e) {
            return "image" === t.type ? "toggleControls" : "close";
          },
          dblclickContent: function (t, e) {
            return "image" === t.type && "zoom";
          },
          dblclickSlide: function (t, e) {
            return "image" === t.type && "zoom";
          },
        },
        lang: "en",
        i18n: {
          en: {
            CLOSE: "Close",
            NEXT: "Next",
            PREV: "Previous",
            ERROR:
              "The requested content cannot be loaded. <br/> Please try again later.",
            PLAY_START: "Start slideshow",
            PLAY_STOP: "Pause slideshow",
            FULL_SCREEN: "Full screen",
            THUMBS: "Thumbnails",
            DOWNLOAD: "Download",
            SHARE: "Share",
            ZOOM: "Zoom",
          },
          de: {
            CLOSE: "Schlie&szlig;en",
            NEXT: "Weiter",
            PREV: "Zur&uuml;ck",
            ERROR:
              "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es sp&auml;ter nochmal.",
            PLAY_START: "Diaschau starten",
            PLAY_STOP: "Diaschau beenden",
            FULL_SCREEN: "Vollbild",
            THUMBS: "Vorschaubilder",
            DOWNLOAD: "Herunterladen",
            SHARE: "Teilen",
            ZOOM: "Vergr&ouml;&szlig;ern",
          },
        },
      },
      s = n(t),
      r = n(e),
      c = 0,
      l = function (t) {
        return t && t.hasOwnProperty && t instanceof n;
      },
      d = (function () {
        return (
          t.requestAnimationFrame ||
          t.webkitRequestAnimationFrame ||
          t.mozRequestAnimationFrame ||
          t.oRequestAnimationFrame ||
          function (e) {
            return t.setTimeout(e, 1e3 / 60);
          }
        );
      })(),
      u = (function () {
        return (
          t.cancelAnimationFrame ||
          t.webkitCancelAnimationFrame ||
          t.mozCancelAnimationFrame ||
          t.oCancelAnimationFrame ||
          function (e) {
            t.clearTimeout(e);
          }
        );
      })(),
      f = (function () {
        var t,
          n = e.createElement("fakeelement"),
          o = {
            transition: "transitionend",
            OTransition: "oTransitionEnd",
            MozTransition: "transitionend",
            WebkitTransition: "webkitTransitionEnd",
          };
        for (t in o) if (void 0 !== n.style[t]) return o[t];
        return "transitionend";
      })(),
      p = function (t) {
        return t && t.length && t[0].offsetHeight;
      },
      h = function (t, e) {
        var o = n.extend(!0, {}, t, e);
        return (
          n.each(e, function (t, e) {
            n.isArray(e) && (o[t] = e);
          }),
          o
        );
      },
      g = function (t) {
        var o, i;
        return (
          !(!t || t.ownerDocument !== e) &&
          (n(".fancybox-container").css("pointer-events", "none"),
          (o = {
            x: t.getBoundingClientRect().left + t.offsetWidth / 2,
            y: t.getBoundingClientRect().top + t.offsetHeight / 2,
          }),
          (i = e.elementFromPoint(o.x, o.y) === t),
          n(".fancybox-container").css("pointer-events", ""),
          i)
        );
      },
      b = function (t, e, o) {
        var i = this;
        (i.opts = h({ index: o }, n.fancybox.defaults)),
          n.isPlainObject(e) && (i.opts = h(i.opts, e)),
          n.fancybox.isMobile && (i.opts = h(i.opts, i.opts.mobile)),
          (i.id = i.opts.id || ++c),
          (i.currIndex = parseInt(i.opts.index, 10) || 0),
          (i.prevIndex = null),
          (i.prevPos = null),
          (i.currPos = 0),
          (i.firstRun = !0),
          (i.group = []),
          (i.slides = {}),
          i.addContent(t),
          i.group.length && i.init();
      };
    n.extend(b.prototype, {
      init: function () {
        var o,
          i,
          a = this,
          s = a.group[a.currIndex],
          r = s.opts;
        r.closeExisting && n.fancybox.close(!0),
          n("body").addClass("fancybox-active"),
          !n.fancybox.getInstance() &&
            !1 !== r.hideScrollbar &&
            !n.fancybox.isMobile &&
            e.body.scrollHeight > t.innerHeight &&
            (n("head").append(
              '<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:' +
                (t.innerWidth - e.documentElement.clientWidth) +
                "px;}</style>"
            ),
            n("body").addClass("compensate-for-scrollbar")),
          (i = ""),
          n.each(r.buttons, function (t, e) {
            i += r.btnTpl[e] || "";
          }),
          (o = n(
            a.translate(
              a,
              r.baseTpl
                .replace("{{buttons}}", i)
                .replace("{{arrows}}", r.btnTpl.arrowLeft + r.btnTpl.arrowRight)
            )
          )
            .attr("id", "fancybox-container-" + a.id)
            .addClass(r.baseClass)
            .data("FancyBox", a)
            .appendTo(r.parentEl)),
          (a.$refs = { container: o }),
          [
            "bg",
            "inner",
            "infobar",
            "toolbar",
            "stage",
            "caption",
            "navigation",
          ].forEach(function (t) {
            a.$refs[t] = o.find(".fancybox-" + t);
          }),
          a.trigger("onInit"),
          a.activate(),
          a.jumpTo(a.currIndex);
      },
      translate: function (t, e) {
        var n = t.opts.i18n[t.opts.lang] || t.opts.i18n.en;
        return e.replace(/\{\{(\w+)\}\}/g, function (t, e) {
          return void 0 === n[e] ? t : n[e];
        });
      },
      addContent: function (t) {
        var e,
          o = this,
          i = n.makeArray(t);
        n.each(i, function (t, e) {
          var i,
            a,
            s,
            r,
            c,
            l = {},
            d = {};
          n.isPlainObject(e)
            ? ((l = e), (d = e.opts || e))
            : "object" === n.type(e) && n(e).length
            ? ((i = n(e)),
              (d = i.data() || {}),
              (d = n.extend(!0, {}, d, d.options)),
              (d.$orig = i),
              (l.src = o.opts.src || d.src || i.attr("href")),
              l.type || l.src || ((l.type = "inline"), (l.src = e)))
            : (l = { type: "html", src: e + "" }),
            (l.opts = n.extend(!0, {}, o.opts, d)),
            n.isArray(d.buttons) && (l.opts.buttons = d.buttons),
            n.fancybox.isMobile &&
              l.opts.mobile &&
              (l.opts = h(l.opts, l.opts.mobile)),
            (a = l.type || l.opts.type),
            (r = l.src || ""),
            !a &&
              r &&
              ((s = r.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i))
                ? ((a = "video"),
                  l.opts.video.format ||
                    (l.opts.video.format =
                      "video/" + ("ogv" === s[1] ? "ogg" : s[1])))
                : r.match(
                    /(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i
                  )
                ? (a = "image")
                : r.match(/\.(pdf)((\?|#).*)?$/i)
                ? ((a = "iframe"),
                  (l = n.extend(!0, l, {
                    contentType: "pdf",
                    opts: { iframe: { preload: !1 } },
                  })))
                : "#" === r.charAt(0) && (a = "inline")),
            a ? (l.type = a) : o.trigger("objectNeedsType", l),
            l.contentType ||
              (l.contentType =
                n.inArray(l.type, ["html", "inline", "ajax"]) > -1
                  ? "html"
                  : l.type),
            (l.index = o.group.length),
            "auto" == l.opts.smallBtn &&
              (l.opts.smallBtn =
                n.inArray(l.type, ["html", "inline", "ajax"]) > -1),
            "auto" === l.opts.toolbar && (l.opts.toolbar = !l.opts.smallBtn),
            (l.$thumb = l.opts.$thumb || null),
            l.opts.$trigger &&
              l.index === o.opts.index &&
              ((l.$thumb = l.opts.$trigger.find("img:first")),
              l.$thumb.length && (l.opts.$orig = l.opts.$trigger)),
            (l.$thumb && l.$thumb.length) ||
              !l.opts.$orig ||
              (l.$thumb = l.opts.$orig.find("img:first")),
            l.$thumb && !l.$thumb.length && (l.$thumb = null),
            (l.thumb = l.opts.thumb || (l.$thumb ? l.$thumb[0].src : null)),
            "function" === n.type(l.opts.caption) &&
              (l.opts.caption = l.opts.caption.apply(e, [o, l])),
            "function" === n.type(o.opts.caption) &&
              (l.opts.caption = o.opts.caption.apply(e, [o, l])),
            l.opts.caption instanceof n ||
              (l.opts.caption =
                void 0 === l.opts.caption ? "" : l.opts.caption + ""),
            "ajax" === l.type &&
              ((c = r.split(/\s+/, 2)),
              c.length > 1 &&
                ((l.src = c.shift()), (l.opts.filter = c.shift()))),
            l.opts.modal &&
              (l.opts = n.extend(!0, l.opts, {
                trapFocus: !0,
                infobar: 0,
                toolbar: 0,
                smallBtn: 0,
                keyboard: 0,
                slideShow: 0,
                fullScreen: 0,
                thumbs: 0,
                touch: 0,
                clickContent: !1,
                clickSlide: !1,
                clickOutside: !1,
                dblclickContent: !1,
                dblclickSlide: !1,
                dblclickOutside: !1,
              })),
            o.group.push(l);
        }),
          Object.keys(o.slides).length &&
            (o.updateControls(),
            (e = o.Thumbs) && e.isActive && (e.create(), e.focus()));
      },
      addEvents: function () {
        var e = this;
        e.removeEvents(),
          e.$refs.container
            .on("click.fb-close", "[data-fancybox-close]", function (t) {
              t.stopPropagation(), t.preventDefault(), e.close(t);
            })
            .on(
              "touchstart.fb-prev click.fb-prev",
              "[data-fancybox-prev]",
              function (t) {
                t.stopPropagation(), t.preventDefault(), e.previous();
              }
            )
            .on(
              "touchstart.fb-next click.fb-next",
              "[data-fancybox-next]",
              function (t) {
                t.stopPropagation(), t.preventDefault(), e.next();
              }
            )
            .on("click.fb", "[data-fancybox-zoom]", function (t) {
              e[e.isScaledDown() ? "scaleToActual" : "scaleToFit"]();
            }),
          s.on("orientationchange.fb resize.fb", function (t) {
            t && t.originalEvent && "resize" === t.originalEvent.type
              ? (e.requestId && u(e.requestId),
                (e.requestId = d(function () {
                  e.update(t);
                })))
              : (e.current &&
                  "iframe" === e.current.type &&
                  e.$refs.stage.hide(),
                setTimeout(
                  function () {
                    e.$refs.stage.show(), e.update(t);
                  },
                  n.fancybox.isMobile ? 600 : 250
                ));
          }),
          r.on("keydown.fb", function (t) {
            var o = n.fancybox ? n.fancybox.getInstance() : null,
              i = o.current,
              a = t.keyCode || t.which;
            if (9 == a) return void (i.opts.trapFocus && e.focus(t));
            if (
              !(
                !i.opts.keyboard ||
                t.ctrlKey ||
                t.altKey ||
                t.shiftKey ||
                n(t.target).is("input,textarea,video,audio")
              )
            )
              return 8 === a || 27 === a
                ? (t.preventDefault(), void e.close(t))
                : 37 === a || 38 === a
                ? (t.preventDefault(), void e.previous())
                : 39 === a || 40 === a
                ? (t.preventDefault(), void e.next())
                : void e.trigger("afterKeydown", t, a);
          }),
          e.group[e.currIndex].opts.idleTime &&
            ((e.idleSecondsCounter = 0),
            r.on(
              "mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle",
              function (t) {
                (e.idleSecondsCounter = 0),
                  e.isIdle && e.showControls(),
                  (e.isIdle = !1);
              }
            ),
            (e.idleInterval = t.setInterval(function () {
              ++e.idleSecondsCounter >= e.group[e.currIndex].opts.idleTime &&
                !e.isDragging &&
                ((e.isIdle = !0), (e.idleSecondsCounter = 0), e.hideControls());
            }, 1e3)));
      },
      removeEvents: function () {
        var e = this;
        s.off("orientationchange.fb resize.fb"),
          r.off("keydown.fb .fb-idle"),
          this.$refs.container.off(".fb-close .fb-prev .fb-next"),
          e.idleInterval &&
            (t.clearInterval(e.idleInterval), (e.idleInterval = null));
      },
      previous: function (t) {
        return this.jumpTo(this.currPos - 1, t);
      },
      next: function (t) {
        return this.jumpTo(this.currPos + 1, t);
      },
      jumpTo: function (t, e) {
        var o,
          i,
          a,
          s,
          r,
          c,
          l,
          d,
          u,
          f = this,
          h = f.group.length;
        if (!(f.isDragging || f.isClosing || (f.isAnimating && f.firstRun))) {
          if (
            ((t = parseInt(t, 10)),
            !(a = f.current ? f.current.opts.loop : f.opts.loop) &&
              (t < 0 || t >= h))
          )
            return !1;
          if (
            ((o = f.firstRun = !Object.keys(f.slides).length),
            (r = f.current),
            (f.prevIndex = f.currIndex),
            (f.prevPos = f.currPos),
            (s = f.createSlide(t)),
            h > 1 &&
              ((a || s.index < h - 1) && f.createSlide(t + 1),
              (a || s.index > 0) && f.createSlide(t - 1)),
            (f.current = s),
            (f.currIndex = s.index),
            (f.currPos = s.pos),
            f.trigger("beforeShow", o),
            f.updateControls(),
            (s.forcedDuration = void 0),
            n.isNumeric(e)
              ? (s.forcedDuration = e)
              : (e = s.opts[o ? "animationDuration" : "transitionDuration"]),
            (e = parseInt(e, 10)),
            (i = f.isMoved(s)),
            s.$slide.addClass("fancybox-slide--current"),
            o)
          )
            return (
              s.opts.animationEffect &&
                e &&
                f.$refs.container.css("transition-duration", e + "ms"),
              f.$refs.container.addClass("fancybox-is-open").trigger("focus"),
              f.loadSlide(s),
              void f.preload("image")
            );
          (c = n.fancybox.getTranslate(r.$slide)),
            (l = n.fancybox.getTranslate(f.$refs.stage)),
            n.each(f.slides, function (t, e) {
              n.fancybox.stop(e.$slide, !0);
            }),
            r.pos !== s.pos && (r.isComplete = !1),
            r.$slide.removeClass(
              "fancybox-slide--complete fancybox-slide--current"
            ),
            i
              ? ((u = c.left - (r.pos * c.width + r.pos * r.opts.gutter)),
                n.each(f.slides, function (t, o) {
                  o.$slide
                    .removeClass("fancybox-animated")
                    .removeClass(function (t, e) {
                      return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(
                        " "
                      );
                    });
                  var i = o.pos * c.width + o.pos * o.opts.gutter;
                  n.fancybox.setTranslate(o.$slide, {
                    top: 0,
                    left: i - l.left + u,
                  }),
                    o.pos !== s.pos &&
                      o.$slide.addClass(
                        "fancybox-slide--" +
                          (o.pos > s.pos ? "next" : "previous")
                      ),
                    p(o.$slide),
                    n.fancybox.animate(
                      o.$slide,
                      {
                        top: 0,
                        left:
                          (o.pos - s.pos) * c.width +
                          (o.pos - s.pos) * o.opts.gutter,
                      },
                      e,
                      function () {
                        o.$slide
                          .css({ transform: "", opacity: "" })
                          .removeClass(
                            "fancybox-slide--next fancybox-slide--previous"
                          ),
                          o.pos === f.currPos && f.complete();
                      }
                    );
                }))
              : e &&
                s.opts.transitionEffect &&
                ((d =
                  "fancybox-animated fancybox-fx-" + s.opts.transitionEffect),
                r.$slide.addClass(
                  "fancybox-slide--" + (r.pos > s.pos ? "next" : "previous")
                ),
                n.fancybox.animate(
                  r.$slide,
                  d,
                  e,
                  function () {
                    r.$slide
                      .removeClass(d)
                      .removeClass(
                        "fancybox-slide--next fancybox-slide--previous"
                      );
                  },
                  !1
                )),
            s.isLoaded ? f.revealContent(s) : f.loadSlide(s),
            f.preload("image");
        }
      },
      createSlide: function (t) {
        var e,
          o,
          i = this;
        return (
          (o = t % i.group.length),
          (o = o < 0 ? i.group.length + o : o),
          !i.slides[t] &&
            i.group[o] &&
            ((e = n('<div class="fancybox-slide"></div>').appendTo(
              i.$refs.stage
            )),
            (i.slides[t] = n.extend(!0, {}, i.group[o], {
              pos: t,
              $slide: e,
              isLoaded: !1,
            })),
            i.updateSlide(i.slides[t])),
          i.slides[t]
        );
      },
      scaleToActual: function (t, e, o) {
        var i,
          a,
          s,
          r,
          c,
          l = this,
          d = l.current,
          u = d.$content,
          f = n.fancybox.getTranslate(d.$slide).width,
          p = n.fancybox.getTranslate(d.$slide).height,
          h = d.width,
          g = d.height;
        l.isAnimating ||
          l.isMoved() ||
          !u ||
          "image" != d.type ||
          !d.isLoaded ||
          d.hasError ||
          ((l.isAnimating = !0),
          n.fancybox.stop(u),
          (t = void 0 === t ? 0.5 * f : t),
          (e = void 0 === e ? 0.5 * p : e),
          (i = n.fancybox.getTranslate(u)),
          (i.top -= n.fancybox.getTranslate(d.$slide).top),
          (i.left -= n.fancybox.getTranslate(d.$slide).left),
          (r = h / i.width),
          (c = g / i.height),
          (a = 0.5 * f - 0.5 * h),
          (s = 0.5 * p - 0.5 * g),
          h > f &&
            ((a = i.left * r - (t * r - t)),
            a > 0 && (a = 0),
            a < f - h && (a = f - h)),
          g > p &&
            ((s = i.top * c - (e * c - e)),
            s > 0 && (s = 0),
            s < p - g && (s = p - g)),
          l.updateCursor(h, g),
          n.fancybox.animate(
            u,
            { top: s, left: a, scaleX: r, scaleY: c },
            o || 366,
            function () {
              l.isAnimating = !1;
            }
          ),
          l.SlideShow && l.SlideShow.isActive && l.SlideShow.stop());
      },
      scaleToFit: function (t) {
        var e,
          o = this,
          i = o.current,
          a = i.$content;
        o.isAnimating ||
          o.isMoved() ||
          !a ||
          "image" != i.type ||
          !i.isLoaded ||
          i.hasError ||
          ((o.isAnimating = !0),
          n.fancybox.stop(a),
          (e = o.getFitPos(i)),
          o.updateCursor(e.width, e.height),
          n.fancybox.animate(
            a,
            {
              top: e.top,
              left: e.left,
              scaleX: e.width / a.width(),
              scaleY: e.height / a.height(),
            },
            t || 366,
            function () {
              o.isAnimating = !1;
            }
          ));
      },
      getFitPos: function (t) {
        var e,
          o,
          i,
          a,
          s = this,
          r = t.$content,
          c = t.$slide,
          l = t.width || t.opts.width,
          d = t.height || t.opts.height,
          u = {};
        return (
          !!(t.isLoaded && r && r.length) &&
          ((e = n.fancybox.getTranslate(s.$refs.stage).width),
          (o = n.fancybox.getTranslate(s.$refs.stage).height),
          (e -=
            parseFloat(c.css("paddingLeft")) +
            parseFloat(c.css("paddingRight")) +
            parseFloat(r.css("marginLeft")) +
            parseFloat(r.css("marginRight"))),
          (o -=
            parseFloat(c.css("paddingTop")) +
            parseFloat(c.css("paddingBottom")) +
            parseFloat(r.css("marginTop")) +
            parseFloat(r.css("marginBottom"))),
          (l && d) || ((l = e), (d = o)),
          (i = Math.min(1, e / l, o / d)),
          (l *= i),
          (d *= i),
          l > e - 0.5 && (l = e),
          d > o - 0.5 && (d = o),
          "image" === t.type
            ? ((u.top =
                Math.floor(0.5 * (o - d)) + parseFloat(c.css("paddingTop"))),
              (u.left =
                Math.floor(0.5 * (e - l)) + parseFloat(c.css("paddingLeft"))))
            : "video" === t.contentType &&
              ((a =
                t.opts.width && t.opts.height ? l / d : t.opts.ratio || 16 / 9),
              d > l / a ? (d = l / a) : l > d * a && (l = d * a)),
          (u.width = l),
          (u.height = d),
          u)
        );
      },
      update: function (t) {
        var e = this;
        n.each(e.slides, function (n, o) {
          e.updateSlide(o, t);
        });
      },
      updateSlide: function (t, e) {
        var o = this,
          i = t && t.$content,
          a = t.width || t.opts.width,
          s = t.height || t.opts.height,
          r = t.$slide;
        o.adjustCaption(t),
          i &&
            (a || s || "video" === t.contentType) &&
            !t.hasError &&
            (n.fancybox.stop(i),
            n.fancybox.setTranslate(i, o.getFitPos(t)),
            t.pos === o.currPos && ((o.isAnimating = !1), o.updateCursor())),
          o.adjustLayout(t),
          r.length &&
            (r.trigger("refresh"),
            t.pos === o.currPos &&
              o.$refs.toolbar
                .add(o.$refs.navigation.find(".fancybox-button--arrow_right"))
                .toggleClass(
                  "compensate-for-scrollbar",
                  r.get(0).scrollHeight > r.get(0).clientHeight
                )),
          o.trigger("onUpdate", t, e);
      },
      centerSlide: function (t) {
        var e = this,
          o = e.current,
          i = o.$slide;
        !e.isClosing &&
          o &&
          (i.siblings().css({ transform: "", opacity: "" }),
          i
            .parent()
            .children()
            .removeClass("fancybox-slide--previous fancybox-slide--next"),
          n.fancybox.animate(
            i,
            { top: 0, left: 0, opacity: 1 },
            void 0 === t ? 0 : t,
            function () {
              i.css({ transform: "", opacity: "" }),
                o.isComplete || e.complete();
            },
            !1
          ));
      },
      isMoved: function (t) {
        var e,
          o,
          i = t || this.current;
        return (
          !!i &&
          ((o = n.fancybox.getTranslate(this.$refs.stage)),
          (e = n.fancybox.getTranslate(i.$slide)),
          !i.$slide.hasClass("fancybox-animated") &&
            (Math.abs(e.top - o.top) > 0.5 || Math.abs(e.left - o.left) > 0.5))
        );
      },
      updateCursor: function (t, e) {
        var o,
          i,
          a = this,
          s = a.current,
          r = a.$refs.container;
        s &&
          !a.isClosing &&
          a.Guestures &&
          (r.removeClass(
            "fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-zoomOut fancybox-can-swipe fancybox-can-pan"
          ),
          (o = a.canPan(t, e)),
          (i = !!o || a.isZoomable()),
          r.toggleClass("fancybox-is-zoomable", i),
          n("[data-fancybox-zoom]").prop("disabled", !i),
          o
            ? r.addClass("fancybox-can-pan")
            : i &&
              ("zoom" === s.opts.clickContent ||
                (n.isFunction(s.opts.clickContent) &&
                  "zoom" == s.opts.clickContent(s)))
            ? r.addClass("fancybox-can-zoomIn")
            : s.opts.touch &&
              (s.opts.touch.vertical || a.group.length > 1) &&
              "video" !== s.contentType &&
              r.addClass("fancybox-can-swipe"));
      },
      isZoomable: function () {
        var t,
          e = this,
          n = e.current;
        if (n && !e.isClosing && "image" === n.type && !n.hasError) {
          if (!n.isLoaded) return !0;
          if (
            (t = e.getFitPos(n)) &&
            (n.width > t.width || n.height > t.height)
          )
            return !0;
        }
        return !1;
      },
      isScaledDown: function (t, e) {
        var o = this,
          i = !1,
          a = o.current,
          s = a.$content;
        return (
          void 0 !== t && void 0 !== e
            ? (i = t < a.width && e < a.height)
            : s &&
              ((i = n.fancybox.getTranslate(s)),
              (i = i.width < a.width && i.height < a.height)),
          i
        );
      },
      canPan: function (t, e) {
        var o = this,
          i = o.current,
          a = null,
          s = !1;
        return (
          "image" === i.type &&
            (i.isComplete || (t && e)) &&
            !i.hasError &&
            ((s = o.getFitPos(i)),
            void 0 !== t && void 0 !== e
              ? (a = { width: t, height: e })
              : i.isComplete && (a = n.fancybox.getTranslate(i.$content)),
            a &&
              s &&
              (s =
                Math.abs(a.width - s.width) > 1.5 ||
                Math.abs(a.height - s.height) > 1.5)),
          s
        );
      },
      loadSlide: function (t) {
        var e,
          o,
          i,
          a = this;
        if (!t.isLoading && !t.isLoaded) {
          if (((t.isLoading = !0), !1 === a.trigger("beforeLoad", t)))
            return (t.isLoading = !1), !1;
          switch (
            ((e = t.type),
            (o = t.$slide),
            o.off("refresh").trigger("onReset").addClass(t.opts.slideClass),
            e)
          ) {
            case "image":
              a.setImage(t);
              break;
            case "iframe":
              a.setIframe(t);
              break;
            case "html":
              a.setContent(t, t.src || t.content);
              break;
            case "video":
              a.setContent(
                t,
                t.opts.video.tpl
                  .replace(/\{\{src\}\}/gi, t.src)
                  .replace(
                    "{{format}}",
                    t.opts.videoFormat || t.opts.video.format || ""
                  )
                  .replace("{{poster}}", t.thumb || "")
              );
              break;
            case "inline":
              n(t.src).length ? a.setContent(t, n(t.src)) : a.setError(t);
              break;
            case "ajax":
              a.showLoading(t),
                (i = n.ajax(
                  n.extend({}, t.opts.ajax.settings, {
                    url: t.src,
                    success: function (e, n) {
                      "success" === n && a.setContent(t, e);
                    },
                    error: function (e, n) {
                      e && "abort" !== n && a.setError(t);
                    },
                  })
                )),
                o.one("onReset", function () {
                  i.abort();
                });
              break;
            default:
              a.setError(t);
          }
          return !0;
        }
      },
      setImage: function (t) {
        var o,
          i = this;
        setTimeout(function () {
          var e = t.$image;
          i.isClosing ||
            !t.isLoading ||
            (e && e.length && e[0].complete) ||
            t.hasError ||
            i.showLoading(t);
        }, 50),
          i.checkSrcset(t),
          (t.$content = n('<div class="fancybox-content"></div>')
            .addClass("fancybox-is-hidden")
            .appendTo(t.$slide.addClass("fancybox-slide--image"))),
          !1 !== t.opts.preload &&
            t.opts.width &&
            t.opts.height &&
            t.thumb &&
            ((t.width = t.opts.width),
            (t.height = t.opts.height),
            (o = e.createElement("img")),
            (o.onerror = function () {
              n(this).remove(), (t.$ghost = null);
            }),
            (o.onload = function () {
              i.afterLoad(t);
            }),
            (t.$ghost = n(o)
              .addClass("fancybox-image")
              .appendTo(t.$content)
              .attr("src", t.thumb))),
          i.setBigImage(t);
      },
      checkSrcset: function (e) {
        var n,
          o,
          i,
          a,
          s = e.opts.srcset || e.opts.image.srcset;
        if (s) {
          (i = t.devicePixelRatio || 1),
            (a = t.innerWidth * i),
            (o = s.split(",").map(function (t) {
              var e = {};
              return (
                t
                  .trim()
                  .split(/\s+/)
                  .forEach(function (t, n) {
                    var o = parseInt(t.substring(0, t.length - 1), 10);
                    if (0 === n) return (e.url = t);
                    o && ((e.value = o), (e.postfix = t[t.length - 1]));
                  }),
                e
              );
            })),
            o.sort(function (t, e) {
              return t.value - e.value;
            });
          for (var r = 0; r < o.length; r++) {
            var c = o[r];
            if (
              ("w" === c.postfix && c.value >= a) ||
              ("x" === c.postfix && c.value >= i)
            ) {
              n = c;
              break;
            }
          }
          !n && o.length && (n = o[o.length - 1]),
            n &&
              ((e.src = n.url),
              e.width &&
                e.height &&
                "w" == n.postfix &&
                ((e.height = (e.width / e.height) * n.value),
                (e.width = n.value)),
              (e.opts.srcset = s));
        }
      },
      setBigImage: function (t) {
        var o = this,
          i = e.createElement("img"),
          a = n(i);
        (t.$image = a
          .one("error", function () {
            o.setError(t);
          })
          .one("load", function () {
            var e;
            t.$ghost ||
              (o.resolveImageSlideSize(
                t,
                this.naturalWidth,
                this.naturalHeight
              ),
              o.afterLoad(t)),
              o.isClosing ||
                (t.opts.srcset &&
                  ((e = t.opts.sizes),
                  (e && "auto" !== e) ||
                    (e =
                      (t.width / t.height > 1 && s.width() / s.height() > 1
                        ? "100"
                        : Math.round((t.width / t.height) * 100)) + "vw"),
                  a.attr("sizes", e).attr("srcset", t.opts.srcset)),
                t.$ghost &&
                  setTimeout(function () {
                    t.$ghost && !o.isClosing && t.$ghost.hide();
                  }, Math.min(300, Math.max(1e3, t.height / 1600))),
                o.hideLoading(t));
          })
          .addClass("fancybox-image")
          .attr("src", t.src)
          .appendTo(t.$content)),
          (i.complete || "complete" == i.readyState) &&
          a.naturalWidth &&
          a.naturalHeight
            ? a.trigger("load")
            : i.error && a.trigger("error");
      },
      resolveImageSlideSize: function (t, e, n) {
        var o = parseInt(t.opts.width, 10),
          i = parseInt(t.opts.height, 10);
        (t.width = e),
          (t.height = n),
          o > 0 && ((t.width = o), (t.height = Math.floor((o * n) / e))),
          i > 0 && ((t.width = Math.floor((i * e) / n)), (t.height = i));
      },
      setIframe: function (t) {
        var e,
          o = this,
          i = t.opts.iframe,
          a = t.$slide;
        (t.$content = n(
          '<div class="fancybox-content' +
            (i.preload ? " fancybox-is-hidden" : "") +
            '"></div>'
        )
          .css(i.css)
          .appendTo(a)),
          a.addClass("fancybox-slide--" + t.contentType),
          (t.$iframe = e =
            n(i.tpl.replace(/\{rnd\}/g, new Date().getTime()))
              .attr(i.attr)
              .appendTo(t.$content)),
          i.preload
            ? (o.showLoading(t),
              e.on("load.fb error.fb", function (e) {
                (this.isReady = 1), t.$slide.trigger("refresh"), o.afterLoad(t);
              }),
              a.on("refresh.fb", function () {
                var n,
                  o,
                  s = t.$content,
                  r = i.css.width,
                  c = i.css.height;
                if (1 === e[0].isReady) {
                  try {
                    (n = e.contents()), (o = n.find("body"));
                  } catch (t) {}
                  o &&
                    o.length &&
                    o.children().length &&
                    (a.css("overflow", "visible"),
                    s.css({
                      width: "100%",
                      "max-width": "100%",
                      height: "9999px",
                    }),
                    void 0 === r &&
                      (r = Math.ceil(
                        Math.max(o[0].clientWidth, o.outerWidth(!0))
                      )),
                    s.css("width", r || "").css("max-width", ""),
                    void 0 === c &&
                      (c = Math.ceil(
                        Math.max(o[0].clientHeight, o.outerHeight(!0))
                      )),
                    s.css("height", c || ""),
                    a.css("overflow", "auto")),
                    s.removeClass("fancybox-is-hidden");
                }
              }))
            : o.afterLoad(t),
          e.attr("src", t.src),
          a.one("onReset", function () {
            try {
              n(this)
                .find("iframe")
                .hide()
                .unbind()
                .attr("src", "//about:blank");
            } catch (t) {}
            n(this).off("refresh.fb").empty(),
              (t.isLoaded = !1),
              (t.isRevealed = !1);
          });
      },
      setContent: function (t, e) {
        var o = this;
        o.isClosing ||
          (o.hideLoading(t),
          t.$content && n.fancybox.stop(t.$content),
          t.$slide.empty(),
          l(e) && e.parent().length
            ? ((e.hasClass("fancybox-content") ||
                e.parent().hasClass("fancybox-content")) &&
                e.parents(".fancybox-slide").trigger("onReset"),
              (t.$placeholder = n("<div>").hide().insertAfter(e)),
              e.css("display", "inline-block"))
            : t.hasError ||
              ("string" === n.type(e) &&
                (e = n("<div>").append(n.trim(e)).contents()),
              t.opts.filter && (e = n("<div>").html(e).find(t.opts.filter))),
          t.$slide.one("onReset", function () {
            n(this).find("video,audio").trigger("pause"),
              t.$placeholder &&
                (t.$placeholder
                  .after(e.removeClass("fancybox-content").hide())
                  .remove(),
                (t.$placeholder = null)),
              t.$smallBtn && (t.$smallBtn.remove(), (t.$smallBtn = null)),
              t.hasError ||
                (n(this).empty(), (t.isLoaded = !1), (t.isRevealed = !1));
          }),
          n(e).appendTo(t.$slide),
          n(e).is("video,audio") &&
            (n(e).addClass("fancybox-video"),
            n(e).wrap("<div></div>"),
            (t.contentType = "video"),
            (t.opts.width = t.opts.width || n(e).attr("width")),
            (t.opts.height = t.opts.height || n(e).attr("height"))),
          (t.$content = t.$slide
            .children()
            .filter("div,form,main,video,audio,article,.fancybox-content")
            .first()),
          t.$content.siblings().hide(),
          t.$content.length ||
            (t.$content = t.$slide.wrapInner("<div></div>").children().first()),
          t.$content.addClass("fancybox-content"),
          t.$slide.addClass("fancybox-slide--" + t.contentType),
          o.afterLoad(t));
      },
      setError: function (t) {
        (t.hasError = !0),
          t.$slide
            .trigger("onReset")
            .removeClass("fancybox-slide--" + t.contentType)
            .addClass("fancybox-slide--error"),
          (t.contentType = "html"),
          this.setContent(t, this.translate(t, t.opts.errorTpl)),
          t.pos === this.currPos && (this.isAnimating = !1);
      },
      showLoading: function (t) {
        var e = this;
        (t = t || e.current) &&
          !t.$spinner &&
          (t.$spinner = n(e.translate(e, e.opts.spinnerTpl))
            .appendTo(t.$slide)
            .hide()
            .fadeIn("fast"));
      },
      hideLoading: function (t) {
        var e = this;
        (t = t || e.current) &&
          t.$spinner &&
          (t.$spinner.stop().remove(), delete t.$spinner);
      },
      afterLoad: function (t) {
        var e = this;
        e.isClosing ||
          ((t.isLoading = !1),
          (t.isLoaded = !0),
          e.trigger("afterLoad", t),
          e.hideLoading(t),
          !t.opts.smallBtn ||
            (t.$smallBtn && t.$smallBtn.length) ||
            (t.$smallBtn = n(e.translate(t, t.opts.btnTpl.smallBtn)).appendTo(
              t.$content
            )),
          t.opts.protect &&
            t.$content &&
            !t.hasError &&
            (t.$content.on("contextmenu.fb", function (t) {
              return 2 == t.button && t.preventDefault(), !0;
            }),
            "image" === t.type &&
              n('<div class="fancybox-spaceball"></div>').appendTo(t.$content)),
          e.adjustCaption(t),
          e.adjustLayout(t),
          t.pos === e.currPos && e.updateCursor(),
          e.revealContent(t));
      },
      adjustCaption: function (t) {
        var e,
          n = this,
          o = t || n.current,
          i = o.opts.caption,
          a = o.opts.preventCaptionOverlap,
          s = n.$refs.caption,
          r = !1;
        s.toggleClass("fancybox-caption--separate", a),
          a &&
            i &&
            i.length &&
            (o.pos !== n.currPos
              ? ((e = s.clone().appendTo(s.parent())),
                e.children().eq(0).empty().html(i),
                (r = e.outerHeight(!0)),
                e.empty().remove())
              : n.$caption && (r = n.$caption.outerHeight(!0)),
            o.$slide.css("padding-bottom", r || ""));
      },
      adjustLayout: function (t) {
        var e,
          n,
          o,
          i,
          a = this,
          s = t || a.current;
        s.isLoaded &&
          !0 !== s.opts.disableLayoutFix &&
          (s.$content.css("margin-bottom", ""),
          s.$content.outerHeight() > s.$slide.height() + 0.5 &&
            ((o = s.$slide[0].style["padding-bottom"]),
            (i = s.$slide.css("padding-bottom")),
            parseFloat(i) > 0 &&
              ((e = s.$slide[0].scrollHeight),
              s.$slide.css("padding-bottom", 0),
              Math.abs(e - s.$slide[0].scrollHeight) < 1 && (n = i),
              s.$slide.css("padding-bottom", o))),
          s.$content.css("margin-bottom", n));
      },
      revealContent: function (t) {
        var e,
          o,
          i,
          a,
          s = this,
          r = t.$slide,
          c = !1,
          l = !1,
          d = s.isMoved(t),
          u = t.isRevealed;
        return (
          (t.isRevealed = !0),
          (e = t.opts[s.firstRun ? "animationEffect" : "transitionEffect"]),
          (i = t.opts[s.firstRun ? "animationDuration" : "transitionDuration"]),
          (i = parseInt(
            void 0 === t.forcedDuration ? i : t.forcedDuration,
            10
          )),
          (!d && t.pos === s.currPos && i) || (e = !1),
          "zoom" === e &&
            (t.pos === s.currPos &&
            i &&
            "image" === t.type &&
            !t.hasError &&
            (l = s.getThumbPos(t))
              ? (c = s.getFitPos(t))
              : (e = "fade")),
          "zoom" === e
            ? ((s.isAnimating = !0),
              (c.scaleX = c.width / l.width),
              (c.scaleY = c.height / l.height),
              (a = t.opts.zoomOpacity),
              "auto" == a &&
                (a = Math.abs(t.width / t.height - l.width / l.height) > 0.1),
              a && ((l.opacity = 0.1), (c.opacity = 1)),
              n.fancybox.setTranslate(
                t.$content.removeClass("fancybox-is-hidden"),
                l
              ),
              p(t.$content),
              void n.fancybox.animate(t.$content, c, i, function () {
                (s.isAnimating = !1), s.complete();
              }))
            : (s.updateSlide(t),
              e
                ? (n.fancybox.stop(r),
                  (o =
                    "fancybox-slide--" +
                    (t.pos >= s.prevPos ? "next" : "previous") +
                    " fancybox-animated fancybox-fx-" +
                    e),
                  r.addClass(o).removeClass("fancybox-slide--current"),
                  t.$content.removeClass("fancybox-is-hidden"),
                  p(r),
                  "image" !== t.type && t.$content.hide().show(0),
                  void n.fancybox.animate(
                    r,
                    "fancybox-slide--current",
                    i,
                    function () {
                      r.removeClass(o).css({ transform: "", opacity: "" }),
                        t.pos === s.currPos && s.complete();
                    },
                    !0
                  ))
                : (t.$content.removeClass("fancybox-is-hidden"),
                  u ||
                    !d ||
                    "image" !== t.type ||
                    t.hasError ||
                    t.$content.hide().fadeIn("fast"),
                  void (t.pos === s.currPos && s.complete())))
        );
      },
      getThumbPos: function (t) {
        var e,
          o,
          i,
          a,
          s,
          r = !1,
          c = t.$thumb;
        return (
          !(!c || !g(c[0])) &&
          ((e = n.fancybox.getTranslate(c)),
          (o = parseFloat(c.css("border-top-width") || 0)),
          (i = parseFloat(c.css("border-right-width") || 0)),
          (a = parseFloat(c.css("border-bottom-width") || 0)),
          (s = parseFloat(c.css("border-left-width") || 0)),
          (r = {
            top: e.top + o,
            left: e.left + s,
            width: e.width - i - s,
            height: e.height - o - a,
            scaleX: 1,
            scaleY: 1,
          }),
          e.width > 0 && e.height > 0 && r)
        );
      },
      complete: function () {
        var t,
          e = this,
          o = e.current,
          i = {};
        !e.isMoved() &&
          o.isLoaded &&
          (o.isComplete ||
            ((o.isComplete = !0),
            o.$slide.siblings().trigger("onReset"),
            e.preload("inline"),
            p(o.$slide),
            o.$slide.addClass("fancybox-slide--complete"),
            n.each(e.slides, function (t, o) {
              o.pos >= e.currPos - 1 && o.pos <= e.currPos + 1
                ? (i[o.pos] = o)
                : o && (n.fancybox.stop(o.$slide), o.$slide.off().remove());
            }),
            (e.slides = i)),
          (e.isAnimating = !1),
          e.updateCursor(),
          e.trigger("afterShow"),
          o.opts.video.autoStart &&
            o.$slide
              .find("video,audio")
              .filter(":visible:first")
              .trigger("play")
              .one("ended", function () {
                this.webkitExitFullscreen && this.webkitExitFullscreen(),
                  e.next();
              }),
          o.opts.autoFocus &&
            "html" === o.contentType &&
            ((t = o.$content.find("input[autofocus]:enabled:visible:first")),
            t.length ? t.trigger("focus") : e.focus(null, !0)),
          o.$slide.scrollTop(0).scrollLeft(0));
      },
      preload: function (t) {
        var e,
          n,
          o = this;
        o.group.length < 2 ||
          ((n = o.slides[o.currPos + 1]),
          (e = o.slides[o.currPos - 1]),
          e && e.type === t && o.loadSlide(e),
          n && n.type === t && o.loadSlide(n));
      },
      focus: function (t, o) {
        var i,
          a,
          s = this,
          r = [
            "a[href]",
            "area[href]",
            'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
            "select:not([disabled]):not([aria-hidden])",
            "textarea:not([disabled]):not([aria-hidden])",
            "button:not([disabled]):not([aria-hidden])",
            "iframe",
            "object",
            "embed",
            "video",
            "audio",
            "[contenteditable]",
            '[tabindex]:not([tabindex^="-"])',
          ].join(",");
        s.isClosing ||
          ((i =
            !t && s.current && s.current.isComplete
              ? s.current.$slide.find(
                  "*:visible" + (o ? ":not(.fancybox-close-small)" : "")
                )
              : s.$refs.container.find("*:visible")),
          (i = i.filter(r).filter(function () {
            return (
              "hidden" !== n(this).css("visibility") &&
              !n(this).hasClass("disabled")
            );
          })),
          i.length
            ? ((a = i.index(e.activeElement)),
              t && t.shiftKey
                ? (a < 0 || 0 == a) &&
                  (t.preventDefault(), i.eq(i.length - 1).trigger("focus"))
                : (a < 0 || a == i.length - 1) &&
                  (t && t.preventDefault(), i.eq(0).trigger("focus")))
            : s.$refs.container.trigger("focus"));
      },
      activate: function () {
        var t = this;
        n(".fancybox-container").each(function () {
          var e = n(this).data("FancyBox");
          e &&
            e.id !== t.id &&
            !e.isClosing &&
            (e.trigger("onDeactivate"), e.removeEvents(), (e.isVisible = !1));
        }),
          (t.isVisible = !0),
          (t.current || t.isIdle) && (t.update(), t.updateControls()),
          t.trigger("onActivate"),
          t.addEvents();
      },
      close: function (t, e) {
        var o,
          i,
          a,
          s,
          r,
          c,
          l,
          u = this,
          f = u.current,
          h = function () {
            u.cleanUp(t);
          };
        return (
          !u.isClosing &&
          ((u.isClosing = !0),
          !1 === u.trigger("beforeClose", t)
            ? ((u.isClosing = !1),
              d(function () {
                u.update();
              }),
              !1)
            : (u.removeEvents(),
              (a = f.$content),
              (o = f.opts.animationEffect),
              (i = n.isNumeric(e) ? e : o ? f.opts.animationDuration : 0),
              f.$slide.removeClass(
                "fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated"
              ),
              !0 !== t ? n.fancybox.stop(f.$slide) : (o = !1),
              f.$slide.siblings().trigger("onReset").remove(),
              i &&
                u.$refs.container
                  .removeClass("fancybox-is-open")
                  .addClass("fancybox-is-closing")
                  .css("transition-duration", i + "ms"),
              u.hideLoading(f),
              u.hideControls(!0),
              u.updateCursor(),
              "zoom" !== o ||
                (a &&
                  i &&
                  "image" === f.type &&
                  !u.isMoved() &&
                  !f.hasError &&
                  (l = u.getThumbPos(f))) ||
                (o = "fade"),
              "zoom" === o
                ? (n.fancybox.stop(a),
                  (s = n.fancybox.getTranslate(a)),
                  (c = {
                    top: s.top,
                    left: s.left,
                    scaleX: s.width / l.width,
                    scaleY: s.height / l.height,
                    width: l.width,
                    height: l.height,
                  }),
                  (r = f.opts.zoomOpacity),
                  "auto" == r &&
                    (r =
                      Math.abs(f.width / f.height - l.width / l.height) > 0.1),
                  r && (l.opacity = 0),
                  n.fancybox.setTranslate(a, c),
                  p(a),
                  n.fancybox.animate(a, l, i, h),
                  !0)
                : (o && i
                    ? n.fancybox.animate(
                        f.$slide
                          .addClass("fancybox-slide--previous")
                          .removeClass("fancybox-slide--current"),
                        "fancybox-animated fancybox-fx-" + o,
                        i,
                        h
                      )
                    : !0 === t
                    ? setTimeout(h, i)
                    : h(),
                  !0)))
        );
      },
      cleanUp: function (e) {
        var o,
          i,
          a,
          s = this,
          r = s.current.opts.$orig;
        s.current.$slide.trigger("onReset"),
          s.$refs.container.empty().remove(),
          s.trigger("afterClose", e),
          s.current.opts.backFocus &&
            ((r && r.length && r.is(":visible")) || (r = s.$trigger),
            r &&
              r.length &&
              ((i = t.scrollX),
              (a = t.scrollY),
              r.trigger("focus"),
              n("html, body").scrollTop(a).scrollLeft(i))),
          (s.current = null),
          (o = n.fancybox.getInstance()),
          o
            ? o.activate()
            : (n("body").removeClass(
                "fancybox-active compensate-for-scrollbar"
              ),
              n("#fancybox-style-noscroll").remove());
      },
      trigger: function (t, e) {
        var o,
          i = Array.prototype.slice.call(arguments, 1),
          a = this,
          s = e && e.opts ? e : a.current;
        if (
          (s ? i.unshift(s) : (s = a),
          i.unshift(a),
          n.isFunction(s.opts[t]) && (o = s.opts[t].apply(s, i)),
          !1 === o)
        )
          return o;
        "afterClose" !== t && a.$refs
          ? a.$refs.container.trigger(t + ".fb", i)
          : r.trigger(t + ".fb", i);
      },
      updateControls: function () {
        var t = this,
          o = t.current,
          i = o.index,
          a = t.$refs.container,
          s = t.$refs.caption,
          r = o.opts.caption;
        o.$slide.trigger("refresh"),
          r && r.length
            ? ((t.$caption = s), s.children().eq(0).html(r))
            : (t.$caption = null),
          t.hasHiddenControls || t.isIdle || t.showControls(),
          a.find("[data-fancybox-count]").html(t.group.length),
          a.find("[data-fancybox-index]").html(i + 1),
          a
            .find("[data-fancybox-prev]")
            .prop("disabled", !o.opts.loop && i <= 0),
          a
            .find("[data-fancybox-next]")
            .prop("disabled", !o.opts.loop && i >= t.group.length - 1),
          "image" === o.type
            ? a
                .find("[data-fancybox-zoom]")
                .show()
                .end()
                .find("[data-fancybox-download]")
                .attr("href", o.opts.image.src || o.src)
                .show()
            : o.opts.toolbar &&
              a.find("[data-fancybox-download],[data-fancybox-zoom]").hide(),
          n(e.activeElement).is(":hidden,[disabled]") &&
            t.$refs.container.trigger("focus");
      },
      hideControls: function (t) {
        var e = this,
          n = ["infobar", "toolbar", "nav"];
        (!t && e.current.opts.preventCaptionOverlap) || n.push("caption"),
          this.$refs.container.removeClass(
            n
              .map(function (t) {
                return "fancybox-show-" + t;
              })
              .join(" ")
          ),
          (this.hasHiddenControls = !0);
      },
      showControls: function () {
        var t = this,
          e = t.current ? t.current.opts : t.opts,
          n = t.$refs.container;
        (t.hasHiddenControls = !1),
          (t.idleSecondsCounter = 0),
          n
            .toggleClass("fancybox-show-toolbar", !(!e.toolbar || !e.buttons))
            .toggleClass(
              "fancybox-show-infobar",
              !!(e.infobar && t.group.length > 1)
            )
            .toggleClass("fancybox-show-caption", !!t.$caption)
            .toggleClass(
              "fancybox-show-nav",
              !!(e.arrows && t.group.length > 1)
            )
            .toggleClass("fancybox-is-modal", !!e.modal);
      },
      toggleControls: function () {
        this.hasHiddenControls ? this.showControls() : this.hideControls();
      },
    }),
      (n.fancybox = {
        version: "3.5.6",
        defaults: a,
        getInstance: function (t) {
          var e = n(
              '.fancybox-container:not(".fancybox-is-closing"):last'
            ).data("FancyBox"),
            o = Array.prototype.slice.call(arguments, 1);
          return (
            e instanceof b &&
            ("string" === n.type(t)
              ? e[t].apply(e, o)
              : "function" === n.type(t) && t.apply(e, o),
            e)
          );
        },
        open: function (t, e, n) {
          return new b(t, e, n);
        },
        close: function (t) {
          var e = this.getInstance();
          e && (e.close(), !0 === t && this.close(t));
        },
        destroy: function () {
          this.close(!0), r.add("body").off("click.fb-start", "**");
        },
        isMobile:
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          ),
        use3d: (function () {
          var n = e.createElement("div");
          return (
            t.getComputedStyle &&
            t.getComputedStyle(n) &&
            t.getComputedStyle(n).getPropertyValue("transform") &&
            !(e.documentMode && e.documentMode < 11)
          );
        })(),
        getTranslate: function (t) {
          var e;
          return (
            !(!t || !t.length) &&
            ((e = t[0].getBoundingClientRect()),
            {
              top: e.top || 0,
              left: e.left || 0,
              width: e.width,
              height: e.height,
              opacity: parseFloat(t.css("opacity")),
            })
          );
        },
        setTranslate: function (t, e) {
          var n = "",
            o = {};
          if (t && e)
            return (
              (void 0 === e.left && void 0 === e.top) ||
                ((n =
                  (void 0 === e.left ? t.position().left : e.left) +
                  "px, " +
                  (void 0 === e.top ? t.position().top : e.top) +
                  "px"),
                (n = this.use3d
                  ? "translate3d(" + n + ", 0px)"
                  : "translate(" + n + ")")),
              void 0 !== e.scaleX && void 0 !== e.scaleY
                ? (n += " scale(" + e.scaleX + ", " + e.scaleY + ")")
                : void 0 !== e.scaleX && (n += " scaleX(" + e.scaleX + ")"),
              n.length && (o.transform = n),
              void 0 !== e.opacity && (o.opacity = e.opacity),
              void 0 !== e.width && (o.width = e.width),
              void 0 !== e.height && (o.height = e.height),
              t.css(o)
            );
        },
        animate: function (t, e, o, i, a) {
          var s,
            r = this;
          n.isFunction(o) && ((i = o), (o = null)),
            r.stop(t),
            (s = r.getTranslate(t)),
            t.on(f, function (c) {
              (!c ||
                !c.originalEvent ||
                (t.is(c.originalEvent.target) &&
                  "z-index" != c.originalEvent.propertyName)) &&
                (r.stop(t),
                n.isNumeric(o) && t.css("transition-duration", ""),
                n.isPlainObject(e)
                  ? void 0 !== e.scaleX &&
                    void 0 !== e.scaleY &&
                    r.setTranslate(t, {
                      top: e.top,
                      left: e.left,
                      width: s.width * e.scaleX,
                      height: s.height * e.scaleY,
                      scaleX: 1,
                      scaleY: 1,
                    })
                  : !0 !== a && t.removeClass(e),
                n.isFunction(i) && i(c));
            }),
            n.isNumeric(o) && t.css("transition-duration", o + "ms"),
            n.isPlainObject(e)
              ? (void 0 !== e.scaleX &&
                  void 0 !== e.scaleY &&
                  (delete e.width,
                  delete e.height,
                  t.parent().hasClass("fancybox-slide--image") &&
                    t.parent().addClass("fancybox-is-scaling")),
                n.fancybox.setTranslate(t, e))
              : t.addClass(e),
            t.data(
              "timer",
              setTimeout(function () {
                t.trigger(f);
              }, o + 33)
            );
        },
        stop: function (t, e) {
          t &&
            t.length &&
            (clearTimeout(t.data("timer")),
            e && t.trigger(f),
            t.off(f).css("transition-duration", ""),
            t.parent().removeClass("fancybox-is-scaling"));
        },
      }),
      (n.fn.fancybox = function (t) {
        var e;
        return (
          (t = t || {}),
          (e = t.selector || !1),
          e
            ? n("body")
                .off("click.fb-start", e)
                .on("click.fb-start", e, { options: t }, i)
            : this.off("click.fb-start").on(
                "click.fb-start",
                { items: this, options: t },
                i
              ),
          this
        );
      }),
      r.on("click.fb-start", "[data-fancybox]", i),
      r.on("click.fb-start", "[data-fancybox-trigger]", function (t) {
        n('[data-fancybox="' + n(this).attr("data-fancybox-trigger") + '"]')
          .eq(n(this).attr("data-fancybox-index") || 0)
          .trigger("click.fb-start", { $trigger: n(this) });
      }),
      (function () {
        var t = null;
        r.on("mousedown mouseup focus blur", ".fancybox-button", function (e) {
          switch (e.type) {
            case "mousedown":
              t = n(this);
              break;
            case "mouseup":
              t = null;
              break;
            case "focusin":
              n(".fancybox-button").removeClass("fancybox-focus"),
                n(this).is(t) ||
                  n(this).is("[disabled]") ||
                  n(this).addClass("fancybox-focus");
              break;
            case "focusout":
              n(".fancybox-button").removeClass("fancybox-focus");
          }
        });
      })();
  }
})(window, document, jQuery),
  (function (t) {
    "use strict";
    var e = {
        youtube: {
          matcher:
            /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
          params: {
            autoplay: 1,
            autohide: 1,
            fs: 1,
            rel: 0,
            hd: 1,
            wmode: "transparent",
            enablejsapi: 1,
            html5: 1,
          },
          paramPlace: 8,
          type: "iframe",
          url: "https://www.youtube-nocookie.com/embed/$4",
          thumb: "https://img.youtube.com/vi/$4/hqdefault.jpg",
        },
        vimeo: {
          matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,
          params: {
            autoplay: 1,
            hd: 1,
            show_title: 1,
            show_byline: 1,
            show_portrait: 0,
            fullscreen: 1,
          },
          paramPlace: 3,
          type: "iframe",
          url: "//player.vimeo.com/video/$2",
        },
        instagram: {
          matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
          type: "image",
          url: "//$1/p/$2/media/?size=l",
        },
        gmap_place: {
          matcher:
            /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
          type: "iframe",
          url: function (t) {
            return (
              "//maps.google." +
              t[2] +
              "/?ll=" +
              (t[9]
                ? t[9] +
                  "&z=" +
                  Math.floor(t[10]) +
                  (t[12] ? t[12].replace(/^\//, "&") : "")
                : t[12] + ""
              ).replace(/\?/, "&") +
              "&output=" +
              (t[12] && t[12].indexOf("layer=c") > 0 ? "svembed" : "embed")
            );
          },
        },
        gmap_search: {
          matcher:
            /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,
          type: "iframe",
          url: function (t) {
            return (
              "//maps.google." +
              t[2] +
              "/maps?q=" +
              t[5].replace("query=", "q=").replace("api=1", "") +
              "&output=embed"
            );
          },
        },
      },
      n = function (e, n, o) {
        if (e)
          return (
            (o = o || ""),
            "object" === t.type(o) && (o = t.param(o, !0)),
            t.each(n, function (t, n) {
              e = e.replace("$" + t, n || "");
            }),
            o.length && (e += (e.indexOf("?") > 0 ? "&" : "?") + o),
            e
          );
      };
    t(document).on("objectNeedsType.fb", function (o, i, a) {
      var s,
        r,
        c,
        l,
        d,
        u,
        f,
        p = a.src || "",
        h = !1;
      (s = t.extend(!0, {}, e, a.opts.media)),
        t.each(s, function (e, o) {
          if ((c = p.match(o.matcher))) {
            if (
              ((h = o.type), (f = e), (u = {}), o.paramPlace && c[o.paramPlace])
            ) {
              (d = c[o.paramPlace]),
                "?" == d[0] && (d = d.substring(1)),
                (d = d.split("&"));
              for (var i = 0; i < d.length; ++i) {
                var s = d[i].split("=", 2);
                2 == s.length &&
                  (u[s[0]] = decodeURIComponent(s[1].replace(/\+/g, " ")));
              }
            }
            return (
              (l = t.extend(!0, {}, o.params, a.opts[e], u)),
              (p =
                "function" === t.type(o.url)
                  ? o.url.call(this, c, l, a)
                  : n(o.url, c, l)),
              (r =
                "function" === t.type(o.thumb)
                  ? o.thumb.call(this, c, l, a)
                  : n(o.thumb, c)),
              "youtube" === e
                ? (p = p.replace(/&t=((\d+)m)?(\d+)s/, function (t, e, n, o) {
                    return (
                      "&start=" +
                      ((n ? 60 * parseInt(n, 10) : 0) + parseInt(o, 10))
                    );
                  }))
                : "vimeo" === e && (p = p.replace("&%23", "#")),
              !1
            );
          }
        }),
        h
          ? (a.opts.thumb ||
              (a.opts.$thumb && a.opts.$thumb.length) ||
              (a.opts.thumb = r),
            "iframe" === h &&
              (a.opts = t.extend(!0, a.opts, {
                iframe: { preload: !1, attr: { scrolling: "no" } },
              })),
            t.extend(a, {
              type: h,
              src: p,
              origSrc: a.src,
              contentSource: f,
              contentType:
                "image" === h
                  ? "image"
                  : "gmap_place" == f || "gmap_search" == f
                  ? "map"
                  : "video",
            }))
          : p && (a.type = a.opts.defaultType);
    });
    var o = {
      youtube: {
        src: "https://www.youtube.com/iframe_api",
        class: "YT",
        loading: !1,
        loaded: !1,
      },
      vimeo: {
        src: "https://player.vimeo.com/api/player.js",
        class: "Vimeo",
        loading: !1,
        loaded: !1,
      },
      load: function (t) {
        var e,
          n = this;
        if (this[t].loaded)
          return void setTimeout(function () {
            n.done(t);
          });
        this[t].loading ||
          ((this[t].loading = !0),
          (e = document.createElement("script")),
          (e.type = "text/javascript"),
          (e.src = this[t].src),
          "youtube" === t
            ? (window.onYouTubeIframeAPIReady = function () {
                (n[t].loaded = !0), n.done(t);
              })
            : (e.onload = function () {
                (n[t].loaded = !0), n.done(t);
              }),
          document.body.appendChild(e));
      },
      done: function (e) {
        var n, o, i;
        "youtube" === e && delete window.onYouTubeIframeAPIReady,
          (n = t.fancybox.getInstance()) &&
            ((o = n.current.$content.find("iframe")),
            "youtube" === e && void 0 !== YT && YT
              ? (i = new YT.Player(o.attr("id"), {
                  events: {
                    onStateChange: function (t) {
                      0 == t.data && n.next();
                    },
                  },
                }))
              : "vimeo" === e &&
                void 0 !== Vimeo &&
                Vimeo &&
                ((i = new Vimeo.Player(o)),
                i.on("ended", function () {
                  n.next();
                })));
      },
    };
    t(document).on({
      "afterShow.fb": function (t, e, n) {
        e.group.length > 1 &&
          ("youtube" === n.contentSource || "vimeo" === n.contentSource) &&
          o.load(n.contentSource);
      },
    });
  })(jQuery),
  (function (t, e, n) {
    "use strict";
    var o = (function () {
        return (
          t.requestAnimationFrame ||
          t.webkitRequestAnimationFrame ||
          t.mozRequestAnimationFrame ||
          t.oRequestAnimationFrame ||
          function (e) {
            return t.setTimeout(e, 1e3 / 60);
          }
        );
      })(),
      i = (function () {
        return (
          t.cancelAnimationFrame ||
          t.webkitCancelAnimationFrame ||
          t.mozCancelAnimationFrame ||
          t.oCancelAnimationFrame ||
          function (e) {
            t.clearTimeout(e);
          }
        );
      })(),
      a = function (e) {
        var n = [];
        (e = e.originalEvent || e || t.e),
          (e =
            e.touches && e.touches.length
              ? e.touches
              : e.changedTouches && e.changedTouches.length
              ? e.changedTouches
              : [e]);
        for (var o in e)
          e[o].pageX
            ? n.push({ x: e[o].pageX, y: e[o].pageY })
            : e[o].clientX && n.push({ x: e[o].clientX, y: e[o].clientY });
        return n;
      },
      s = function (t, e, n) {
        return e && t
          ? "x" === n
            ? t.x - e.x
            : "y" === n
            ? t.y - e.y
            : Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2))
          : 0;
      },
      r = function (t) {
        if (
          t.is(
            'a,area,button,[role="button"],input,label,select,summary,textarea,video,audio,iframe'
          ) ||
          n.isFunction(t.get(0).onclick) ||
          t.data("selectable")
        )
          return !0;
        for (var e = 0, o = t[0].attributes, i = o.length; e < i; e++)
          if ("data-fancybox-" === o[e].nodeName.substr(0, 14)) return !0;
        return !1;
      },
      c = function (e) {
        var n = t.getComputedStyle(e)["overflow-y"],
          o = t.getComputedStyle(e)["overflow-x"],
          i =
            ("scroll" === n || "auto" === n) && e.scrollHeight > e.clientHeight,
          a = ("scroll" === o || "auto" === o) && e.scrollWidth > e.clientWidth;
        return i || a;
      },
      l = function (t) {
        for (var e = !1; ; ) {
          if ((e = c(t.get(0)))) break;
          if (
            ((t = t.parent()),
            !t.length || t.hasClass("fancybox-stage") || t.is("body"))
          )
            break;
        }
        return e;
      },
      d = function (t) {
        var e = this;
        (e.instance = t),
          (e.$bg = t.$refs.bg),
          (e.$stage = t.$refs.stage),
          (e.$container = t.$refs.container),
          e.destroy(),
          e.$container.on(
            "touchstart.fb.touch mousedown.fb.touch",
            n.proxy(e, "ontouchstart")
          );
      };
    (d.prototype.destroy = function () {
      var t = this;
      t.$container.off(".fb.touch"),
        n(e).off(".fb.touch"),
        t.requestId && (i(t.requestId), (t.requestId = null)),
        t.tapped && (clearTimeout(t.tapped), (t.tapped = null));
    }),
      (d.prototype.ontouchstart = function (o) {
        var i = this,
          c = n(o.target),
          d = i.instance,
          u = d.current,
          f = u.$slide,
          p = u.$content,
          h = "touchstart" == o.type;
        if (
          (h && i.$container.off("mousedown.fb.touch"),
          (!o.originalEvent || 2 != o.originalEvent.button) &&
            f.length &&
            c.length &&
            !r(c) &&
            !r(c.parent()) &&
            (c.is("img") ||
              !(o.originalEvent.clientX > c[0].clientWidth + c.offset().left)))
        ) {
          if (!u || d.isAnimating || u.$slide.hasClass("fancybox-animated"))
            return o.stopPropagation(), void o.preventDefault();
          (i.realPoints = i.startPoints = a(o)),
            i.startPoints.length &&
              (u.touch && o.stopPropagation(),
              (i.startEvent = o),
              (i.canTap = !0),
              (i.$target = c),
              (i.$content = p),
              (i.opts = u.opts.touch),
              (i.isPanning = !1),
              (i.isSwiping = !1),
              (i.isZooming = !1),
              (i.isScrolling = !1),
              (i.canPan = d.canPan()),
              (i.startTime = new Date().getTime()),
              (i.distanceX = i.distanceY = i.distance = 0),
              (i.canvasWidth = Math.round(f[0].clientWidth)),
              (i.canvasHeight = Math.round(f[0].clientHeight)),
              (i.contentLastPos = null),
              (i.contentStartPos = n.fancybox.getTranslate(i.$content) || {
                top: 0,
                left: 0,
              }),
              (i.sliderStartPos = n.fancybox.getTranslate(f)),
              (i.stagePos = n.fancybox.getTranslate(d.$refs.stage)),
              (i.sliderStartPos.top -= i.stagePos.top),
              (i.sliderStartPos.left -= i.stagePos.left),
              (i.contentStartPos.top -= i.stagePos.top),
              (i.contentStartPos.left -= i.stagePos.left),
              n(e)
                .off(".fb.touch")
                .on(
                  h
                    ? "touchend.fb.touch touchcancel.fb.touch"
                    : "mouseup.fb.touch mouseleave.fb.touch",
                  n.proxy(i, "ontouchend")
                )
                .on(
                  h ? "touchmove.fb.touch" : "mousemove.fb.touch",
                  n.proxy(i, "ontouchmove")
                ),
              n.fancybox.isMobile &&
                e.addEventListener("scroll", i.onscroll, !0),
              (((i.opts || i.canPan) &&
                (c.is(i.$stage) || i.$stage.find(c).length)) ||
                (c.is(".fancybox-image") && o.preventDefault(),
                n.fancybox.isMobile &&
                  c.parents(".fancybox-caption").length)) &&
                ((i.isScrollable = l(c) || l(c.parent())),
                (n.fancybox.isMobile && i.isScrollable) || o.preventDefault(),
                (1 === i.startPoints.length || u.hasError) &&
                  (i.canPan
                    ? (n.fancybox.stop(i.$content), (i.isPanning = !0))
                    : (i.isSwiping = !0),
                  i.$container.addClass("fancybox-is-grabbing")),
                2 === i.startPoints.length &&
                  "image" === u.type &&
                  (u.isLoaded || u.$ghost) &&
                  ((i.canTap = !1),
                  (i.isSwiping = !1),
                  (i.isPanning = !1),
                  (i.isZooming = !0),
                  n.fancybox.stop(i.$content),
                  (i.centerPointStartX =
                    0.5 * (i.startPoints[0].x + i.startPoints[1].x) -
                    n(t).scrollLeft()),
                  (i.centerPointStartY =
                    0.5 * (i.startPoints[0].y + i.startPoints[1].y) -
                    n(t).scrollTop()),
                  (i.percentageOfImageAtPinchPointX =
                    (i.centerPointStartX - i.contentStartPos.left) /
                    i.contentStartPos.width),
                  (i.percentageOfImageAtPinchPointY =
                    (i.centerPointStartY - i.contentStartPos.top) /
                    i.contentStartPos.height),
                  (i.startDistanceBetweenFingers = s(
                    i.startPoints[0],
                    i.startPoints[1]
                  )))));
        }
      }),
      (d.prototype.onscroll = function (t) {
        var n = this;
        (n.isScrolling = !0), e.removeEventListener("scroll", n.onscroll, !0);
      }),
      (d.prototype.ontouchmove = function (t) {
        var e = this;
        return void 0 !== t.originalEvent.buttons &&
          0 === t.originalEvent.buttons
          ? void e.ontouchend(t)
          : e.isScrolling
          ? void (e.canTap = !1)
          : ((e.newPoints = a(t)),
            void (
              (e.opts || e.canPan) &&
              e.newPoints.length &&
              e.newPoints.length &&
              ((e.isSwiping && !0 === e.isSwiping) || t.preventDefault(),
              (e.distanceX = s(e.newPoints[0], e.startPoints[0], "x")),
              (e.distanceY = s(e.newPoints[0], e.startPoints[0], "y")),
              (e.distance = s(e.newPoints[0], e.startPoints[0])),
              e.distance > 0 &&
                (e.isSwiping
                  ? e.onSwipe(t)
                  : e.isPanning
                  ? e.onPan()
                  : e.isZooming && e.onZoom()))
            ));
      }),
      (d.prototype.onSwipe = function (e) {
        var a,
          s = this,
          r = s.instance,
          c = s.isSwiping,
          l = s.sliderStartPos.left || 0;
        if (!0 !== c)
          "x" == c &&
            (s.distanceX > 0 &&
            (s.instance.group.length < 2 ||
              (0 === s.instance.current.index && !s.instance.current.opts.loop))
              ? (l += Math.pow(s.distanceX, 0.8))
              : s.distanceX < 0 &&
                (s.instance.group.length < 2 ||
                  (s.instance.current.index === s.instance.group.length - 1 &&
                    !s.instance.current.opts.loop))
              ? (l -= Math.pow(-s.distanceX, 0.8))
              : (l += s.distanceX)),
            (s.sliderLastPos = {
              top: "x" == c ? 0 : s.sliderStartPos.top + s.distanceY,
              left: l,
            }),
            s.requestId && (i(s.requestId), (s.requestId = null)),
            (s.requestId = o(function () {
              s.sliderLastPos &&
                (n.each(s.instance.slides, function (t, e) {
                  var o = e.pos - s.instance.currPos;
                  n.fancybox.setTranslate(e.$slide, {
                    top: s.sliderLastPos.top,
                    left:
                      s.sliderLastPos.left +
                      o * s.canvasWidth +
                      o * e.opts.gutter,
                  });
                }),
                s.$container.addClass("fancybox-is-sliding"));
            }));
        else if (Math.abs(s.distance) > 10) {
          if (
            ((s.canTap = !1),
            r.group.length < 2 && s.opts.vertical
              ? (s.isSwiping = "y")
              : r.isDragging ||
                !1 === s.opts.vertical ||
                ("auto" === s.opts.vertical && n(t).width() > 800)
              ? (s.isSwiping = "x")
              : ((a = Math.abs(
                  (180 * Math.atan2(s.distanceY, s.distanceX)) / Math.PI
                )),
                (s.isSwiping = a > 45 && a < 135 ? "y" : "x")),
            "y" === s.isSwiping && n.fancybox.isMobile && s.isScrollable)
          )
            return void (s.isScrolling = !0);
          (r.isDragging = s.isSwiping),
            (s.startPoints = s.newPoints),
            n.each(r.slides, function (t, e) {
              var o, i;
              n.fancybox.stop(e.$slide),
                (o = n.fancybox.getTranslate(e.$slide)),
                (i = n.fancybox.getTranslate(r.$refs.stage)),
                e.$slide
                  .css({
                    transform: "",
                    opacity: "",
                    "transition-duration": "",
                  })
                  .removeClass("fancybox-animated")
                  .removeClass(function (t, e) {
                    return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ");
                  }),
                e.pos === r.current.pos &&
                  ((s.sliderStartPos.top = o.top - i.top),
                  (s.sliderStartPos.left = o.left - i.left)),
                n.fancybox.setTranslate(e.$slide, {
                  top: o.top - i.top,
                  left: o.left - i.left,
                });
            }),
            r.SlideShow && r.SlideShow.isActive && r.SlideShow.stop();
        }
      }),
      (d.prototype.onPan = function () {
        var t = this;
        if (s(t.newPoints[0], t.realPoints[0]) < (n.fancybox.isMobile ? 10 : 5))
          return void (t.startPoints = t.newPoints);
        (t.canTap = !1),
          (t.contentLastPos = t.limitMovement()),
          t.requestId && i(t.requestId),
          (t.requestId = o(function () {
            n.fancybox.setTranslate(t.$content, t.contentLastPos);
          }));
      }),
      (d.prototype.limitMovement = function () {
        var t,
          e,
          n,
          o,
          i,
          a,
          s = this,
          r = s.canvasWidth,
          c = s.canvasHeight,
          l = s.distanceX,
          d = s.distanceY,
          u = s.contentStartPos,
          f = u.left,
          p = u.top,
          h = u.width,
          g = u.height;
        return (
          (i = h > r ? f + l : f),
          (a = p + d),
          (t = Math.max(0, 0.5 * r - 0.5 * h)),
          (e = Math.max(0, 0.5 * c - 0.5 * g)),
          (n = Math.min(r - h, 0.5 * r - 0.5 * h)),
          (o = Math.min(c - g, 0.5 * c - 0.5 * g)),
          l > 0 && i > t && (i = t - 1 + Math.pow(-t + f + l, 0.8) || 0),
          l < 0 && i < n && (i = n + 1 - Math.pow(n - f - l, 0.8) || 0),
          d > 0 && a > e && (a = e - 1 + Math.pow(-e + p + d, 0.8) || 0),
          d < 0 && a < o && (a = o + 1 - Math.pow(o - p - d, 0.8) || 0),
          { top: a, left: i }
        );
      }),
      (d.prototype.limitPosition = function (t, e, n, o) {
        var i = this,
          a = i.canvasWidth,
          s = i.canvasHeight;
        return (
          n > a
            ? ((t = t > 0 ? 0 : t), (t = t < a - n ? a - n : t))
            : (t = Math.max(0, a / 2 - n / 2)),
          o > s
            ? ((e = e > 0 ? 0 : e), (e = e < s - o ? s - o : e))
            : (e = Math.max(0, s / 2 - o / 2)),
          { top: e, left: t }
        );
      }),
      (d.prototype.onZoom = function () {
        var e = this,
          a = e.contentStartPos,
          r = a.width,
          c = a.height,
          l = a.left,
          d = a.top,
          u = s(e.newPoints[0], e.newPoints[1]),
          f = u / e.startDistanceBetweenFingers,
          p = Math.floor(r * f),
          h = Math.floor(c * f),
          g = (r - p) * e.percentageOfImageAtPinchPointX,
          b = (c - h) * e.percentageOfImageAtPinchPointY,
          m = (e.newPoints[0].x + e.newPoints[1].x) / 2 - n(t).scrollLeft(),
          v = (e.newPoints[0].y + e.newPoints[1].y) / 2 - n(t).scrollTop(),
          y = m - e.centerPointStartX,
          x = v - e.centerPointStartY,
          w = l + (g + y),
          $ = d + (b + x),
          S = { top: $, left: w, scaleX: f, scaleY: f };
        (e.canTap = !1),
          (e.newWidth = p),
          (e.newHeight = h),
          (e.contentLastPos = S),
          e.requestId && i(e.requestId),
          (e.requestId = o(function () {
            n.fancybox.setTranslate(e.$content, e.contentLastPos);
          }));
      }),
      (d.prototype.ontouchend = function (t) {
        var o = this,
          s = o.isSwiping,
          r = o.isPanning,
          c = o.isZooming,
          l = o.isScrolling;
        if (
          ((o.endPoints = a(t)),
          (o.dMs = Math.max(new Date().getTime() - o.startTime, 1)),
          o.$container.removeClass("fancybox-is-grabbing"),
          n(e).off(".fb.touch"),
          e.removeEventListener("scroll", o.onscroll, !0),
          o.requestId && (i(o.requestId), (o.requestId = null)),
          (o.isSwiping = !1),
          (o.isPanning = !1),
          (o.isZooming = !1),
          (o.isScrolling = !1),
          (o.instance.isDragging = !1),
          o.canTap)
        )
          return o.onTap(t);
        (o.speed = 100),
          (o.velocityX = (o.distanceX / o.dMs) * 0.5),
          (o.velocityY = (o.distanceY / o.dMs) * 0.5),
          r ? o.endPanning() : c ? o.endZooming() : o.endSwiping(s, l);
      }),
      (d.prototype.endSwiping = function (t, e) {
        var o = this,
          i = !1,
          a = o.instance.group.length,
          s = Math.abs(o.distanceX),
          r = "x" == t && a > 1 && ((o.dMs > 130 && s > 10) || s > 50);
        (o.sliderLastPos = null),
          "y" == t && !e && Math.abs(o.distanceY) > 50
            ? (n.fancybox.animate(
                o.instance.current.$slide,
                {
                  top: o.sliderStartPos.top + o.distanceY + 150 * o.velocityY,
                  opacity: 0,
                },
                200
              ),
              (i = o.instance.close(!0, 250)))
            : r && o.distanceX > 0
            ? (i = o.instance.previous(300))
            : r && o.distanceX < 0 && (i = o.instance.next(300)),
          !1 !== i || ("x" != t && "y" != t) || o.instance.centerSlide(200),
          o.$container.removeClass("fancybox-is-sliding");
      }),
      (d.prototype.endPanning = function () {
        var t,
          e,
          o,
          i = this;
        i.contentLastPos &&
          (!1 === i.opts.momentum || i.dMs > 350
            ? ((t = i.contentLastPos.left), (e = i.contentLastPos.top))
            : ((t = i.contentLastPos.left + 500 * i.velocityX),
              (e = i.contentLastPos.top + 500 * i.velocityY)),
          (o = i.limitPosition(
            t,
            e,
            i.contentStartPos.width,
            i.contentStartPos.height
          )),
          (o.width = i.contentStartPos.width),
          (o.height = i.contentStartPos.height),
          n.fancybox.animate(i.$content, o, 366));
      }),
      (d.prototype.endZooming = function () {
        var t,
          e,
          o,
          i,
          a = this,
          s = a.instance.current,
          r = a.newWidth,
          c = a.newHeight;
        a.contentLastPos &&
          ((t = a.contentLastPos.left),
          (e = a.contentLastPos.top),
          (i = { top: e, left: t, width: r, height: c, scaleX: 1, scaleY: 1 }),
          n.fancybox.setTranslate(a.$content, i),
          r < a.canvasWidth && c < a.canvasHeight
            ? a.instance.scaleToFit(150)
            : r > s.width || c > s.height
            ? a.instance.scaleToActual(
                a.centerPointStartX,
                a.centerPointStartY,
                150
              )
            : ((o = a.limitPosition(t, e, r, c)),
              n.fancybox.animate(a.$content, o, 150)));
      }),
      (d.prototype.onTap = function (e) {
        var o,
          i = this,
          s = n(e.target),
          r = i.instance,
          c = r.current,
          l = (e && a(e)) || i.startPoints,
          d = l[0] ? l[0].x - n(t).scrollLeft() - i.stagePos.left : 0,
          u = l[0] ? l[0].y - n(t).scrollTop() - i.stagePos.top : 0,
          f = function (t) {
            var o = c.opts[t];
            if ((n.isFunction(o) && (o = o.apply(r, [c, e])), o))
              switch (o) {
                case "close":
                  r.close(i.startEvent);
                  break;
                case "toggleControls":
                  r.toggleControls();
                  break;
                case "next":
                  r.next();
                  break;
                case "nextOrClose":
                  r.group.length > 1 ? r.next() : r.close(i.startEvent);
                  break;
                case "zoom":
                  "image" == c.type &&
                    (c.isLoaded || c.$ghost) &&
                    (r.canPan()
                      ? r.scaleToFit()
                      : r.isScaledDown()
                      ? r.scaleToActual(d, u)
                      : r.group.length < 2 && r.close(i.startEvent));
              }
          };
        if (
          (!e.originalEvent || 2 != e.originalEvent.button) &&
          (s.is("img") || !(d > s[0].clientWidth + s.offset().left))
        ) {
          if (
            s.is(
              ".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container"
            )
          )
            o = "Outside";
          else if (s.is(".fancybox-slide")) o = "Slide";
          else {
            if (
              !r.current.$content ||
              !r.current.$content.find(s).addBack().filter(s).length
            )
              return;
            o = "Content";
          }
          if (i.tapped) {
            if (
              (clearTimeout(i.tapped),
              (i.tapped = null),
              Math.abs(d - i.tapX) > 50 || Math.abs(u - i.tapY) > 50)
            )
              return this;
            f("dblclick" + o);
          } else
            (i.tapX = d),
              (i.tapY = u),
              c.opts["dblclick" + o] &&
              c.opts["dblclick" + o] !== c.opts["click" + o]
                ? (i.tapped = setTimeout(function () {
                    (i.tapped = null), r.isAnimating || f("click" + o);
                  }, 500))
                : f("click" + o);
          return this;
        }
      }),
      n(e)
        .on("onActivate.fb", function (t, e) {
          e && !e.Guestures && (e.Guestures = new d(e));
        })
        .on("beforeClose.fb", function (t, e) {
          e && e.Guestures && e.Guestures.destroy();
        });
  })(window, document, jQuery),
  (function (t, e) {
    "use strict";
    e.extend(!0, e.fancybox.defaults, {
      btnTpl: {
        slideShow:
          '<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6.5 5.4v13.2l11-6.6z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.33 5.75h2.2v12.5h-2.2V5.75zm5.15 0h2.2v12.5h-2.2V5.75z"/></svg></button>',
      },
      slideShow: { autoStart: !1, speed: 3e3, progress: !0 },
    });
    var n = function (t) {
      (this.instance = t), this.init();
    };
    e.extend(n.prototype, {
      timer: null,
      isActive: !1,
      $button: null,
      init: function () {
        var t = this,
          n = t.instance,
          o = n.group[n.currIndex].opts.slideShow;
        (t.$button = n.$refs.toolbar
          .find("[data-fancybox-play]")
          .on("click", function () {
            t.toggle();
          })),
          n.group.length < 2 || !o
            ? t.$button.hide()
            : o.progress &&
              (t.$progress = e(
                '<div class="fancybox-progress"></div>'
              ).appendTo(n.$refs.inner));
      },
      set: function (t) {
        var n = this,
          o = n.instance,
          i = o.current;
        i && (!0 === t || i.opts.loop || o.currIndex < o.group.length - 1)
          ? n.isActive &&
            "video" !== i.contentType &&
            (n.$progress &&
              e.fancybox.animate(
                n.$progress.show(),
                { scaleX: 1 },
                i.opts.slideShow.speed
              ),
            (n.timer = setTimeout(function () {
              o.current.opts.loop || o.current.index != o.group.length - 1
                ? o.next()
                : o.jumpTo(0);
            }, i.opts.slideShow.speed)))
          : (n.stop(), (o.idleSecondsCounter = 0), o.showControls());
      },
      clear: function () {
        var t = this;
        clearTimeout(t.timer),
          (t.timer = null),
          t.$progress && t.$progress.removeAttr("style").hide();
      },
      start: function () {
        var t = this,
          e = t.instance.current;
        e &&
          (t.$button
            .attr(
              "title",
              (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_STOP
            )
            .removeClass("fancybox-button--play")
            .addClass("fancybox-button--pause"),
          (t.isActive = !0),
          e.isComplete && t.set(!0),
          t.instance.trigger("onSlideShowChange", !0));
      },
      stop: function () {
        var t = this,
          e = t.instance.current;
        t.clear(),
          t.$button
            .attr(
              "title",
              (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_START
            )
            .removeClass("fancybox-button--pause")
            .addClass("fancybox-button--play"),
          (t.isActive = !1),
          t.instance.trigger("onSlideShowChange", !1),
          t.$progress && t.$progress.removeAttr("style").hide();
      },
      toggle: function () {
        var t = this;
        t.isActive ? t.stop() : t.start();
      },
    }),
      e(t).on({
        "onInit.fb": function (t, e) {
          e && !e.SlideShow && (e.SlideShow = new n(e));
        },
        "beforeShow.fb": function (t, e, n, o) {
          var i = e && e.SlideShow;
          o
            ? i && n.opts.slideShow.autoStart && i.start()
            : i && i.isActive && i.clear();
        },
        "afterShow.fb": function (t, e, n) {
          var o = e && e.SlideShow;
          o && o.isActive && o.set();
        },
        "afterKeydown.fb": function (n, o, i, a, s) {
          var r = o && o.SlideShow;
          !r ||
            !i.opts.slideShow ||
            (80 !== s && 32 !== s) ||
            e(t.activeElement).is("button,a,input") ||
            (a.preventDefault(), r.toggle());
        },
        "beforeClose.fb onDeactivate.fb": function (t, e) {
          var n = e && e.SlideShow;
          n && n.stop();
        },
      }),
      e(t).on("visibilitychange", function () {
        var n = e.fancybox.getInstance(),
          o = n && n.SlideShow;
        o && o.isActive && (t.hidden ? o.clear() : o.set());
      });
  })(document, jQuery),
  (function (t, e) {
    "use strict";
    var n = (function () {
      for (
        var e = [
            [
              "requestFullscreen",
              "exitFullscreen",
              "fullscreenElement",
              "fullscreenEnabled",
              "fullscreenchange",
              "fullscreenerror",
            ],
            [
              "webkitRequestFullscreen",
              "webkitExitFullscreen",
              "webkitFullscreenElement",
              "webkitFullscreenEnabled",
              "webkitfullscreenchange",
              "webkitfullscreenerror",
            ],
            [
              "webkitRequestFullScreen",
              "webkitCancelFullScreen",
              "webkitCurrentFullScreenElement",
              "webkitCancelFullScreen",
              "webkitfullscreenchange",
              "webkitfullscreenerror",
            ],
            [
              "mozRequestFullScreen",
              "mozCancelFullScreen",
              "mozFullScreenElement",
              "mozFullScreenEnabled",
              "mozfullscreenchange",
              "mozfullscreenerror",
            ],
            [
              "msRequestFullscreen",
              "msExitFullscreen",
              "msFullscreenElement",
              "msFullscreenEnabled",
              "MSFullscreenChange",
              "MSFullscreenError",
            ],
          ],
          n = {},
          o = 0;
        o < e.length;
        o++
      ) {
        var i = e[o];
        if (i && i[1] in t) {
          for (var a = 0; a < i.length; a++) n[e[0][a]] = i[a];
          return n;
        }
      }
      return !1;
    })();
    if (n) {
      var o = {
        request: function (e) {
          (e = e || t.documentElement),
            e[n.requestFullscreen](e.ALLOW_KEYBOARD_INPUT);
        },
        exit: function () {
          t[n.exitFullscreen]();
        },
        toggle: function (e) {
          (e = e || t.documentElement),
            this.isFullscreen() ? this.exit() : this.request(e);
        },
        isFullscreen: function () {
          return Boolean(t[n.fullscreenElement]);
        },
        enabled: function () {
          return Boolean(t[n.fullscreenEnabled]);
        },
      };
      e.extend(!0, e.fancybox.defaults, {
        btnTpl: {
          fullScreen:
            '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fsenter" title="{{FULL_SCREEN}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"/></svg></button>',
        },
        fullScreen: { autoStart: !1 },
      }),
        e(t).on(n.fullscreenchange, function () {
          var t = o.isFullscreen(),
            n = e.fancybox.getInstance();
          n &&
            (n.current &&
              "image" === n.current.type &&
              n.isAnimating &&
              ((n.isAnimating = !1),
              n.update(!0, !0, 0),
              n.isComplete || n.complete()),
            n.trigger("onFullscreenChange", t),
            n.$refs.container.toggleClass("fancybox-is-fullscreen", t),
            n.$refs.toolbar
              .find("[data-fancybox-fullscreen]")
              .toggleClass("fancybox-button--fsenter", !t)
              .toggleClass("fancybox-button--fsexit", t));
        });
    }
    e(t).on({
      "onInit.fb": function (t, e) {
        var i;
        if (!n)
          return void e.$refs.toolbar
            .find("[data-fancybox-fullscreen]")
            .remove();
        e && e.group[e.currIndex].opts.fullScreen
          ? ((i = e.$refs.container),
            i.on(
              "click.fb-fullscreen",
              "[data-fancybox-fullscreen]",
              function (t) {
                t.stopPropagation(), t.preventDefault(), o.toggle();
              }
            ),
            e.opts.fullScreen &&
              !0 === e.opts.fullScreen.autoStart &&
              o.request(),
            (e.FullScreen = o))
          : e && e.$refs.toolbar.find("[data-fancybox-fullscreen]").hide();
      },
      "afterKeydown.fb": function (t, e, n, o, i) {
        e &&
          e.FullScreen &&
          70 === i &&
          (o.preventDefault(), e.FullScreen.toggle());
      },
      "beforeClose.fb": function (t, e) {
        e &&
          e.FullScreen &&
          e.$refs.container.hasClass("fancybox-is-fullscreen") &&
          o.exit();
      },
    });
  })(document, jQuery),
  (function (t, e) {
    "use strict";
    var n = "fancybox-thumbs";
    e.fancybox.defaults = e.extend(
      !0,
      {
        btnTpl: {
          thumbs:
            '<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"/></svg></button>',
        },
        thumbs: {
          autoStart: !1,
          hideOnClose: !0,
          parentEl: ".fancybox-container",
          axis: "y",
        },
      },
      e.fancybox.defaults
    );
    var o = function (t) {
      this.init(t);
    };
    e.extend(o.prototype, {
      $button: null,
      $grid: null,
      $list: null,
      isVisible: !1,
      isActive: !1,
      init: function (t) {
        var e = this,
          n = t.group,
          o = 0;
        (e.instance = t),
          (e.opts = n[t.currIndex].opts.thumbs),
          (t.Thumbs = e),
          (e.$button = t.$refs.toolbar.find("[data-fancybox-thumbs]"));
        for (
          var i = 0, a = n.length;
          i < a && (n[i].thumb && o++, !(o > 1));
          i++
        );
        o > 1 && e.opts
          ? (e.$button.removeAttr("style").on("click", function () {
              e.toggle();
            }),
            (e.isActive = !0))
          : e.$button.hide();
      },
      create: function () {
        var t,
          o = this,
          i = o.instance,
          a = o.opts.parentEl,
          s = [];
        o.$grid ||
          ((o.$grid = e(
            '<div class="' + n + " " + n + "-" + o.opts.axis + '"></div>'
          ).appendTo(i.$refs.container.find(a).addBack().filter(a))),
          o.$grid.on("click", "a", function () {
            i.jumpTo(e(this).attr("data-index"));
          })),
          o.$list ||
            (o.$list = e('<div class="' + n + '__list">').appendTo(o.$grid)),
          e.each(i.group, function (e, n) {
            (t = n.thumb),
              t || "image" !== n.type || (t = n.src),
              s.push(
                '<a href="javascript:;" tabindex="0" data-index="' +
                  e +
                  '"' +
                  (t && t.length
                    ? ' style="background-image:url(' + t + ')"'
                    : 'class="fancybox-thumbs-missing"') +
                  "></a>"
              );
          }),
          (o.$list[0].innerHTML = s.join("")),
          "x" === o.opts.axis &&
            o.$list.width(
              parseInt(o.$grid.css("padding-right"), 10) +
                i.group.length * o.$list.children().eq(0).outerWidth(!0)
            );
      },
      focus: function (t) {
        var e,
          n,
          o = this,
          i = o.$list,
          a = o.$grid;
        o.instance.current &&
          ((e = i
            .children()
            .removeClass("fancybox-thumbs-active")
            .filter('[data-index="' + o.instance.current.index + '"]')
            .addClass("fancybox-thumbs-active")),
          (n = e.position()),
          "y" === o.opts.axis &&
          (n.top < 0 || n.top > i.height() - e.outerHeight())
            ? i.stop().animate({ scrollTop: i.scrollTop() + n.top }, t)
            : "x" === o.opts.axis &&
              (n.left < a.scrollLeft() ||
                n.left > a.scrollLeft() + (a.width() - e.outerWidth())) &&
              i.parent().stop().animate({ scrollLeft: n.left }, t));
      },
      update: function () {
        var t = this;
        t.instance.$refs.container.toggleClass(
          "fancybox-show-thumbs",
          this.isVisible
        ),
          t.isVisible
            ? (t.$grid || t.create(),
              t.instance.trigger("onThumbsShow"),
              t.focus(0))
            : t.$grid && t.instance.trigger("onThumbsHide"),
          t.instance.update();
      },
      hide: function () {
        (this.isVisible = !1), this.update();
      },
      show: function () {
        (this.isVisible = !0), this.update();
      },
      toggle: function () {
        (this.isVisible = !this.isVisible), this.update();
      },
    }),
      e(t).on({
        "onInit.fb": function (t, e) {
          var n;
          e &&
            !e.Thumbs &&
            ((n = new o(e)), n.isActive && !0 === n.opts.autoStart && n.show());
        },
        "beforeShow.fb": function (t, e, n, o) {
          var i = e && e.Thumbs;
          i && i.isVisible && i.focus(o ? 0 : 250);
        },
        "afterKeydown.fb": function (t, e, n, o, i) {
          var a = e && e.Thumbs;
          a && a.isActive && 71 === i && (o.preventDefault(), a.toggle());
        },
        "beforeClose.fb": function (t, e) {
          var n = e && e.Thumbs;
          n && n.isVisible && !1 !== n.opts.hideOnClose && n.$grid.hide();
        },
      });
  })(document, jQuery),
  (function (t, e) {
    "use strict";
    function n(t) {
      var e = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "/": "&#x2F;",
        "`": "&#x60;",
        "=": "&#x3D;",
      };
      return String(t).replace(/[&<>"'`=\/]/g, function (t) {
        return e[t];
      });
    }
    e.extend(!0, e.fancybox.defaults, {
      btnTpl: {
        share:
          '<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.55 19c1.4-8.4 9.1-9.8 11.9-9.8V5l7 7-7 6.3v-3.5c-2.8 0-10.5 2.1-11.9 4.2z"/></svg></button>',
      },
      share: {
        url: function (t, e) {
          return (
            (!t.currentHash &&
              "inline" !== e.type &&
              "html" !== e.type &&
              (e.origSrc || e.src)) ||
            window.location
          );
        },
        tpl: '<div class="fancybox-share"><h1>{{SHARE}}</h1><p><a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg><span>Facebook</span></a><a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg><span>Twitter</span></a><a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url={{url}}&description={{descr}}&media={{media}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg><span>Pinterest</span></a></p><p><input class="fancybox-share__input" type="text" value="{{url_raw}}" onclick="select()" /></p></div>',
      },
    }),
      e(t).on("click", "[data-fancybox-share]", function () {
        var t,
          o,
          i = e.fancybox.getInstance(),
          a = i.current || null;
        a &&
          ("function" === e.type(a.opts.share.url) &&
            (t = a.opts.share.url.apply(a, [i, a])),
          (o = a.opts.share.tpl
            .replace(
              /\{\{media\}\}/g,
              "image" === a.type ? encodeURIComponent(a.src) : ""
            )
            .replace(/\{\{url\}\}/g, encodeURIComponent(t))
            .replace(/\{\{url_raw\}\}/g, n(t))
            .replace(
              /\{\{descr\}\}/g,
              i.$caption ? encodeURIComponent(i.$caption.text()) : ""
            )),
          e.fancybox.open({
            src: i.translate(i, o),
            type: "html",
            opts: {
              touch: !1,
              animationEffect: !1,
              afterLoad: function (t, e) {
                i.$refs.container.one("beforeClose.fb", function () {
                  t.close(null, 0);
                }),
                  e.$content.find(".fancybox-share__button").click(function () {
                    return (
                      window.open(this.href, "Share", "width=550, height=450"),
                      !1
                    );
                  });
              },
              mobile: { autoFocus: !1 },
            },
          }));
      });
  })(document, jQuery),
  (function (t, e, n) {
    "use strict";
    function o() {
      var e = t.location.hash.substr(1),
        n = e.split("-"),
        o =
          n.length > 1 && /^\+?\d+$/.test(n[n.length - 1])
            ? parseInt(n.pop(-1), 10) || 1
            : 1,
        i = n.join("-");
      return { hash: e, index: o < 1 ? 1 : o, gallery: i };
    }
    function i(t) {
      "" !== t.gallery &&
        n("[data-fancybox='" + n.escapeSelector(t.gallery) + "']")
          .eq(t.index - 1)
          .focus()
          .trigger("click.fb-start");
    }
    function a(t) {
      var e, n;
      return (
        !!t &&
        ((e = t.current ? t.current.opts : t.opts),
        "" !==
          (n =
            e.hash ||
            (e.$orig
              ? e.$orig.data("fancybox") || e.$orig.data("fancybox-trigger")
              : "")) && n)
      );
    }
    n.escapeSelector ||
      (n.escapeSelector = function (t) {
        return (t + "").replace(
          /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g,
          function (t, e) {
            return e
              ? "\0" === t
                ? "ï¿½"
                : t.slice(0, -1) +
                  "\\" +
                  t.charCodeAt(t.length - 1).toString(16) +
                  " "
              : "\\" + t;
          }
        );
      }),
      n(function () {
        !1 !== n.fancybox.defaults.hash &&
          (n(e).on({
            "onInit.fb": function (t, e) {
              var n, i;
              !1 !== e.group[e.currIndex].opts.hash &&
                ((n = o()),
                (i = a(e)) &&
                  n.gallery &&
                  i == n.gallery &&
                  (e.currIndex = n.index - 1));
            },
            "beforeShow.fb": function (n, o, i, s) {
              var r;
              i &&
                !1 !== i.opts.hash &&
                (r = a(o)) &&
                ((o.currentHash =
                  r + (o.group.length > 1 ? "-" + (i.index + 1) : "")),
                t.location.hash !== "#" + o.currentHash &&
                  (s && !o.origHash && (o.origHash = t.location.hash),
                  o.hashTimer && clearTimeout(o.hashTimer),
                  (o.hashTimer = setTimeout(function () {
                    "replaceState" in t.history
                      ? (t.history[s ? "pushState" : "replaceState"](
                          {},
                          e.title,
                          t.location.pathname +
                            t.location.search +
                            "#" +
                            o.currentHash
                        ),
                        s && (o.hasCreatedHistory = !0))
                      : (t.location.hash = o.currentHash),
                      (o.hashTimer = null);
                  }, 300))));
            },
            "beforeClose.fb": function (n, o, i) {
              i &&
                !1 !== i.opts.hash &&
                (clearTimeout(o.hashTimer),
                o.currentHash && o.hasCreatedHistory
                  ? t.history.back()
                  : o.currentHash &&
                    ("replaceState" in t.history
                      ? t.history.replaceState(
                          {},
                          e.title,
                          t.location.pathname +
                            t.location.search +
                            (o.origHash || "")
                        )
                      : (t.location.hash = o.origHash)),
                (o.currentHash = null));
            },
          }),
          n(t).on("hashchange.fb", function () {
            var t = o(),
              e = null;
            n.each(n(".fancybox-container").get().reverse(), function (t, o) {
              var i = n(o).data("FancyBox");
              if (i && i.currentHash) return (e = i), !1;
            }),
              e
                ? e.currentHash === t.gallery + "-" + t.index ||
                  (1 === t.index && e.currentHash == t.gallery) ||
                  ((e.currentHash = null), e.close())
                : "" !== t.gallery && i(t);
          }),
          setTimeout(function () {
            n.fancybox.getInstance() || i(o());
          }, 50));
      });
  })(window, document, jQuery),
  (function (t, e) {
    "use strict";
    var n = new Date().getTime();
    e(t).on({
      "onInit.fb": function (t, e, o) {
        e.$refs.stage.on(
          "mousewheel DOMMouseScroll wheel MozMousePixelScroll",
          function (t) {
            var o = e.current,
              i = new Date().getTime();
            e.group.length < 2 ||
              !1 === o.opts.wheel ||
              ("auto" === o.opts.wheel && "image" !== o.type) ||
              (t.preventDefault(),
              t.stopPropagation(),
              o.$slide.hasClass("fancybox-animated") ||
                ((t = t.originalEvent || t),
                i - n < 250 ||
                  ((n = i),
                  e[
                    (-t.deltaY || -t.deltaX || t.wheelDelta || -t.detail) < 0
                      ? "next"
                      : "previous"
                  ]())));
          }
        );
      },
    });
  })(document, jQuery);

/*bkSlider */
/**
 * bxSlider v4.2.12
 * Copyright 2013-2015 Steven Wanderski
 * Written while drinking Belgian ales and listening to jazz
 * Licensed under MIT (http://opensource.org/licenses/MIT)
 */

(function ($) {
  var defaults = {
    // GENERAL
    mode: "horizontal",
    slideSelector: "",
    infiniteLoop: true,
    hideControlOnEnd: false,
    speed: 500,
    easing: null,
    slideMargin: 0,
    startSlide: 0,
    randomStart: false,
    captions: false,
    ticker: false,
    tickerHover: false,
    adaptiveHeight: false,
    adaptiveHeightSpeed: 500,
    video: false,
    useCSS: true,
    preloadImages: "visible",
    responsive: true,
    slideZIndex: 50,
    wrapperClass: "bx-wrapper",

    // TOUCH
    touchEnabled: true,
    swipeThreshold: 50,
    oneToOneTouch: true,
    preventDefaultSwipeX: true,
    preventDefaultSwipeY: false,

    // ACCESSIBILITY
    ariaLive: true,
    ariaHidden: true,

    // KEYBOARD
    keyboardEnabled: false,

    // PAGER
    pager: true,
    pagerType: "full",
    pagerShortSeparator: " / ",
    pagerSelector: null,
    buildPager: null,
    pagerCustom: null,

    // CONTROLS
    controls: true,
    nextText: "Next",
    prevText: "Prev",
    nextSelector: null,
    prevSelector: null,
    autoControls: false,
    startText: "Start",
    stopText: "Stop",
    autoControlsCombine: false,
    autoControlsSelector: null,

    // AUTO
    auto: false,
    pause: 4000,
    autoStart: true,
    autoDirection: "next",
    stopAutoOnClick: false,
    autoHover: false,
    autoDelay: 0,
    autoSlideForOnePage: false,

    // CAROUSEL
    minSlides: 1,
    maxSlides: 1,
    moveSlides: 0,
    slideWidth: 0,
    shrinkItems: false,

    // CALLBACKS
    onSliderLoad: function () {
      return true;
    },
    onSlideBefore: function () {
      return true;
    },
    onSlideAfter: function () {
      return true;
    },
    onSlideNext: function () {
      return true;
    },
    onSlidePrev: function () {
      return true;
    },
    onSliderResize: function () {
      return true;
    },
    onAutoChange: function () {
      return true;
    }, //calls when auto slides starts and stops
  };

  $.fn.bxSlider = function (options) {
    if (this.length === 0) {
      return this;
    }

    // support multiple elements
    if (this.length > 1) {
      this.each(function () {
        $(this).bxSlider(options);
      });
      return this;
    }

    // create a namespace to be used throughout the plugin
    var slider = {},
      // set a reference to our slider element
      el = this,
      // get the original window dimens (thanks a lot IE)
      windowWidth = $(window).width(),
      windowHeight = $(window).height();

    // Return if slider is already initialized
    if ($(el).data("bxSlider")) {
      return;
    }

    /**
     * ===================================================================================
     * = PRIVATE FUNCTIONS
     * ===================================================================================
     */

    /**
     * Initializes namespace settings to be used throughout plugin
     */
    var init = function () {
      // Return if slider is already initialized
      if ($(el).data("bxSlider")) {
        return;
      }
      // merge user-supplied options with the defaults
      slider.settings = $.extend({}, defaults, options);
      // parse slideWidth setting
      slider.settings.slideWidth = parseInt(slider.settings.slideWidth);
      // store the original children
      slider.children = el.children(slider.settings.slideSelector);
      // check if actual number of slides is less than minSlides / maxSlides
      if (slider.children.length < slider.settings.minSlides) {
        slider.settings.minSlides = slider.children.length;
      }
      if (slider.children.length < slider.settings.maxSlides) {
        slider.settings.maxSlides = slider.children.length;
      }
      // if random start, set the startSlide setting to random number
      if (slider.settings.randomStart) {
        slider.settings.startSlide = Math.floor(
          Math.random() * slider.children.length
        );
      }
      // store active slide information
      slider.active = { index: slider.settings.startSlide };
      // store if the slider is in carousel mode (displaying / moving multiple slides)
      slider.carousel =
        slider.settings.minSlides > 1 || slider.settings.maxSlides > 1
          ? true
          : false;
      // if carousel, force preloadImages = 'all'
      if (slider.carousel) {
        slider.settings.preloadImages = "all";
      }
      // calculate the min / max width thresholds based on min / max number of slides
      // used to setup and update carousel slides dimensions
      slider.minThreshold =
        slider.settings.minSlides * slider.settings.slideWidth +
        (slider.settings.minSlides - 1) * slider.settings.slideMargin;
      slider.maxThreshold =
        slider.settings.maxSlides * slider.settings.slideWidth +
        (slider.settings.maxSlides - 1) * slider.settings.slideMargin;
      // store the current state of the slider (if currently animating, working is true)
      slider.working = false;
      // initialize the controls object
      slider.controls = {};
      // initialize an auto interval
      slider.interval = null;
      // determine which property to use for transitions
      slider.animProp = slider.settings.mode === "vertical" ? "top" : "left";
      // determine if hardware acceleration can be used
      slider.usingCSS =
        slider.settings.useCSS &&
        slider.settings.mode !== "fade" &&
        (function () {
          // create our test div element
          var div = document.createElement("div"),
            // css transition properties
            props = [
              "WebkitPerspective",
              "MozPerspective",
              "OPerspective",
              "msPerspective",
            ];
          // test for each property
          for (var i = 0; i < props.length; i++) {
            if (div.style[props[i]] !== undefined) {
              slider.cssPrefix = props[i]
                .replace("Perspective", "")
                .toLowerCase();
              slider.animProp = "-" + slider.cssPrefix + "-transform";
              return true;
            }
          }
          return false;
        })();
      // if vertical mode always make maxSlides and minSlides equal
      if (slider.settings.mode === "vertical") {
        slider.settings.maxSlides = slider.settings.minSlides;
      }
      // save original style data
      el.data("origStyle", el.attr("style"));
      el.children(slider.settings.slideSelector).each(function () {
        $(this).data("origStyle", $(this).attr("style"));
      });

      // perform all DOM / CSS modifications
      setup();
    };

    /**
     * Performs all DOM and CSS modifications
     */
    var setup = function () {
      var preloadSelector = slider.children.eq(slider.settings.startSlide); // set the default preload selector (visible)

      // wrap el in a wrapper
      el.wrap(
        '<div class="' +
          slider.settings.wrapperClass +
          '"><div class="bx-viewport"></div></div>'
      );
      // store a namespace reference to .bx-viewport
      slider.viewport = el.parent();

      // add aria-live if the setting is enabled and ticker mode is disabled
      if (slider.settings.ariaLive && !slider.settings.ticker) {
        slider.viewport.attr("aria-live", "polite");
      }
      // add a loading div to display while images are loading
      slider.loader = $('<div class="bx-loading" />');
      slider.viewport.prepend(slider.loader);
      // set el to a massive width, to hold any needed slides
      // also strip any margin and padding from el
      el.css({
        width:
          slider.settings.mode === "horizontal"
            ? slider.children.length * 1000 + 215 + "%"
            : "auto",
        position: "relative",
      });
      // if using CSS, add the easing property
      if (slider.usingCSS && slider.settings.easing) {
        el.css(
          "-" + slider.cssPrefix + "-transition-timing-function",
          slider.settings.easing
        );
        // if not using CSS and no easing value was supplied, use the default JS animation easing (swing)
      } else if (!slider.settings.easing) {
        slider.settings.easing = "swing";
      }
      // make modifications to the viewport (.bx-viewport)
      slider.viewport.css({
        width: "100%",
        overflow: "hidden",
        position: "relative",
      });
      slider.viewport.parent().css({
        maxWidth: getViewportMaxWidth(),
      });
      // apply css to all slider children
      slider.children.css({
        // the float attribute is a reserved word in compressors like YUI compressor and need to be quoted #48
        float: slider.settings.mode === "horizontal" ? "left" : "none",
        listStyle: "none",
        position: "relative",
      });
      // apply the calculated width after the float is applied to prevent scrollbar interference
      slider.children.css("width", getSlideWidth());
      // if slideMargin is supplied, add the css
      if (
        slider.settings.mode === "horizontal" &&
        slider.settings.slideMargin > 0
      ) {
        slider.children.css("marginRight", slider.settings.slideMargin);
      }
      if (
        slider.settings.mode === "vertical" &&
        slider.settings.slideMargin > 0
      ) {
        slider.children.css("marginBottom", slider.settings.slideMargin);
      }
      // if "fade" mode, add positioning and z-index CSS
      if (slider.settings.mode === "fade") {
        slider.children.css({
          position: "absolute",
          zIndex: 0,
          display: "none",
        });
        // prepare the z-index on the showing element
        slider.children
          .eq(slider.settings.startSlide)
          .css({ zIndex: slider.settings.slideZIndex, display: "block" });
      }
      // create an element to contain all slider controls (pager, start / stop, etc)
      slider.controls.el = $('<div class="bx-controls" />');
      // if captions are requested, add them
      if (slider.settings.captions) {
        appendCaptions();
      }
      // check if startSlide is last slide
      slider.active.last = slider.settings.startSlide === getPagerQty() - 1;
      // if video is true, set up the fitVids plugin
      if (slider.settings.video) {
        el.fitVids();
      }
      if (slider.settings.preloadImages === "all" || slider.settings.ticker) {
        preloadSelector = slider.children;
      }
      // only check for control addition if not in "ticker" mode
      if (!slider.settings.ticker) {
        // if controls are requested, add them
        if (slider.settings.controls) {
          appendControls();
        }
        // if auto is true, and auto controls are requested, add them
        if (slider.settings.auto && slider.settings.autoControls) {
          appendControlsAuto();
        }
        // if pager is requested, add it
        if (slider.settings.pager) {
          appendPager();
        }
        // if any control option is requested, add the controls wrapper
        if (
          slider.settings.controls ||
          slider.settings.autoControls ||
          slider.settings.pager
        ) {
          slider.viewport.after(slider.controls.el);
        }
        // if ticker mode, do not allow a pager
      } else {
        slider.settings.pager = false;
      }
      loadElements(preloadSelector, start);
    };

    var loadElements = function (selector, callback) {
      var total = selector.find('img:not([src=""]), iframe').length,
        count = 0;
      if (total === 0) {
        callback();
        return;
      }
      selector.find('img:not([src=""]), iframe').each(function () {
        $(this)
          .one("load error", function () {
            if (++count === total) {
              callback();
            }
          })
          .each(function () {
            if (this.complete || this.src == "") {
              $(this).trigger("load");
            }
          });
      });
    };

    /**
     * Start the slider
     */
    var start = function () {
      // if infinite loop, prepare additional slides
      if (
        slider.settings.infiniteLoop &&
        slider.settings.mode !== "fade" &&
        !slider.settings.ticker
      ) {
        var slice =
            slider.settings.mode === "vertical"
              ? slider.settings.minSlides
              : slider.settings.maxSlides,
          sliceAppend = slider.children
            .slice(0, slice)
            .clone(true)
            .addClass("bx-clone"),
          slicePrepend = slider.children
            .slice(-slice)
            .clone(true)
            .addClass("bx-clone");
        if (slider.settings.ariaHidden) {
          sliceAppend.attr("aria-hidden", true);
          slicePrepend.attr("aria-hidden", true);
        }
        el.append(sliceAppend).prepend(slicePrepend);
      }
      // remove the loading DOM element
      slider.loader.remove();
      // set the left / top position of "el"
      setSlidePosition();
      // if "vertical" mode, always use adaptiveHeight to prevent odd behavior
      if (slider.settings.mode === "vertical") {
        slider.settings.adaptiveHeight = true;
      }
      // set the viewport height
      slider.viewport.height(getViewportHeight());
      // make sure everything is positioned just right (same as a window resize)
      el.redrawSlider();
      // onSliderLoad callback
      slider.settings.onSliderLoad.call(el, slider.active.index);
      // slider has been fully initialized
      slider.initialized = true;
      // bind the resize call to the window
      if (slider.settings.responsive) {
        $(window).bind("resize", resizeWindow);
      }
      // if auto is true and has more than 1 page, start the show
      if (
        slider.settings.auto &&
        slider.settings.autoStart &&
        (getPagerQty() > 1 || slider.settings.autoSlideForOnePage)
      ) {
        initAuto();
      }
      // if ticker is true, start the ticker
      if (slider.settings.ticker) {
        initTicker();
      }
      // if pager is requested, make the appropriate pager link active
      if (slider.settings.pager) {
        updatePagerActive(slider.settings.startSlide);
      }
      // check for any updates to the controls (like hideControlOnEnd updates)
      if (slider.settings.controls) {
        updateDirectionControls();
      }
      // if touchEnabled is true, setup the touch events
      if (slider.settings.touchEnabled && !slider.settings.ticker) {
        initTouch();
      }
      // if keyboardEnabled is true, setup the keyboard events
      if (slider.settings.keyboardEnabled && !slider.settings.ticker) {
        $(document).keydown(keyPress);
      }
    };

    /**
     * Returns the calculated height of the viewport, used to determine either adaptiveHeight or the maxHeight value
     */
    var getViewportHeight = function () {
      var height = 0;
      // first determine which children (slides) should be used in our height calculation
      var children = $();
      // if mode is not "vertical" and adaptiveHeight is false, include all children
      if (
        slider.settings.mode !== "vertical" &&
        !slider.settings.adaptiveHeight
      ) {
        children = slider.children;
      } else {
        // if not carousel, return the single active child
        if (!slider.carousel) {
          children = slider.children.eq(slider.active.index);
          // if carousel, return a slice of children
        } else {
          // get the individual slide index
          var currentIndex =
            slider.settings.moveSlides === 1
              ? slider.active.index
              : slider.active.index * getMoveBy();
          // add the current slide to the children
          children = slider.children.eq(currentIndex);
          // cycle through the remaining "showing" slides
          for (i = 1; i <= slider.settings.maxSlides - 1; i++) {
            // if looped back to the start
            if (currentIndex + i >= slider.children.length) {
              children = children.add(slider.children.eq(i - 1));
            } else {
              children = children.add(slider.children.eq(currentIndex + i));
            }
          }
        }
      }
      // if "vertical" mode, calculate the sum of the heights of the children
      if (slider.settings.mode === "vertical") {
        children.each(function (index) {
          height += $(this).outerHeight();
        });
        // add user-supplied margins
        if (slider.settings.slideMargin > 0) {
          height +=
            slider.settings.slideMargin * (slider.settings.minSlides - 1);
        }
        // if not "vertical" mode, calculate the max height of the children
      } else {
        height = Math.max.apply(
          Math,
          children
            .map(function () {
              return $(this).outerHeight(false);
            })
            .get()
        );
      }

      if (slider.viewport.css("box-sizing") === "border-box") {
        height +=
          parseFloat(slider.viewport.css("padding-top")) +
          parseFloat(slider.viewport.css("padding-bottom")) +
          parseFloat(slider.viewport.css("border-top-width")) +
          parseFloat(slider.viewport.css("border-bottom-width"));
      } else if (slider.viewport.css("box-sizing") === "padding-box") {
        height +=
          parseFloat(slider.viewport.css("padding-top")) +
          parseFloat(slider.viewport.css("padding-bottom"));
      }

      return height;
    };

    /**
     * Returns the calculated width to be used for the outer wrapper / viewport
     */
    var getViewportMaxWidth = function () {
      var width = "100%";
      if (slider.settings.slideWidth > 0) {
        if (slider.settings.mode === "horizontal") {
          width =
            slider.settings.maxSlides * slider.settings.slideWidth +
            (slider.settings.maxSlides - 1) * slider.settings.slideMargin;
        } else {
          width = slider.settings.slideWidth;
        }
      }
      return width;
    };

    /**
     * Returns the calculated width to be applied to each slide
     */
    var getSlideWidth = function () {
      var newElWidth = slider.settings.slideWidth, // start with any user-supplied slide width
        wrapWidth = slider.viewport.width(); // get the current viewport width
      // if slide width was not supplied, or is larger than the viewport use the viewport width
      if (
        slider.settings.slideWidth === 0 ||
        (slider.settings.slideWidth > wrapWidth && !slider.carousel) ||
        slider.settings.mode === "vertical"
      ) {
        newElWidth = wrapWidth;
        // if carousel, use the thresholds to determine the width
      } else if (
        slider.settings.maxSlides > 1 &&
        slider.settings.mode === "horizontal"
      ) {
        if (wrapWidth > slider.maxThreshold) {
          return newElWidth;
        } else if (wrapWidth < slider.minThreshold) {
          newElWidth =
            (wrapWidth -
              slider.settings.slideMargin * (slider.settings.minSlides - 1)) /
            slider.settings.minSlides;
        } else if (slider.settings.shrinkItems) {
          newElWidth = Math.floor(
            (wrapWidth + slider.settings.slideMargin) /
              Math.ceil(
                (wrapWidth + slider.settings.slideMargin) /
                  (newElWidth + slider.settings.slideMargin)
              ) -
              slider.settings.slideMargin
          );
        }
      }
      return newElWidth;
    };

    /**
     * Returns the number of slides currently visible in the viewport (includes partially visible slides)
     */
    var getNumberSlidesShowing = function () {
      var slidesShowing = 1,
        childWidth = null;
      if (
        slider.settings.mode === "horizontal" &&
        slider.settings.slideWidth > 0
      ) {
        // if viewport is smaller than minThreshold, return minSlides
        if (slider.viewport.width() < slider.minThreshold) {
          slidesShowing = slider.settings.minSlides;
          // if viewport is larger than maxThreshold, return maxSlides
        } else if (slider.viewport.width() > slider.maxThreshold) {
          slidesShowing = slider.settings.maxSlides;
          // if viewport is between min / max thresholds, divide viewport width by first child width
        } else {
          childWidth =
            slider.children.first().width() + slider.settings.slideMargin;
          slidesShowing =
            Math.floor(
              (slider.viewport.width() + slider.settings.slideMargin) /
                childWidth
            ) || 1;
        }
        // if "vertical" mode, slides showing will always be minSlides
      } else if (slider.settings.mode === "vertical") {
        slidesShowing = slider.settings.minSlides;
      }
      return slidesShowing;
    };

    /**
     * Returns the number of pages (one full viewport of slides is one "page")
     */
    var getPagerQty = function () {
      var pagerQty = 0,
        breakPoint = 0,
        counter = 0;
      // if moveSlides is specified by the user
      if (slider.settings.moveSlides > 0) {
        if (slider.settings.infiniteLoop) {
          pagerQty = Math.ceil(slider.children.length / getMoveBy());
        } else {
          // when breakpoint goes above children length, counter is the number of pages
          while (breakPoint < slider.children.length) {
            ++pagerQty;
            breakPoint = counter + getNumberSlidesShowing();
            counter +=
              slider.settings.moveSlides <= getNumberSlidesShowing()
                ? slider.settings.moveSlides
                : getNumberSlidesShowing();
          }
          return counter;
        }
        // if moveSlides is 0 (auto) divide children length by sides showing, then round up
      } else {
        pagerQty = Math.ceil(slider.children.length / getNumberSlidesShowing());
      }
      return pagerQty;
    };

    /**
     * Returns the number of individual slides by which to shift the slider
     */
    var getMoveBy = function () {
      // if moveSlides was set by the user and moveSlides is less than number of slides showing
      if (
        slider.settings.moveSlides > 0 &&
        slider.settings.moveSlides <= getNumberSlidesShowing()
      ) {
        return slider.settings.moveSlides;
      }
      // if moveSlides is 0 (auto)
      return getNumberSlidesShowing();
    };

    /**
     * Sets the slider's (el) left or top position
     */
    var setSlidePosition = function () {
      var position, lastChild, lastShowingIndex;
      // if last slide, not infinite loop, and number of children is larger than specified maxSlides
      if (
        slider.children.length > slider.settings.maxSlides &&
        slider.active.last &&
        !slider.settings.infiniteLoop
      ) {
        if (slider.settings.mode === "horizontal") {
          // get the last child's position
          lastChild = slider.children.last();
          position = lastChild.position();
          // set the left position
          setPositionProperty(
            -(
              position.left -
              (slider.viewport.width() - lastChild.outerWidth())
            ),
            "reset",
            0
          );
        } else if (slider.settings.mode === "vertical") {
          // get the last showing index's position
          lastShowingIndex = slider.children.length - slider.settings.minSlides;
          position = slider.children.eq(lastShowingIndex).position();
          // set the top position
          setPositionProperty(-position.top, "reset", 0);
        }
        // if not last slide
      } else {
        // get the position of the first showing slide
        position = slider.children
          .eq(slider.active.index * getMoveBy())
          .position();
        // check for last slide
        if (slider.active.index === getPagerQty() - 1) {
          slider.active.last = true;
        }
        // set the respective position
        if (position !== undefined) {
          if (slider.settings.mode === "horizontal") {
            setPositionProperty(-position.left, "reset", 0);
          } else if (slider.settings.mode === "vertical") {
            setPositionProperty(-position.top, "reset", 0);
          }
        }
      }
    };

    /**
     * Sets the el's animating property position (which in turn will sometimes animate el).
     * If using CSS, sets the transform property. If not using CSS, sets the top / left property.
     *
     * @param value (int)
     *  - the animating property's value
     *
     * @param type (string) 'slide', 'reset', 'ticker'
     *  - the type of instance for which the function is being
     *
     * @param duration (int)
     *  - the amount of time (in ms) the transition should occupy
     *
     * @param params (array) optional
     *  - an optional parameter containing any variables that need to be passed in
     */
    var setPositionProperty = function (value, type, duration, params) {
      var animateObj, propValue;
      // use CSS transform
      if (slider.usingCSS) {
        // determine the translate3d value
        propValue =
          slider.settings.mode === "vertical"
            ? "translate3d(0, " + value + "px, 0)"
            : "translate3d(" + value + "px, 0, 0)";
        // add the CSS transition-duration
        el.css(
          "-" + slider.cssPrefix + "-transition-duration",
          duration / 1000 + "s"
        );
        if (type === "slide") {
          // set the property value
          el.css(slider.animProp, propValue);
          if (duration !== 0) {
            // bind a callback method - executes when CSS transition completes
            el.bind(
              "transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",
              function (e) {
                //make sure it's the correct one
                if (!$(e.target).is(el)) {
                  return;
                }
                // unbind the callback
                el.unbind(
                  "transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd"
                );
                updateAfterSlideTransition();
              }
            );
          } else {
            //duration = 0
            updateAfterSlideTransition();
          }
        } else if (type === "reset") {
          el.css(slider.animProp, propValue);
        } else if (type === "ticker") {
          // make the transition use 'linear'
          el.css(
            "-" + slider.cssPrefix + "-transition-timing-function",
            "linear"
          );
          el.css(slider.animProp, propValue);
          if (duration !== 0) {
            el.bind(
              "transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd",
              function (e) {
                //make sure it's the correct one
                if (!$(e.target).is(el)) {
                  return;
                }
                // unbind the callback
                el.unbind(
                  "transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd"
                );
                // reset the position
                setPositionProperty(params.resetValue, "reset", 0);
                // start the loop again
                tickerLoop();
              }
            );
          } else {
            //duration = 0
            setPositionProperty(params.resetValue, "reset", 0);
            tickerLoop();
          }
        }
        // use JS animate
      } else {
        animateObj = {};
        animateObj[slider.animProp] = value;
        if (type === "slide") {
          el.animate(animateObj, duration, slider.settings.easing, function () {
            updateAfterSlideTransition();
          });
        } else if (type === "reset") {
          el.css(slider.animProp, value);
        } else if (type === "ticker") {
          el.animate(animateObj, duration, "linear", function () {
            setPositionProperty(params.resetValue, "reset", 0);
            // run the recursive loop after animation
            tickerLoop();
          });
        }
      }
    };

    /**
     * Populates the pager with proper amount of pages
     */
    var populatePager = function () {
      var pagerHtml = "",
        linkContent = "",
        pagerQty = getPagerQty();
      // loop through each pager item
      for (var i = 0; i < pagerQty; i++) {
        linkContent = "";
        // if a buildPager function is supplied, use it to get pager link value, else use index + 1
        if (
          (slider.settings.buildPager &&
            $.isFunction(slider.settings.buildPager)) ||
          slider.settings.pagerCustom
        ) {
          linkContent = slider.settings.buildPager(i);
          slider.pagerEl.addClass("bx-custom-pager");
        } else {
          linkContent = i + 1;
          slider.pagerEl.addClass("bx-default-pager");
        }
        // var linkContent = slider.settings.buildPager && $.isFunction(slider.settings.buildPager) ? slider.settings.buildPager(i) : i + 1;
        // add the markup to the string
        pagerHtml +=
          '<div class="bx-pager-item"><a href="" data-slide-index="' +
          i +
          '" class="bx-pager-link">' +
          linkContent +
          "</a></div>";
      }
      // populate the pager element with pager links
      slider.pagerEl.html(pagerHtml);
    };

    /**
     * Appends the pager to the controls element
     */
    var appendPager = function () {
      if (!slider.settings.pagerCustom) {
        // create the pager DOM element
        slider.pagerEl = $('<div class="bx-pager" />');
        // if a pager selector was supplied, populate it with the pager
        if (slider.settings.pagerSelector) {
          $(slider.settings.pagerSelector).html(slider.pagerEl);
          // if no pager selector was supplied, add it after the wrapper
        } else {
          slider.controls.el.addClass("bx-has-pager").append(slider.pagerEl);
        }
        // populate the pager
        populatePager();
      } else {
        slider.pagerEl = $(slider.settings.pagerCustom);
      }
      // assign the pager click binding
      slider.pagerEl.on("click touchend", "a", clickPagerBind);
    };

    /**
     * Appends prev / next controls to the controls element
     */
    var appendControls = function () {
      slider.controls.next = $(
        '<a class="bx-next" href="">' + slider.settings.nextText + "</a>"
      );
      slider.controls.prev = $(
        '<a class="bx-prev" href="">' + slider.settings.prevText + "</a>"
      );
      // bind click actions to the controls
      slider.controls.next.bind("click touchend", clickNextBind);
      slider.controls.prev.bind("click touchend", clickPrevBind);
      // if nextSelector was supplied, populate it
      if (slider.settings.nextSelector) {
        $(slider.settings.nextSelector).append(slider.controls.next);
      }
      // if prevSelector was supplied, populate it
      if (slider.settings.prevSelector) {
        $(slider.settings.prevSelector).append(slider.controls.prev);
      }
      // if no custom selectors were supplied
      if (!slider.settings.nextSelector && !slider.settings.prevSelector) {
        // add the controls to the DOM
        slider.controls.directionEl = $(
          '<div class="bx-controls-direction" />'
        );
        // add the control elements to the directionEl
        slider.controls.directionEl
          .append(slider.controls.prev)
          .append(slider.controls.next);
        // slider.viewport.append(slider.controls.directionEl);
        slider.controls.el
          .addClass("bx-has-controls-direction")
          .append(slider.controls.directionEl);
      }
    };

    /**
     * Appends start / stop auto controls to the controls element
     */
    var appendControlsAuto = function () {
      slider.controls.start = $(
        '<div class="bx-controls-auto-item"><a class="bx-start" href="">' +
          slider.settings.startText +
          "</a></div>"
      );
      slider.controls.stop = $(
        '<div class="bx-controls-auto-item"><a class="bx-stop" href="">' +
          slider.settings.stopText +
          "</a></div>"
      );
      // add the controls to the DOM
      slider.controls.autoEl = $('<div class="bx-controls-auto" />');
      // bind click actions to the controls
      slider.controls.autoEl.on("click", ".bx-start", clickStartBind);
      slider.controls.autoEl.on("click", ".bx-stop", clickStopBind);
      // if autoControlsCombine, insert only the "start" control
      if (slider.settings.autoControlsCombine) {
        slider.controls.autoEl.append(slider.controls.start);
        // if autoControlsCombine is false, insert both controls
      } else {
        slider.controls.autoEl
          .append(slider.controls.start)
          .append(slider.controls.stop);
      }
      // if auto controls selector was supplied, populate it with the controls
      if (slider.settings.autoControlsSelector) {
        $(slider.settings.autoControlsSelector).html(slider.controls.autoEl);
        // if auto controls selector was not supplied, add it after the wrapper
      } else {
        slider.controls.el
          .addClass("bx-has-controls-auto")
          .append(slider.controls.autoEl);
      }
      // update the auto controls
      updateAutoControls(slider.settings.autoStart ? "stop" : "start");
    };

    /**
     * Appends image captions to the DOM
     */
    var appendCaptions = function () {
      // cycle through each child
      slider.children.each(function (index) {
        // get the image title attribute
        var title = $(this).find("img:first").attr("title");
        // append the caption
        if (title !== undefined && ("" + title).length) {
          $(this).append(
            '<div class="bx-caption"><span>' + title + "</span></div>"
          );
        }
      });
    };

    /**
     * Click next binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickNextBind = function (e) {
      e.preventDefault();
      if (slider.controls.el.hasClass("disabled")) {
        return;
      }
      // if auto show is running, stop it
      if (slider.settings.auto && slider.settings.stopAutoOnClick) {
        el.stopAuto();
      }
      el.goToNextSlide();
    };

    /**
     * Click prev binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickPrevBind = function (e) {
      e.preventDefault();
      if (slider.controls.el.hasClass("disabled")) {
        return;
      }
      // if auto show is running, stop it
      if (slider.settings.auto && slider.settings.stopAutoOnClick) {
        el.stopAuto();
      }
      el.goToPrevSlide();
    };

    /**
     * Click start binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickStartBind = function (e) {
      el.startAuto();
      e.preventDefault();
    };

    /**
     * Click stop binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickStopBind = function (e) {
      el.stopAuto();
      e.preventDefault();
    };

    /**
     * Click pager binding
     *
     * @param e (event)
     *  - DOM event object
     */
    var clickPagerBind = function (e) {
      var pagerLink, pagerIndex;
      e.preventDefault();
      if (slider.controls.el.hasClass("disabled")) {
        return;
      }
      // if auto show is running, stop it
      if (slider.settings.auto && slider.settings.stopAutoOnClick) {
        el.stopAuto();
      }
      pagerLink = $(e.currentTarget);
      if (pagerLink.attr("data-slide-index") !== undefined) {
        pagerIndex = parseInt(pagerLink.attr("data-slide-index"));
        // if clicked pager link is not active, continue with the goToSlide call
        if (pagerIndex !== slider.active.index) {
          el.goToSlide(pagerIndex);
        }
      }
    };

    /**
     * Updates the pager links with an active class
     *
     * @param slideIndex (int)
     *  - index of slide to make active
     */
    var updatePagerActive = function (slideIndex) {
      // if "short" pager type
      var len = slider.children.length; // nb of children
      if (slider.settings.pagerType === "short") {
        if (slider.settings.maxSlides > 1) {
          len = Math.ceil(slider.children.length / slider.settings.maxSlides);
        }
        slider.pagerEl.html(
          slideIndex + 1 + slider.settings.pagerShortSeparator + len
        );
        return;
      }
      // remove all pager active classes
      slider.pagerEl.find("a").removeClass("active");
      // apply the active class for all pagers
      slider.pagerEl.each(function (i, el) {
        $(el).find("a").eq(slideIndex).addClass("active");
      });
    };

    /**
     * Performs needed actions after a slide transition
     */
    var updateAfterSlideTransition = function () {
      // if infinite loop is true
      if (slider.settings.infiniteLoop) {
        var position = "";
        // first slide
        if (slider.active.index === 0) {
          // set the new position
          position = slider.children.eq(0).position();
          // carousel, last slide
        } else if (
          slider.active.index === getPagerQty() - 1 &&
          slider.carousel
        ) {
          position = slider.children
            .eq((getPagerQty() - 1) * getMoveBy())
            .position();
          // last slide
        } else if (slider.active.index === slider.children.length - 1) {
          position = slider.children.eq(slider.children.length - 1).position();
        }
        if (position) {
          if (slider.settings.mode === "horizontal") {
            setPositionProperty(-position.left, "reset", 0);
          } else if (slider.settings.mode === "vertical") {
            setPositionProperty(-position.top, "reset", 0);
          }
        }
      }
      // declare that the transition is complete
      slider.working = false;
      // onSlideAfter callback
      slider.settings.onSlideAfter.call(
        el,
        slider.children.eq(slider.active.index),
        slider.oldIndex,
        slider.active.index
      );
    };

    /**
     * Updates the auto controls state (either active, or combined switch)
     *
     * @param state (string) "start", "stop"
     *  - the new state of the auto show
     */
    var updateAutoControls = function (state) {
      // if autoControlsCombine is true, replace the current control with the new state
      if (slider.settings.autoControlsCombine) {
        slider.controls.autoEl.html(slider.controls[state]);
        // if autoControlsCombine is false, apply the "active" class to the appropriate control
      } else {
        slider.controls.autoEl.find("a").removeClass("active");
        slider.controls.autoEl
          .find("a:not(.bx-" + state + ")")
          .addClass("active");
      }
    };

    /**
     * Updates the direction controls (checks if either should be hidden)
     */
    var updateDirectionControls = function () {
      if (getPagerQty() === 1) {
        slider.controls.prev.addClass("disabled");
        slider.controls.next.addClass("disabled");
      } else if (
        !slider.settings.infiniteLoop &&
        slider.settings.hideControlOnEnd
      ) {
        // if first slide
        if (slider.active.index === 0) {
          slider.controls.prev.addClass("disabled");
          slider.controls.next.removeClass("disabled");
          // if last slide
        } else if (slider.active.index === getPagerQty() - 1) {
          slider.controls.next.addClass("disabled");
          slider.controls.prev.removeClass("disabled");
          // if any slide in the middle
        } else {
          slider.controls.prev.removeClass("disabled");
          slider.controls.next.removeClass("disabled");
        }
      }
    };
    /* auto start and stop functions */
    var windowFocusHandler = function () {
      el.startAuto();
    };
    var windowBlurHandler = function () {
      el.stopAuto();
    };
    /**
     * Initializes the auto process
     */
    var initAuto = function () {
      // if autoDelay was supplied, launch the auto show using a setTimeout() call
      if (slider.settings.autoDelay > 0) {
        var timeout = setTimeout(el.startAuto, slider.settings.autoDelay);
        // if autoDelay was not supplied, start the auto show normally
      } else {
        el.startAuto();

        //add focus and blur events to ensure its running if timeout gets paused
        $(window).focus(windowFocusHandler).blur(windowBlurHandler);
      }
      // if autoHover is requested
      if (slider.settings.autoHover) {
        // on el hover
        el.hover(
          function () {
            // if the auto show is currently playing (has an active interval)
            if (slider.interval) {
              // stop the auto show and pass true argument which will prevent control update
              el.stopAuto(true);
              // create a new autoPaused value which will be used by the relative "mouseout" event
              slider.autoPaused = true;
            }
          },
          function () {
            // if the autoPaused value was created be the prior "mouseover" event
            if (slider.autoPaused) {
              // start the auto show and pass true argument which will prevent control update
              el.startAuto(true);
              // reset the autoPaused value
              slider.autoPaused = null;
            }
          }
        );
      }
    };

    /**
     * Initializes the ticker process
     */
    var initTicker = function () {
      var startPosition = 0,
        position,
        transform,
        value,
        idx,
        ratio,
        property,
        newSpeed,
        totalDimens;
      // if autoDirection is "next", append a clone of the entire slider
      if (slider.settings.autoDirection === "next") {
        el.append(slider.children.clone().addClass("bx-clone"));
        // if autoDirection is "prev", prepend a clone of the entire slider, and set the left position
      } else {
        el.prepend(slider.children.clone().addClass("bx-clone"));
        position = slider.children.first().position();
        startPosition =
          slider.settings.mode === "horizontal"
            ? -position.left
            : -position.top;
      }
      setPositionProperty(startPosition, "reset", 0);
      // do not allow controls in ticker mode
      slider.settings.pager = false;
      slider.settings.controls = false;
      slider.settings.autoControls = false;
      // if autoHover is requested
      if (slider.settings.tickerHover) {
        if (slider.usingCSS) {
          idx = slider.settings.mode === "horizontal" ? 4 : 5;
          slider.viewport.hover(
            function () {
              transform = el.css("-" + slider.cssPrefix + "-transform");
              value = parseFloat(transform.split(",")[idx]);
              setPositionProperty(value, "reset", 0);
            },
            function () {
              totalDimens = 0;
              slider.children.each(function (index) {
                totalDimens +=
                  slider.settings.mode === "horizontal"
                    ? $(this).outerWidth(true)
                    : $(this).outerHeight(true);
              });
              // calculate the speed ratio (used to determine the new speed to finish the paused animation)
              ratio = slider.settings.speed / totalDimens;
              // determine which property to use
              property = slider.settings.mode === "horizontal" ? "left" : "top";
              // calculate the new speed
              newSpeed = ratio * (totalDimens - Math.abs(parseInt(value)));
              tickerLoop(newSpeed);
            }
          );
        } else {
          // on el hover
          slider.viewport.hover(
            function () {
              el.stop();
            },
            function () {
              // calculate the total width of children (used to calculate the speed ratio)
              totalDimens = 0;
              slider.children.each(function (index) {
                totalDimens +=
                  slider.settings.mode === "horizontal"
                    ? $(this).outerWidth(true)
                    : $(this).outerHeight(true);
              });
              // calculate the speed ratio (used to determine the new speed to finish the paused animation)
              ratio = slider.settings.speed / totalDimens;
              // determine which property to use
              property = slider.settings.mode === "horizontal" ? "left" : "top";
              // calculate the new speed
              newSpeed =
                ratio * (totalDimens - Math.abs(parseInt(el.css(property))));
              tickerLoop(newSpeed);
            }
          );
        }
      }
      // start the ticker loop
      tickerLoop();
    };

    /**
     * Runs a continuous loop, news ticker-style
     */
    var tickerLoop = function (resumeSpeed) {
      var speed = resumeSpeed ? resumeSpeed : slider.settings.speed,
        position = { left: 0, top: 0 },
        reset = { left: 0, top: 0 },
        animateProperty,
        resetValue,
        params;

      // if "next" animate left position to last child, then reset left to 0
      if (slider.settings.autoDirection === "next") {
        position = el.find(".bx-clone").first().position();
        // if "prev" animate left position to 0, then reset left to first non-clone child
      } else {
        reset = slider.children.first().position();
      }
      animateProperty =
        slider.settings.mode === "horizontal" ? -position.left : -position.top;
      resetValue =
        slider.settings.mode === "horizontal" ? -reset.left : -reset.top;
      params = { resetValue: resetValue };
      setPositionProperty(animateProperty, "ticker", speed, params);
    };

    /**
     * Check if el is on screen
     */
    var isOnScreen = function (el) {
      var win = $(window),
        viewport = {
          top: win.scrollTop(),
          left: win.scrollLeft(),
        },
        bounds = el.offset();

      viewport.right = viewport.left + win.width();
      viewport.bottom = viewport.top + win.height();
      bounds.right = bounds.left + el.outerWidth();
      bounds.bottom = bounds.top + el.outerHeight();

      return !(
        viewport.right < bounds.left ||
        viewport.left > bounds.right ||
        viewport.bottom < bounds.top ||
        viewport.top > bounds.bottom
      );
    };

    /**
     * Initializes keyboard events
     */
    var keyPress = function (e) {
      var activeElementTag = document.activeElement.tagName.toLowerCase(),
        tagFilters = "input|textarea",
        p = new RegExp(activeElementTag, ["i"]),
        result = p.exec(tagFilters);

      if (result == null && isOnScreen(el)) {
        if (e.keyCode === 39) {
          clickNextBind(e);
          return false;
        } else if (e.keyCode === 37) {
          clickPrevBind(e);
          return false;
        }
      }
    };

    /**
     * Initializes touch events
     */
    var initTouch = function () {
      // initialize object to contain all touch values
      slider.touch = {
        start: { x: 0, y: 0 },
        end: { x: 0, y: 0 },
      };
      slider.viewport.bind(
        "touchstart MSPointerDown pointerdown",
        onTouchStart
      );

      //for browsers that have implemented pointer events and fire a click after
      //every pointerup regardless of whether pointerup is on same screen location as pointerdown or not
      slider.viewport.on("click", ".bxslider a", function (e) {
        if (slider.viewport.hasClass("click-disabled")) {
          e.preventDefault();
          slider.viewport.removeClass("click-disabled");
        }
      });
    };

    /**
     * Event handler for "touchstart"
     *
     * @param e (event)
     *  - DOM event object
     */
    var onTouchStart = function (e) {
      //disable slider controls while user is interacting with slides to avoid slider freeze that happens on touch devices when a slide swipe happens immediately after interacting with slider controls
      slider.controls.el.addClass("disabled");

      if (slider.working) {
        e.preventDefault();
        slider.controls.el.removeClass("disabled");
      } else {
        // record the original position when touch starts
        slider.touch.originalPos = el.position();
        var orig = e.originalEvent,
          touchPoints =
            typeof orig.changedTouches !== "undefined"
              ? orig.changedTouches
              : [orig];
        // record the starting touch x, y coordinates
        slider.touch.start.x = touchPoints[0].pageX;
        slider.touch.start.y = touchPoints[0].pageY;
        var chromePointerEvents = typeof PointerEvent === "function";
        if (chromePointerEvents) {
          if (orig.pointerId === undefined) {
            return;
          }
        }
        if (slider.viewport.get(0).setPointerCapture) {
          slider.pointerId = orig.pointerId;
          slider.viewport.get(0).setPointerCapture(slider.pointerId);
        }
        // bind a "touchmove" event to the viewport
        slider.viewport.bind(
          "touchmove MSPointerMove pointermove",
          onTouchMove
        );
        // bind a "touchend" event to the viewport
        slider.viewport.bind("touchend MSPointerUp pointerup", onTouchEnd);
        slider.viewport.bind("MSPointerCancel pointercancel", onPointerCancel);
      }
    };

    /**
     * Cancel Pointer for Windows Phone
     *
     * @param e (event)
     *  - DOM event object
     */
    var onPointerCancel = function (e) {
      /* onPointerCancel handler is needed to deal with situations when a touchend
      doesn't fire after a touchstart (this happens on windows phones only) */
      setPositionProperty(slider.touch.originalPos.left, "reset", 0);

      //remove handlers
      slider.controls.el.removeClass("disabled");
      slider.viewport.unbind("MSPointerCancel pointercancel", onPointerCancel);
      slider.viewport.unbind(
        "touchmove MSPointerMove pointermove",
        onTouchMove
      );
      slider.viewport.unbind("touchend MSPointerUp pointerup", onTouchEnd);
      if (slider.viewport.get(0).releasePointerCapture) {
        slider.viewport.get(0).releasePointerCapture(slider.pointerId);
      }
    };

    /**
     * Event handler for "touchmove"
     *
     * @param e (event)
     *  - DOM event object
     */
    var onTouchMove = function (e) {
      var orig = e.originalEvent,
        touchPoints =
          typeof orig.changedTouches !== "undefined"
            ? orig.changedTouches
            : [orig],
        // if scrolling on y axis, do not prevent default
        xMovement = Math.abs(touchPoints[0].pageX - slider.touch.start.x),
        yMovement = Math.abs(touchPoints[0].pageY - slider.touch.start.y),
        value = 0,
        change = 0;

      // x axis swipe
      if (xMovement * 3 > yMovement && slider.settings.preventDefaultSwipeX) {
        e.preventDefault();
        // y axis swipe
      } else if (
        yMovement * 3 > xMovement &&
        slider.settings.preventDefaultSwipeY
      ) {
        e.preventDefault();
      }
      if (slider.settings.mode !== "fade" && slider.settings.oneToOneTouch) {
        // if horizontal, drag along x axis
        if (slider.settings.mode === "horizontal") {
          change = touchPoints[0].pageX - slider.touch.start.x;
          value = slider.touch.originalPos.left + change;
          // if vertical, drag along y axis
        } else {
          change = touchPoints[0].pageY - slider.touch.start.y;
          value = slider.touch.originalPos.top + change;
        }
        setPositionProperty(value, "reset", 0);
      }
    };

    /**
     * Event handler for "touchend"
     *
     * @param e (event)
     *  - DOM event object
     */
    var onTouchEnd = function (e) {
      slider.viewport.unbind(
        "touchmove MSPointerMove pointermove",
        onTouchMove
      );
      //enable slider controls as soon as user stops interacing with slides
      slider.controls.el.removeClass("disabled");
      var orig = e.originalEvent,
        touchPoints =
          typeof orig.changedTouches !== "undefined"
            ? orig.changedTouches
            : [orig],
        value = 0,
        distance = 0;
      // record end x, y positions
      slider.touch.end.x = touchPoints[0].pageX;
      slider.touch.end.y = touchPoints[0].pageY;
      // if fade mode, check if absolute x distance clears the threshold
      if (slider.settings.mode === "fade") {
        distance = Math.abs(slider.touch.start.x - slider.touch.end.x);
        if (distance >= slider.settings.swipeThreshold) {
          if (slider.touch.start.x > slider.touch.end.x) {
            el.goToNextSlide();
          } else {
            el.goToPrevSlide();
          }
          el.stopAuto();
        }
        // not fade mode
      } else {
        // calculate distance and el's animate property
        if (slider.settings.mode === "horizontal") {
          distance = slider.touch.end.x - slider.touch.start.x;
          value = slider.touch.originalPos.left;
        } else {
          distance = slider.touch.end.y - slider.touch.start.y;
          value = slider.touch.originalPos.top;
        }
        // if not infinite loop and first / last slide, do not attempt a slide transition
        if (
          !slider.settings.infiniteLoop &&
          ((slider.active.index === 0 && distance > 0) ||
            (slider.active.last && distance < 0))
        ) {
          setPositionProperty(value, "reset", 200);
        } else {
          // check if distance clears threshold
          if (Math.abs(distance) >= slider.settings.swipeThreshold) {
            if (distance < 0) {
              el.goToNextSlide();
            } else {
              el.goToPrevSlide();
            }
            el.stopAuto();
          } else {
            // el.animate(property, 200);
            setPositionProperty(value, "reset", 200);
          }
        }
      }
      slider.viewport.unbind("touchend MSPointerUp pointerup", onTouchEnd);
      if (slider.viewport.get(0).releasePointerCapture) {
        slider.viewport.get(0).releasePointerCapture(slider.pointerId);
      }
    };

    /**
     * Window resize event callback
     */
    var resizeWindow = function (e) {
      // don't do anything if slider isn't initialized.
      if (!slider.initialized) {
        return;
      }
      // Delay if slider working.
      if (slider.working) {
        window.setTimeout(resizeWindow, 10);
      } else {
        // get the new window dimens (again, thank you IE)
        var windowWidthNew = $(window).width(),
          windowHeightNew = $(window).height();
        // make sure that it is a true window resize
        // *we must check this because our dinosaur friend IE fires a window resize event when certain DOM elements
        // are resized. Can you just die already?*
        if (
          windowWidth !== windowWidthNew ||
          windowHeight !== windowHeightNew
        ) {
          // set the new window dimens
          windowWidth = windowWidthNew;
          windowHeight = windowHeightNew;
          // update all dynamic elements
          el.redrawSlider();
          // Call user resize handler
          slider.settings.onSliderResize.call(el, slider.active.index);
        }
      }
    };

    /**
     * Adds an aria-hidden=true attribute to each element
     *
     * @param startVisibleIndex (int)
     *  - the first visible element's index
     */
    var applyAriaHiddenAttributes = function (startVisibleIndex) {
      var numberOfSlidesShowing = getNumberSlidesShowing();
      // only apply attributes if the setting is enabled and not in ticker mode
      if (slider.settings.ariaHidden && !slider.settings.ticker) {
        // add aria-hidden=true to all elements
        slider.children.attr("aria-hidden", "true");
        // get the visible elements and change to aria-hidden=false
        slider.children
          .slice(startVisibleIndex, startVisibleIndex + numberOfSlidesShowing)
          .attr("aria-hidden", "false");
      }
    };

    /**
     * Returns index according to present page range
     *
     * @param slideOndex (int)
     *  - the desired slide index
     */
    var setSlideIndex = function (slideIndex) {
      if (slideIndex < 0) {
        if (slider.settings.infiniteLoop) {
          return getPagerQty() - 1;
        } else {
          //we don't go to undefined slides
          return slider.active.index;
        }
        // if slideIndex is greater than children length, set active index to 0 (this happens during infinite loop)
      } else if (slideIndex >= getPagerQty()) {
        if (slider.settings.infiniteLoop) {
          return 0;
        } else {
          //we don't move to undefined pages
          return slider.active.index;
        }
        // set active index to requested slide
      } else {
        return slideIndex;
      }
    };

    /**
     * ===================================================================================
     * = PUBLIC FUNCTIONS
     * ===================================================================================
     */

    /**
     * Performs slide transition to the specified slide
     *
     * @param slideIndex (int)
     *  - the destination slide's index (zero-based)
     *
     * @param direction (string)
     *  - INTERNAL USE ONLY - the direction of travel ("prev" / "next")
     */
    el.goToSlide = function (slideIndex, direction) {
      // onSlideBefore, onSlideNext, onSlidePrev callbacks
      // Allow transition canceling based on returned value
      var performTransition = true,
        moveBy = 0,
        position = { left: 0, top: 0 },
        lastChild = null,
        lastShowingIndex,
        eq,
        value,
        requestEl;
      // store the old index
      slider.oldIndex = slider.active.index;
      //set new index
      slider.active.index = setSlideIndex(slideIndex);

      // if plugin is currently in motion, ignore request
      if (slider.working || slider.active.index === slider.oldIndex) {
        return;
      }
      // declare that plugin is in motion
      slider.working = true;

      performTransition = slider.settings.onSlideBefore.call(
        el,
        slider.children.eq(slider.active.index),
        slider.oldIndex,
        slider.active.index
      );

      // If transitions canceled, reset and return
      if (typeof performTransition !== "undefined" && !performTransition) {
        slider.active.index = slider.oldIndex; // restore old index
        slider.working = false; // is not in motion
        return;
      }

      if (direction === "next") {
        // Prevent canceling in future functions or lack there-of from negating previous commands to cancel
        if (
          !slider.settings.onSlideNext.call(
            el,
            slider.children.eq(slider.active.index),
            slider.oldIndex,
            slider.active.index
          )
        ) {
          performTransition = false;
        }
      } else if (direction === "prev") {
        // Prevent canceling in future functions or lack there-of from negating previous commands to cancel
        if (
          !slider.settings.onSlidePrev.call(
            el,
            slider.children.eq(slider.active.index),
            slider.oldIndex,
            slider.active.index
          )
        ) {
          performTransition = false;
        }
      }

      // check if last slide
      slider.active.last = slider.active.index >= getPagerQty() - 1;
      // update the pager with active class
      if (slider.settings.pager || slider.settings.pagerCustom) {
        updatePagerActive(slider.active.index);
      }
      // // check for direction control update
      if (slider.settings.controls) {
        updateDirectionControls();
      }
      // if slider is set to mode: "fade"
      if (slider.settings.mode === "fade") {
        // if adaptiveHeight is true and next height is different from current height, animate to the new height
        if (
          slider.settings.adaptiveHeight &&
          slider.viewport.height() !== getViewportHeight()
        ) {
          slider.viewport.animate(
            { height: getViewportHeight() },
            slider.settings.adaptiveHeightSpeed
          );
        }
        // fade out the visible child and reset its z-index value
        slider.children
          .filter(":visible")
          .fadeOut(slider.settings.speed)
          .css({ zIndex: 0 });
        // fade in the newly requested slide
        slider.children
          .eq(slider.active.index)
          .css("zIndex", slider.settings.slideZIndex + 1)
          .fadeIn(slider.settings.speed, function () {
            $(this).css("zIndex", slider.settings.slideZIndex);
            updateAfterSlideTransition();
          });
        // slider mode is not "fade"
      } else {
        // if adaptiveHeight is true and next height is different from current height, animate to the new height
        if (
          slider.settings.adaptiveHeight &&
          slider.viewport.height() !== getViewportHeight()
        ) {
          slider.viewport.animate(
            { height: getViewportHeight() },
            slider.settings.adaptiveHeightSpeed
          );
        }
        // if carousel and not infinite loop
        if (
          !slider.settings.infiniteLoop &&
          slider.carousel &&
          slider.active.last
        ) {
          if (slider.settings.mode === "horizontal") {
            // get the last child position
            lastChild = slider.children.eq(slider.children.length - 1);
            position = lastChild.position();
            // calculate the position of the last slide
            moveBy = slider.viewport.width() - lastChild.outerWidth();
          } else {
            // get last showing index position
            lastShowingIndex =
              slider.children.length - slider.settings.minSlides;
            position = slider.children.eq(lastShowingIndex).position();
          }
          // horizontal carousel, going previous while on first slide (infiniteLoop mode)
        } else if (
          slider.carousel &&
          slider.active.last &&
          direction === "prev"
        ) {
          // get the last child position
          eq =
            slider.settings.moveSlides === 1
              ? slider.settings.maxSlides - getMoveBy()
              : (getPagerQty() - 1) * getMoveBy() -
                (slider.children.length - slider.settings.maxSlides);
          lastChild = el.children(".bx-clone").eq(eq);
          position = lastChild.position();
          // if infinite loop and "Next" is clicked on the last slide
        } else if (direction === "next" && slider.active.index === 0) {
          // get the last clone position
          position = el
            .find("> .bx-clone")
            .eq(slider.settings.maxSlides)
            .position();
          slider.active.last = false;
          // normal non-zero requests
        } else if (slideIndex >= 0) {
          //parseInt is applied to allow floats for slides/page
          requestEl = slideIndex * parseInt(getMoveBy());
          position = slider.children.eq(requestEl).position();
        }

        /* If the position doesn't exist
         * (e.g. if you destroy the slider on a next click),
         * it doesn't throw an error.
         */
        if (typeof position !== "undefined") {
          value =
            slider.settings.mode === "horizontal"
              ? -(position.left - moveBy)
              : -position.top;
          // plugin values to be animated
          setPositionProperty(value, "slide", slider.settings.speed);
        }
        slider.working = false;
      }
      if (slider.settings.ariaHidden) {
        applyAriaHiddenAttributes(slider.active.index * getMoveBy());
      }
    };

    /**
     * Transitions to the next slide in the show
     */
    el.goToNextSlide = function () {
      // if infiniteLoop is false and last page is showing, disregard call
      if (!slider.settings.infiniteLoop && slider.active.last) {
        return;
      }
      if (slider.working == true) {
        return;
      }
      var pagerIndex = parseInt(slider.active.index) + 1;
      el.goToSlide(pagerIndex, "next");
    };

    /**
     * Transitions to the prev slide in the show
     */
    el.goToPrevSlide = function () {
      // if infiniteLoop is false and last page is showing, disregard call
      if (!slider.settings.infiniteLoop && slider.active.index === 0) {
        return;
      }
      if (slider.working == true) {
        return;
      }
      var pagerIndex = parseInt(slider.active.index) - 1;
      el.goToSlide(pagerIndex, "prev");
    };

    /**
     * Starts the auto show
     *
     * @param preventControlUpdate (boolean)
     *  - if true, auto controls state will not be updated
     */
    el.startAuto = function (preventControlUpdate) {
      // if an interval already exists, disregard call
      if (slider.interval) {
        return;
      }
      // create an interval
      slider.interval = setInterval(function () {
        if (slider.settings.autoDirection === "next") {
          el.goToNextSlide();
        } else {
          el.goToPrevSlide();
        }
      }, slider.settings.pause);
      //allback for when the auto rotate status changes
      slider.settings.onAutoChange.call(el, true);
      // if auto controls are displayed and preventControlUpdate is not true
      if (slider.settings.autoControls && preventControlUpdate !== true) {
        updateAutoControls("stop");
      }
    };

    /**
     * Stops the auto show
     *
     * @param preventControlUpdate (boolean)
     *  - if true, auto controls state will not be updated
     */
    el.stopAuto = function (preventControlUpdate) {
      // if no interval exists, disregard call
      if (!slider.interval) {
        return;
      }
      // clear the interval
      clearInterval(slider.interval);
      slider.interval = null;
      //allback for when the auto rotate status changes
      slider.settings.onAutoChange.call(el, false);
      // if auto controls are displayed and preventControlUpdate is not true
      if (slider.settings.autoControls && preventControlUpdate !== true) {
        updateAutoControls("start");
      }
    };

    /**
     * Returns current slide index (zero-based)
     */
    el.getCurrentSlide = function () {
      return slider.active.index;
    };

    /**
     * Returns current slide element
     */
    el.getCurrentSlideElement = function () {
      return slider.children.eq(slider.active.index);
    };

    /**
     * Returns a slide element
     * @param index (int)
     *  - The index (zero-based) of the element you want returned.
     */
    el.getSlideElement = function (index) {
      return slider.children.eq(index);
    };

    /**
     * Returns number of slides in show
     */
    el.getSlideCount = function () {
      return slider.children.length;
    };

    /**
     * Return slider.working variable
     */
    el.isWorking = function () {
      return slider.working;
    };

    /**
     * Update all dynamic slider elements
     */
    el.redrawSlider = function () {
      // resize all children in ratio to new screen size
      slider.children.add(el.find(".bx-clone")).outerWidth(getSlideWidth());
      // adjust the height
      slider.viewport.css("height", getViewportHeight());
      // update the slide position
      if (!slider.settings.ticker) {
        setSlidePosition();
      }
      // if active.last was true before the screen resize, we want
      // to keep it last no matter what screen size we end on
      if (slider.active.last) {
        slider.active.index = getPagerQty() - 1;
      }
      // if the active index (page) no longer exists due to the resize, simply set the index as last
      if (slider.active.index >= getPagerQty()) {
        slider.active.last = true;
      }
      // if a pager is being displayed and a custom pager is not being used, update it
      if (slider.settings.pager && !slider.settings.pagerCustom) {
        populatePager();
        updatePagerActive(slider.active.index);
      }
      if (slider.settings.ariaHidden) {
        applyAriaHiddenAttributes(slider.active.index * getMoveBy());
      }
    };

    /**
     * Destroy the current instance of the slider (revert everything back to original state)
     */
    el.destroySlider = function () {
      // don't do anything if slider has already been destroyed
      if (!slider.initialized) {
        return;
      }
      slider.initialized = false;
      $(".bx-clone", this).remove();
      slider.children.each(function () {
        if ($(this).data("origStyle") !== undefined) {
          $(this).attr("style", $(this).data("origStyle"));
        } else {
          $(this).removeAttr("style");
        }
      });
      if ($(this).data("origStyle") !== undefined) {
        this.attr("style", $(this).data("origStyle"));
      } else {
        $(this).removeAttr("style");
      }
      $(this).unwrap().unwrap();
      if (slider.controls.el) {
        slider.controls.el.remove();
      }
      if (slider.controls.next) {
        slider.controls.next.remove();
      }
      if (slider.controls.prev) {
        slider.controls.prev.remove();
      }
      if (
        slider.pagerEl &&
        slider.settings.controls &&
        !slider.settings.pagerCustom
      ) {
        slider.pagerEl.remove();
      }
      $(".bx-caption", this).remove();
      if (slider.controls.autoEl) {
        slider.controls.autoEl.remove();
      }
      clearInterval(slider.interval);
      if (slider.settings.responsive) {
        $(window).unbind("resize", resizeWindow);
      }
      if (slider.settings.keyboardEnabled) {
        $(document).unbind("keydown", keyPress);
      }
      //remove self reference in data
      $(this).removeData("bxSlider");
      // remove global window handlers
      $(window).off("blur", windowBlurHandler).off("focus", windowFocusHandler);
    };

    /**
     * Reload the slider (revert all DOM changes, and re-initialize)
     */
    el.reloadSlider = function (settings) {
      if (settings !== undefined) {
        options = settings;
      }
      el.destroySlider();
      init();
      //store reference to self in order to access public functions later
      $(el).data("bxSlider", this);
    };

    init();

    $(el).data("bxSlider", this);

    // returns the current jQuery object
    return this;
  };
})(jQuery);

/* End of bxSlider */



/*============================================================================
    Home page - social media
  ==============================================================================*/

var social = {
  twitter: function () {
    if (!window.twttr) {
      //Initialize twitter feed
      window.twttr = (function (d, s, id) {
        var t,
          js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s);
        js.id = id;
        js.src = "https://platform.twitter.com/widgets.js";
        fjs.parentNode.insertBefore(js, fjs);
        return (
          window.twttr ||
          (t = {
            _e: [],
            ready: function (f) {
              t._e.push(f);
            },
          })
        );
      })(document, "script", "twitter-wjs");
    }

    if (window.twttr) {
      window.twttr.ready(function (twttr) {
        twttr.widgets.load(document.getElementById("twitter-timeline"));
      });
    }
  },
  unload: function () {},
};

var instagram = {
  loadContent: function (s) {
    if (s.clientID) {
      var url =
        "https://api.instagram.com/v1/users/self/media/recent/?access_token=" +
        s.clientID;

      $.ajax({
        type: "GET",
        url: url,
        dataType: "jsonp",
        success: function (data) {
          if (data.meta.code === 200 && data.data.length) {
            var data = data.data;
            var count = 0;
            s.el.empty();

            for (var i = 0; i < data.length; i++) {
              var thisMedia = data[i],
                item;

              var url = thisMedia.images.low_resolution.url;

              if (!thisMedia.images.low_resolution.url.indexOf("null") > -1) {
                item =
                  '<div class="il-photo__img instagram__bg" style="background-image:url(' +
                  url +
                  ')" data-filter="' +
                  thisMedia.filter +
                  '" /></div>';
                item =
                  '<a href="' +
                  thisMedia.link +
                  '" target="_blank" class="instagram__link">' +
                  item +
                  "</a>";
              }

              if (thisMedia.videos) {
                item =
                  '<div class="instagram__video instagram__bg" style="background-image:url(' +
                  url +
                  ')" data-filter="' +
                  thisMedia.filter +
                  '" /></div>';
                item =
                  '<a href="' +
                  thisMedia.link +
                  '" target="_blank" class="instagram__link instagram__video-link">' +
                  item +
                  "</a>";
              }

              if (item) {
                item =
                  '<div class="four columns instagram__item">' +
                  item +
                  "</div>";
              }
              if (item !== "") {
                s.el.append(item);
                count++;
              }
              if (count == s.limit) {
                break;
              }
            }
          }
        },
        error: function () {},
      });
    }
  },
};

$(".social-feeds-wrap").each(function (index, value) {
  social.twitter();

  var $target = $(this).find(".js-instafeed");
  instagram.loadContent({
    el: $target,
    clientID: $target.data("client-id"),
    limit: $target.data("count"),
  });
});
$(document).on("shopify:block:select", function (e) {
  var blockId = e.detail.blockId;
  var $parentSection = $("#shopify-section-" + e.detail.sectionId);

  if (
    $parentSection.hasClass("slideshow-section") ||
    $parentSection.hasClass("testimonial-section")
  ) {
    sliderBlock.select(blockId, $parentSection);
  }

  utils.resizeActionButtons();
});

$(document).on("shopify:block:deselect", function (e) {
  var $parentSection = $("#shopify-section-" + e.detail.sectionId);

  if (
    $parentSection.hasClass("slideshow-section") ||
    $parentSection.hasClass("testimonial-section")
  ) {
    sliderBlock.deselect($parentSection);
  }
});

$(document).on("shopify:section:reorder", function (e) {
  utils.pageBannerCheck();
});

$(document).on("shopify:section:load", function (e) {
  var $parentSection = $("#shopify-section-" + e.detail.sectionId);

  utils.pageBannerCheck();

  if ($parentSection.hasClass("social-feeds-section")) {
    $(".social-feeds-wrap").each(function (index, value) {
      social.twitter();

      var $target = $(this).find(".js-instafeed");
      instagram.loadContent({
        el: $target,
        clientID: $target.data("client-id"),
        limit: $target.data("count"),
      });
    });
  }

  if ($parentSection.hasClass("faq-section")) {
    faqAccordion.init();
  }

  if ($parentSection.hasClass("cart-section")) {
    cart.init();
  }

  if ($parentSection.hasClass("featured-promotions-section")) {
    featuredPromotions.init();
  }

  if ($parentSection.hasClass("slideshow-section")) {
    slideshow.init();
  }

  if ($parentSection.hasClass("testimonial-section")) {
    testimonial.init();
  }

  if ($parentSection.hasClass("image-gallery-section")) {
    gallery.init();
  }

  if ($parentSection.hasClass("featured-products-section")) {
    productPage.initializeQuantityBox();
    productPage.init();
  }

  if ($parentSection.hasClass("featured-collection-section")) {
    featuredCollectionSection.init();
  }

  if ($parentSection.hasClass("video-section")) {
    videoSection.init();
  }

  if ($parentSection.hasClass("recently-viewed")) {
    recentlyViewed.init(".js-recently-viewed");
  }

  if ($parentSection.hasClass("product-template")) {
    productPage.init();
    productPage.relatedProducts();
    recentlyViewed.init();
  }

  if ($parentSection.hasClass("article-template-section")) {
    if (window.location.pathname.indexOf("/comments") != -1) {
      $("html,body").animate(
        { scrollTop: $("#new-comment").offset().top - 140 },
        "slow"
      );
    }
  }

  if ($parentSection.hasClass("collection-template-section")) {
    collectionSidebarFilter.init();
  }

  if ($parentSection.hasClass("search-template-section")) {
    collection.init();
  }

  if ($parentSection.hasClass("header-section")) {
    header.init();
    header.loadMegaMenu();
  }

  if ($parentSection.hasClass("mega-menu-section")) {
    header.loadMegaMenu();
  }

  if ($parentSection.hasClass("page-details-section")) {
    featuredCollectionSection.init();
    videoSection.init();
  }
});

$(document).on("shopify:section:unload", function (e) {
  var $target = $(e.target);
  var $parentSection = $("#shopify-section-" + e.detail.sectionId);

  if ($parentSection.hasClass("header-section")) {
    header.unload($target);
    header.unloadMegaMenu();
  }

  if ($parentSection.hasClass("slideshow-section")) {
    slideshow.unload($target);
  }

  if ($parentSection.hasClass("testimonial-section")) {
    testimonial.unload($target);
  }

  if ($parentSection.hasClass("video-section")) {
    videoSection.unload($target);
  }

  if ($parentSection.hasClass("product-template")) {
    productPage.unload($target);
  }

  if ($parentSection.hasClass("mega-menu-section")) {
    header.unloadMegaMenu();
  }

  if ($parentSection.hasClass("page-details-section")) {
    videoSection.unload($target);
  }
});

$(document).on("shopify:section:select", function (e) {
  var $parentSection = $("#shopify-section-" + e.detail.sectionId);

  if ($parentSection.hasClass("social-feeds-section")) {
    $(".social-feeds-wrap").each(function (index, value) {
      social.twitter();
    });
  }

  if ($parentSection.hasClass("mega-menu-section")) {
    var megaMenuParent = $(".header ." + e.detail.sectionId).data("dropdown");
    setTimeout(function () {
      $(
        'a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]'
      ).trigger("mouseenter");
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]')
        .parents("header")
        .addClass("editor-hover--true");
      header.removeDataAttributes(
        ".header .mega-menu.dropdown_container .dropdown_column"
      );
    }, 10);
  }

  if ($parentSection.hasClass("featured-collection-section")) {
    featuredCollectionSection.unload($parentSection);
    featuredCollectionSection.init();
  }

  utils.pageBannerCheck();
  var evt = document.createEvent("UIEvents");
  evt.initUIEvent("resize", true, false, window, 0);
  window.dispatchEvent(evt);
});

$(document).on("shopify:section:deselect", function (e) {
  var $parentSection = $("#shopify-section-" + e.detail.sectionId);

  if ($parentSection.hasClass("mega-menu-section")) {
    var megaMenuParent = $(".header ." + e.detail.sectionId).data("dropdown");
    $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger(
      "mouseout"
    );
    $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]')
      .parents("header")
      .removeClass("editor-hover--true");
  }
});

/* Friend buy Trigger
=============================================================================*/

/*For Review button placement 
==================================================================================*/
$(document).on("DOMNodeInserted", ".yotpo.yotpo-main-widget", function () {
  $(
    ".yotpo.yotpo-main-widget .yotpo-regular-box.yotpo-bottomline.yotpo-bottomline-2-boxes"
  )
    .children(
      ".yotpo.yotpo-main-widget .write-question-button.yotpo-default-button"
    )
    .insertBefore(
      ".yotpo.yotpo-main-widget .yotpo-label.yotpo-small-box:first .yotpo-logo-line"
    );
  $(
    ".yotpo.yotpo-main-widget .yotpo-regular-box.yotpo-bottomline.yotpo-bottomline-2-boxes"
  )
    .children(
      ".yotpo.yotpo-main-widget .write-review-button.yotpo-default-button"
    )
    .insertBefore(
      ".yotpo.yotpo-main-widget .yotpo-label.yotpo-small-box:first .yotpo-logo-line"
    );
});

$(document).on("DOMNodeInserted", ".social_front", function () {
  $(".social h4").remove();
  $("#customer_login").insertAfter(".social_front");
  $("#create_customer").insertAfter(".social_front");
});

$(document).on(
  "DOMNodeInserted",
  ".product_section .yotpo-slider",
  function () {
    var slider_images = $(this).find(".yotpo-display-wrapper").data("images");
    if (slider_images <= 3) {
      $(this).addClass("yotpo-custom-margin");
    } else {
      $(this).removeClass("yotpo-custom-margin");
    }
  }
);

$(".newsletter-cont-btn, a.juno-trigger").click(function (e) {
  e.preventDefault();
  $(".ju_tab_text").trigger("click");
});

$(".friendbuy-popup").click(function (e) {
  //   e.preventDefault();
  $('div[id$="ribbon_container"]').trigger("click");
});
/* Friend buy  Insert Promo in category pages at nth position
=============================================================================*/

// 	if(is_home != 'index'){
//      $(document).on('DOMNodeInserted', 'div[id$="ribbon_container"]', function() {
//        if (!$('.product-list').find('a.friendbuy-trigger').length > 0) {
//          $('.product-list').children(':eq(3)').after('<div class="four columns alpha thumbnail"> <div class="product-wrap"><a href="javascript:void(0)" class="friendbuy-trigger"><img src="//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif"></a></div></div>');
//        }
//        $('.friendbuy-trigger').click(function(e) {
//          e.preventDefault();
//          $('.on-screen .toggle-mobile-menu').trigger('click');
//          $('div[id$="ribbon_container"]').trigger('click');
//        });
//      });
//     }

(function ($) {
  //     var element = $('.follow-scroll'),
  //         originalY = element.offset().top;

  //     // Space between element and top of screen (when scrolling)
  //     var topMargin = 60;

  //     // Should probably be set in CSS; but here just for emphasis
  //     element.css('position', 'relative');

  //     $(window).on('scroll', function(event) {
  //         var scrollTop = $(window).scrollTop();

  //         element.stop(false, false).animate({
  //             top: scrollTop < originalY
  //                     ? 0
  //                     : scrollTop - originalY + topMargin
  //         }, 300);
  //     });
  $("div.mobile-menu").css("display", "block");
  if ($(window).width() <= 798) {
    $("div.w3-sidebar ul.cart_items").addClass("fixed-mini-cart");
  }

  //   $('.write-review-button').removeAttr('class');
})(jQuery);
window.onresize = function (event) {
  viewportwidth = $(window).width();
  if (viewportwidth < 700) {
    if (!$("div.w3-sidebar ul.cart_items").hasClass("fixed-mini-cart")) {
      $("div.w3-sidebar ul.cart_items").addClass("fixed-mini-cart");
    }
    // some jquery stuff here;
  } else {
    $("div.w3-sidebar ul.cart_items").removeClass("fixed-mini-cart");
  }
};

//   $(window).scroll(function () {
//     if ($(window).scrollTop() >= 300)
//     {
//       $(".subtotal").addClass("subtotal-box");
//     }
//     else
//     {
//       $(".subtotal").removeClass("subtotal-box");
//     }

//   });

function get_minicart_notify() {
  //     NudgeFlush();
  window.appn.notification_shown = false;
  for (var i = "", t = 0; t < document.scripts.length; t++)
    document.scripts[t].src.indexOf("notifications-v") > -1 &&
      (i = utilGetParameterByName(
        "shop",
        "?" + document.scripts[t].src.split("?")[1]
      ));
  (i = i.replace(".myshopify.com", "")),
    (window.appn = {
      shop: i,
      api_get:
        "https://notificationssg.herokuapp.com/api/v1/shop-notifications",
      shop_notifications_shown: [],
      notifications: [],
      settings: {},
      cart_total_price: 0,
    }),
    "dev" == utilGetParameterByName("env") &&
      (window.appn.api_get =
        "https://localhost:5000/api/v1/shop-notifications"),
    jQuery.ajax({
      cache: !1,
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      type: "GET",
      url: "/cart.js",
      success: function (i) {
        (window.appn.cart_total_price = i.total_price / 100),
          startNotifications(),
          jQuery("#shop-notification").show();
      },
    });
}

$(document).ready(function () {
  $(".filter-group ul.toggle_list").hide();
  var HideShowFilter = function () {
    $(".cart_container .cart_content").show();
    $("#mySidebar").css("transform", "translateX(0px)");
    $("#myOverlay").fadeIn();
  };
  $("body").on("click", "[data-cart-open]", function () {
    console.log("data cart open cliked");
    var _cart_json = $.getJSON("/cart.json");
    _cart_json.then(function (cart) {
      trackViewCart(cart);
    });
  });
  /* Track GA select_content event */
  // $(document).on("click", "[data-productJson]", function (e) {
  //   var product = JSON.parse($(this).attr("data-productJson")),
  //     collectionHandle = $(this).attr("data-collection-handle"),
  //     collectionName = $(this).attr("data-collection-name");
  //   // console.log(product);
  //   _index = 0;
  //   try {
  //     var _items = [];
  //     var item_id = `shopify_US_${product.id}_${product.variants[0].id}`;
  //     _items.push({
  //       item_id: item_id,
  //       item_name: product.title,
  //       item_list_id: collectionHandle,
  //       item_list_name: collectionName,
  //       currency: theme.settings.currency,
  //       index: _index,
  //       item_brand: theme.settings.shopName,
  //       item_category: product.type,
  //       item_variant: product.variants[0].title,
  //       price: product.price / 100,
  //       quantity: 1,
  //     });
  //     gtag("event", "select_item", {
  //       item_list_id: collectionHandle,
  //       item_list_name: collectionName,
  //       currency: theme.settings.currency,
  //       value: product.price / 100,
  //       items: _items,
  //     });
  //   } catch (ex) {
  //     console.log("GA select_item ", ex);
  //   }
  //   return true;
  // });
  /* Track GA select_content event */
  $("#open_filter").on("click", HideShowFilter);
  $("#open_mble_cart").on("click", HideShowFilter);

  $("#close_sidebar").on("click", function () {
    $("#mySidebar").css("transform", "translateX(100%)");
    $("#myOverlay").fadeOut();
  });

  $(".close_sidebar").on("click", function (e) {
    e.preventDefault();
    $("#mySidebar").css("transform", "translateX(100%)");
    $("#myOverlay").fadeOut();
  });

  $("#myOverlay").on("click", function () {
    $("#mySidebar").css("transform", "translateX(100%)");
    $("#myOverlay").fadeOut();
  });
  $("#customer_login").show();

  $("#forgot-pwd-btn").on("click", function () {
    $("#login_form").hide();
    $(".recover-password").show();
  });
  $("#forgot-cancel-btn").on("click", function () {
    $("#login_form").show();
    $(".recover-password").hide();
  });

  if (window.location.hash == "#recover") {
    $("#login_form").hide();
    $(".recover-password").show();
  }

  //----- OPEN
  $("#forgot-pwd-btn-popup").on("click", function () {
    $("#popup_login_form").hide();
    $(".recover-password-popup").show();
  });
  $("#forgot-cancel-btn-popup").on("click", function () {
    $("#popup_login_form").show();
    $(".recover-password-popup").hide();
  });
  $("#popup-register-btn").on("click", function () {
    $("#popup_login_form").hide();
    $("#popup_register_form").show();
    //$('.popup-inner').addClass('margin-top65');
    //$('.popup-inner').addClass('margin-bottom10');
  });
  $("#popup-login-btn").on("click", function () {
    $("#popup_login_form").show();
    $("#popup_register_form").hide();
    //$('.popup-inner').removeClass('margin-top65');
    //$('.popup-inner').removeClass('margin-bottom10');
  });

  $("[data-popup-open]").on("click", function (e) {
    $("#popup_login_form").show();
    $("div.login-popup-overlay").show();
    $(".recover-password-popup").hide();
    $("#popup_register_form").hide();
    var targeted_popup_class = jQuery(this).attr("data-popup-open");
    $('[data-popup="' + targeted_popup_class + '"]').fadeIn(350);

    e.preventDefault();
  });
  //----- CLOSE
  $("[data-popup-close]").on("click", function (e) {
    $("div.login-popup-overlay").hide();
    var targeted_popup_class = jQuery(this).attr("data-popup-close");
    $('[data-popup="' + targeted_popup_class + '"]').fadeOut(350);
    e.preventDefault();
  });
  $("div.login-popup-overlay").on("click", function (e) {});
  //     $('#mobile_menu span.icon-submit').click(function(e) {
  //       $('form.header_search_form').submit();
  //       e.preventDefault();
  //     });
  //      $('body').on("click", '.popup', function() {
  //       var targeted_popup_class = 'popup-1';
  //       $('[data-popup="' + targeted_popup_class + '"]').fadeOut(350);
  //       $('div.login-popup-overlay').hide();
  //       e.preventDefault();
  //      });

  /*Like2Have Image modal open*/

  /*Ajax Contact form post */
});
$(function () {
  //Lightbox default options
  //https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = "fade";
  $.fancybox.defaults.transitionEffect = "fade";
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ["close"];
  $.fancybox.defaults.mobile.clickSlide = "close";
  $.fancybox.defaults.mobile.clickContent = "zoom";
  $.fancybox.defaults.afterLoad = function (instance, slide) {
    //     console.log(slide)
    if ($(window).width() > 798) {
      var pixelRatio = window.devicePixelRatio || 1;

      if (pixelRatio > 1.5) {
        slide.width = slide.width / pixelRatio;
        slide.height = slide.height / pixelRatio;
      }
    }

    //     $(window).on('resize',function(){
    //       if($(window).width()>798){
    //         var pixelRatio = window.devicePixelRatio || 1;

    //         if ( pixelRatio > 1.5 ) {
    //           slide.width  = slide.width  / pixelRatio;
    //           slide.height = slide.height / pixelRatio;
    //         }
    //       }
    //     })
    if (instance.current.type == "image") {
      slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>");
    }
    if (instance.group.length > 1) {
      slide.$content
        .find(".fancybox-image-wrap")
        .append(
          '<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>' +
            svgArrowSizeLeft +
            '</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>' +
            svgArrowSizeRight +
            "</span></a>"
        );
    }
  };

  //backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();
  if ($(window).width() <= 798) {
    $('[rel="product-lightbox"]').fancybox();
  } else {
    $('[rel="product-lightbox"]').fancybox({
      width: "800",
      height: "800",
    });
  }

  if ($(window).width() < 798) {
    $('[rel="product-lightbox"]').fancybox({
      width: 550,
      height: 800,
    });
  }
  $(window).on("resize", function () {
    if ($(window).width() < 798) {
      $('[rel="product-lightbox"]').fancybox({
        width: 550,
        height: 800,
      });
    }
  });

  $("form.search_form,form.header_search_form").on("submit", function () {
    var val = $(this).find('input[name="q"]').val().length;
    console.log(val);
    if (val <= 0) {
      return false;
    }
  });

  /* $("#show_contact_form").on('click',function(e){      
    	$('form.jotform-contactform').show();   
      	$('form.jotform-wholesale-form').show();      
      	$('form.jotform-custom-screen-cleansers').show();
      	$('.form-success-msg').hide();
    }) */
  /* $('form[name="form_81264052351448"]').submit(function (e) {
      var formdata = $('form[name="form_81264052351448"]').serialize();
      $.ajax({  
        url: 'https://submit.jotform.me/submit/81264052351448/',  
        type: 'post',
        data: formdata,
        beforeSend:function(){
          
        },
        success: function(data) {          
          $('.form-success-msg').show();
          $("#q3_name").val('');$("#q4_email").val('');$("#q5_company").val('');$("#q6_phoneNumber").val('');$("#q7_message").val('');
          $('form.jotform-contactform').hide();
        },
        error:function(err){
          console.log(JSON.stringify(err))
        }
      });
      e.preventDefault();
      return true;  
      
    });  */
  /* Wholsale jotform submit via ajax */
  /* $('form.jotform-wholesale-form').submit(function (e) {
      var formdata = $('form[name="form_81264366651459"]').serialize();
      $.ajax({  
        url: 'https://submit.jotform.me/submit/81264366651459/',  
        type: 'post',
        data: formdata,
        beforeSend:function(){

        },
        success: function(data) {          
          $('.form-success-msg').show();
          $("#q3_name").val('');$("#q4_email").val('');$("#q5_company").val('');$("#q6_phoneNumber").val('');$("#q7_message").val('');
          $('form.jotform-wholesale-form').hide();
        },
        error:function(err){
          console.log(JSON.stringify(err))
        }
      });
      e.preventDefault();
      return true;  

    }); */
  /* custom screen cleanser jotform submit via ajax */
  /* $('form.jotform-custom-screen-cleansers').submit(function (e) {
      var formdata = $('form[name="form_81264184551456"]').serialize();
      $.ajax({  
        url: 'https://submit.jotform.me/submit/81264184551456/',  
        type: 'post',
        data: formdata,
        beforeSend:function(){

        },
        success: function(data) {          
          $('h2.form-success-msg').show();
          $("#q3_name").val('');$("#q4_email").val('');$("#q5_company").val('');$("#q6_phoneNumber").val('');$("#q7_message").val('');
          $('form.jotform-custom-screen-cleansers').hide();
        },
        error:function(err){
          console.log(JSON.stringify(err))
        }
      });
      e.preventDefault();
      return true;  

    }); */
});

function updateCartMsg() {
  console.log("UPDATE CART MESSAGE");
  jQuery.ajax({
    type: "Get",
    url: "/cart.js",
    data: {},
    dataType: "json",
    success: function () {
      $("#promo-title").css("display", "none");
      for (i = 0; i < this.success.arguments[0].items.length; i++) {
        item = this.success.arguments[0].items[i];
        if (item.product_type == "Phone Case") {
          $("#promo-title").css("display", "block");
          break;
        }
      }
    },
  });
}

//FREE SHIPPING BAR JS
var fsb_adjusted = false;
$("#fsb_placeholder").on("fsb_fully_loaded", function (event, p1) {
  if ((p1 == "inserted" || p1 == "inserted_sticky") && !fsb_adjusted) {
    fsb_adjusted = true;
    var fsb_height = $("#fsb_bar").outerHeight();
    //       $("<div />", {html: '<style>' + '.header.is-absolute,#header.mobile_nav-fixed--true,.sticky_nav{top:' + fsb_height + 'px!important;}' + '@media(max-width: 768px){div.breadcrumb-collection{padding-top:' + fsb_height + 'px;}' + '#pagecontent{display:block;margin-top:' + fsb_height + 'px!important;}}' + '</style>'}).appendTo("body");
  }
  $("#fsb_close").on("click", function () {
    // $("<div />", {html: '<style>' + '.header.is-absolute,#header.mobile_nav-fixed--true,.sticky_nav{top:0!important;}@media(max-width: 768px){div.breadcrumb-collection{padding-top:0;}#pagecontent{margin-top:0!important;}}' + '</style>'}).appendTo("body")
  });
});

/* BxSLider Ca;; */
(function ($) {
  var thumbslider = $(".sliderLocation").bxSlider({
    mode: "horizontal",
    slideWidth: 110,
    // minSlides: 5,
    // maxSlides: 5,
    infiniteLoop: false,
    moveSlides: 1,
    slideMargin: 10,
    pager: false,
    prevText: "",
    nextText: "",
    //setGallerySize: false,
    hideControlOnEnd: true,
    swipeThreshold: 100,
    touchEnabled: false,
    dots: true,
    //shrinkItems: true
  });
})(jQuery);

$(document).ready(function () {
  var btn = $(".tab"),
    info = $(".info-tab");
  if ($(".nav-tabs a.current-tab").length > 0) {
    var current_Tab = $(".nav-tabs a.current-tab").data("tab");
    var SingleTab = $("#" + current_Tab);
    SingleTab.nextUntil("h2.video-accordion-title").fadeIn();
    // 	console.log(SingleTab.nextUntil( "h2.video-accordion-title" ).attr('data-parent',SingleTab.attr('id')))

    var $faqHeading = SingleTab.next();
    var $btn = $faqHeading.find('button[type="button"]');
    $btn.attr("aria-expanded", true);

    var $heading = $faqHeading.find("dd#" + $btn.attr("id"));
    SingleTab.addClass("active");
    $heading.attr("aria-hidden", false);
  } else {
    console.log("tabs are not Available");
    $(".my-div").show();
  }
  btn.click(function (e) {
    e.preventDefault();
    var index = $(this).index();
    info.hide();
    info.eq(index).show();
    $(".tab").removeClass("current-tab");
    $(this).addClass("current-tab");
    var $heading = $("#" + $(this).data("tab"));
    $(".my-div").hide();

    $heading.nextUntil("h2.video-accordion-title").fadeToggle(function () {});
    $heading.addClass("active");
    var $faqHeading = $heading.next();

    var $btn = $faqHeading.find('button[type="button"]');
    $btn.attr("aria-expanded", true);
    console.log($btn);
    var $heading = $faqHeading.find("dd#" + $btn.attr("id"));
    $heading.attr("aria-hidden", false);
  });

  // $(document).on("closing", ".remodal", function (e) {
  //   console.log("remodal is closing");
  //   $(".remodal-overlay").removeClass("phonecase-popup");
  // });
  var phonecase_confirm_popup = $(
    "[data-remodal-id=phonecase-confirm]"
  ).remodal({
    hashTracking: false,
    closeOnOutsideClick: true,
  });

  $(".yes-btn").on("click", function (e) {
    phonecase_confirm_popup.close();
    window.location = "/checkout";
  });

  PhoneCaseCk = Cookies.get("phonecase_confirm_popup");
  if (PhoneCaseCk == "false" || PhoneCaseCk == false) {
    $(
      ".cart_content input.action_button, a.minicart-checkout-btn, input#checkout"
    ).removeClass("hidden-force");
    $("a.minicart-checkout-btn").addClass("hidden-force");
  }

  $(document).on("closing", "[data-remodal-id=phonecase-confirm]", function () {
    console.log("Closing Modal");
    $(".modal-wrap2").removeClass("modal--show");

    jQuery.getJSON("/cart.js", function (cart) {
      cart_total = cart.total_price;
      to_free_shipping = (3500 - cart_total) / 100;
      console.log("carttotal", cart_total);
      console.log("to_free_shipping", to_free_shipping);
      if (cart_total > 3500) {
        $(".top-bar-free-shipping").hide();
        $(".top-bar-shipping-reached").show();
      }
      $(".top-bar-free-shipping-amount").text(to_free_shipping.toFixed(2));
    });

    $(
      ".cart_content input.action_button, a.minicart-checkout-btn, input#checkout"
    ).removeClass("hidden-force");
    $("a.minicart-checkout-btn").addClass("hidden-force");
  });

  $(".description-toggler").on("click", function () {
    $(this).parent().toggleClass("description-togglee--open");
  });

  //   if($( window ).width() <= 798){
  //     $(".description-toggle-wrap").removeClass("description-togglee--open");
  //   }

  $(".j-featured-review-expand").click(function (e) {
    e.preventDefault();
    $(this).parent().toggleClass("featured-review--expanded");
  });

  $("a.minicart-checkout-btn").on("click", function (e) {
    e.preventDefault();

    if (window.phonecase_confirm_enabled == true) {
      phonecase_confirm_popup.open();
      $(".remodal-overlay").addClass("phonecase-popup");
      PhoneCaseCk = Cookies.get("phonecase_confirm_popup");
      console.log(PhoneCaseCk);
      PhoneCaseCk = Cookies.get("phonecase_confirm_popup");
      if (PhoneCaseCk == undefined && PhoneCaseCk != false) {
        //       console.log('Yes Phone cases is here')

        Cookies.set("phonecase_confirm_popup", "false", {
          expires: 90,
          path: "/",
        });
      } else {
        $(
          ".cart_content input.action_button, a.minicart-checkout-btn, input#checkout"
        ).removeClass("hidden-force");
        $("a.minicart-checkout-btn").addClass("hidden-force");
        //       console.log('Yes Phone cases is here, but popup will no open')
      }
    } else {
      window.location = "/checkout";
    }
  });

  $(
    '#create-customer [name="customer[email]"], #create-customer input.password'
  ).val("");
});

var spotted_info = $(".spotted-info");
function spotted_slider() {
  var options = {
    pageDots: false,
    wrapAround: true,
    groupCells: 3,
    contain: true,
    cellAlign: "center",
    lazyLoad: true,
    draggable: true,
    dragThreshold: 3,
      on: {
          ready: handleReady,
          settle: handleSettle,
          change:handleChange
      }
  };
  if ($(window).width() <= 798) {
    if (spotted_info.hasClass("flickity-enabled")) {
      spotted_info.flickity("destroy");
    }
    spotted_info.flickity({
      pageDots: false,
      cellAlign: "center",
      wrapAround: true,
      groupCells: 1,
      contain: true,
      lazyLoad: true,
      draggable: true,
      on: {
          ready: handleReady,
          settle: handleSettle,
          change:handleChange
      }
      // selectedAttraction: 0.2
      // friction: 0.8
    });
  } else {
    if (spotted_info.hasClass("flickity-enabled")) {
      spotted_info.flickity("destroy");
    }
    spotted_info.flickity(options);
  }
}

    function handleReady() {
        spotted_info.attr('aria-label', 'Track of tiles. Use arrow keys to navigate.');
        spotted_info.find('.spotted-img-box:not(.is-selected)').addClass('is-hidden')
    }
        function handleChange(){
          spotted_info.find('.spotted-img-box').removeClass('is-hidden')
        }
        function handleSettle(){
          console.log('settle called')
          hideNonVisibleSlides();
        }
      function hideNonVisibleSlides() {
        spotted_info.find('.spotted-img-box:not(.is-selected)').addClass('is-hidden')
      }

spotted_slider();
// $(window).on('resize',function(){spotted_slider();})

function sortUnorderedList(ul, sortDescending) {
  if (typeof ul == "string") ul = document.getElementById(ul);

  var lis = ul.getElementsByTagName("LI");
  var vals = [];

  for (var i = 0, l = lis.length; i < l; i++) vals.push(lis[i].innerHTML);

  vals.sort();

  if (sortDescending) vals.reverse();

  for (var i = 0, l = lis.length; i < l; i++) lis[i].innerHTML = vals[i];
}

// sortUnorderedList("list", desc);
var divs = $(".footer-list-shop-by-device, .footer-list-test-shop-by-device");
$.each(divs, function (index, ele) {
  var lis = $(ele).find("li");
  for (var i = 0; i < lis.length; i += 17) {
    lis.slice(i, i + 17).wrapAll("<ul class='menu_list'></ul>");
  }
});
var divs = $(".footer-list-shop-products li");
for (var i = 0; i < divs.length; i += 4) {
  divs.slice(i, i + 4).wrapAll("<ul class='menu_list'></ul>");
}

var divs = $(".footer-list-shop-galaxy li");
for (var i = 0; i < divs.length; i += 5) {
  divs.slice(i, i + 5).wrapAll("<ul class='menu_list'></ul>");
}
var divs = $(".footer-list-shop-iphone li");
// $(".footer-list-shop-iphone").empty();
for (var i = 0; i < divs.length; i += 12) {
  divs.slice(i, i + 12).wrapAll("<ul class='menu_list'></ul>");
}

var divs = $(".footer-list-shop-pixel li");
for (var i = 0; i < divs.length; i += 3) {
  divs.slice(i, i + 3).wrapAll("<ul class='menu_list'></ul>");
}
// console.log('pixel',divs)

var divs = $(".footer-list-about-flaunt li");
divs.slice(0, 6).wrapAll("<ul class='menu_list'></ul>");
divs.slice(6, 12).wrapAll("<ul class='menu_list'></ul>");
divs.slice(12, 16).wrapAll("<ul class='menu_list'></ul>");
// for(var i = 0; i < divs.length; i+=5) {
//   divs.slice(i, i+5).wrapAll("<ul class='menu_list'></ul>");
// }
var divs = $(".footer-list-need-some-help li");
for (var i = 0; i < divs.length; i += 4) {
  divs.slice(i, i + 4).wrapAll("<ul class='menu_list'></ul>");
}

$(".toggle-password").on("click", function (e) {
  var $text = $(this).siblings(".password");
  var type = $text.attr("type");
  if (type == "password") {
    $(this).text("hide");
    $(this).siblings(".password").attr("type", "text");
  } else {
    $(this).text("show");
    $(this).siblings(".password").attr("type", "password");
  }
});

// $('.toggle-password').on('click',function(){
//   if( e.innerHTML == 'Show' ) {
//       e.innerHTML = 'Hide'
//       document.getElementById('password').type="text";
//   } else {
//       e.innerHTML = 'Show'
//       document.getElementById('password').type="password";
//   }
// })

$("body").on("click", ".action_button.action_edit a", function (e) {
  var id = $(this).attr("data-id");
  $(".edit_address").hide();
  $("#edit_address_" + id).toggle();
  //   $('html, body').animate({
  //     scrollTop: $("#edit_address_"+id).offset().top - 130
  //   }, 1500);
});
$("body").on("click", "a.cancel-address", function (e) {
  var id = $(this).attr("data-id");
  $("#edit_address_" + id).hide();
});

// ==================================================
//
// jquery-input-mask-phone-number v1.0
//
// Licensed (The MIT License)
//
// Copyright Â© Raja Rama Mohan Thavalam <rajaram.tavalam@gmail.com>
//
// ==================================================
(function ($) {
  $.fn.usPhoneFormat = function (options) {
    var params = $.extend(
      {
        format: "xxx-xxx-xxxx",
        international: false,
      },
      options
    );

    if (params.format === "xxx-xxx-xxxx") {
      $(this).bind("paste", function (e) {
        e.preventDefault();
        var inputValue = e.originalEvent.clipboardData.getData("Text");
        if (!$.isNumeric(inputValue)) {
          return false;
        } else {
          inputValue = String(
            inputValue.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")
          );
          $(this).val(inputValue);
          $(this).val("");
          inputValue = inputValue.substring(0, 12);
          $(this).val(inputValue);
        }
      });
      $(this).on("keypress", function (e) {
        if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
          return false;
        }
        var curchr = this.value.length;
        var curval = $(this).val();
        if (curchr == 3) {
          $(this).val(curval + "-");
        } else if (curchr == 7) {
          $(this).val(curval + "-");
        }
        $(this).attr("maxlength", "12");
      });
    } else if (params.format === "(xxx) xxx-xxxx") {
      $(this).on("keypress", function (e) {
        if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
          return false;
        }
        var curchr = this.value.length;
        var curval = $(this).val();
        if (curchr == 3) {
          $(this).val("(" + curval + ")" + " ");
        } else if (curchr == 9) {
          $(this).val(curval + "-");
        }
        $(this).attr("maxlength", "14");
      });
      $(this).bind("paste", function (e) {
        e.preventDefault();
        var inputValue = e.originalEvent.clipboardData.getData("Text");
        if (!$.isNumeric(inputValue)) {
          return false;
        } else {
          inputValue = String(
            inputValue.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")
          );
          $(this).val(inputValue);
          $(this).val("");
          inputValue = inputValue.substring(0, 14);
          $(this).val(inputValue);
        }
      });
    }
  };
})(jQuery);

$(document).ready(function () {
  $("#address_phone_new,.phone_number").usPhoneFormat({
    format: "(xxx) xxx-xxxx",
  });
  $("#address_phone_new,.phone_number").keyup(function () {
    $(this).val(
      $(this)
        .val()
        .replace(/(\d{3})\-?(\d{3})\-?(\d{4})/, "($1)-$2-$3")
    );
  });
});

$(document).ready(function () {
  //check user IP and show cookie popup
  if ($("body").hasClass("has-cookie-banner")) {
    var user_state = Cookies.get("user_state");
    var banner_cookie = Cookies.get("cookie_banner");
    $(".cookie_close, .coolie_txt a").on("click", function () {
      $(".cookie-banner").removeClass("show");
      Cookies.set("cookie_banner", "true", { expires: 365 });
    });
    if (window.customer_logged_in == false) {
      if (user_state == undefined) {
        dbip
          .getVisitor({ tryNavigatorGeolocation: false })
          .then(function (data) {
            // console.log(info)
            user_state = data.stateProvCode;
            // console.log(data);
            if (user_state == "CA" && banner_cookie == undefined) {
              Cookies.set("user_state", user_state, {
                expires: 365,
              });
              $(".cookie-banner").addClass("show");
            }
          });
      } else {
        // console.log("cookie", banner_cookie, "country", user_state);
        if (user_state == "CA" && banner_cookie == undefined) {
          Cookies.set("user_state", user_state, {
            expires: 365,
          });
          $(".cookie-banner").addClass("show");
        }
      }
    } else {
      if (window.address_state == "CA" && banner_cookie == undefined) {
        $(".cookie-banner").addClass("show");
      }
    }
  }
  //Check to see if the window is top if not then display button
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $(".scroll-top").fadeIn();
    } else {
      $(".scroll-top").fadeOut();
    }
  });

  //Click event to scroll to top
  $(".scroll-top").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 800);
    return false;
  });
  $("li.js_currency_wrapper.mobile_menu").on("click", function () {
    $(this).toggleClass("active-currency");
    //     $(this).find('i.fa').trigger('click')
  });

  //stop clicking on minicart AfterPay link
  $("body").on("click", ".rebuy-cart__flyout-installments a", function (e) {
    e.preventDefault();
  });

  //Adding select a device as default option for iPhone cases PDP variant dropdown
  if (!$("body").hasClass("gift-card")) {
    // var label =
    //   $(".selector-wrapper").length > 1 ? "Select a Model" : "Select a Device";
    var label = "Select a Model";
    // console.log('label',label)
    var has_variant_url = Shopify.urlParam("variant") ? true : false;
    if (has_variant_url == false) {
      if ($(".single-option-selector").length > 0) {
        // console.log($(".single-option-selector"), "here");
        if (
          $(".single-option-selector:eq(0)" + ' option[value*="iPhone"]:eq(0)')
            .length
        ) {
          $(
            ".single-option-selector:eq(0)" + ' option[value*="iPhone"]:eq(0)'
          ).before(
            '<option value=""  disabled selected="selected">' +
              label +
              "</option>"
          );
        } else if (
          $(".single-option-selector:eq(0)" + ' option[value*="Pixel"]:eq(0)')
            .length
        ) {
          $(
            ".single-option-selector:eq(0)" + ' option[value*="Pixel"]:eq(0)'
          ).before(
            '<option value=""  disabled selected="selected">' +
              label +
              "</option>"
          );
        } else if (
          $(".single-option-selector:eq(0)" + ' option[value*="AirPods"]:eq(0)')
            .length
        ) {
          $(
            ".single-option-selector:eq(0)" + ' option[value*="AirPods"]:eq(0)'
          ).before(
            '<option value=""  disabled selected="selected">Select a Model</option>'
          );
          label = "Select a Model";
        } else {
          $(
            ".single-option-selector:eq(0)" + ' option[value*="Galaxy"]:eq(0)'
          ).before(
            '<option value=""  disabled selected="selected">' +
              label +
              "</option>"
          );
        }
        $(".add_to_cart")
          .attr("disabled", "disabled")
          .find("span.text")
          .text(label);
      }
    } else {
      console.log("asdasd");
      if ($(".single-option-selector").length > 0) {
        var t = $(".add_to_cart").find("span.text").text();
        if (t.indexOf("Coming Soo") > -1) {
          $(".add_to_cart")
            .attr("disabled", "disabled")
            .find("span.text")
            .text("Coming Soon");
        } else {
          $(".add_to_cart")
            .removeAttr("disabled", "disabled")
            .find("span.text")
            .text("Add to Bag");
        }
        //               console.log(t.indexOf('Coming Soo'))
      }
    }
  }
  KlaviyoSubscribe.attachToForms("#email_signup", {
    hide_form_on_success: true,
    extra_properties: {
      $source: "$embed",
      $method_type: "Klaviyo Form",
      $method_id: "embed",
      $consent_version: "Embed default text",
    },
    success: function ($form, data, c) {
      console.log($form, data, c);
      var email = $form.find('input[type="email"]').val();
      console.log("klaviyo submission", email);
      try {
        gtag("event", "sign_up", {
          userId: "",
          uemh: SHA256(email),
          method: "Footer Newsletter",
        });
      } catch (er) {
        console.log(er);
      }
      if (data.is_subscribed == true) {
        $(".old-subscriber").html("You are already subscribed.");
        //            	console.log('already subscribed')
      } else {
        $(".new-subscriber").html(
          "Thank you! Check your email for a confirmation message."
        );
        //             console.log('Thank you for subscribing us')
      }
    },
  });

  $("body").on("click touchstart", "#custom_bis_trigger", function (event) {
    console.log("click");
    $(".BIS_trigger").trigger("click");
  });

  var eles = $(".plp-product-section .product_form_options");
  plpAtcButton(eles, label);

  // $("body").on("click", ".plp-product-section .add_to_cart", function () {
  //   var parent = $(this).parents("form.product_form_options");
  //   var btn = $(this);
  //   var current_selected = parent.find("select.single-option-selector").val();
  //   console.log('current_selected',current_selected);
  //   alert('current_selected'+current_selected)
  //   if (current_selected) {
  //     btn.find(".text").text("Adding...");
  //     setTimeout(function () {
  //       btn.find(".text").text("ADDED!");
  //       setTimeout(function () {
  //         btn.find(".text").text("Add to Bag");
  //       }, 1000);
  //     }, 1500);
  //   }
  // });
  // $("body").on("click", ".plp-product-section .add_to_cart", function () {
  //   var parent = $(this).parents("form.product_form");
  //   var btn = $(this);
  //   btn.find(".text").text("Adding...");
  //   setTimeout(function () {
  //     btn.find(".text").text("ADDED!");
  //     setTimeout(function () {
  //       btn.find(".text").text("Add to Bag");
  //     }, 1000);
  //   }, 1500);
  // });
});
/* rebuy Get the set widget*/
if($('body').hasClass('product')){
  document.addEventListener('rebuy.ready', (event) => {
      // console.log('rebuy.ready',$('.rebuy-bundle__items'),event);
      // if($(window).width() <768){
      //   $('.rebuy-bundle__items').flickity({        
      //   draggable: true,
      //   prevNextButtons: true,
      //   wrapAround: false,
      //   cellAlign: 'left',
      //   pageDots: false,
      //   freeScroll: false,
      //     groupCells: 2
      //   })
      // } 
      $("body").on("change", ".rebuy-bundle__items select", function () {
        var anyDisabled = false;
        $(".rebuy-bundle__items select").each(function () {
          if ($(this).val() === "disabled") {
            $(this).removeClass('ready')
            anyDisabled = true;
            return false;
          }else{
            $(this).addClass('ready')
          }
        });
        if (anyDisabled) {
          $(".bundle-btn").addClass("disable-btn");
        } else {
          $(".bundle-btn").removeClass("disable-btn");
        }
      });
  });
}
/* rebuy Get the set widget*/

// Search Icon mobile JS
$(document).ready( function(){
  $(document).on("click", '.search-mobile-submit', function() {
    $('.dropdown_container.mobile-search').toggleClass('active');
  });

  $(document).on('click', function(evt) {
    if (!$(evt.target).parent().siblings('.dropdown_container.mobile-search').length && !$(evt.target).is('.search-terms')) {
      $('.dropdown_container.mobile-search').removeClass('active');
      $('.mobile-search .search-terms').val('');
    }
  })
})
  function plp_link_slider(){
var link_slider = $('.link_button-list');
if($(window).width() <= 798 ){
  if (link_slider.hasClass("flickity-enabled")) {
    link_slider.flickity("destroy");
  }
  link_slider.flickity({
    pageDots: false,
    cellAlign: "left",
    wrapAround: false,
    groupCells: 2,
    contain: true,
    lazyLoad: true,
    draggable: true
  });
}else{
  if (link_slider.hasClass("flickity-enabled")) {
    link_slider.flickity("destroy");
  }  
}
}
plp_link_slider();
  $(document).ready(function(){
    $('.link_button-list .link_button.is_subtab').click(function(){
      var $this = $(this),
        this_handle = $this.attr('data-handle'),
        isActive = false;
      $this.siblings('.is_subtab.is_current').removeClass('is_current')
      $('.sublink_main .sublink').removeClass('is_active')
      if($this.hasClass('is_current')){
        isActive = true;
      }
      $this.addClass('is_current')
      $('.sublink_main').addClass('is_open');
      $('.sublink_main .sublink[data-handle='+this_handle+']').addClass('is_active');
      if(isActive){
        $this.removeClass('is_current')
        $('.sublink_main .sublink[data-handle='+this_handle+']').removeClass('is_active');
        $('.sublink_main').removeClass('is_open');
      }

    })

    $(document).click(function(event) { 
      var $target = $(event.target);
      if(!$target.closest('.link_button.is_subtab').length && !$target.closest('.sublink_main .sublink').length) {
        $('.is_subtab.is_current').removeClass('is_current');
        $('.sublink_main.is_open').removeClass('is_open');
      }        
    });

    $("body").on('click',"#js_accessibility_trigger",function(){
      if(document.querySelector("#accessiblyAppDialogButton")){
          document.querySelector("#accessiblyAppDialogButton").click()  
      }
    })
    
  });

  